webpackJsonp([1],{

/***/ "+SL1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+V29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__ = __webpack_require__("AE0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("L/hj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminUserList',
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__["a" /* default */]
  },
  computed: {
    users: function users() {
      return this.$store.getters.adminUserList;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchUserList', true);
  },
  data: function data() {
    var _this = this;

    return {
      currentPage: 1,
      fields: [{
        key: 'id',
        label: this.$t('message.adminUserList.table.id')
      }, {
        key: 'firstName',
        label: this.$t('message.adminUserList.table.firstName')
      }, {
        key: 'lastName',
        label: this.$t('message.adminUserList.table.lastName')
      }, {
        key: 'email',
        label: this.$t('message.adminUserList.table.email')
      }, {
        key: 'dateOfBirth',
        label: this.$t('message.adminUserList.table.dateOfBirth'),
        formatter: function formatter(value) {
          return _this.$moment(value).format('DD.MM.YYYY');
        }
      }, {
        key: 'roles',
        label: this.$t('message.adminUserList.table.roles')
      }, {
        key: 'contractNumber',
        label: this.$t('message.adminUserList.table.contractNumber')
      }, {
        key: 'isCertificateOfDeathApproved',
        label: this.$t('message.adminUserList.table.status'),
        formatter: function formatter(value) {
          if (value) {
            return _this.$t('message.adminUserList.status.death');
          }
          return _this.$t('message.adminUserList.status.alive');
        }
      }, {
        key: 'createdAt',
        label: this.$t('message.adminUserList.table.registration'),
        formatter: function formatter(value) {
          return _this.$moment(value).format('DD.MM.YYYY');
        }
      }, {
        key: 'isAuthorized',
        label: this.$t('message.adminUserList.table.legitimation'),
        formatter: function formatter(value) {
          if (!value) {
            return _this.$t('message.adminUserList.isNotAuthorized');
          }
          return _this.$t('message.adminUserList.isAuthorized');
        }
      }],
      filterValue: null,
      pageOptions: [20, 50, 100],
      perPage: 20
    };
  },

  methods: {
    getFilteredUsers: function getFilteredUsers(value) {
      var _this2 = this;

      var filtered = this.users.filter(function (user) {
        if (!value) {
          return true;
        }
        var formattedDateOfBirth = _this2.$moment(user.dateOfBirth).format('DD.MM.YYYY');
        var translatedRoles = user.roles.filter(function (role) {
          return _this2.$t('enums.roles.' + role.roleOfUser).toLowerCase().includes(value.toLowerCase());
        });
        var deathValue = _this2.$t('message.adminUserList.status.death').toLowerCase();
        var aliveValue = _this2.$t('message.adminUserList.status.alive').toLowerCase();
        var formattedDateOfRegistration = _this2.$moment(user.createdAt).format('DD.MM.YYYY');
        var isAuthorizedValue = _this2.$t('message.adminUserList.isAuthorized').toLowerCase();
        var isNotAuthorizedValue = _this2.$t('message.adminUserList.isNotAuthorized').toLowerCase();

        if (user.id.toString().includes(value.toLowerCase())) {
          return user;
        } else if (user.firstName && user.firstName.toLowerCase().includes(value.toLowerCase())) {
          return user;
        } else if (user.lastName && user.lastName.toLowerCase().includes(value.toLowerCase())) {
          return user;
        } else if (user.email && user.email.toLowerCase().includes(value.toLowerCase())) {
          return user;
        } else if (formattedDateOfBirth.toString().includes(value.toLowerCase())) {
          return true;
        } else if (translatedRoles.length > 0) {
          return true;
        } else if (user.contractNumber && user.contractNumber.toString().includes(value.toLowerCase())) {
          return true;
        } else if (user.isCertificateOfDeathApproved && deathValue.includes(value.toLowerCase())) {
          return true;
        } else if (!user.isCertificateOfDeathApproved && aliveValue.includes(value.toLowerCase())) {
          return true;
        } else if (formattedDateOfRegistration.toString().includes(value.toLowerCase())) {
          return true;
        } else if (user.isAuthorized && isAuthorizedValue.includes(value.toLowerCase())) {
          return true;
        } else if (!user.isAuthorized && isNotAuthorizedValue.includes(value.toLowerCase())) {
          return true;
        }
      });
      return filtered;
    },
    translatedRoles: function translatedRoles(roles) {
      return __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].getTranslatedRoles(this, roles);
    },
    showDetails: function showDetails(item) {
      this.$router.push('/admin/users/' + item.id);
    }
  }
});

/***/ }),

/***/ "+gC3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactPersonList_vue__ = __webpack_require__("+vLl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0992743b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactPersonList_vue__ = __webpack_require__("zgIE");
function injectStyle (ssrContext) {
  __webpack_require__("C2pS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0992743b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactPersonList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0992743b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactPersonList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+kr4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContractPartnerTemplateDetails_vue__ = __webpack_require__("l+Xk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dca5a586_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContractPartnerTemplateDetails_vue__ = __webpack_require__("tgqS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContractPartnerTemplateDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dca5a586_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContractPartnerTemplateDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+vLl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_BusinessCard__ = __webpack_require__("ReR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_HeaderView__ = __webpack_require__("AE0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contactPerson_ContactPersonDialog__ = __webpack_require__("VjwA");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactPersonList',
  components: {
    BusinessCard: __WEBPACK_IMPORTED_MODULE_0__components_common_BusinessCard__["a" /* default */],
    ContactPersonDialog: __WEBPACK_IMPORTED_MODULE_2__components_contactPerson_ContactPersonDialog__["a" /* default */],
    HeaderView: __WEBPACK_IMPORTED_MODULE_1__components_common_HeaderView__["a" /* default */]
  },
  created: function created() {
    this.$store.dispatch('fetchContactPersons');
    this.$store.dispatch('fetchInvitations');
  },

  computed: {
    contactPersons: function contactPersons() {
      var _this = this;

      var mappedContactPersons = this.$store.getters.contactPersons.map(function (contactPerson) {
        return {
          id: contactPerson.id,
          avatarUuid: contactPerson.avatarUuid,
          name: contactPerson.firstName + ' ' + contactPerson.lastName,
          email: contactPerson.email,
          status: _this.$t('enums.invitationStatus.REGISTERED')
        };
      });
      var mappedInvitations = this.$store.getters.invitations.map(function (invitation) {
        return {
          id: invitation.id,
          name: invitation.contactPersonFirstname + ' ' + invitation.contactPersonLastname,
          email: invitation.contactPersonEmail,
          status: _this.$t('enums.invitationStatus.' + invitation.status)
        };
      });
      return mappedContactPersons.concat(mappedInvitations);
    }
  },
  methods: {
    showContactPerson: function showContactPerson(contactPerson) {
      if (contactPerson.status === this.$t('enums.invitationStatus.REGISTERED')) {
        this.$router.push('/contactpersons/' + contactPerson.id);
      }
    },
    showContactPersonDialog: function showContactPersonDialog() {
      this.$refs.contactPersonDialog.show();
    },
    submitContactPersonDialog: function submitContactPersonDialog(contactPerson) {
      var _this2 = this;

      this.$store.dispatch('inviteContactPerson', contactPerson).then(function () {
        _this2.showSuccessMsg({
          message: _this2.$t('message.contactPersonList.submitContactPersonDialog', { email: contactPerson.email })
        });
      }).catch(function () {
        _this2.showErrorMsg({
          message: _this2.$t('error.contactPersonList.submitContentPersonDialog') // TODO i18n
        });
      });
    }
  },
  notifications: {
    showErrorMsg: {
      type: 'error'
    },
    showSuccessMsg: {
      type: 'success'
    }
  }
});

/***/ }),

/***/ "/8zH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardContentContactPerson_vue__ = __webpack_require__("X69m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32195596_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardContentContactPerson_vue__ = __webpack_require__("IDhU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardContentContactPerson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32195596_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardContentContactPerson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/KeR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("L/hj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_AvatarForm__ = __webpack_require__("q2t0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AvatarForm: __WEBPACK_IMPORTED_MODULE_2__components_account_AvatarForm__["a" /* default */]
  },
  props: {
    onSubmit: {
      type: Function,
      required: true
    },
    onSubmitAvatar: {
      type: Function,
      required: true
    },
    onDeleteAvatar: {
      type: Function,
      required: true
    },
    personalInfo: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      avatar: this.$store.getters.currentUser.avatar ? this.$store.getters.currentUser.avatar : null,
      avatarFile: null,
      dateOfBirth: this.personalInfo.dateOfBirth ? this.$moment(this.personalInfo.dateOfBirth).format('DD.MM.YYYY') : null,
      firstName: this.personalInfo.firstName,
      isReadonly: true,
      lastName: this.personalInfo.lastName,
      maxFileSize: 6 * 1024 * 1024,
      maxHeight: 600,
      maxWidth: 600,
      salutation: this.personalInfo.salutation,
      salutations: [{ text: this.$t('enums.salutations.MR'), value: 'MR' }, { text: this.$t('enums.salutations.MRS'), value: 'MRS' }],
      title: this.personalInfo.title
    };
  },

  methods: {
    cancel: function cancel() {
      this.avatar = this.$store.getters.currentUser.avatar ? this.$store.getters.currentUser.avatar : null;
      this.dateOfBirth = this.personalInfo.dateOfBirth ? this.$moment(this.personalInfo.dateOfBirth).format('DD.MM.YYYY') : null;
      this.firstName = this.personalInfo.firstName;
      this.lastName = this.personalInfo.lastName;
      this.salutation = this.personalInfo.salutation;
      this.title = this.personalInfo.title;
      this.setReadonly(true);
    },
    deleteAvatar: function deleteAvatar() {
      var _this = this;

      this.onDeleteAvatar().then(function () {
        _this.avatar = _this.$store.getters.avatar ? _this.$store.getters.avatar : null;
      });
    },
    updateAvatar: function updateAvatar(avatarFile, newAvatar) {
      this.avatarFile = avatarFile;
      this.avatar = newAvatar;
    },
    setReadonly: function setReadonly(isReadonly) {
      this.isReadonly = isReadonly;
    },
    submit: function submit() {
      var _this2 = this;

      if (this.avatarFile !== null) {
        this.onSubmitAvatar(this.avatarFile).then(function () {
          _this2.avatarFile = null;
        });
      }

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.personalInfo.dateOfBirth = this.$moment(this.dateOfBirth, 'DD.MM.YYYY').format('YYYY-MM-DD');
        this.personalInfo.firstName = this.firstName;
        this.personalInfo.lastName = this.lastName;
        this.personalInfo.salutation = this.salutation;
        this.personalInfo.title = this.title;
        this.onSubmit(this.personalInfo).then(function () {
          _this2.setReadonly(!_this2.isReadonly);
        });
      }
    }
  },
  validations: {
    dateOfBirth: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      isValidDate: __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].validators.isValidDate
    },
    firstName: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
    },
    lastName: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
    },
    salutation: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
    }
  },
  notifications: {
    showSuccessMsg: {
      type: 'success'
    }
  }
});

/***/ }),

/***/ "/Toh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("XNDa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a6408f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("1Pwh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a6408f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/f27":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/uTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios_auth__ = __webpack_require__("NwdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("L/hj");





// Due to avoid name conflicts with the other store modules
// we make us of *List instead of simply using plural
var state = {
  adminContractPartnerList: [],
  adminContractPartnerTemplateList: [],
  adminContractPartner: {},
  adminAddresses: null,
  adminContactPersons: null,
  adminContracts: [],
  adminCertificateOfDeath: null,
  adminCertificateOfInheritance: null,
  adminPowerOfAttorney: null,
  adminUserInvitationList: null,
  userById: {},
  userList: []
};

var getters = {
  adminAddresses: function adminAddresses(state) {
    return state.adminAddresses;
  },
  adminContactPersons: function adminContactPersons(state) {
    return state.adminContactPersons;
  },
  adminContracts: function adminContracts(state) {
    return state.adminContracts;
  },
  adminCertificateOfDeath: function adminCertificateOfDeath(state) {
    return state.adminCertificateOfDeath;
  },
  adminCertificateOfInheritance: function adminCertificateOfInheritance(state) {
    return state.adminCertificateOfInheritance;
  },
  adminPowerOfAttorney: function adminPowerOfAttorney(state) {
    return state.adminPowerOfAttorney;
  },
  adminUserInvitationList: function adminUserInvitationList(state) {
    return state.adminUserInvitationList;
  },
  adminContractPartner: function adminContractPartner(state) {
    return state.adminContractPartner;
  },
  adminContractPartnerList: function adminContractPartnerList(state) {
    return state.adminContractPartnerList;
  },
  adminContractPartnerTemplateList: function adminContractPartnerTemplateList(state) {
    return state.adminContractPartnerTemplateList;
  },
  userById: function userById(state) {
    return state.userById;
  },
  adminUserList: function adminUserList(state) {
    return state.userList;
  }
};

var actions = {
  deleteAdminContractPartnerTemplate: function deleteAdminContractPartnerTemplate(_ref, contractPartner) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        getters = _ref.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].delete('/management/contractPartnerTemplates/' + contractPartner.id, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        commit('removeAdminContractPartnerTemplate', contractPartner.id);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  fetchAdminContractPartnerById: function fetchAdminContractPartnerById(_ref2, id) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        getters = _ref2.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var adminContractPartner = state.adminContractPartnerList.find(function (adminContractPartner) {
        return adminContractPartner.id === id;
      });
      if (adminContractPartner) {
        commit('setAdminContractPartner', adminContractPartner);
        resolve();
      } else {
        var currentUser = getters.currentUser;
        var idToken = currentUser.idToken;
        var authValue = 'Bearer '.concat(idToken);
        __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/contractPartners/' + id, {
          headers: {
            Authorization: authValue
          }
        }).then(function (response) {
          commit('setAdminContractPartner', response.data);
          dispatch('setLogoutTimer');
          resolve();
        }).catch(function (error) {
          return reject(error);
        });
      }
    });
  },
  fetchAdminContractPartnerList: function fetchAdminContractPartnerList(_ref3) {
    var getters = _ref3.getters,
        commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/contractPartners', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setAdminContractPartnerList', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  fetchAdminContractPartnerTemplateById: function fetchAdminContractPartnerTemplateById(_ref4, id) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch,
        getters = _ref4.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/contractPartnerTemplates/' + id, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setAdminContractPartner', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  fetchAdminContractPartnerTemplateList: function fetchAdminContractPartnerTemplateList(_ref5) {
    var getters = _ref5.getters,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/contractPartnerTemplates', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setAdminContractPartnerTemplateList', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (error) {
        return reject(error);
      });
    });
  },
  fetchUserList: function fetchUserList(_ref6, onlyPhCp) {
    var getters = _ref6.getters,
        commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/users', {
        headers: {
          Authorization: authValue
        },
        params: {
          onlyPhCp: onlyPhCp
        }
      }).then(function (response) {
        commit('setUserList', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchAdminAddresses: function fetchAdminAddresses(_ref7, userId) {
    var getters = _ref7.getters,
        commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/users/' + userId + '/addresses', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setAdminAddresses', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchAdminContracts: function fetchAdminContracts(_ref8, userId) {
    var getters = _ref8.getters,
        commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/users/' + userId + '/contracts', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setAdminContracts', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchUserById: function fetchUserById(_ref9, userId) {
    var getters = _ref9.getters,
        commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/users/' + userId, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setUserById', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchAdminContactPersons: function fetchAdminContactPersons(_ref10, userId) {
    var getters = _ref10.getters,
        commit = _ref10.commit,
        dispatch = _ref10.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/users/' + userId + '/contactPersons', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setAdminContactPersons', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        commit('setAdminContactPersons', null);
        reject(err);
      });
    });
  },
  setHeirStatus: function setHeirStatus(_ref11, data) {
    var getters = _ref11.getters,
        commit = _ref11.commit,
        dispatch = _ref11.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].put('/management/users/' + data.phId + '/contactPersons/' + data.contactPersonId + '/certificateOfInheritanceSettings', {
        isCertificateOfInheritanceApproved: data.isCertificateOfInheritanceApproved,
        isEntitledInCertificateOfInheritance: data.isEntitledInCertificateOfInheritance
      }, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  deleteAdminCertificateOfDeath: function deleteAdminCertificateOfDeath(_ref12, policyHolderId) {
    var getters = _ref12.getters,
        commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].delete('/management/users/' + policyHolderId + '/certificateOfDeath', {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        commit('setAdminCertificateOfDeath', null);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  deleteAdminCertificateOfInheritance: function deleteAdminCertificateOfInheritance(_ref13, data) {
    var getters = _ref13.getters,
        commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].delete('/management/users/' + data.policyHolderId + '/contactPersons/' + data.cpId + '/certificateOfInheritance', {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        commit('setAdminCertificateOfInheritance', null);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  deleteAdminPowerOfAttorney: function deleteAdminPowerOfAttorney(_ref14, policyHolderId) {
    var getters = _ref14.getters,
        commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].delete('/management/users/' + policyHolderId + '/powerOfAttorny', {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        commit('setAdminPowerOfAttorney', null);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchAdminCertificateOfDeath: function fetchAdminCertificateOfDeath(_ref15, userId) {
    var getters = _ref15.getters,
        commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/users/' + userId + '/certificateOfDeath', {
        responseType: 'arraybuffer',
        headers: {
          Authorization: authValue,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var poaMeta = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].contentDispositionToMeta(response);
        poaMeta.file = response.data;
        commit('setAdminCertificateOfDeath', poaMeta);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function () {
        commit('setAdminCertificateOfDeath', null);
      });
    });
  },
  fetchAdminCertificateOfInheritance: function fetchAdminCertificateOfInheritance(_ref16, data) {
    var getters = _ref16.getters,
        commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    var currentUser = getters.currentUser;
    var idToken = currentUser.idToken;
    var authValue = 'Bearer '.concat(idToken);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/users/' + data.policyHolderId + '/contactPersons/' + data.cpId + '/certificateOfInheritance', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        if (response.data.certificateOfInheritance) {
          var certificateOfInheritanceMeta = {};
          certificateOfInheritanceMeta.file = response.data.certificateOfInheritance;
          commit('setAdminCertificateOfInheritance', certificateOfInheritanceMeta);
        } else {
          commit('setAdminCertificateOfInheritance', null);
        }
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        commit('setAdminCertificateOfInheritance', null);
        reject(err);
      });
    });
  },
  fetchAdminPowerOfAttorney: function fetchAdminPowerOfAttorney(_ref17, userId) {
    var getters = _ref17.getters,
        commit = _ref17.commit,
        dispatch = _ref17.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/users/' + userId + '/powerOfAttorny', {
        responseType: 'arraybuffer',
        headers: {
          Authorization: authValue,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var poaMeta = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].contentDispositionToMeta(response);
        poaMeta.file = response.data;
        commit('setAdminPowerOfAttorney', poaMeta);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function () {
        commit('setAdminPowerOfAttorney', null);
      });
    });
  },
  uploadAdminCertificateOfDeath: function uploadAdminCertificateOfDeath(_ref18, data) {
    var getters = _ref18.getters,
        commit = _ref18.commit,
        dispatch = _ref18.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      var formData = new FormData();
      formData.append('file', data.certificateOfDeath);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].post('/management/users/' + data.policyHolderId + '/certificateOfDeath', formData, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        var certificateOfDeathMeta = {};
        certificateOfDeathMeta.uploaderId = currentUser.id;
        certificateOfDeathMeta.filename = data.certificateOfDeath.name;
        certificateOfDeathMeta.mimeType = data.certificateOfDeath.type;
        certificateOfDeathMeta.file = data.certificateOfDeath;
        commit('setAdminCertificateOfDeath', certificateOfDeathMeta);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  uploadAdminCertificateOfInheritance: function uploadAdminCertificateOfInheritance(_ref19, data) {
    var getters = _ref19.getters,
        commit = _ref19.commit,
        dispatch = _ref19.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].post('/management/users/' + data.policyHolderId + '/contactPersons/' + data.cpId + '/certificateOfInheritance', data.documents, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        var certificateOfInheritanceMeta = {};
        certificateOfInheritanceMeta.file = data.documents.certificateOfInheritance;
        certificateOfInheritanceMeta.filename = data.file.name;
        commit('setAdminCertificateOfInheritance', certificateOfInheritanceMeta);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  storeAdminContractPartnerTemplate: function storeAdminContractPartnerTemplate(_ref20, contractPartnerTemplate) {
    var commit = _ref20.commit,
        dispatch = _ref20.dispatch,
        getters = _ref20.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      if ('isDeletable' in contractPartnerTemplate) {
        __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].put('/management/contractPartnerTemplates/' + contractPartnerTemplate.id, contractPartnerTemplate, {
          headers: {
            Authorization: authValue
          }
        }).then(function (response) {
          commit('addAdminContractPartnerTemplate', response.data);
          dispatch('setLogoutTimer');
          resolve();
        }).catch(function (error) {
          return reject(error);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].post('/management/contractPartnerTemplates', contractPartnerTemplate, {
          headers: {
            Authorization: authValue
          }
        }).then(function (response) {
          commit('addAdminContractPartnerTemplate', response.data);
          dispatch('setLogoutTimer');
          resolve();
        }).catch(function (error) {
          return reject(error);
        });
      }
    });
  },
  uploadAdminPowerOfAttorney: function uploadAdminPowerOfAttorney(_ref21, data) {
    var getters = _ref21.getters,
        commit = _ref21.commit,
        dispatch = _ref21.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      var formData = new FormData();
      formData.append('file', data.powerOfAttorney);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].post('/management/users/' + data.policyHolderId + '/powerOfAttorny', formData, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        var powerOfAttorneyMeta = {};
        powerOfAttorneyMeta.filename = data.powerOfAttorney.name;
        powerOfAttorneyMeta.mimeType = data.powerOfAttorney.type;
        powerOfAttorneyMeta.file = data.powerOfAttorney;
        commit('setAdminPowerOfAttorney', powerOfAttorneyMeta);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchAdminUserInvitationList: function fetchAdminUserInvitationList(_ref22, userId) {
    var getters = _ref22.getters,
        commit = _ref22.commit,
        dispatch = _ref22.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/management/users/' + userId + '/invitations', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setAdmiUserInvitationList', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  markAsDead: function markAsDead(_ref23, data) {
    var getters = _ref23.getters,
        commit = _ref23.commit,
        dispatch = _ref23.dispatch;

    var currentUser = getters.currentUser;
    var idToken = currentUser.idToken;
    var authValue = 'Bearer '.concat(idToken);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].put('/management/users/' + data.id + '/markAsDead', { dateOfDeath: data.dateOfDeath }, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        dispatch('setLogoutTimer');
        resolve(data.dateOfDeath);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  authorize: function authorize(_ref24, data) {
    var getters = _ref24.getters,
        commit = _ref24.commit,
        dispatch = _ref24.dispatch;

    var currentUser = getters.currentUser;
    var idToken = currentUser.idToken;
    var authValue = 'Bearer '.concat(idToken);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].put('/management/users/' + data.id + '/authorize', { isAuthorized: data.isAuthorized }, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  }
};

var mutations = {
  addAdminContractPartnerTemplate: function addAdminContractPartnerTemplate(state, adminContractPartnerTemplate) {
    state.adminContractPartnerTemplateList.push(adminContractPartnerTemplate);
  },
  setAdminContractPartner: function setAdminContractPartner(state, adminContractPartner) {
    state.adminContractPartner = adminContractPartner;
  },
  setAdminContractPartnerList: function setAdminContractPartnerList(state, adminContractPartnerList) {
    state.adminContractPartnerList = adminContractPartnerList;
  },
  setAdminContractPartnerTemplateList: function setAdminContractPartnerTemplateList(state, adminContractPartnerTemplateList) {
    state.adminContractPartnerTemplateList = adminContractPartnerTemplateList;
  },
  setAdminAddresses: function setAdminAddresses(state, adminAddresses) {
    state.adminAddresses = adminAddresses;
  },
  setAdminContactPersons: function setAdminContactPersons(state, adminContactPersons) {
    state.adminContactPersons = adminContactPersons;
  },
  setAdminContracts: function setAdminContracts(state, adminContracts) {
    state.adminContracts = adminContracts;
  },
  setAdminCertificateOfDeath: function setAdminCertificateOfDeath(state, adminCertificateOfDeath) {
    state.adminCertificateOfDeath = adminCertificateOfDeath;
  },
  setAdminCertificateOfInheritance: function setAdminCertificateOfInheritance(state, adminCertificateOfInheritance) {
    state.adminCertificateOfInheritance = adminCertificateOfInheritance;
  },
  setAdminPowerOfAttorney: function setAdminPowerOfAttorney(state, adminPowerOfAttorney) {
    state.adminPowerOfAttorney = adminPowerOfAttorney;
  },
  setAdmiUserInvitationList: function setAdmiUserInvitationList(state, adminUserInvitationList) {
    state.adminUserInvitationList = adminUserInvitationList;
  },
  setUserById: function setUserById(state, userById) {
    state.userById = userById;
  },
  setUserList: function setUserList(state, userList) {
    state.userList = userList;
  },
  removeAdminContractPartnerTemplate: function removeAdminContractPartnerTemplate(state, id) {
    var templateIndex = state.adminContractPartnerTemplateList.findIndex(function (template) {
      return template.id === id;
    });
    if (templateIndex !== -1) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.adminContractPartnerTemplateList, templateIndex);
    }
  },
  updateAdminContractPartnerCity: function updateAdminContractPartnerCity(state, city) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.adminContractPartner, 'city', city);
  },
  updateAdminContractPartnerCountry: function updateAdminContractPartnerCountry(state, country) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.adminContractPartner, 'country', country);
  },
  updateAdminContractPartnerDomain: function updateAdminContractPartnerDomain(state, domain) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.adminContractPartner, 'domain', domain);
  },
  updateAdminContractPartnerEmail: function updateAdminContractPartnerEmail(state, email) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.adminContractPartner, 'email', email);
  },
  updateAdminContractPartnerName: function updateAdminContractPartnerName(state, name) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.adminContractPartner, 'contractPartnerName', name);
  },
  updateAdminContractPartnerStreet: function updateAdminContractPartnerStreet(state, street) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.adminContractPartner, 'street', street);
  },
  updateAdminContractPartnerStreetNumber: function updateAdminContractPartnerStreetNumber(state, streetNumber) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.adminContractPartner, 'streetNumber', streetNumber);
  },
  updateAdminContractPartnerPostalCode: function updateAdminContractPartnerPostalCode(state, postalCode) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.adminContractPartner, 'postalCode', postalCode);
  },
  updateAdminContractPartnerPostOfficeBox: function updateAdminContractPartnerPostOfficeBox(state, postOfficeBox) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.adminContractPartner, 'postOfficeBox', postOfficeBox);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "0GBZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0b9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contracts_ContractsCard__ = __webpack_require__("hZwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractWizard__ = __webpack_require__("a6Wh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_HeaderView__ = __webpack_require__("AE0Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContractList',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$store.dispatch('fetchContractPartners').then(function () {
        return vm.$store.dispatch('fetchAddresses');
      }).then(function () {
        return vm.$store.dispatch('fetchContactPersons');
      }).then(function () {
        return vm.$store.dispatch('fetchContracts');
      }).then(function () {
        if (to.params && to.params.id) {
          vm.$store.dispatch('fetchContractById', { id: to.params.id }).catch(function () {
            return vm.showErrorMsg({
              message: vm.$t('error.contractList.fetchContractById')
            });
          });
        } else {
          vm.$store.commit('setCurrentContract', {});
          vm.$store.commit('updateContractCategory', null);
          if (vm.$store.getters.contactPersons.length > 0) {
            vm.$store.commit('updateContactPerson', vm.$store.getters.contactPersons[0]);
          }
        }
      }).catch(function () {
        return vm.showErrorMsg({
          message: vm.$t('error.contractList.fetchContracts')
        });
      });
    });
  },

  components: {
    ContractsCard: __WEBPACK_IMPORTED_MODULE_0__components_contracts_ContractsCard__["a" /* default */],
    ContractWizard: __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractWizard__["a" /* default */],
    HeaderView: __WEBPACK_IMPORTED_MODULE_2__components_common_HeaderView__["a" /* default */]
  },
  computed: {
    contractCategories: function contractCategories() {
      var _this = this;

      return this.$store.getters.contractCategories.map(function (category) {
        return {
          value: category,
          text: _this.$t('enums.contractCategories.' + category)
        };
      });
    },
    contractWizardTitle: function contractWizardTitle() {
      var subMessage = this.$t('message.contractList.infoCard.step' + (this.wizardIndex + 1) + '.title') + ' ' + this.$t('message.contractList.infoCard.step' + (this.wizardIndex + 1) + '.message');
      var subTitle = '<span class="subtitle ml-2">' + subMessage + '</span>';
      if (this.currentContract.id && this.currentContract.id !== -1) {
        return this.$t('message.contractList.contractWizardTitle.edit') + subTitle;
      } else {
        return this.$t('message.contractList.contractWizardTitle.create') + subTitle;
      }
    },

    currentContract: {
      get: function get() {
        return this.$store.getters.currentContract;
      },
      set: function set(contract) {
        this.$store.commit('setCurrentContract', contract);
      }
    }
  },
  data: function data() {
    return {
      wizardIndex: 0
    };
  },

  methods: {
    wizardChange: function wizardChange(next) {
      this.wizardIndex = next;
    },
    getContractsByCategory: function getContractsByCategory(category) {
      return this.$store.getters.contracts.filter(function (contract) {
        return contract.contractCategory === category;
      });
    },
    onShowDetails: function onShowDetails(item) {
      this.$router.push({ name: 'EditContract', params: { id: item.id } });
    }
  },
  notifications: {
    showErrorMsg: {
      type: 'error'
    },
    showSuccessMsg: {
      type: 'success'
    }
  },
  watch: {
    '$route': function $route(to, from) {
      var _this2 = this;

      if (to.params && to.params.id) {
        this.$store.dispatch('fetchContractPartners').then(function () {
          return _this2.$store.dispatch('fetchAddresses');
        }).then(function () {
          return _this2.$store.dispatch('fetchContactPersons');
        }).then(function () {
          return _this2.$store.dispatch('fetchContracts');
        }).then(function () {
          return _this2.$store.dispatch('fetchContractById', { id: to.params.id });
        }).catch(function () {
          _this2.showErrorMsg({
            message: _this2.$t('error.contractList.fetchContractById')
          });
        });
      }
    }
  }
});

/***/ }),

/***/ "0kM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{staticClass:"text-uppercase",attrs:{"title":_vm.$t('message.policies.title'),"icon":''}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('p',[_vm._v("Mit diesen Hinweisen informieren wir Sie über die Verarbeitung Ihrer personenbezogenen Daten durch die\n        CodeCamp:N GmbH und die Ihnen nach dem Datenschutzrecht zustehenden Rechte. Verantwortliche Stelle im Sinne\n        der Datenschutzgesetze, insbesondere der EU-Datenschutzgrundverordnung (DS-GVO), ist:")]),_vm._v(" "),_c('h5',[_vm._v("I. Name und Anschrift des Verantwortlichen")]),_vm._v(" "),_c('p',[_vm._v("Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler Datenschutzgesetze der\n        Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist die:")]),_vm._v(" "),_c('p',[_vm._v("\n        CodeCamp:N GmbH "),_c('br'),_vm._v("\n        Solgerstr. 18 "),_c('br'),_vm._v("\n        90429 Nürnberg "),_c('br'),_vm._v("\n        Telefon: +49 911 2744 8523 "),_c('br'),_vm._v("\n        E-Mail: info@codecamp-n.com\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("II. Kontaktdaten des Datenschutzbeauftragten")]),_vm._v(" "),_c('p',[_vm._v("Unseren Datenschutzbeauftragten erreichen Sie unter:")]),_vm._v(" "),_c('p',[_vm._v("\n        Frau Sabine Sobola "),_c('br'),_vm._v("\n        LiiDU GmbH "),_c('br'),_vm._v("\n        Neupfarrplatz 10 "),_c('br'),_vm._v("\n        93047 Regensburg "),_c('br'),_vm._v("\n        Deutschland "),_c('br'),_vm._v("\n        Telefon: 0941 46392460 "),_c('br'),_vm._v("\n        Mail: info@liidu.de\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("III. Ihre Betroffenenrechte")]),_vm._v(" "),_c('p',[_vm._v("Sie können unter der oben genannten Adresse Auskunft über die zu Ihrer Person gespeicherten Daten verlangen.\n        Darüber hinaus können Sie unter bestimmten Voraussetzungen die Berichtigung oder die Löschung Ihrer Daten\n        verlangen. Ihnen kann weiterhin ein Recht auf Einschränkung der Verarbeitung Ihrer Daten sowie ein Recht auf\n        Herausgabe der von Ihnen bereitgestellten Daten in einem strukturierten, gängigen und maschinenlesbaren\n        Format zustehen.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("IV. Widerspruchsrecht")]),_vm._v(" "),_c('p',[_vm._v("\n        Sie haben das Recht, einer Verarbeitung Ihrer personenbezogenen Daten zu Zwecken der Direktwerbung zu\n        widersprechen. Verarbeiten wir Ihre Daten zur Wahrung berechtigter Interessen, können Sie dieser Verarbeitung\n        widersprechen, wenn sich aus Ihrer besonderen Situation Gründe ergeben, die gegen die Datenverarbeitung\n        sprechen.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("V. Recht auf Datenübertragbarkeit")]),_vm._v(" "),_c('p',[_vm._v("\n        Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags\n        automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung erfolgt in einem\n        maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen\n        verlangen, erfolgt dies nur, soweit es technisch machbar ist.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("VI. Recht auf Löschung")]),_vm._v(" "),_c('p',[_vm._v("\n        Sie haben das Recht, von dem Verantwortlichen zu verlangen, dass die Sie betreffenden personenbezogenen Daten\n        unverzüglich gelöscht werden. Sofern Sie eine endgültige Löschung Ihres angelegten Accounts und somit auch die\n        Löschung Ihrer personenbezogenen Daten veranlassen möchten, stehen Ihnen zwei Möglichkeiten zur Verfügung.\n        Zum einen können Sie jederzeit eine E-Mail an info@codecamp-n.com schicken und die Löschung Ihrer Daten\n        veranlassen. Dabei wird Ihr Account und die damit verbundenen personenbezogenen Daten durch einen\n        Administrator gelöscht\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("VII. Beschwerderecht")]),_vm._v(" "),_c('p',[_vm._v("\n        Sie haben die Möglichkeit, sich mit einer Beschwerde an uns oder den oben genannten (o. g.)\n        Datenschutzbeauftragten unter den o. g. Kontaktdaten oder an eine Datenschutzaufsichtsbehörde zu wenden.\n        Die für uns zuständige Datenschutzaufsichtsbehörde ist:\n      ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Aufsichtsbehörde")]),_vm._v(" "),_c('br'),_vm._v("\n        Bayerisches Landesamt für Datenschutzaufsicht "),_c('br'),_vm._v("\n        Promenade 18, 91522 Ansbach "),_c('br'),_vm._v("\n        Postanschrift: Postfach 606, 91511 Ansbach "),_c('br'),_vm._v("\n        Telefon: 0981/180093-0 "),_c('br'),_vm._v("\n        Telefax: 0981/180093-99 "),_c('br'),_vm._v("\n        E-Mail: poststelle@lda.bayern.de "),_c('br'),_vm._v("\n        Homepage: https://www.lda.bayern.de "),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("VIII. Zwecke der Datenverarbeitung durch die verantwortliche Stelle und Dritte")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('p',[_vm._v("\n        Wir verarbeiten Ihre personenbezogenen Daten unter Beachtung der EU-Datenschutz-Grundverordnung (DS-GVO).\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Meine-vertraege.net ist ein digitaler Vertragsmanager der es Benutzern erlaubt, seine kompletten\n        Vertragsverhältnisse zu erfassen und aufzulisten. Der digitale Vertragsmanager wird als\n        Assistancedienstleistung der Bestattungsvorsorgeversicherung von der NÜRNBERGER VERSICHERUNG in\n        Kooperation mit dem Kuratorium Deutsche Bestattungskultur angeboten.\n      ")]),_vm._v("\n      Sie können sich auf unserer Webseite durch Angaben von Name, Vorname, E-Mail-Adresse, Geburtsdatum,\n      Versicherungsnummer und einem Passwort registrieren und einen Account einrichten. Rechtsgrundlage hierfür\n      ist der mit Ihnen geschlossene Vertrag nach Art. 6 Abs. 1 S. 1 lit. b) DS-GVO.\n      "),_c('p',[_vm._v("\n        Des Weiteren kann der Kontoinhaber Kontaktpersonen bestimmen, welche nach seinem Ableben Einsicht in die ihnen\n        zugeordneten Verträge gewährt bekommen. Rechtsgrundlage hierfür ist Ihre Einwilligung nach\n        Art. 6 Abs. 1 S. 1 lit. a) DS-GVO.\n      ")]),_vm._v("\n      Um eine Darstellung unserer Webseite zu gewährleisten und unsere Anwendung stetig weiterzuentwickeln,\n      verwenden auf unserer Website Cookies. Nähere Informationen zum Einsatz und der Rechtsgrundlage finden\n      Sie im Abschnitt „Cookies“.\n      "),_c('p',[_vm._v("\n        Des Weiteren kann es sein, dass es uns gesetzlich vorgeschrieben ist, Ihre Daten zu verarbeiten. Diese\n        Verarbeitung, ist dann zur Erfüllung einer gesetzlichen Verpflichtung erforderlich (Art. 6 Abs. 1 S. 1 lit. c)\n        DS-GVO). Dies ist zum Beispiel in solchen Situationen der Fall, wenn wir durch Gesetz bestimmte\n        Aufbewahrungsfristen haben.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("IX. Amazon Web Services")]),_vm._v(" "),_c('p',[_vm._v("\n        Wir hosten unsere Systeme bei Amazon Web Services, Inc., 410 Terry Avenue North, Seattle WA 98109, USA („AWS“)\n        auf der Rechtsgrundlage Vertragserfüllung nach Art. 6 Abs. 1 S.1 lit. b) DS-GVO. Die Systeme werden in der\n        EU Region Irland des AWS Netzwerks gehostet. Entsprechend Art. 28 DS-GVO haben wir einen\n        Auftragsdatenverarbeitungsvertrag (Data-Processing-Agreement) mit Amazon Web Services abgeschlossen. Dabei\n        handelt es sich um einen Vertrag, in dem sich AWS unter anderem dazu verpflichtet, die Daten unserer Nutzer\n        zu schützen, entsprechend den festgehaltenen Datenschutzbestimmungen in unserem Auftrag zu verarbeiten und\n        insbesondere nicht an Dritte weiterzugeben. Nähere Informationen hierzu finden Sie in der\n        "),_c('a',{attrs:{"href":"https://aws.amazon.com/de/privacy/?nc1=f_pr"}},[_vm._v("Datenschutzerklärung von AWS")]),_vm._v(".\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("X. Speicherdauer")]),_vm._v(" "),_c('p',[_vm._v("\n        Wir halten uns an die Grundsätze der Datenvermeidung und Datensparsamkeit. Wir speichern Ihre\n        personenbezogenen Daten daher nur so lange, wie dies zur Erreichung der hier genannten Zwecke erforderlich ist\n        oder wie es die vom Gesetzgeber vorgesehenen vielfältigen Speicherfristen vorsehen. Nach Fortfall des\n        jeweiligen Zweckes bzw. Ablauf dieser Fristen werden die entsprechenden Daten routinemäßig und entsprechend\n        den gesetzlichen Vorschriften gesperrt oder gelöscht. Ihnen steht es frei, die bei der Registrierung\n        angegebenen Daten jederzeit vollständig aus der Datenbank löschen zu lassen. Rechtsgrundlage für die\n        Aufbewahrung der Unterlagen für die Dauer der gesetzlichen Aufbewahrungsfristen ist die Erfüllung gesetzlicher\n        Vorgaben nach Art. 6 Abs. 1 S. 1 lit. c) DS-GVO.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("XI.TLS-Verschlüsselung")]),_vm._v(" "),_c('p',[_vm._v("\n        Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der Technik\n        entsprechende Verschlüsselungsverfahren (z.B. TLS) über HTTPS.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("XII. Kontaktformular")]),_vm._v(" "),_c('p',[_vm._v("\n        Treten Sie bzgl. Fragen jeglicher Art per E-Mail mit uns in Kontakt, erteilen Sie uns zum Zwecke der\n        Kontaktaufnahme Ihre freiwillige Einwilligung nach Art. 6 Abs. 1 S. 1 lit. a) DS-GVO. Hierfür ist die Angabe\n        einer validen E-Mail-Adresse erforderlich. Diese dient der Zuordnung der Anfrage und der anschließenden\n        Beantwortung derselben. Die Angabe weiterer Daten ist optional. Die von Ihnen gemachten Angaben werden zum\n        Zwecke der Bearbeitung der Anfrage sowie für mögliche Anschlussfragen gespeichert. Nach Erledigung der von\n        Ihnen gestellten Anfrage werden personenbezogene Daten automatisch gelöscht.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("XIII. Verwendung von Google Maps")]),_vm._v(" "),_c('p',[_vm._v("\n        Auf unserer Website verwenden wir Google Maps (API) von Google Ireland Limited, Gordon House, 4 Barrow St,\n        Dublin, D04 E5W5, Irland (“Google”). Google Maps ist ein Webdienst zur Darstellung von interaktiven\n        (Land-)Karten, um geographische Informationen visuell darzustellen. Über die Nutzung dieses Dienstes wird\n        Ihnen unser Standort angezeigt und eine etwaige Anfahrt erleichtert.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Bereits beim Aufrufen derjenigen Unterseiten, in die die Karte von Google Maps eingebunden ist, werden\n        Informationen über Ihre Nutzung unserer Website (wie z.B. Ihre IP-Adresse) an Server von Google übertragen\n        und dort gespeichert, hierbei kann es auch zu einer Übermittlung an die Server der Google LLC. in den USA\n        kommen. Dies erfolgt unabhängig davon, ob Google ein Nutzerkonto bereitstellt, über das Sie eingeloggt sind\n        oder ob ein Nutzerkonto besteht. Wenn Sie bei Google eingeloggt sind, werden Ihre Daten direkt Ihrem Konto\n        zugeordnet. Wenn Sie die Zuordnung mit Ihrem Profil bei Google nicht wünschen, müssen Sie sich vor Aktivierung\n        des Buttons ausloggen. Google speichert Ihre Daten (selbst für nicht eingeloggte Nutzer) als Nutzungsprofile\n        und wertet diese aus. Die Erhebung, Speicherung und die Auswertung erfolgen gemäß Art. 6 Abs. 1 S. 1 lit. a)\n        DS-GVO auf Basis ihrer Einwilligung.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Wenn Sie mit der künftigen Übermittlung Ihrer Daten an Google im Rahmen der Nutzung von Google Maps nicht\n        einverstanden sind, besteht auch die Möglichkeit, den Webdienst von Google Maps vollständig zu deaktivieren,\n        indem Sie die Anwendung JavaScript in Ihrem Browser ausschalten. Google Maps und damit auch die Kartenanzeige\n        auf dieser Internetseite kann dann nicht genutzt werden.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Die Nutzungsbedingungen von Google können Sie unter\n        "),_c('a',{attrs:{"href":"https://www.google.de/intl/de/policies/terms/regional.html"}},[_vm._v("https://www.google.de/intl/de/policies/terms/regional.html")]),_vm._v("\n        einsehen, die zusätzlichen Nutzungsbedingungen für Google Maps finden Sie unter\n        "),_c('a',{attrs:{"href":"https://www.google.com/intl/de_US/help/terms_maps.html"}},[_vm._v("https://www.google.com/intl/de_US/help/terms_maps.html")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("XIV. Eingebettete YouTube-Videos")]),_vm._v(" "),_c('p',[_vm._v("\n        Auf einigen unserer Webseiten betten wir Youtube-Videos ein. Betreiber der entsprechenden Plugins ist die\n        YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. Wenn Sie eine Seite mit dem YouTube-Plugin besuchen,\n        wird eine Verbindung zu Servern von Youtube hergestellt. Dabei wird Youtube mitgeteilt, welche Seiten Sie\n        besuchen. Wenn Sie in Ihrem Youtube-Account eingeloggt sind, kann Youtube Ihr Surfverhalten Ihnen persönlich\n        zuzuordnen. Dies verhindern Sie, indem Sie sich vorher aus Ihrem Youtube-Account ausloggen.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Wird ein Youtube-Video gestartet, setzt der Anbieter Cookies ein, die Hinweise über das Nutzerverhalten sammeln.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Wer das Speichern von Cookies für das Google-Ad-Programm deaktiviert hat, wird auch beim Anschauen von\n        Youtube-Videos mit keinen solchen Cookies rechnen müssen. Youtube legt aber auch in anderen Cookies\n        nicht-personenbezogene Nutzungsinformationen ab. Möchten Sie dies verhindern, so müssen Sie das Speichern\n        von Cookies im Browser blockieren.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Die Nutzung von YouTube erfolgt auf Grundlage von Art. 6 Abs. 1 S. 1 lit. a) DS-GVO; die Einwilligung ist\n        jederzeit widerrufbar.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Weitere Informationen zum Datenschutz bei „Youtube\" finden Sie in der Datenschutzerklärung des Anbieters unter:\n        "),_c('a',{attrs:{"href":"https://policies.google.com/privacy?hl=de"}},[_vm._v("https://policies.google.com/privacy?hl=de")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("XV. Änderung unserer Datenschutzbestimmungen")]),_vm._v(" "),_c('p',[_vm._v("\n        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen\n        Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z.B.\n        bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung. Die\n        aktuelle Datenschutzerklärung ist auf dem Stand des 14.07.2021.\n      ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("XVI. Fragen zum Datenschutz")]),_vm._v(" "),_c('p',[_vm._v("\n        Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail an info@codecamp-n.com oder wenden\n        Sie sich direkt an den von uns bestellten Datenschutzbeauftragten unter den oben genannten Kontaktdaten.\n      ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0pqe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.$t('message.terms.title'),"icon":''}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("Nutzungsbedingungen digitaler Vertragsmanager")]),_vm._v(" "),_c('li',[_c('a',{staticClass:"ref",attrs:{"href":"#first"}},[_vm._v("§ 1. Geltungsbereich")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"ref",attrs:{"href":"#second"}},[_vm._v("§ 2. Registrierung durch den Nutzer")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"ref",attrs:{"href":"#third"}},[_vm._v("§ 3. Leistungen digitaler Vertragsmanager")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"ref",attrs:{"href":"#fourth"}},[_vm._v("§ 4. Pflichten des Nutzers")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"ref",attrs:{"href":"#fifth"}},[_vm._v("§ 5. Haftung")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"ref",attrs:{"href":"#sixth"}},[_vm._v("§ 6. Urheberrechte")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"ref",attrs:{"href":"#seventh"}},[_vm._v("§ 7. Schlussbestimmungen")])])]),_vm._v(" "),_c('h1',{attrs:{"id":"first"}},[_vm._v("§ 1. Geltungsbereich")]),_vm._v(" "),_c('p',[_vm._v("(1) Diese Nutzungsbedingungen\n        sind Allgemeine Geschäftsbedingungen (im Folgenden “AGB”) und gelten für alle Nutzer\n        der Webseite "),_c('a',{attrs:{"href":"http://www.meine-vertraege.net"}},[_vm._v("www.meine-vertraege.net")]),_vm._v(" (im Folgenden “digitaler\n        Vertragsmanager”). Maßgebend\n        ist die jeweils bei Registrierung (§ 2) gültige Fassung der AGB.")]),_vm._v(" "),_c('p',[_vm._v("(2) Betreiber des digitalen\n        Vertragsmanagers ist CodeCamp:N GmbH, Solgerstr. 18,\n        90429 Nürnberg (im Folgenden „CodeCamp:N“).\n\n      ")]),_vm._v(" "),_c('p',[_vm._v("(3) Nutzer sind\n        natürliche Personen, die nach § 2 registriert wurden.\n\n      ")]),_vm._v(" "),_c('p',[_vm._v("(4) Abweichende\n        Bedingungen des Nutzers akzeptieren wir, also CodeCamp:N,\n        nicht. Dies gilt auch, wenn wir der Einbeziehung nicht ausdrücklich\n        widersprechen.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(5) Die Dienstleistung\n        der CodeCamp:N im Rahmen des digitalen\n        Vertragsmanagers stellt eine Geschäftsbesorgung nach §§ 675, 611 BGB dar.\n      ")]),_vm._v(" "),_c('h1',{attrs:{"id":"second"}},[_vm._v("§ 2. Registrierung durch den Nutzer\n      ")]),_vm._v(" "),_c('p',[_vm._v("(1) Nutzer des digitalen\n        Vertragsmanagers können ausschließlich nur solche sein, die zugleich eine versicherte Personen der\n        Bestattungsvorsorgeversicherung\n        der NÜRNBERGER Lebensversicherung AG sind. Soweit der Versicherungsnehmer und\n        die versicherte Person sich unterscheiden, ist ausschließlich die versicherte\n        Person berechtigt, die Registrierung durchzuführen.")]),_vm._v(" "),_c('p',[_vm._v("(2) Der Nutzer\n        registriert sich nach Abschluss der Bestattungsvorsorgeversicherung unter\n        Angabe von Vor-, Nachname, E-Mail-Adresse und Versicherungsnummer bei der\n        NÜRNBERGER Lebensversicherung AG erstmalig auf der Internetseite des digitalen\n        Vertragsmanagers unter "),_c('a',{attrs:{"href":"http://www.meine-vertraege.net"}},[_vm._v("www.meine-vertraege.net")]),_vm._v(". Daraufhin prüft\n        CodeCamp:N,\n        ob der Nutzer über eine Bestattungsvorsorgeversicherung bei der NÜRNBERGER\n        Lebensversicherung AG verfügt. Wenn dem so ist, wird CodeCamp:N\n        die Registrierung bestätigen und den Nutzer legitimieren. Andernfalls wird der\n        Nutzer durch CodeCamp:N darauf hingewiesen, dass eine\n        Legitimierung fehlgeschlagen ist und sein Konto gelöscht wird. Ein wirksamer\n        Vertrag zwischen dem Nutzer und CodeCamp:N über die\n        Nutzung des digitalen Vertragsmanagers kommt nur dann zustande, wenn CodeCamp:N\n        die Registrierung bestätigt.")]),_vm._v(" "),_c('h1',{attrs:{"id":"third"}},[_vm._v("§ 3. Leistungen digitaler Vertragsmanager\n      ")]),_vm._v(" "),_c('p',[_vm._v("(1) Der digitale\n        Vertragsmanager ermöglicht die Erfassung von Verträgen des Nutzers unter "),_c('a',{attrs:{"href":"http://www.meine-vertraege.net"}},[_vm._v("www.meine-vertraege.net")]),_vm._v("<, indem Informationen über den jeweiligen\n        Vertrag durch den Nutzer gespeichert werden können. Diese Informationen über die erfassten\n        Verträge können vom Nutzer jederzeit eingesehen und geändert werden (Vertragsverwaltung).\n        "),_c('b',[_vm._v("Vertragsdaten beim jeweiligen\n          Vertragspartner des Nutzers können über den digitalen Vertragsmanager nicht\n          geändert werden.")])]),_vm._v(" "),_c('p',[_vm._v("(2) Des Weiteren kann der\n        Nutzer seine Wohnadresse/n erfassen und verwalten (Adressverwaltung). Jeder\n        gespeicherte Vertrag nach § 3 Abs. 1 kann somit einer Wohnadresse des Nutzers zugeordnet\n        werden.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(3) Im Übrigen kann der\n        Nutzer eine oder mehrere Kontaktpersonen unter Angabe von Namen, Anschriften\n        und E-Mail-Adressen speichern. Die vom Nutzer jeweils bestimmte Kontaktpersonen\n        erhalten nach dem Versterben des Nutzers ein Leserecht auf die gespeicherten Verträge\n        des Nutzers, soweit der Nutzer der jeweiligen Kontaktperson einzelne Verträge\n        zugewiesen hat. Der Nutzer hat die Möglichkeit, das Leserecht der Kontaktperson\n        auf bestimmte Verträge zu beschränken.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(4) Wenn CodeCamp:N über die Kontaktperson oder auf andere Weise die\n        Meldung erhält, dass der Nutzer verstorben ist, so wird CodeCamp:N daraufhin\n        die Vertragspartner des Nutzers, der jeweils gespeicherten Verträge über den\n        Tod des Nutzers informieren. Die Meldung über den Tod des Nutzers hat in\n        nachweisbarer Form zu erfolgen, d. h. der Nachweis gilt für CodeCamp:N\n        als erbracht, wenn CodeCamp:N das Original oder eine Kopie einer Sterbeurkunde\n        erhält und diese verifizieren konnte. Außerdem werden die Informationen über\n        die gespeicherten Verträge des Nutzers im digitalen Vertragsmanager nach dem\n        Tod des Nutzers eingefroren, d. h. die Informationen können von niemandem mehr (auch\n        nicht von einer leseberechtigten Kontaktperson) verändert werden.")]),_vm._v(" "),_c('p',[_vm._v("(5) Erben des\n        verstorbenen Nutzers, die sich bei CodeCamp:N melden\n        und sich als Erben legitimieren können (z.B. durch Vorlage eines Erbscheins),\n        erhalten zusätzlich ein Leserecht auf alle vom Nutzer gespeicherten Verträge,\n        soweit sie nicht bereits als Kontaktperson über ein Leserecht verfügen.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(6) "),_c('b',[_vm._v("Die Information, die von CodeCamp:N gegenüber\n        dem Vertragspartner des Nutzers erfolgt, ist lediglich eine Information und\n        führt zu keinerlei rechtlichen Wirkung wie etwa einer Vertragsänderung oder\n        Vertragskündigung.")]),_vm._v(" Die Information erfolgt gemäß den Vorgaben des\n        Nutzers (insbesondere Adressat der Information). CodeCamp:N\n        prüft diese Vorgaben nicht auf ihre Richtigkeit.\n      ")]),_vm._v(" "),_c('h1',{attrs:{"id":"fourth"}},[_vm._v("§ 4. Pflichten des Nutzers\n      ")]),_vm._v(" "),_c('p',[_vm._v("(1) Der Nutzer ist\n        verpflichtet, vollständige und richtige Informationen und Daten im digitalen\n        Vertragsmanager einzugeben. Sollte der Nutzer vorsätzlich falsche Angaben\n        machen, behält sich CodeCamp:N vor, den Nutzer von der\n        Nutzung des digitalen Vertragsmanagers auszuschließen und/oder ggf. Schadensersatz\n        zu verlangen.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(2) CodeCamp:N\n        ist nicht verpflichtet, die Informationen des Nutzers im digitalen\n        Vertragsmanagers auf Ihre Richtigkeit und Vollständigkeit zu prüfen. Außerdem\n        übernimmt CodeCamp:N keine Verpflichtung diese\n        Information zu aktualisieren. Die Pflicht zur Pflege dieser Informationen,\n        insbesondere jedoch nicht abschließend die Prüfung auf die Richtigkeit,\n        Vollständigkeit sowie die Aktualität der Informationen, obliegt dem Nutzer.\n      ")]),_vm._v(" "),_c('h1',{attrs:{"id":"fifth"}},[_vm._v("§ 5. Haftung")]),_vm._v(" "),_c('p',[_vm._v("(1) CodeCamp:N\n        haftet nicht für die Richtigkeit und Vollständigkeit der vom Nutzer eingegebenen\n        Informationen und Daten. CodeCamp:N haftet dem Nutzer\n        gegenüber nur in Fällen vertraglicher und außervertraglicher Pflichtverletzung\n        soweit Vorsatz und grobe Fahrlässigkeit vorliegt.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(2) In sonstigen Fällen\n        haftet CodeCamp:N– soweit in Abs. 3 nicht abweichend\n        geregelt – nur bei Verletzung einer Vertragspflicht, deren Erfüllung die\n        ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf\n        deren Einhaltung der Nutzer regelmäßig vertrauen darf (so genannte\n        Kardinalpflicht), und zwar beschränkt auf den Ersatz des vorhersehbaren und\n        typischen Schadens. In allen übrigen Fällen ist die Haftung vorbehaltlich der\n        Regelung in Abs. 3 ausgeschlossen.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(3) Die Nutzung des\n        digitalen Vertragsmanagers im Wege des Internets erfolgt auf eigene Gefahr des\n        Nutzers. CodeCamp:N haftet nicht für den technisch\n        bedingten Ausfall des Internets bzw. des Zugangs zum Internet.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(4) CodeCamp:N\n        übernimmt die Haftung für die Inhalte seiner Webseite gemäß den gesetzlichen\n        Bestimmungen. Eine Gewähr für Richtigkeit und Vollständigkeit der Information\n        wird nicht übernommen. Verweise und Links auf Webseiten Dritter bedeuten nicht,\n        dass sich CodeCamp:N die hinter dem Verweis oder Link\n        liegenden Inhalte zu eigen macht. Die Inhalte begründen keine Verantwortung von\n        CodeCamp:N für die dort bereit gehaltenen Daten und\n        Informationen. CodeCamp:N hat keinen Einfluss auf die\n        hinter dem Link liegenden Inhalte. Für rechtswidrige, fehlerhafte oder\n        unvollständige Inhalte und für Schäden, die aufgrund der Nutzung von einem\n        hinter dem Link liegenden Inhalt verursacht worden sind, haftet CodeCamp:N daher nicht.")]),_vm._v(" "),_c('h1',{attrs:{"id":"sixth"}},[_vm._v("§ 6. Urheberrechte")]),_vm._v(" "),_c('p',[_vm._v("(1) Der digitale\n        Vertragsmanager beinhaltet Daten und Informationen aller Art, die marken-\n        und/oder urheberrechtlich zugunsten CodeCamp:N oder im\n        Einzelfall auch zugunsten Dritter geschützt sind. Es ist daher nicht gestattet,\n        den digitalen Vertragsmanager als Webseite im Ganzen oder einzelne Teile davon\n        herunterzuladen, zu vervielfältigen und/oder zu verbreiten. Gestattet ist die\n        technisch bedingte Vervielfältigung zum Zwecke des Browsing, soweit diese\n        Handlung keinen wirtschaftlichen Zwecken dient, sowie die dauerhafte\n        Vervielfältigung für den eigenen Gebrauch.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(2) Eine Verwendung der\n        Bilder, Filme und Texte des digitalen Vertragsmanagers ist ohne ausdrückliche\n        Zustimmung der CodeCamp:N nicht gestattet.\n      ")]),_vm._v(" "),_c('h1',{attrs:{"id":"seventh"}},[_vm._v("§ 7. Schlussbestimmungen")]),_vm._v(" "),_c('p',[_vm._v("(1) Es gilt das Recht der\n        Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(2) Sollten\n        einzelne oder mehrere Bestimmungen ganz oder teilweise unwirksam sein oder\n        werden, so wird hiervon die Gültigkeit der übrigen Bestimmungen nicht berührt.\n        Gleiches gilt im Fall einer Regelungslücke. CodeCamp:N\n        und Nutzer werden, sofern möglich, die unwirksame bzw. fehlende Klausel durch\n        eine wirksame Klausel ersetzen, die dem Sinn und Zweck der unwirksamen bzw.\n        fehlenden Klausel am nächsten kommt.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(3) Gerichtsstand für\n        sämtliche Streitigkeiten aus oder im Zusammenhang mit diesen AGB ist Nürnberg.\n      ")]),_vm._v(" "),_c('p',[_vm._v("(4) CodeCamp:N\n        behält sich das Recht vor, diese AGB – soweit erforderlich – zu modifizieren\n        und sie der technischen sowie rechtlichen Entwicklung anzupassen. Der Nutzer wird\n        auf die Veränderung hingewiesen. Im Falle der Unwirksamkeit einzelner\n        Regelungen dieser AGB bleibt die Wirksamkeit im Übrigen unberührt (vgl. § 8\n        Abs. 2).\n      ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "12l7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.$t('message.adminContractPartnerList.title'),"icon":"ti-agenda"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0",attrs:{"title":_vm.$t('message.adminContractPartnerList.card.title.contractPartners')}},[_c('b-table',{attrs:{"striped":"","hover":"","responsive":"","fields":_vm.fields,"items":_vm.contractPartners},scopedSlots:_vm._u([{key:"address",fn:function(data){return [_c('address',[_c('div',[_vm._v(_vm._s(data.item.street)+" "+_vm._s(data.item.streetNumber))]),_vm._v(" "),_c('div',[(data.item.postalCode)?_c('span',[_vm._v(_vm._s(data.item.postalCode))]):_c('span',[_vm._v(_vm._s(data.item.postOfficeBox))]),_vm._v("\n                "+_vm._s(data.item.city)+"\n              ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(data.item.country))])])]}},{key:"actions",fn:function(data){return [_c('div',{staticClass:"d-flex flex-row"},[_c('b-btn',{staticClass:"ml-auto btn-action",attrs:{"variant":"link"},on:{"click":function($event){_vm.showDetails(data)}}},[_c('span',{staticClass:"ti-files"})])],1)]}}])})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0",attrs:{"title":_vm.$t('message.adminContractPartnerList.card.title.contractPartnerTemplates')}},[_c('b-table',{attrs:{"striped":"","hover":"","responsive":"","fields":_vm.fields,"items":_vm.contractPartnerTemplates},scopedSlots:_vm._u([{key:"address",fn:function(data){return [_c('address',[_c('div',[_vm._v(_vm._s(data.item.street)+" "+_vm._s(data.item.streetNumber))]),_vm._v(" "),_c('div',[(data.item.postalCode)?_c('span',[_vm._v(_vm._s(data.item.postalCode))]):_c('span',[_vm._v(_vm._s(data.item.postOfficeBox))]),_vm._v("\n                "+_vm._s(data.item.city)+"\n              ")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(data.item.country))])])]}},{key:"actions",fn:function(data){return [_c('div',{staticClass:"d-flex flex-row"},[_c('div',{staticClass:"ml-auto"},[_c('b-btn',{staticClass:"btn-action",attrs:{"variant":"link"},on:{"click":function($event){_vm.showContractPartnerTemplate(data)}}},[_c('span',{staticClass:"ti-pencil-alt"})])],1)])]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Pwh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{staticClass:"p-5",attrs:{"variant":"danger","dismissible":"","show":_vm.error.isVisible},on:{"dismissed":function($event){_vm.error.isVisible=false}}},[_vm._v("\n    "+_vm._s(_vm.error.message)+"\n  ")]),_vm._v(" "),_c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v(_vm._s(_vm.$t('message.resetPassword.title')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('message.resetPassword.message')))]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.email.$error ? false : null,"invalid-feedback":_vm.invalidEmail}},[_c('b-form-input',{attrs:{"placeholder":_vm.$t('message.resetPassword.input.email.placeholder'),"state":_vm.$v.email.$error ? false : null},on:{"change":function($event){_vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-btn',{attrs:{"variant":"link"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('message.resetPassword.btn.back')))])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary","type":"submit"}},[_vm._v(_vm._s(_vm.$t('message.resetPassword.btn.send')))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1UH2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactPersonDetails_vue__ = __webpack_require__("6Y8p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb4ea85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactPersonDetails_vue__ = __webpack_require__("944s");
function injectStyle (ssrContext) {
  __webpack_require__("+SL1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactPersonDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb4ea85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactPersonDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1b5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.authData.email = to.query.email;
    });
  },
  created: function created() {
    this.signInAttempts = 0;
  },

  computed: {
    autoLogout: function autoLogout() {
      return this.$store.getters.autoLogout;
    }
  },
  data: function data() {
    return {
      authData: {
        email: null,
        password: null
      },
      signInAttempts: 0
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('signIn', this.authData).then(function () {
          if (_this.$route.query.redirect) {
            _this.$router.replace(_this.$route.query.redirect);
          } else {
            _this.$router.replace('/');
          }
        }).catch(function (error) {
          if (error.response !== undefined) {
            if (error.response.data.errorCode === 'USER_DECLARED_DEAD') {
              return _this.showErrorMsg({
                message: _this.$t('error.signIn.death')
              });
            } else {
              return _this.showErrorMsg({
                message: _this.$t('error.signIn.error')
              });
            }
          } else {
            if (error.code === 'UserNotConfirmedException') {
              _this.$router.push({ path: '/signup/confirm', query: { email: _this.authData.email } });
            }
            if (_this.signInAttempts === 3) {
              // TODO send email for 3 wrong sign in attempts
            }
            _this.signInAttempts += 1;
            return _this.showErrorMsg({
              message: _this.$t('error.signIn.submit')
            });
          }
        });
      }
    }
  },
  validations: {
    authData: {
      email: {
        email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"],
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      }
    }
  },
  notifications: {
    showErrorMsg: {
      type: 'error'
    }
  }
});

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2AZw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContractPartnerList_vue__ = __webpack_require__("GRDY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365ab179_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContractPartnerList_vue__ = __webpack_require__("12l7");
function injectStyle (ssrContext) {
  __webpack_require__("RUcB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-365ab179"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContractPartnerList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365ab179_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContractPartnerList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2AxU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminUserStatus__ = __webpack_require__("DynV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_BusinessCard__ = __webpack_require__("ReR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_AdminUserAddress__ = __webpack_require__("9cxb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_AdminUserContactPerson__ = __webpack_require__("vhM7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_AdminUserInvitation__ = __webpack_require__("87nF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_AdminContractsCard__ = __webpack_require__("gh8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_AdminUserDocuments__ = __webpack_require__("6Dj1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_HeaderView__ = __webpack_require__("AE0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__("L/hj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminUserDetail',
  components: {
    AdminUserAddress: __WEBPACK_IMPORTED_MODULE_2__components_admin_AdminUserAddress__["a" /* default */],
    AdminUserContactPerson: __WEBPACK_IMPORTED_MODULE_3__components_admin_AdminUserContactPerson__["a" /* default */],
    AdminUserInvitation: __WEBPACK_IMPORTED_MODULE_4__components_admin_AdminUserInvitation__["a" /* default */],
    AdminContractsCard: __WEBPACK_IMPORTED_MODULE_5__components_admin_AdminContractsCard__["a" /* default */],
    AdminUserDocuments: __WEBPACK_IMPORTED_MODULE_6__components_admin_AdminUserDocuments__["a" /* default */],
    AdminUserStatus: __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminUserStatus__["a" /* default */],
    BusinessCard: __WEBPACK_IMPORTED_MODULE_1__components_common_BusinessCard__["a" /* default */],
    HeaderView: __WEBPACK_IMPORTED_MODULE_7__components_common_HeaderView__["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var id = parseInt(to.params.id);
      vm.$store.dispatch('fetchUserById', id).then(function () {
        var user = vm.$store.getters.userById;
        if (!user || user.id !== id) {
          next('/admin/users');
        }
      });
      vm.$store.dispatch('fetchAdminContracts', id);
      vm.$store.dispatch('fetchAdminContactPersons', id).catch(function () {});
    });
  },

  computed: {
    contractCategories: function contractCategories() {
      var _this = this;

      return this.$store.getters.contractCategories.map(function (category) {
        return {
          value: category,
          text: _this.$t('enums.contractCategories.' + category)
        };
      });
    },
    name: function name() {
      return this.user.salutation ? this.$t('enums.salutations.' + this.user.salutation) + ' ' + this.user.firstName + ' ' + this.user.lastName : '';
    },
    roles: function roles() {
      if (this.user.roles) {
        return __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].getTranslatedRoles(this, this.user.roles).join(', ');
      }
    },
    user: function user() {
      return this.$store.getters.userById;
    }
  },
  methods: {
    getContractsByCategory: function getContractsByCategory(category) {
      return this.$store.getters.adminContracts.filter(function (contract) {
        return contract.contractCategory === category;
      });
    }
  }
});

/***/ }),

/***/ "2tAM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.contractPartnerName)?_c('b',[_vm._v("\n    "+_vm._s(_vm.item.contractPartnerName)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.item.id !== -1 && _vm.item.contractPartnerName !== 'Neuen Vertragspartner anlegen')?_c('address',[_c('div',[_vm._v(_vm._s(_vm.item.street)+" "+_vm._s(_vm.item.streetNumber))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.item.postalCode + ', ' + _vm.item.city))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2vMh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.title,"icon":'ti-user'}})],1)],1),_vm._v(" "),_c('business-card',{staticClass:"rounded-0 h-100",attrs:{"name":_vm.policyHolder.firstName + ' ' + _vm.policyHolder.lastName,"relation":_vm.$t('enums.relationTypes.' + _vm.policyHolder.relationshipType),"email":_vm.policyHolder.email,"imageSrc":_vm.policyHolder.avatarUuid,"showIcon":!!_vm.policyHolder.dateOfDeath,"dateOfDeath":_vm.policyHolder.dateOfDeath,"variant":"noHover"}},[_c('div',{attrs:{"slot":"bcFooter"},slot:"bcFooter"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row"},[_c('b-badge',{staticClass:"p-2 mr-2"},[_vm._v("\n                "+_vm._s(_vm.policyHolder.numberOfAssignedContracts)+"\n              ")]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.getNumberOfAssignedContractsText(_vm.policyHolder))+"\n              ")])],1)])]),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[(!this.$store.getters.policyHolderContracts)?_c('b-card',{staticClass:"rounded-0"},[_c('p',[_vm._v(_vm._s(_vm.$t('message.policyHolderDetails.infoText', { policyHolderName: _vm.policyHolderName })))])]):_vm._e(),_vm._v(" "),(this.$store.getters.policyHolderContracts)?_c('b-card',{staticClass:"rounded-0"},[_c('p',[_vm._v(_vm._s(_vm.$t('message.policyHolderDetails.infoText2', { policyHolderName: _vm.policyHolderName })))])]):_vm._e(),_vm._v(" "),(this.$store.getters.policyHolderContracts)?_c('policy-holder-contracts'):_vm._e(),_vm._v(" "),(!_vm.codOrCoiApproved)?_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('h6',[_vm._v(_vm._s(_vm.$t('message.policyHolderDetails.reportDeath', { policyHolderName: _vm.policyHolderName })))])])],1):_vm._e(),_vm._v(" "),_c('b-row',{class:[_vm.codOrCoiApproved ? 'mt-4' : 'mt-2']},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',{staticClass:"rounded-0"},[_vm._v("\n            "+_vm._s(_vm.$t('message.policyHolderDetails.certificateOfDeath'))+"\n            "),(_vm.loadingCertificateOfDeath)?_c('spinner',{attrs:{"size":"80","line-size":12,"line-fg-color":"grey","line-bg-color":"lightgrey","speed":1.5}}):_vm._e(),_vm._v(" "),(!_vm.certificateOfDeath && !_vm.loadingCertificateOfDeath)?_c('b-form-file',{ref:"certificateOfDeath",staticClass:"rounded-0 mt-4",attrs:{"accept":"application/pdf, image/*"},on:{"change":_vm.uploadCertificateOfDeath},model:{value:(_vm.certificateOfDeath),callback:function ($$v) {_vm.certificateOfDeath=$$v},expression:"certificateOfDeath"}}):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.certificateOfDeath && !_vm.loadingCertificateOfDeath)?_c('b-btn',{staticClass:"p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate",attrs:{"variant":"transparent"},on:{"click":_vm.printCertificateOfDeath}},[_c('b-alert',{staticClass:"rounded-0 certificate pb-0 mb-0",attrs:{"show":"","variant":"dark"}},[_c('p',[_c('span',{staticClass:"ti-printer mr-2"}),_vm._v("\n                      "+_vm._s(_vm.$t('message.policyHolderDetails.certificateOfDeathMessage'))+"\n                    ")]),_vm._v(" "),(!_vm.codApproved)?_c('p',{staticClass:"text-left"},[_vm._v("\n                      "+_vm._s(_vm.$t('message.policyHolderDetails.certificateOfDeathEnable', { policyHolderName:
                      _vm.policyHolderName
                      }))+"\n                    ")]):_vm._e()])],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right"},[(_vm.certificateOfDeath && !_vm.loadingCertificateOfDeath && _vm.isCodOwner && !_vm.codApproved)?_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.delete_cod",modifiers:{"delete_cod":true}}],staticClass:"mt-3",attrs:{"variant":"danger"}},[_vm._v("\n                  "+_vm._s(_vm.$t('message.policyHolderDetails.deleteDocument'))+"\n                ")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-card',{staticClass:"rounded-0"},[_vm._v("\n            "+_vm._s(_vm.$t('message.policyHolderDetails.certificateOfInheritance'))+"\n            "),(_vm.loadingCertificateOfInheritance)?_c('spinner',{attrs:{"size":"80","line-size":12,"line-fg-color":"grey","line-bg-color":"lightgrey","speed":1.5}}):_vm._e(),_vm._v(" "),(!_vm.certificateOfInheritance && !_vm.loadingCertificateOfInheritance)?_c('b-form-file',{ref:"certificateOfInheritance",staticClass:"rounded-0 mt-4",attrs:{"accept":"application/pdf"},on:{"change":_vm.uploadCertificateOfInheritance},model:{value:(_vm.certificateOfInheritance),callback:function ($$v) {_vm.certificateOfInheritance=$$v},expression:"certificateOfInheritance"}}):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.certificateOfInheritance && !_vm.loadingCertificateOfInheritance)?_c('b-btn',{staticClass:"p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate",attrs:{"variant":"transparent"},on:{"click":_vm.printCertificateOfInheritance}},[_c('b-alert',{staticClass:"rounded-0 certificate pb-0 mb-0",attrs:{"show":"","variant":"dark"}},[_c('p',[_c('span',{staticClass:"ti-printer mr-2"}),_vm._v("\n                      "+_vm._s(_vm.$t('message.policyHolderDetails.certificateOfInheritanceMessage'))+"\n                    ")]),_vm._v(" "),(!_vm.coiApproved)?_c('p',{staticClass:"text-left"},[_vm._v("\n                      "+_vm._s(_vm.$t('message.policyHolderDetails.certificateOfInheritanceEnable',
                      { policyHolderName: _vm.policyHolderName }))+"\n                    ")]):_vm._e()])],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right"},[(_vm.certificateOfInheritance  && !_vm.loadingCertificateOfInheritance && !_vm.coiApproved)?_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.delete_coi",modifiers:{"delete_coi":true}}],staticClass:"mt-3",attrs:{"variant":"danger"}},[_vm._v("\n                  "+_vm._s(_vm.$t('message.policyHolderDetails.deleteDocument'))+"\n                ")]):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"delete_cod","cancel-variant":"primary","ok-variant":"danger","title":_vm.$t('message.policyHolderDetails.modal.title'),"ok-title":_vm.$t('message.policyHolderDetails.modal.ok'),"cancel-title":_vm.$t('message.policyHolderDetails.modal.cancel')},on:{"ok":_vm.deleteCertificateOfDeath}},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.policyHolderDetails.modal.message')))])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"delete_coi","cancel-variant":"primary","ok-variant":"danger","title":_vm.$t('message.policyHolderDetails.modal.title'),"ok-title":_vm.$t('message.policyHolderDetails.modal.ok'),"cancel-title":_vm.$t('message.policyHolderDetails.modal.cancel')},on:{"ok":_vm.deleteCertificateOfInheritance}},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.policyHolderDetails.modal.message')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3K5H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ti_icons_SVG_user_svg__ = __webpack_require__("obC3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ti_icons_SVG_user_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ti_icons_SVG_user_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      required: true
    },
    relation: {
      type: String
    },
    contractNumber: {
      type: String
    },
    createdAt: {
      type: String
    },
    dateOfBirth: {
      type: String
    },
    dateOfDeath: {
      type: String
    },
    email: {
      type: String
    },
    phone: {
      type: String
    },
    roles: {
      type: String
    },
    status: {
      type: String
    },
    imageSrc: {
      type: String
    },
    size: {
      type: String
    },
    userTitle: {
      type: String
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: function _default() {
        return 'bCardHover';
      }
    }
  },
  computed: {
    getStyle: function getStyle() {
      if (this.variant === 'noHover') {
        return {
          class: 'noHover'
        };
      } else {
        return {
          class: 'bCardHover'
        };
      }
    },
    businessCardStyle: function businessCardStyle() {
      var styleClass = '';
      if (this.size && this.size === 'sm') {
        styleClass = 'business-card__sm';
      }
      styleClass = styleClass + ' ' + this.getStyle.class;
      return styleClass;
    },
    businessCardImageWidth: function businessCardImageWidth() {
      if (this.size && this.size === 'sm') {
        return 100;
      }
      return 150;
    },
    businessCardImageHeight: function businessCardImageHeight() {
      if (this.size && this.size === 'sm') {
        return 100;
      }
      return 150;
    },
    createdAtFormatted: function createdAtFormatted() {
      return this.createdAt ? this.$moment(this.createdAt, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
    },
    dateOfBirthFormatted: function dateOfBirthFormatted() {
      return this.dateOfBirth ? this.$moment(this.dateOfBirth, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
    },
    dateOfDeathFormatted: function dateOfDeathFormatted() {
      return this.dateOfDeath ? this.$moment(this.dateOfDeath, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
    },
    source: function source() {
      return this.imageSrc ? "https://meine-vertraege.net:8080" + 'avatars/' + this.imageSrc : __WEBPACK_IMPORTED_MODULE_0_ti_icons_SVG_user_svg___default.a;
    }
  }
});

/***/ }),

/***/ "3L2t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_address_AddressForm__ = __webpack_require__("Sm2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Infobox__ = __webpack_require__("AHrk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_home__ = __webpack_require__("8AWp");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddressForm: __WEBPACK_IMPORTED_MODULE_1__components_address_AddressForm__["a" /* default */],
    Infobox: __WEBPACK_IMPORTED_MODULE_2__components_common_Infobox__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon__["a" /* default */]
  },
  computed: {
    addresses: function addresses() {
      return this.$store.getters.addresses;
    },
    addressInfo: function addressInfo() {
      if (this.isPolicyHolder) {
        return this.$t('message.addressList.addressInfo.policyHolder');
      } else if (this.isContactPerson) {
        return this.$t('message.addressList.addressInfo.contactPerson');
      }
    },
    isContactPerson: function isContactPerson() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesContactPerson = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'CONTACT_PERSON';
        });
        if (rolesContactPerson.length > 0) {
          return true;
        }
      }
      return false;
    },
    isPolicyHolder: function isPolicyHolder() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesPolicyHolder = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'POLICY_HOLDER';
        });
        if (rolesPolicyHolder.length > 0) {
          return true;
        }
      }
      return false;
    }
  },
  data: function data() {
    return {
      isEditable: false,
      newAddress: null,
      selectedAddress: null
    };
  },
  created: function created() {
    this.$store.dispatch('fetchAddresses');
  },

  methods: {
    getTitle: function getTitle(_address) {
      return _address.street + ' ' + _address.streetNumber;
    },
    cancel: function cancel() {
      this.isEditable = false;
    },
    deleteAddress: function deleteAddress() {
      var _this = this;

      var deletionId = this.selectedAddress.id;
      if (deletionId !== null && deletionId !== undefined) {
        this.$store.dispatch('deleteAddressById', deletionId).then(function () {
          _this.showSuccessMsg({
            message: _this.$t('message.addressDetails.deleteAddress')
          });
          _this.$store.dispatch('fetchAddresses');
          _this.selectedAddress = null;
        }).catch(function () {
          _this.showErrorMsg({
            message: _this.$t('error.addressDetails.deleteAddress')
          });
          _this.selectedAddress = null;
        });
      }
    },
    editAddress: function editAddress(_address) {
      this.setCurrentAddress(_address);
      this.isEditable = true;
    },
    setCurrentAddress: function setCurrentAddress(_address) {
      this.selectedAddress = _address;
    },
    getCurrentAddress: function getCurrentAddress() {
      return this.selectedAddress;
    },
    getMessage: function getMessage(address) {
      if (!this.isPolicyHolder) {
        return '';
      }
      return address.numberOfContracts === 1 ? this.$t('message.addressList.infobox.messageSingle') : this.$t('message.addressList.infobox.message', { numberOfContracts: address.numberOfContracts });
    },
    getSubtitle: function getSubtitle(address) {
      return address.postalCode + ' ' + address.city;
    },
    saveAddress: function saveAddress() {
      var _this2 = this;

      this.$store.dispatch('updateAddress', this.selectedAddress).then(function () {
        _this2.showSuccessMsg({
          message: _this2.$t('message.addressDetails.saveAddress')
        });
        _this2.isEditable = false;
        _this2.selectedAddress = null;
      }).catch(function () {
        _this2.showErrorMsg({
          message: _this2.$t('error.addressDetails.saveAddress')
        });
        _this2.selectedAddress = null;
      });
    }
  },

  notifications: {
    showSuccessMsg: {
      type: 'success'
    },
    showErrorMsg: {
      type: 'error'
    }
  }
});

/***/ }),

/***/ "6Dj1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserDocuments_vue__ = __webpack_require__("dOuy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efcd880c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserDocuments_vue__ = __webpack_require__("ABx1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserDocuments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efcd880c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserDocuments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Y8p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_BusinessCard__ = __webpack_require__("ReR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractsCard__ = __webpack_require__("hZwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_HeaderView__ = __webpack_require__("AE0Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactPersonDetails',
  components: {
    BusinessCard: __WEBPACK_IMPORTED_MODULE_0__components_common_BusinessCard__["a" /* default */],
    ContractsCard: __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractsCard__["a" /* default */],
    HeaderView: __WEBPACK_IMPORTED_MODULE_2__components_common_HeaderView__["a" /* default */]
  },
  computed: {
    contactPerson: function contactPerson() {
      return this.$store.getters.contactPerson;
    },
    contracts: function contracts() {
      return this.$store.getters.contractsByContactPerson;
    },
    name: function name() {
      return this.contactPerson.firstName + ' ' + this.contactPerson.lastName;
    },
    relationship: function relationship() {
      if (this.contactPerson.relationshipType) {
        return this.$t('enums.relationTypes.' + this.contactPerson.relationshipType);
      }
      return '';
    }
  },
  created: function created() {
    var _this = this;

    var id = parseInt(this.$route.params.id);
    if (id) {
      var filteredContactPersons = this.$store.getters.contactPersons.filter(function (contactPerson) {
        return contactPerson.id === id;
      });
      if (filteredContactPersons.length === 0) {
        this.$store.dispatch('fetchContactPersonById', id).catch(function () {
          _this.showErrorMsg({
            message: _this.$t('error.contactPersonDetails.contactPersonById')
          });
          _this.$router.replace('/contactpersons');
        });
      } else {
        this.$store.commit('setContactPerson', filteredContactPersons[0]);
      }
      this.$store.dispatch('fetchContractsByContactPerson', id).catch(function () {
        _this.showErrorMsg({
          message: _this.$t('error.contractPersonDetails.fetchContractsByContactPerson')
        });
      });
    } else {
      this.$router.replace('/contactpersons');
    }
  },

  methods: {
    deleteContactPerson: function deleteContactPerson() {
      var _this2 = this;

      this.$store.dispatch('deleteContactPerson', this.contactPerson.id).then(function () {
        _this2.showSuccessMsg({
          message: _this2.$t('message.contactPersonDetails.deleteContactPerson')
        });
        _this2.$router.push('/contactpersons');
      }).catch(function () {
        _this2.showErrorMsg({
          message: _this2.$t('error.contactPersonDetails.deleteContactPerson')
        });
      });
    },
    showDetails: function showDetails(contract) {
      this.$router.push('/contracts/' + contract.id);
    }
  },
  notifications: {
    showErrorMsg: {
      type: 'error'
    },
    showSuccessMsg: {
      type: 'success'
    }
  }
});

/***/ }),

/***/ "6tIf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var messages = {
  de: {
    enums: {
      contractCategories: {
        INSURANCE: 'Versicherung',
        FINANCE: 'Finanzen',
        HABITATION_HOUSEHOLD_AND_COMMUNICATION: 'Wohnen, Haushalt & Kommunikation',
        LEISURE_AND_CLUB: 'Freizeit & Vereine',
        SUBSCRIPTION: 'Abonnement',
        ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT: 'Online Abonnements & Social Media Accounts',
        OTHER: 'Sonstiges'
      },
      contractStatuses: {
        NOT_YET_PROCESSED: 'Noch nicht bearbeitet',
        INFORMATION_SENT: 'Informationsschreiben verschickt'
      },
      estateAdministrationTypes: {
        TRANSFER_TO_PERSON_OF_TRUST: 'An Kontaktperson übertragen',
        TERMINATE_CONTRACT: 'kündigen'
      },
      invitationStatus: {
        INVITED: 'Bestätigung ausstehend',
        INVITED_AND_REMINDER_SENT: 'Bestätigung ausstehend - Erinnerung versendet',
        REGISTERED: 'Registriert'
      },
      relationTypes: {
        SPOUSE: 'Ehepartner/in',
        COMPANION: 'Lebensgefährte/in',
        FRIEND: 'Freunde/Bekannte',
        EXTENDED_FAMILY: 'erweiterter Familienkreis',
        CHILD: 'Kind',
        SIBLING: 'Geschwister'
      },
      roles: {
        ADMIN: 'Admin',
        CONTACT_PERSON: 'Kontaktperson',
        POLICY_HOLDER: 'Versicherungsnehmer'
      },
      salutations: {
        MR: 'Herr',
        MRS: 'Frau'
      }
    },
    message: {
      accountDeactivationForm: {
        btn: {
          ok: 'Ja, löschen',
          cancel: 'Nein, abbrechen'
        },
        deactivate: 'Zur Kontodeaktivierung klicken Sie bitte {deactivateLink}',
        deactivateLink: 'hier',
        message: 'Wenn Sie fortfahren, werden alle Ihre gespeicherten Daten und Vertragsinformationen endgültig gelöscht',
        question: 'Sind Sie sicher, dass Sie Ihr Konto deaktivieren möchten?',
        title: 'Konto deaktivieren?'
      },
      accountDetails: {
        card: {
          title: {
            changeEmail: 'Email ändern',
            changePassword: 'Passwort ändern',
            deactivate: 'Konto Deaktivierung',
            powerOfAttorney: 'Meine Vollmacht'
          }
        },
        deletePowerOfAttorney: 'Ihre Vollmacht wurde erfolgreich widerrufen',
        saveChangedPassword: 'Das Passwort wurde erfolgreich geändert',
        saveChangedEmail: 'Ihre E-Mail-Adresse wurde erfolgreich geändert',
        savePersonalInfo: 'Ihre persönlichen Informationen wurden erfolgreich aktualisiert',
        title: 'Meine persönlichen Informationen'
      },
      accountPowerOfAttorneyForm: {
        btn: {
          browse: 'Durchsuchen',
          cancel: 'Nein, Abbrechen',
          ok: 'Ja, sicher',
          printPoa: 'Vollmacht',
          revokePoa: 'Vollmacht widerrufen?'
        },
        message: 'Sind Sie sicher, dass Sie Ihre Vollmacht wiederrufen möchten? Dadurch werden wir nicht mehr in der Lage sein, Ihre Vertragspartner nach Ihrem Ableben zu informieren.',
        pleaseUpload: 'Bitte laden Sie hier Ihre Vollmacht hoch. Erlaubte Formate: PDF, JPG und PNG.',
        title: 'Vollmacht widerrufen?',
        uploadSuccess: 'Vollmacht erfolgreich hochgeladen'
      },
      addressConfirmForm: {
        btn: {
          back: 'Zurück',
          submit: 'Speichern'
        },
        storeAddress: 'Die angegebene Adresse wurde erfolgreich gespeichert',
        subtitle: 'Bitte überprüfen Sie die erfassten Eingaben',
        title: 'Adresse prüfen'
      },
      addressDetails: {
        changedAdresses: 'Verträge erfolgreich geändert',
        btn: {
          back: 'Zurück',
          cancel: 'Abbrechen',
          delete: 'Löschen',
          edit: 'Bearbeiten',
          save: 'Speichern'
        },
        contractsCard: {
          title: 'Erfasste Verträge zu dieser Adresse'
        },
        deleteAddress: 'Die Adresse wurde erfolgreich gelöscht',
        modal: {
          btn: {
            cancel: 'Nein, behalten',
            ok: 'Ja, löschen'
          },
          question: 'Sind Sie sicher, dass Sie diese Adresse löschen möchten?',
          title: 'Adresse löschen'
        },
        moveBtn: 'Adresse ändern',
        moveMessage: 'Bitte wählen Sie hier, eine Adresse aus, die diesen Verträgen neu zugeordnet werden soll. Die enstprechenden Vertragspartner werden von uns via E-Mail über den Adresswechsel informiert. Parallel bekommen Sie ebenso eine PDF mit einer Liste von den betroffenen Vertragspartnern zur Einsicht.',
        moveMessageSingleAddr: 'Wir bieten Ihnen die Möglichkeit Ihre Vertragspartner über Adressänderungen zu informieren. Sie können über den Punkt “Adressen” im Navigationsbereich Ihre neue Adresse hinzufügen und im Nachgang diese auswählen um Ihre Vertragspartner über den Adresswechsel zu informieren. Ihre bereits angelegten Verträge werden sogleich der neuen Adresse zugeordnet.',
        moveTitle: 'Umzugsmitteilung',
        saveAddress: 'Die Adresse wurde erfolgreich geändert',
        title: 'Adressübersicht'
      },
      addressList: {
        addressInfo: {
          contactPerson: 'Hier können Sie Ihre derzeitige Wohnanschrift hinzufügen.',
          policyHolder: 'Hier können Sie Ihre derzeitige Wohnanschrift und etwaige Zweitwohnsitze hinzufügen. Dies wird benötigt um Ihren Vertrag zuordnen zu können und Ihrem Vertragspartner detaillierter informieren zu können.'
        },
        infobox: {
          message: '{numberOfContracts} Verträge zur Adresse',
          messageSingle: '1 Vertrag zur Adresse'
        },
        subtitle: 'Übersicht über angelegte Wohnorte',
        title: 'Adressen',
        subtitleNonPolicyHolder: 'Übersicht über Ihren angelegten Wohnort'
      },
      addressSearchForm: {
        btn: {
          submit: 'Weiter'
        },
        input: {
          placeholder: {
            autocomplete: 'Adresse, z.B. Kirchenstraße 1, Nürnberg'
          }
        },
        title: 'Neue Adresse erfassen'
      },
      addressForm: {
        label: {
          street: 'Straße',
          streetNumber: 'Hausnummer',
          additionalAddress: 'Addresszusatz',
          postalCode: 'Postleitzahl',
          city: 'Stadt',
          country: 'Land'
        }
      },
      adminContractPartnerDetails: {
        btn: {
          back: 'Zurück',
          delete: 'Löschen',
          save: 'Speichern'
        },
        label: {
          city: 'Stadt',
          country: 'Land',
          domain: 'Domain',
          email: 'E-Mail-Adresse',
          name: 'Name',
          street: 'Straße',
          streetNumber: 'Hausnummer',
          postalCode: 'Postleitzahl',
          postOfficeBox: 'Postfach'
        },
        saveContractPartner: 'Der angegebene Vertragspartner wurde erfolgreich als Template gespeichert',
        title: 'Vertragspartner',
        warning: 'ContractPartner die als Template generiert wurden, werden automatisch ins Suchfeld der Plattform übernommen.'
      },
      adminContractPartnerList: {
        card: {
          title: {
            contractPartners: 'Liste aller Vertragspartner',
            contractPartnerTemplates: 'Templates für Vertragspartner'
          }
        },
        table: {
          address: 'Adresse',
          approved: 'Geprüfte Adresse',
          email: 'E-Mail-Adresse',
          domain: 'URL / Domain',
          name: 'Name'
        },
        yes: 'Ja',
        no: 'Nein',
        title: 'Vertragspartner'
      },
      adminContractPartnerTemplateDetails: {
        deleteContractPartnerTemplate: 'Das angegebene Template wurde erfolgreich gelöscht',
        saveContractPartnerTemplate: 'Das angegebene Template wurde erfolgreich gespeichert',
        title: 'Vertragspartnertemplate'
      },
      adminUserAddress: {
        table: {
          city: 'Stadt',
          postalCode: 'PLZ',
          street: 'Straße',
          streetNumber: 'Hausnummer'
        },
        title: 'Adressen'
      },
      adminUserContactPerson: {
        table: {
          city: 'Stadt',
          confirmationStatus: 'Best. Status',
          dateOfBirth: 'Geburtsdatum',
          email: 'E-Mail',
          firstName: 'Vorname',
          heir: 'Erbe',
          lastName: 'Nachname',
          postalCode: 'PLZ',
          relation: 'Zugehörigkeit',
          street: 'Straße',
          streetNumber: 'Hausnummer'
        },
        title: 'Kontaktpersonen'
      },
      adminUserInvitation: {
        table: {
          contactPersonFirstname: 'Vorname',
          contactPersonLastname: 'Nachname',
          contactPersonEmail: 'E-Mail',
          createdAt: 'Datum',
          status: 'Status'
        },
        title: 'Einladungen'
      },
      adminContractsCard: {
        cancellationPeriod: 'Kündigungsfrist',
        conclusionDate: 'Vertragsabschluss',
        company: 'Firma',
        contractDuration: 'Vertragslaufzeit',
        contractNumber: 'Vertragsnummer',
        insuredPersonNumber: 'Kundennummer',
        insuranceNumber: 'Versicherungsnummer',
        noItems: 'Keine Daten vorhanden',
        time: {
          month: '{value} Monat',
          months: '{value} Monate'
        },
        type: 'Vertragstyp'
      },
      adminUserList: {
        isAuthorized: 'Ja',
        isNotAuthorized: 'Nein',
        perPage: 'Zeilen pro Seite',
        table: {
          id: 'ID',
          firstName: 'Vorname',
          lastName: 'Nachname',
          email: 'E-Mail-Adresse',
          dateOfBirth: 'Geburtsdatum',
          roles: 'Rollen',
          contractNumber: 'Vers.-Nr.',
          status: 'Status',
          registration: 'Registrierung',
          legitimation: 'Legitimation'
        },
        status: {
          death: 'Tot',
          alive: 'Lebend'
        },
        title: 'Nutzer'
      },
      adminUserDetail: {
        alive: 'Lebendig',
        dead: 'Tot',
        legitimation: 'Legitimation',
        no: 'Nein',
        save: 'Aktualisieren',
        status: 'Status',
        yes: 'Ja'
      },
      adminUserDocuments: {
        deleteDocument: 'Dokument entfernen',
        modal: {
          btn: {
            ok: 'Ja',
            cancel: 'Nein'
          },
          message: 'Möchten Sie das Dokument wirklich entfernen?',
          title: 'Dokument wirklich entfernen?'
        },
        noCod: 'Keine Sterbeurkunde vorhanden',
        noCoi: 'Kein Erbschein vorhanden',
        noPH: 'Kontaktpersonen haben keine Kontaktpersonen',
        uploadCod: 'Sterbeurkunde hochladen',
        uploadCoi: 'Erbschein hochladen',
        uploadPoa: 'Vollmacht hochladen',
        selectCP: 'Kontaktperson auswählen',
        viewCod: 'Sterbeurkunde einsehen',
        viewCoi: 'Erbschein einsehen',
        viewPoa: 'Vollmacht einsehen'
      },
      adminUserStatus: {
        update: {
          death: 'Sterbedatum erfolgreich aktualisiert',
          legi: 'Legitimationsstatus erfolgreich aktualisiert'
        }
      },
      accountChangeEmailForm: {
        btn: {
          save: 'Neue E-Mail-Adresse speichern'
        },
        label: {
          currentEmail: 'Alte E-Mail-Adresse',
          email: 'Neue E-Mail-Adresse',
          emailConfirm: 'Neue E-Mail-Adresse wiederholen'
        }
      },
      adminSidebar: {
        navItem: {
          account: 'Mein Account',
          dashboard: 'Übersicht',
          contractPartners: 'Vertragspartner',
          users: 'Nutzer'
        }
      },
      appHeader: {
        btn: {
          signOut: 'Abmelden'
        }
      },
      appSidebar: {
        navItem: {
          addresses: 'Adressen',
          account: 'Mein Account',
          contactPersons: 'Kontaktpersonen',
          contactPersonOf: 'Kontaktperson von:',
          contracts: 'Verträge',
          contractsOf: 'Verträge',
          dashboard: 'Übersicht',
          faq: 'Wissenswertes'
        }
      },
      avatar: {
        btn: {
          delete: 'Profilbild Löschen',
          no: 'Nein, abbrechen',
          yes: 'Ja, löschen'
        },
        default: 'Bild',
        delete: 'Bild erfolgreich gelöscht',
        maxFileDimensions: 'Hier können Sie Ihr Profilbild hochladen. Maximalgröße:',
        maxFileDimensionsValue: '{width} x {height}, 6MB',
        questionTitle: 'Profilbild löschen?',
        question: 'Sind Sie sicher, dass Sie Ihr Profilbild löschen möchten?',
        upload: 'Bild erfolgreich hochgeladen'
      },
      businessCard: {
        deceased: 'Verstorben am:',
        relation: 'Angehörigkeit:',
        status: 'Bestätigungsstatus:'
      },
      contractAddressDetails: {
        question: 'Welche Adresse ist auf diesem Vertrag angegeben?',
        noAddressHint: 'Es wurde noch keine Adresse hinzugefügt. Eine neue Adresse können Sie unter dem Navigationspunkt "Adressen" hinzufügen. An dieser Stelle können Sie den Schritt überspringen und zu einem späteren Zeitpunkt eine Adresse diesem Vertrag zuordnen.'
      },
      cookiePopup: {
        message: 'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies.\nDurch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu. Weitere Informationen zu Cookies erhalten Sie in unserer Datenschutzerklärung.',
        ok: 'OK'
      },
      changePasswordForm: {
        btn: {
          save: 'Neues Passwort speichern'
        },
        label: {
          oldPassword: 'Altes Passwort',
          newPassword: 'Neues Passwort',
          newPasswordConfirm: 'Neues Passwort bestätigen'
        }
      },
      contactPersonDetails: {
        btn: {
          back: 'Zurück',
          delete: 'Löschen'
        },
        contractsCard: {
          cancellationPeriod: 'Kündigungsfrist',
          company: 'Firma',
          estateAdministration: 'Nachlasswunsch',
          status: 'Status',
          title: 'Verträge, über die {firstName} {lastName} informiert werden soll',
          type: 'Vertragstyp'
        },
        deleteContactPerson: 'Die von Ihnen ausgewählte Kontaktperson wurde erfolgreich gelöscht',
        modal: {
          btn: {
            ok: 'Ja, ich bin mir sicher',
            cancel: 'Nein, abbrechen'
          },
          title: 'Kontaktperson löschen',
          question: 'Sind Sie sicher, dass Sie {salutation} {firstName} {lastName} entfernen möchten? Sofern Sie dieser Person bereits Verträge zugeordnet haben, werden diese als nicht fertiggestellt gekennzeichnet'
        },
        title: 'Personenübersicht'
      },
      contactPersonDialog: {
        btn: {
          cancel: 'Abbrechen',
          submit: 'Kontaktperson einladen'
        },
        label: {
          email: 'E-Mail-Adresse',
          firstName: 'Vorname',
          lastName: 'Nachname',
          salutation: 'Anrede'
        },
        title: 'Neue Kontaktperson erfassen'
      },
      contactPersonList: {
        btn: {
          createContactPerson: 'Kontaktperson hinzufügen'
        },
        introductoryPhrase: 'Bestimmen Sie hier bitte Ihre Kontaktpersonen, die im Falle Ihres Ablebens Zugang zu Ihrem Digitalen Nachlassplaner erhalten sollen. Am besten bestimmen Sie als Kontaktperson Ihren Ehepartner oder Ihr Kind bzw. eine andere erbberechtigte Person. Damit sichern Sie ab, dass diese Person Ihren Digitalen Nachlassplaner bei Bedarf uneingeschränkt nutzen kann.',
        submitContactPersonDialog: 'Ihre Einladung an {email} wurde erfolgreich versandt',
        title: 'Kontaktpersonen'
      },
      contractEstateDetails: {
        infoTextWithContactPersons: 'Bestimmen Sie eine Kontaktperson, die nach Ihrem Ableben Einsicht in diesen Vertrag gewährt bekommt.',
        infoTextWithoutContactPersons: 'Sie haben noch keine bestätigte Kontaktperson. Sie können eine Kontaktperson diesem Vertrag zuordnen, nachdem diese bestätigt worden ist.'
      },
      contractWizard: {
        btn: {
          cancel: 'Abbrechen',
          delete: 'Vertrag Löschen',
          finish: 'Fertigstellen',
          next: 'Weiter',
          prev: 'Zurück'
        },
        deleteContractModal: {
          btn: {
            cancel: 'Nein, abbrechen',
            ok: 'Ja, sicher'
          },
          message: 'Sind Sie sicher, dass Sie diesen Vertrag inklusive aller Daten löschen wollen?',
          title: 'Vertrag löschen'
        },
        contractWizardModal: {
          btn: {
            submit: 'Schließen'
          },
          message: '<p>Ihr Vertrag wurde erfolgreich zur Vertragsübersicht hinzugefügt jedoch nicht komplett fertiggestellt.</p><div>Um Verträge fertigzustellen, müssen Sie eine bestätigte Kontaktperson und Adresse ausgewählt haben. Eines dieser beiden Elemente wurde noch nicht erfasst. Sie können mit der Fertigstellung des Vertrages fortfahren, indem Sie nach Bestätigung einer Kontaktperson und/oder Erfassung einer Adresse auf den jeweiligen Vertrag klicken und die fehlenden Elemente ergänzen</div>',
          title: 'Vertrag nicht fertiggestellt'
        },
        deleteContract: 'Der von Ihnen angegeben Vertrag wurde erfolgreich gelöscht',
        tabContent: {
          contractAddress: 'Adresse',
          contractEstate: 'Kontaktperson',
          contractInformation: 'Vetragsinformationen',
          contractPartner: 'Vertragspartner'
        }
      },
      contractsCard: {
        cancellationPeriod: {
          month: '{value} Monat',
          months: '{value} Monate'
        },
        noItems: 'Keine Daten vorhanden'
      },
      contractInformationForm: {
        contractCategoryModal: {
          btn: {
            ok: 'Weiter',
            cancel: 'Abbrechen'
          },
          message: 'Sind Sie sicher, dass Sie die Vertragskategorie ändern wollen? Bereits eingebene Informationen können zum Teil verloren gehen.',
          title: 'Vertragskategorie ändern'
        },
        label: {
          accountNumber: 'Kontonummer',
          cancellationPeriod: 'Kündigungsfrist',
          comment: 'Kommentar',
          conclusionDate: 'Vertragsabschluss',
          contractCategory: 'Kategorie',
          contractDuration: 'Vertragslaufzeit',
          contractNumber: 'Vertragsnummer',
          insuranceNumber: 'Vers.-Nr.',
          contractType: 'Vertragstyp',
          insuredPersonNumber: 'Kundennummer',
          link: 'Link',
          inMonths: '(in Monaten)',
          months: 'Monate',
          username: 'Benutzername / E-Mail Adresse'
        },
        contractPlaceholder: {
          unique: {
            insurance: ' z.B. Risikolebensversicherung, Haftpflichtversicherung, etc.',
            finance: 'z.B. Bausparvertrag',
            habitationHouseholdAndCommunication: 'z.B. Strom, Gas, Mobilfunkvertrag, etc.',
            leisureAndClub: 'z.B. Monatsbeitrag Fußballverein, Fitnessstudio, etc.',
            subscription: 'z.B. Zeitungsabonnement',
            onlineSubscriptionAndSocialMediaAccount: 'z.B. Musik-Streaming Abonnement, Facebook, etc.',
            other: 'z.B. Arbeitsvertrag, Spenden, etc.'
          },
          universal: {
            exampleUserContractNumber: 'z.B. 1234567'
          }
        },
        option: {
          null: 'Bitte legen Sie eine Vertragskategorie fest'
        }
      },
      contractList: {
        createContract: 'Der von Ihnen angelegte Vertrag wurde erfolgreich gespeichert',
        contractWizardTitle: {
          create: 'Neuen Vertrag erfassen',
          edit: 'Vertrag bearbeiten'
        },
        infoCard: {
          text: 'Hier können Sie Verträge zu Ihrer Vertragsübersicht hinzufügen. Um einen Vertrag zu erfassen werden Sie durch vier Schritte geführt.',
          step1: {
            title: 'Schritt 1:',
            contractPartnerName: 'Neuen Vertragspartner anlegen',
            message: 'Fügen Sie einen Vertragspartner hinzu. Falls dieser noch nicht angelegt worden ist, können Sie über die Option "Neuen Vertragspartner anlegen" einen neuen hinzufügen.'
          },
          step2: {
            title: 'Schritt 2:',
            message: 'Ordnen Sie den Vertrag einer entsprechenden Kategorie zu und ergänzen Sie die vertraglichen Details.'
          },
          step3: {
            title: 'Schritt 3:',
            message: 'Wählen Sie eine Adresse aus, auf die dieser Vertrag läuft.'
          },
          step4: {
            title: 'Schritt 4:',
            message: 'Ordnen Sie diesem Vertrag eine von Ihnen ausgewählte Kontaktperson zu, die nach Ihrem Ableben Einsicht in diesen Vertrag bekommt.'
          }
        },
        title: 'Verträge'
      },
      contractOverview: {
        label: {
          address: 'Vertragsadresse:',
          info: 'Vertragsdetails:',
          partner: 'Vertragspartner:'
        }
      },
      contractPartnerDetails: {
        label: {
          requiredFields: 'Alle mit ' + '<span class="text-danger">*</span>' + ' gekennzeichneten Felder sind Pflichtfelder',
          city: 'Stadt',
          confirmed: 'Ich bestätige hiermit, dass die obenstehenden Daten korrekt sind.',
          contractPartnerName: 'Firma / Vertragspartner',
          country: 'Land',
          domain: 'URL / Domain',
          email: 'E-Mail',
          street: 'Straße',
          streetNumber: 'Hausnummer',
          postOfficeBox: 'Postfach',
          postalCode: 'Postleitzahl'
        },
        infoText: 'Sollten sich diese Daten in der Zukunft ändern, sind Sie verpflichtet diese zu aktualisieren. Durch meine-vertraege.net werden keine automatischen Aktualisierungen der Daten vorgenommen.',
        placeholder: {
          contractPartner: 'Vertragspartner angeben'
        }
      },
      dashboard: {
        infobox: {
          addresses: {
            subtitle: 'Adressen'
          },
          contactPersons: {
            invitations: '{amount} weitere Einladung/en ausstehend',
            subtitle: 'Kontaktpersonen'
          },
          contracts: {
            completed: '{amount} davon noch nicht fertiggestellt',
            subtitle: 'Verträge'
          }
        },
        faq: {
          text: '<p>Über das Fenster "Wissenswertes" in der Navigationsleiste erfahren Sie wertvolle Informationen zu den Themen.<br>' + '<p><span class="ti-arrow-right"></span> Trauer - was ist das?</p>' + '<p><span class="ti-arrow-right"></span> Der Todesfall - was ist zu tun?</p>' + '<p><span class="ti-arrow-right"></span> Formen der Bestattung</p>' + '<p><span class="ti-arrow-right"></span> Todesanzeigen</p>' + '<p><span class="ti-arrow-right"></span> Beileidsbekundungen</p>',
          title: 'Wissenswertes'
        },
        info: {
          text: '<p><b>Vertragsmanager:</b><br><span class="ti-arrow-right"></span> Mit diesem Vertragsmanager können Sie Ihre Verträge einpflegen und verwalten. Alles auf einem Blick!<p>' + '<b>Todesmeldung an Vertragspartner:</b><br><span class="ti-arrow-right"></span> Wir werden uns darum kümmern, dass all Ihre Vertragspartner über Ihr Ableben informiert werden. Dies erspart Ihren engsten Vertrauten viel Zeit!<p>' + '<b>Bestimmung von Kontaktpersonen:</b><br><span class="ti-arrow-right"></span> Sie können Kontaktpersonen bestimmen, welche nach Ihrem Ableben Zugriff auf Ihre Verträge bekommen und so bestens über Ihre bestehenden Verträge informiert sind.',
          title: 'meine-vertraege.net - Ihr Digitaler Vertragsmanager'
        },
        powerOfAttorney: {
          address: '<br>CodeCamp:N GmbH<br>Solgerstraße 18<br>90429 Nürnberg',
          download: 'Vorlage herunterladen',
          explanation: '<p>Um die Vorteile von meine-vertraege.net in vollen Umfang nutzen zu können, benötigen wir von Ihnen eine Vollmachtserklärung. So können wir nach Ihrem Ableben Ihre Vertragspartner darüber informieren. Vor diesem Hintergrund ersparen Sie Ihren Hinterbliebenen viel Arbeit.' + '<p>Bitte befolgen Sie die folgenden Schritte um die Vollmacht zu erklären.',
          step1: '1. Vollmachtvorlage herunterladen & ausdrucken',
          step2: '2. Vollmacht handschriftlich unterzeichnen',
          step3: '3. Per Post an folgende Adresse verschicken oder unter "Mein Account" hochladen:',
          title: '<span class="ti-file mr-2"></span>Vollmacht erteilen'
        },
        title: 'Willkommen {userName} zu meine-vertraege.net'
      },
      dashboardContentContactPerson: {
        addRolePolicyHolder: 'Sie haben sich erfolgreich als versicherte Person registriert. Sie können nun den vollen Umfang von "meine-vertraege.net" nutzen',
        insurance: {
          btn: {
            submit: 'Weiter'
          },
          label: {
            dateOfBirth: 'Geburtsdatum',
            contractNumber: 'Vers.-Nr.'
          },
          message: 'Sollten Sie eine Sterbegeldversicherung bei der NÜRNBERGER Versicherung abgeschlossen haben, können Sie hier Ihre Versicherungsnummer eingeben. Damit erhalten Sie Zugang zum vollen Funktionsumfang der Plattform meine-vertrage.net. Dazu gehört die Erfassung all Ihrer Vertragsverhältnisse, dem Anlegen von Adressen und dem Bestimmen von Kontaktpersonen, die nach Ihrem Ableben Einsicht in Ihren Vertragsmanager bekommen.',
          title: 'Haben Sie schon eine Sterbegeldversicherung?'
        },
        message: 'Personen, die Sie als Kontaktperson angelegt haben',
        numberOfAssignedContract: 'Vertrag',
        numberOfAssignedContracts: 'Verträge'
      },
      footer: {
        copyright: '© 2018',
        imprint: 'Impressum',
        privacyPolicies: 'Datenschutzrichtlinien',
        terms: 'Nutzungsbedingungen',
        info: 'Info'

      },
      faq: {
        collapse: 'Weiterlesen',
        title: 'Wissenswertes'
      },
      imprint: {
        title: 'Impressum'
      },
      info: {
        title: 'Informationen'
      },
      personalInformationForm: {
        btn: {
          cancel: 'Abbrechen',
          edit: 'Bearbeiten',
          save: 'Speichern'
        },
        label: {
          dateOfBirth: 'Geburtsdatum',
          firstName: 'Vorname',
          lastName: 'Nachname',
          salutation: 'Anrede',
          title: 'Titel'
        }
      },
      policies: {
        title: 'Datenschutzhinweise'
      },
      policyHolderContracts: {
        back: 'Zurück'
      },
      policyHolderDetails: {
        certificateOfDeath: 'Sterbeurkunde',
        certificateOfDeathEnable: 'Das Dokument wurde erfolgreich hochgeladen. Wir werden Ihnen nach erfolgreicher Legitimierung den Zugang zur Vertragsübersicht von {policyHolderName} freischalten.',
        certificateOfDeathMessage: 'Sterbeurkunde anzeigen',
        certificateOfInheritance: 'Erbschein',
        certificateOfInheritanceEnable: 'Das Dokument wurde erfolgreich hochgeladen. Wir werden Ihnen nach erfolgreicher Legitimierung den Zugang zur Vertragsübersicht von {policyHolderName} freischalten.',
        certificateOfInheritanceMessage: 'Erbschein anzeigen',
        deleteDocument: 'Dokument entfernen',
        infoText: 'Sie wurden als Kontaktperson von {policyHolderName} festgelegt. Um Einsicht in die Ihnen zugeordneten Verträge zu erhalten, benötigen wir im Todesfall eine Sterbeurkunde für {policyHolderName} um Ihnen Zugriff auf die Ihnen zugeordneten Verträge geben zu können. Dies versetzt uns in die Lage, die Vertragspartner von {policyHolderName} über das Ableben in Kenntnis zu setzen. Sollen Sie in Besitz eines entsprechenden Erbscheins sein, so wird Ihnen nach dem Hochladen die uneingeschränkte Vertragseinsicht gewährt.',
        infoText2: 'Hier sehen Sie alle Verträge, die {policyHolderName} Ihnen zugeordnet hat.',
        modal: {
          cancel: 'Nein, Abbrechen',
          message: 'Möchten Sie das Dokument wirklich entfernen?',
          ok: 'Ja, sicher',
          title: 'Dokument entfernen?'
        },
        reportDeath: '{policyHolderName} als tot melden:',
        uploadCertificateOfDeath: 'Die von Ihnen ausgewählte Datei wurde erfolgreich als Sterbeurkunde hochgeladen',
        uploadCertificateOfInheritance: 'Die von Ihnen ausgewählte Datei wurde erfolgreich als Erbschein hochgeladen',
        title: 'Vertragsübersicht von {firstName} {lastName}'
      },
      resetPassword: {
        title: 'Passwort vergessen?',
        message: 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Kennwort zurückzusetzen. Eventuell müssen Sie den Spamordner prüfen, oder die Adresse als Absender zulassen.',
        btn: {
          send: 'Senden',
          back: 'Zurück'
        },
        input: {
          email: {
            placeholder: 'E-Mail-Adresse'
          }
        }
      },
      resetPasswordConfirm: {
        btn: {
          back: 'Zurück',
          send: 'Senden'
        },
        label: {
          password: 'Passwort',
          passwordConfirm: 'Passwort bestätigen',
          verificationCode: 'Aktivierungscode'
        },
        input: {
          placeholder: {
            password: 'Geben Sie hier Ihr neues Passwort ein',
            passwordConfirm: 'Geben Sie hier Ihr neues Passwort erneut ein',
            verificationCode: 'Geben Sie hier Ihren Aktivierungscode ein'
          }
        },
        message: '',
        title: 'Neues Passwort vergeben'
      },
      signIn: {
        autoLogout: 'Guten Tag {salutation} {firstName} {lastName}, Sie waren länger als 20 Minuten inaktiv und wurden automatisch ausgeloggt. Sie können sich im untenstehenden Anmeldeformular erneut anmelden',
        input: {
          placeholder: {
            email: 'Bitte geben Sie hier Ihre E-Mail-Adresse ein',
            password: 'Bitte geben Sie hier Ihr Passwort ein'
          }
        },
        label: {
          email: 'E-Mail-Adresse'
        },
        title: 'Anmelden'
      },
      signUp: {
        btn: {
          submit: 'Registrieren'
        },
        label: {
          dateOfBirth: 'Geburtstag',
          email: 'E-Mail-Adresse',
          firstName: 'Vorname',
          contractNumber: 'Versicherungsnummer',
          lastName: 'Nachname',
          relation: 'Angehörigkeit zu {salutation} {firstName} {lastName}',
          salutation: 'Anrede',
          password: 'Passwort',
          passwordConfirm: 'Passwort bestätigen'
        },
        link: 'Hier registrieren',
        radio: {
          mister: 'Herr',
          miss: 'Frau'
        },
        question: 'Haben Sie noch keinen Account? ',
        privacyPolicies: 'Datenschutzrichtlinien',
        signIn: 'Haben Sie schon einen Account? {signInLink}',
        signInHere: 'Hier anmelden',
        terms: 'Nutzungsbedingungen',
        termsAndPolicies: 'Ich stimme den {terms} und {privacyPolicies} zu.',
        title: 'Registrierung'
      },
      signUpConfirm: {
        activated: 'Ihr Account wurde erfolgreich aktiviert. Sie können sich nun anmelden',
        again: 'Wenn Sie noch keine E-Mail erhalten haben, {resendLink}. Falls Sie erneut keine E-Mail erhalten, wenden Sie sich bitte an unseren Support unter {supportLink}.',
        btn: {
          back: 'Zurück',
          resend: 'klicken Sie hier um die E-Mail erneut zu senden',
          send: 'Aktivieren'
        },
        input: {
          placeholder: {
            verificationCode: 'Aktivierungscode'
          }
        },
        message: 'Vielen Dank für Ihre Registrierung. Bitte geben Sie den an Ihre E-Mail-Adresse gesendeten Aktivierungscode ein, um die Registrierung abzuschließen.',
        title: 'Bestätigung Ihrer Registrierung'
      },
      signUpContactPerson: {
        accountOptions: {
          no: 'Nein, noch nicht',
          yes: 'Ja, habe ich'
        },
        btn: {
          submit: 'Weiter'
        },
        label: {
          acceptRequest: 'Möchten Sie die Anfrage als Kontaktperson annehmen?',
          hasAccount: 'Haben Sie bereits einen Account bei meine-vertraege.net?',
          relation: 'Angehörigkeit zu {salutation} {firstName} {lastName}'
        },
        requestOptions: {
          no: 'Nein, ablehnen',
          yes: 'Ja, annehmen'
        },
        title: 'Kontaktpersonenanfrage von {salutation} {firstName} {lastName}'
      },
      signUpContactPersonRejected: {
        title: 'Anfrage abgelehnt',
        message: '<p>Vielen Dank für Ihre Antwort. Wir werden den Einlader informieren, dass Sie die Anfrage abgelehnt haben.</p><p>Mit freundlichen Grüßen</p>Ihr Team von meine-vertraege.net'
      },
      support: {
        email: 'support@meine-vertraege.net'
      },
      terms: {
        title: 'Nutzungsbedingungen digitaler Vertragsmanager'
      }
    },
    error: {
      accountDetails: {
        deletePowerOfAttorney: {
          common: 'Beim Versuch Ihre Vollmacht zu widerrufen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
          notFound: 'Es existiert keine Vollmacht, die widerrufen werden könnte'
        },
        getPowerOfAttorney: 'Beim Versuch Ihre Vollmacht anzuzeigen ist ein Fehler unterlaufen. Bitte Versuchen Sie es später erneut',
        saveChangedPassword: {
          common: 'Beim Versuch Ihr neues Passwort zu speichern ist ein Fehler unterlaufen',
          limitExceeded: 'Das Passwort wurde zu oft geändert. Bitte versuchen Sie es später erneut'
        },
        saveChangedEmail: 'Beim Versuch Ihre neue E-Mail-Adresse zu speichern ist ein Fehler unterlaufen'
      },
      accountPowerOfAttorneyForm: {
        uploadFailure: 'Fehler beim Hochladen der Vollmacht'
      },
      addressDetails: {
        changedAdresses: 'Es ist ein Fehler unterlaufen. Bitte versuchen Sie es erneut',
        contractsByAddress: 'Es ist ein Fehler beim Laden der Verträge zu dieser Adresse unterlaufen. Bitte versuchen Sie es erneut',
        deleteAddress: 'Es ist ein Fehler unterlaufen. Bitte versuchen Sie es erneut',
        fetchAddressById: 'Beim Laden der Adresse ist ein Fehler unterlaufen. Bitte versuchen Sie es erneut',
        saveAddress: 'Es ist ein Fehler unterlaufen. Bitte versuchen Sie es erneut'
      },
      addressConfirmForm: {
        storeAddress: 'Beim Versuch die von Ihnen angegebene Adresse zu speichern ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      addressForm: {
        street: 'Bitte geben Sie eine Straße an',
        streetNumber: 'Bitte geben Sie eine Hausnummer an',
        postalCode: 'Bitte geben Sie eine Postleitzahl an',
        city: 'Bitte geben Sie eine Stadt an',
        country: 'Bitte geben sie ein Land an'
      },
      addressSearchForm: {
        autocomplete: 'Bitte selektieren Sie einen Ort aus der Auswahlliste'
      },
      adminContractPartnerDetails: {
        fetchContractPartnerTemplateById: 'Beim Versuch den angegebenen Vertragspartner zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        saveContractPartner: 'Beim Versuch den angegebenen Vertragspartner als Template zu speichern ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      adminContractPartnerTemplateDetails: {
        deleteAdminContractPartnerTemplate: 'Beim Versuch das angegebene Template zu löschen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        fetchAdminContractPartnerTemplateById: 'Beim Versuch das angegebene Template zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        saveContractPartnerTemplate: 'Beim Versuch das angegegebene Template zu speichern ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      adminUserStatus: {
        update: {
          death: 'Sterbedatum erfolgreich aktualisiert',
          legi: 'Legitimationsstatus erfolgreich aktualisiert'
        }
      },
      avatar: {
        delete: 'Fehler beim Löschen',
        fileToolarge: 'Bilddatei zu groß',
        uploadFail: 'Fehler beim Upload',
        wrongDimensions: 'Ungültige Bildabmessungen',
        wrongFileType: 'Dieses Format wird nicht unterstützt'
      },
      changePasswordForm: {
        oldPassword: 'Bitte geben Sie Ihr altes Passwort ein',
        newPassword: 'Bitte geben Sie mindestens 6 Zeichen ein, davon: 1 Großbuchstabe, 1 Kleinbuchstabe, eine Zahl und/oder ein Sonderzeichen',
        newPasswordConfirm: 'Die angegebenen Passwörter sind leer oder stimmen nicht über ein'
      },
      contactPersonDetails: {
        contactPersonById: 'Beim Laden der Kontaktperson ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        deleteContactPerson: 'Beim Versuch die von Ihnen ausgewählte Kontaktperson zu löschen, ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
        fetchContractsByContactPerson: 'Beim Laden der Verträge, die der Kontaktperson zu geordnet sind, ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      contactPersonList: {
        submitContentPersonDialog: 'Beim Versuch die Einladung an Ihre Kontaktperson zu versenden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      contractPartnerDetails: {
        contractPartner: {
          city: 'Bitte geben Sie eine Stadt an',
          confirmed: 'Bitte bestätigen Sie die Echtheit Ihrer Angeben',
          country: 'Bitte geben Sie ein Land an',
          contractPartnerName: 'Bitte geben Sie eine Firma oder einen Vertragspartner an',
          domain: 'Bitte geben Sie eine Domain an',
          email: 'Bitte geben Sie eine E-Mail an',
          street: 'Bitte geben Sie eine Straße an',
          streetNumber: 'Bitte geben Sie eine Hausnummer an',
          postOfficeBox: 'Bitte geben Sie ein Postfach an',
          postalCode: 'Bitte geben Sie eine Postleitzahl an'
        }
      },
      contractInformationForm: {
        accountNumber: 'Bitte geben Sie eine gültige Kontonummer an',
        cancellationPeriod: 'Bitte geben Sie eine gültige Zahl mit maximal 2 Stellen als Kündigungsfrist ein',
        comment: 'Bitte geben Sie maximal 325 Zeichen für einen gültigen Kommentar ein',
        conclusionDate: 'Das angegebene Datum ist leider ungültig.',
        contractDuration: 'Bitte geben Sie eine gültige Zahl mit maximal 3 Stellen als Vertragslaufzeit ein',
        contractNumber: 'Bitte geben Sie eine gültige Vertragsnummer an',
        contractType: 'Bitte geben Sie maximal 100 Zeichen für einen gültigen Vertragstyp ein',
        insuredPersonNumber: 'Bitte geben Sie ein gültige Kundennummer ein',
        link: 'Bitte geben Sie eine gültige URL im Format "http://codecamp-n.de", oder "www.codecamp-n.de" ein',
        username: 'Bitte geben Sie Ihren Benutzernamen bzw. Ihre E-Mail ein'
      },
      contractList: {
        create: 'Beim Anlegen Ihres Vertragspartners ist ein Fehler unterlaufen',
        check: 'Bitte überprüfen Sie Ihre Eingaben',
        estateAdministration: {
          type: 'Bitte selektieren Sie eine der möglichen Nachlassregelungen',
          personOfTrust: 'Bitte selektieren Sie eine Kontaktperson'
        },
        fetchContracts: 'Beim Versuch Ihre Verträge zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        fetchContractById: 'Beim Versuch den angegebenen Vertrag zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        invalid: 'Bitte überprüfen Sie Ihre Eingaben und befüllen Sie alle Pflichtfelder',
        missing: 'Bitte geben Sie einen Vertragspartner an',
        noContractPartnerFounded: 'Der gewünschte Vertragspartner konnte nicht gefunden werden. Bitte legen Sie einen neuen an.'
      },
      contractPartnerForm: {
        contractPartner: {
          company: 'Bitte geben Sie einen Vertragspartner an '
        }
      },
      contractWizard: {
        deleteContract: 'Beim Versuch den Vertrag zu löschen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        storeContract: 'Beim Versuch den Vertrag zu speichern ist ein Fehler unterlaufen. Bitte veruschen Sie es später erneut'
      },
      dashboardContentContactPerson: {
        addRolePolicyHolder: 'Ihre Versicherungsnummer konnte nicht validiert werden, bitte überprüfen Sie Ihre Eingaben. Sollten Sie weiterhin Probleme bei der Registrierung haben, melden Sie sich unter support@meine-vertraege.net.',
        contractNumber: 'Diese Versicherungsnummer ist nicht gültig. Bitte überprüfen Sie Ihre Eingabe',
        dateOfBirth: 'Bitte geben Sie ein gültiges Datum im Format "TT.MM.JJJJ" ein'
      },
      personalInformationForm: {
        dateOfBirth: 'Bitte geben Sie ein gültiges Datum im Format "TT.MM.JJJJ" ein',
        firstName: 'Bitte geben Sie Ihren Vornamen ein',
        lastName: 'Bitte geben Sie Ihren Nachnamen ein',
        salutation: 'Bitte geben Sie eine Anrede an'
      },
      policyHolderDetails: {
        policyHolderById: 'Beim Versuch die angegebene Kontaktperson zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        deleteCertificateOfDeath: 'Beim Versuch die Sterbeurkunde hoch zu löschen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        uploadCertificateOfDeath: 'Beim Versuch die angegebene Datei, als Sterbeurkunde hoch zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        deleteCertificateOfInheritance: 'Beim Versuch den Erbschein zu löschen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        uploadCertificateOfInheritance: 'Beim Versuch die angegebene Datei, als Erbschein hoch zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        fileReaderError: 'Beim Versuch Ihre Datei einzulesen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      resetPassword: {
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        submit: 'Benutzername {email} unbekannt'
      },
      resetPasswordConfirm: {
        submit: 'Der angegebene Benutzer konnte nicht gefunden werden oder der eingegebene Aktivierungscode ist ungültig. Bitte versuchen Sie es erneut, oder wenden Sie sich an unseren Support unter {supportLink}',
        password: 'Bitte geben Sie mindestens 6 Zeichen ein, davon: 1 Großbuchstabe, 1 Kleinbuchstabe, eine Zahl und/oder ein Sonderzeichen',
        passwordConfirm: 'Die angegebenen Passwörter sind leer oder stimmen nicht über ein',
        verificationCode: 'Bitte geben Sie einen Aktivierungscode ein'
      },
      signIn: {
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        password: 'Bitte geben Sie ein Passwort ein',
        submit: 'Der Benutzername oder das Passwort sind nicht korrekt',
        death: 'Dieses Konto ist nicht länger zugänglich. Bei Fragen kontaktieren Sie bitte support@meine-vertraege.net',
        error: 'Es ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      signUp: {
        acceptTerms: 'Bitte akzeptieren Sie die Nutzungsbedingungen und Datenschutzrichtlinien',
        dateOfBirth: 'Bitte geben Sie ein gültiges Datum im Format "TT.MM.JJJJ" ein',
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        firstName: 'Bitte geben Sie Ihren Vornamen ein. Es sind nur Buchstaben erlaubt',
        contractNumber: 'Diese Versicherungsnummer ist nicht gültig. Bitte überprüfen Sie Ihre Eingabe',
        lastName: 'Bitte geben Sie Ihren Nachnamen ein. Es sind nur Buchstaben erlaubt',
        password: 'Bitte geben Sie mindestens 6 Zeichen ein, davon: 1 Großbuchstabe, 1 Kleinbuchstabe, eine Zahl und/oder ein Sonderzeichen',
        passwordConfirm: 'Die eingegebenen Passwörter stimmen nicht überein',
        salutation: 'Bitten wählen Sie eine der beiden Optionen aus',
        submit: 'Beim Versuch Ihre Daten zu speichern ist ein Fehler aufgetreten. Bitte wenden Sie sich an unseren Support unter {supportLink}',
        relation: 'Bitte wählen Sie eine Angehörigkeit aus'
      },
      signUpConfirm: {
        expired: 'Der von Ihnen eingegebene Aktivierungscode ist abgelaufen. Bitte wenden Sie sich an unseren Support unter {supportLink}',
        resend: 'Es konnte zu dem angegebenen Benutzer kein Aktvierungscode generiert werden. Bitte wenden Sie sich an unseren Support unter {supportLink}',
        submit: 'Der von Ihnen eingegebene Aktivierungscode ist ungültig. Bitte versuchen Sie es erneut, oder wenden Sie sich an unseren Support unter {supportLink}',
        verificationCode: 'Bitte geben Sie einen Aktivierungscode ein'
      },
      signUpContactPerson: {
        delete: 'Beim Versuch Ihre Einladung zu löschen ist ein Fehler unterlaufen. Bitten wenden Sie sich an unseren Support'
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),

/***/ "75gL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"rounded-0"},[_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('message.signUp.title')))]),_vm._v(" "),_c('b-alert',{staticClass:"mt-4 p-4 mx-auto",attrs:{"variant":_vm.notification.variant,"dismissible":"","show":_vm.notification.isVisible},on:{"dismissed":function($event){_vm.notification.isVisible=false}}},[_c('i18n',{attrs:{"path":"error.signUp.submit","tag":"div"}},[_c('b-link',{attrs:{"href":"mailto:support@meine-vertraege.net","place":"supportLink"}},[_vm._v(_vm._s(_vm.$t('message.support.email'))+"\n      ")])],1)],1),_vm._v(" "),_c('b-form',{staticClass:"mt-3 p-3",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-group',{attrs:{"state":_vm.$v.regData.salutation.$error ? false : null,"invalid-feedback":_vm.$t('error.signUp.salutation')}},[_c('label',[_vm._v("\n        "+_vm._s(_vm.$t('message.signUp.label.salutation'))+"\n        "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-radio-group',{attrs:{"options":_vm.salutations,"state":_vm.$v.regData.salutation.$error ? false : null},on:{"change":function($event){_vm.$v.regData.salutation.$touch()}},model:{value:(_vm.regData.salutation),callback:function ($$v) {_vm.$set(_vm.regData, "salutation", $$v)},expression:"regData.salutation"}})],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.regData.firstName.$error ? false : null,"invalid-feedback":_vm.$t('error.signUp.firstName')}},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('message.signUp.label.firstName'))+"\n            "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.regData.firstName.$error ? false : null},on:{"change":function($event){_vm.$v.regData.firstName.$touch()}},model:{value:(_vm.regData.firstName),callback:function ($$v) {_vm.$set(_vm.regData, "firstName", $$v)},expression:"regData.firstName"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.regData.lastName.$error ? false : null,"invalid-feedback":_vm.$t('error.signUp.lastName')}},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('message.signUp.label.lastName'))+"\n            "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.regData.lastName.$error ? false : null},on:{"change":function($event){_vm.$v.regData.lastName.$touch()}},model:{value:(_vm.regData.lastName),callback:function ($$v) {_vm.$set(_vm.regData, "lastName", $$v)},expression:"regData.lastName"}})],1)],1)],1),_vm._v(" "),(_vm.invitation)?_c('b-form-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"signup-relation","label-for":"signup-relation","state":_vm.$v.regData.relation.$error ? false : null,"invalid-feedback":_vm.$t('error.signUp.relation')}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n            "+_vm._s(_vm.relationText)+"\n            "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-select',{staticClass:"rounded-0",attrs:{"options":_vm.relationTypes},model:{value:(_vm.regData.relation),callback:function ($$v) {_vm.$set(_vm.regData, "relation", $$v)},expression:"regData.relation"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-form-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.regData.email.$error ? false : null,"invalid-feedback":_vm.$t('error.signUp.email')}},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('message.signUp.label.email'))+"\n            "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"id":"email","state":_vm.$v.regData.email.$error ? false : null},on:{"change":function($event){_vm.$v.regData.email.$touch()}},model:{value:(_vm.regData.email),callback:function ($$v) {_vm.$set(_vm.regData, "email", $$v)},expression:"regData.email"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.regData.password.$error ? false : true,"invalid-feedback":_vm.$t('error.signUp.password')}},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('message.signUp.label.password'))+"\n            "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"type":"password","state":_vm.$v.regData.password.$error ? false : null},on:{"textinput":function($event){_vm.$v.regData.password.$touch()}},model:{value:(_vm.regData.password),callback:function ($$v) {_vm.$set(_vm.regData, "password", $$v)},expression:"regData.password"}}),_vm._v(" "),_c('div',{staticClass:"feedback-color",attrs:{"slot":"valid-feedback"},slot:"valid-feedback"},[_vm._v("\n            "+_vm._s(_vm.$t('error.signUp.password'))+"\n          ")])],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.regData.passwordConfirm.$error ? false : null,"invalid-feedback":_vm.$t('error.signUp.passwordConfirm')}},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('message.signUp.label.passwordConfirm'))+"\n            "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"type":"password","state":_vm.$v.regData.passwordConfirm.$error ? false : null},on:{"change":function($event){_vm.$v.regData.passwordConfirm.$touch()}},model:{value:(_vm.regData.passwordConfirm),callback:function ($$v) {_vm.$set(_vm.regData, "passwordConfirm", $$v)},expression:"regData.passwordConfirm"}})],1)],1)],1),_vm._v(" "),(!_vm.invitation)?_c('b-form-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.regData.dateOfBirth.$error ? false : null,"invalid-feedback":_vm.$t('error.signUp.dateOfBirth')}},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('message.signUp.label.dateOfBirth'))+"\n            "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-input-group',[_c('b-form-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.regData.dateOfBirth.$error ? false : null},on:{"textinput":function($event){_vm.$v.regData.dateOfBirth.$touch()}},model:{value:(_vm.regData.dateOfBirth),callback:function ($$v) {_vm.$set(_vm.regData, "dateOfBirth", $$v)},expression:"regData.dateOfBirth"}}),_vm._v(" "),_c('b-input-group-text',{staticClass:"rounded-0",attrs:{"slot":"append"},slot:"append"},[_c('span',{staticClass:"ti-calendar"})])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.invitation)?_c('b-form-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.regData.contractNumber.$error ? false : null,"invalid-feedback":_vm.$t('error.signUp.contractNumber')}},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('message.signUp.label.contractNumber'))+"\n            "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.regData.contractNumber.$error ? false : null},on:{"change":function($event){_vm.$v.regData.contractNumber.$touch()}},model:{value:(_vm.regData.contractNumber),callback:function ($$v) {_vm.$set(_vm.regData, "contractNumber", $$v)},expression:"regData.contractNumber"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.regData.acceptTerms.$error ? false : null,"invalid-feedback":_vm.$t('error.signUp.acceptTerms')}},[_c('b-form-checkbox',{attrs:{"state":_vm.$v.regData.acceptTerms.$error ? false : null},on:{"change":function($event){_vm.$v.regData.acceptTerms.$touch()}},model:{value:(_vm.regData.acceptTerms),callback:function ($$v) {_vm.$set(_vm.regData, "acceptTerms", $$v)},expression:"regData.acceptTerms"}},[_c('i18n',{attrs:{"path":"message.signUp.termsAndPolicies","tag":"p"}},[_c('router-link',{attrs:{"to":"/terms","place":"terms"}},[_vm._v(_vm._s(_vm.$t('message.signUp.terms')))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/policies","place":"privacyPolicies"}},[_vm._v(_vm._s(_vm.$t('message.signUp.privacyPolicies'))+"\n              ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('b-btn',{staticClass:"w-100 p-3 rounded-0",attrs:{"variant":"primary","type":"submit","disabled":_vm.$v.$invalid}},[_vm._v(_vm._s(_vm.$t('message.signUp.btn.submit'))+"\n        ")])],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',{staticClass:"text-center"},[_c('i18n',{attrs:{"path":"message.signUp.signIn","tag":"p"}},[_c('router-link',{attrs:{"to":"/signin","place":"signInLink"}},[_vm._v(_vm._s(_vm.$t('message.signUp.signInHere')))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "76mk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.2690e4c.png";

/***/ }),

/***/ "7d9F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7uXA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('h2',[_c('span',{staticClass:"ti-settings mr-2"}),_vm._v("\n        "+_vm._s(_vm.$t('message.appSidebar.navItem.account'))+"\n      ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0"},[_c('h4',{staticClass:"text-muted font-weight-normal"},[_c('span',{staticClass:"ti-id-badge mr-2"}),_vm._v("\n          "+_vm._s(_vm.$t('message.accountDetails.title'))+"\n        ")]),_vm._v(" "),_c('personal-information-form',{attrs:{"personalInfo":_vm.personalInfo,"onDeleteAvatar":_vm.deleteAvatar,"onSubmit":_vm.savePersonalInfo,"onSubmitAvatar":_vm.uploadAvatar}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"6"}},[_c('b-card',{staticClass:"rounded-0"},[_c('h4',{staticClass:"text-muted font-weight-normal"},[_c('span',{staticClass:"ti-key mr-2"}),_vm._v("\n          "+_vm._s(_vm.$t('message.accountDetails.card.title.changePassword'))+"\n        ")]),_vm._v(" "),_c('change-passsword-form',{attrs:{"passwordData":_vm.passwordData,"onSubmit":_vm.saveChangedPassword}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"mt-sm-4 mt-lg-0",attrs:{"sm":"12","md":"12","lg":"6"}},[_c('b-card',{staticClass:"rounded-0"},[_c('h4',{staticClass:"text-muted font-weight-normal"},[_c('span',{staticClass:"ti-email mr-2"}),_vm._v("\n          "+_vm._s(_vm.$t('message.accountDetails.card.title.changeEmail'))+"\n        ")]),_vm._v(" "),_c('account-change-email-form',{ref:"accountChangeEmailForm",on:{"submit":_vm.saveChangedEmail}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[(_vm.isPolicyHolder)?_c('b-col',[_c('b-card',{staticClass:"rounded-0 h-100"},[_c('h4',{staticClass:"text-muted font-weight-normal"},[_c('span',{staticClass:"ti-share-alt mr-2"}),_vm._v("\n          "+_vm._s(_vm.$t('message.accountDetails.card.title.powerOfAttorney'))+"\n        ")]),_vm._v(" "),_c('account-power-of-attorney-form',{attrs:{"user":_vm.user,"onPrintPoaFn":_vm.printPoa,"onRevokePoaFn":_vm.revokePoa}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',[_c('b-card',{staticClass:"rounded-0 h-100"},[_c('h4',{staticClass:"text-muted font-weight-normal"},[_c('span',{staticClass:"ti-archive mr-2"}),_vm._v("\n          "+_vm._s(_vm.$t('message.accountDetails.card.title.deactivate'))+"\n        ")]),_vm._v(" "),_c('account-deactivation-form',{attrs:{"onDeactivateFn":_vm.deactivateAccount}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "87nF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserInvitation_vue__ = __webpack_require__("aFTp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f44053a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserInvitation_vue__ = __webpack_require__("IKVC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserInvitation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f44053a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserInvitation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Ukx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractAddressDetails_vue__ = __webpack_require__("XoGe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e6a5682_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractAddressDetails_vue__ = __webpack_require__("WAKv");
function injectStyle (ssrContext) {
  __webpack_require__("nkW5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e6a5682"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractAddressDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e6a5682_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractAddressDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "944s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.$t('message.contactPersonDetails.title'),"icon":'ti-user'}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('business-card',{attrs:{"name":_vm.name,"relation":_vm.relationship,"email":_vm.contactPerson.email,"imageSrc":_vm.contactPerson.avatarUuid,"variant":"noHover"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-btn',{attrs:{"variant":"link","to":"/contactPersons"}},[_vm._v("\n        "+_vm._s(_vm.$t('message.contactPersonDetails.btn.back'))+"\n      ")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.delete-contact-person-modal",modifiers:{"delete-contact-person-modal":true}}],staticClass:"rounded-0",attrs:{"variant":"danger"}},[_vm._v("\n        "+_vm._s(_vm.$t('message.contactPersonDetails.btn.delete'))+"\n      ")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',[_c('contracts-card',{attrs:{"collapseId":"contact-persons-contracts-card","items":_vm.contracts,"title":_vm.$t('message.contactPersonDetails.contractsCard.title',
         { firstName: _vm.contactPerson.firstName, lastName: _vm.contactPerson.lastName })},on:{"showDetails":_vm.showDetails}})],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"delete-contact-person-modal","cancel-variant":"danger","ok-variant":"success","title":_vm.$t('message.contactPersonDetails.modal.title'),"ok-title":_vm.$t('message.contactPersonDetails.modal.btn.ok'),"cancel-title":_vm.$t('message.contactPersonDetails.modal.btn.cancel')},on:{"ok":_vm.deleteContactPerson}},[_c('p',{staticClass:"mt-4"},[_vm._v("\n      "+_vm._s(_vm.$t('message.contactPersonDetails.modal.question',
      {
      salutation: _vm.$t('enums.salutations.' + _vm.contactPerson.salutation),
      firstName: _vm.contactPerson.firstName,
      lastName: _vm.contactPerson.lastName
      }))+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9aVW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressConfirmForm_vue__ = __webpack_require__("oPHQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c0284e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressConfirmForm_vue__ = __webpack_require__("NQQj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressConfirmForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c0284e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressConfirmForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9cxb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserAddress_vue__ = __webpack_require__("yc7G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98f4cedc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserAddress_vue__ = __webpack_require__("oIsk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98f4cedc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A4RO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__("SlQu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06badf36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__("Fmg7");
function injectStyle (ssrContext) {
  __webpack_require__("RT2X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06badf36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06badf36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A9Ar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressDetails_vue__ = __webpack_require__("S5bc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9564b94c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressDetails_vue__ = __webpack_require__("wBvz");
function injectStyle (ssrContext) {
  __webpack_require__("f5rW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9564b94c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9564b94c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ABx1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"h-100"},[(!_vm.powerOfAttorney)?_c('label',{staticClass:"btn w-100 mt-4 alert alert-dark"},[_vm._v("\n          "+_vm._s(_vm.$t('message.adminUserDocuments.uploadPoa'))+"\n          "),_c('input',{attrs:{"type":"file","hidden":"","accept":"application/pdf, image/*"},on:{"change":_vm.uploadPoa}})]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.powerOfAttorney)?_c('b-btn',{staticClass:"p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate",attrs:{"variant":"transparent"},on:{"click":_vm.downloadPowerOfAttorney}},[_c('b-alert',{staticClass:"rounded-0 certificate pb-0 mb-0",attrs:{"show":"","variant":"dark"}},[_c('p',[_c('span',{staticClass:"ti-printer mr-2"}),_vm._v("\n                  "+_vm._s(_vm.$t('message.adminUserDocuments.viewPoa'))+"\n                ")])])],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right"},[(_vm.powerOfAttorney)?_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.delete-poa-modal",modifiers:{"delete-poa-modal":true}}],staticClass:"mt-3",attrs:{"variant":"danger"}},[_vm._v("\n              "+_vm._s(_vm.$t('message.adminUserDocuments.deleteDocument'))+"\n            ")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-card',{staticClass:"h-100"},[(!_vm.certificateOfDeath)?_c('label',{staticClass:"btn w-100 mt-4 alert alert-dark"},[_vm._v("\n          "+_vm._s(_vm.$t('message.adminUserDocuments.uploadCod'))+"\n          "),_c('input',{attrs:{"type":"file","hidden":"","accept":"application/pdf, image/*"},on:{"change":_vm.uploadCertificateOfDeath}})]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.certificateOfDeath)?_c('b-btn',{staticClass:"p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate",attrs:{"variant":"transparent"},on:{"click":_vm.downloadCertificateOfDeath}},[_c('b-alert',{staticClass:"rounded-0 certificate pb-0 mb-0",attrs:{"show":"","variant":"dark"}},[_c('p',[_c('span',{staticClass:"ti-printer mr-2"}),_vm._v("\n                  "+_vm._s(_vm.$t('message.adminUserDocuments.viewCod'))+"\n                ")])])],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right"},[(_vm.certificateOfDeath)?_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.delete-cod-modal",modifiers:{"delete-cod-modal":true}}],staticClass:"mt-3",attrs:{"variant":"danger"}},[_vm._v("\n              "+_vm._s(_vm.$t('message.adminUserDocuments.deleteDocument'))+"\n            ")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-card',{staticClass:"h-100"},[_c('b-form-select',{staticClass:"mt-4",attrs:{"options":_vm.options},on:{"change":_vm.selectCp},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._v(" "),(!_vm.certificateOfInheritance && _vm.selected)?_c('label',{staticClass:"btn w-100 mt-4 alert alert-dark"},[_vm._v("\n          "+_vm._s(_vm.$t('message.adminUserDocuments.uploadCoi'))+"\n          "),_c('input',{attrs:{"type":"file","hidden":"","accept":"application/pdf"},on:{"change":_vm.uploadCertificateOfInheritance}})]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.certificateOfInheritance)?_c('b-btn',{staticClass:"p-0 w-100 mt-4 mb-0 rounded-0 btn-certificate",attrs:{"variant":"transparent"},on:{"click":_vm.downloadCertificateOfInheritance}},[_c('b-alert',{staticClass:"rounded-0 certificate pb-0 mb-0",attrs:{"show":"","variant":"dark"}},[_c('p',[_c('span',{staticClass:"ti-printer mr-2"}),_vm._v("\n                  "+_vm._s(_vm.$t('message.adminUserDocuments.viewCoi'))+"\n                ")])])],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right"},[(_vm.certificateOfInheritance)?_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.delete-coi-modal",modifiers:{"delete-coi-modal":true}}],staticClass:"mt-3",attrs:{"variant":"danger"}},[_vm._v("\n              "+_vm._s(_vm.$t('message.adminUserDocuments.deleteDocument'))+"\n            ")]):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"delete-cod-modal","cancel-variant":"primary","ok-variant":"danger","title":_vm.$t('message.adminUserDocuments.modal.title'),"ok-title":_vm.$t('message.adminUserDocuments.modal.btn.ok'),"cancel-title":_vm.$t('message.adminUserDocuments.modal.btn.cancel')},on:{"ok":_vm.deleteCertificateOfDeath}},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.adminUserDocuments.modal.message')))])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"delete-coi-modal","cancel-variant":"primary","ok-variant":"danger","title":_vm.$t('message.adminUserDocuments.modal.title'),"ok-title":_vm.$t('message.adminUserDocuments.modal.btn.ok'),"cancel-title":_vm.$t('message.adminUserDocuments.modal.btn.cancel')},on:{"ok":_vm.deleteCertificateOfInheritance}},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.adminUserDocuments.modal.message')))])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"delete-poa-modal","cancel-variant":"primary","ok-variant":"danger","title":_vm.$t('message.adminUserDocuments.modal.title'),"ok-title":_vm.$t('message.adminUserDocuments.modal.btn.ok'),"cancel-title":_vm.$t('message.adminUserDocuments.modal.btn.cancel')},on:{"ok":_vm.deletePowerOfAttorney}},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.adminUserDocuments.modal.message')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AE0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderView_vue__ = __webpack_require__("Qaka");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdb6f89c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderView_vue__ = __webpack_require__("cJ7x");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdb6f89c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AHrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Infobox_vue__ = __webpack_require__("zC/Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5240e048_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Infobox_vue__ = __webpack_require__("LNCa");
function injectStyle (ssrContext) {
  __webpack_require__("GZFa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5240e048"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Infobox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5240e048_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Infobox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AIXB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form',{staticClass:"mt-2",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-row',[_c('b-col',{attrs:{"offset-md":"2","offset-lg":"3"}},[_c('avatar-form',{attrs:{"avatar":_vm.avatar,"isReadonly":_vm.isReadonly},on:{"onUpdateAvatar":_vm.updateAvatar}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label-for":"salutation","label":_vm.$t('message.personalInformationForm.label.salutation'),"state":_vm.$v.salutation.$error ? false : null,"invalid-feedback":_vm.$t('error.personalInformationForm.salutation')}},[(!_vm.isReadonly)?_c('b-form-select',{staticClass:"rounded-0",attrs:{"id":"salutation","options":_vm.salutations,"state":_vm.$v.salutation.$error ? false : null},on:{"changed":function($event){_vm.$v.salutation.$touch()}},model:{value:(_vm.salutation),callback:function ($$v) {_vm.salutation=$$v},expression:"salutation"}}):_c('b-form-input',{staticClass:"rounded-0",class:{'text-muted': _vm.isReadonly},attrs:{"id":"salutation","disabled":_vm.isReadonly,"value":_vm.$t('enums.salutations.' + _vm.personalInfo.salutation)}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-for":"first-name","label":_vm.$t('message.personalInformationForm.label.firstName'),"state":_vm.$v.firstName.$error ? false : null,"invalid-feedback":_vm.$t('error.personalInformationForm.firstName')}},[_c('b-form-input',{staticClass:"rounded-0",attrs:{"id":"first-name","disabled":_vm.isReadonly,"state":_vm.$v.firstName.$error ? false : null},on:{"changed":function($event){_vm.$v.firstName.$touch()}},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-for":"date-of-birth","label":_vm.$t('message.personalInformationForm.label.dateOfBirth'),"state":_vm.$v.dateOfBirth.$error ? false : null,"invalid-feedback":_vm.$t('error.personalInformationForm.dateOfBirth')}},[_c('b-form-input',{staticClass:"rounded-0",class:{'text-muted': _vm.isReadonly},attrs:{"id":"date-of-birth","placeholder":"TT.MM.JJJJ","disabled":_vm.isReadonly,"state":_vm.$v.dateOfBirth.$error ? false : null},on:{"change":function($event){_vm.$v.dateOfBirth.$touch()}},model:{value:(_vm.dateOfBirth),callback:function ($$v) {_vm.dateOfBirth=$$v},expression:"dateOfBirth"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('message.personalInformationForm.label.title'),"label-for":"title"}},[_c('b-form-input',{staticClass:"rounded-0",class:{'text-muted': _vm.isReadonly},attrs:{"id":"title","disabled":_vm.isReadonly},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label-for":"last-name","label":_vm.$t('message.personalInformationForm.label.lastName'),"state":_vm.$v.lastName.$error ? false : null,"invalid-feedback":_vm.$t('error.personalInformationForm.lastName')}},[_c('b-form-input',{staticClass:"rounded-0",class:{'text-muted': _vm.isReadonly},attrs:{"id":"last-name","disabled":_vm.isReadonly,"state":_vm.$v.lastName.$error ? false : null},on:{"change":function($event){_vm.$v.lastName.$touch()}},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticClass:"text-right"},[(_vm.isReadonly)?_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.setReadonly(!_vm.isReadonly)}}},[_c('span',{staticClass:"ti-pencil mr-2"}),_vm._v("\n          "+_vm._s(_vm.$t('message.personalInformationForm.btn.edit'))+"\n        ")]):_c('div',[_c('b-btn',{attrs:{"variant":"danger"},on:{"click":_vm.cancel}},[_c('span',{staticClass:"ti-close mr-2"}),_vm._v("\n            "+_vm._s(_vm.$t('message.personalInformationForm.btn.cancel'))+"\n          ")]),_vm._v(" "),(this.$store.getters.currentUser.avatar)?_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.deleteAvatarModal",modifiers:{"deleteAvatarModal":true}}],attrs:{"variant":"danger"}},[_c('span',{staticClass:"ti-trash mr-2"}),_vm._v("\n            "+_vm._s(_vm.$t('message.avatar.btn.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.submit}},[_c('span',{staticClass:"ti-save mr-2"}),_vm._v("\n            "+_vm._s(_vm.$t('message.personalInformationForm.btn.save'))+"\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"deleteAvatarModal","cancel-variant":"primary","ok-variant":"danger","title":_vm.$t('message.avatar.questionTitle'),"ok-title":_vm.$t('message.avatar.btn.yes'),"cancel-title":_vm.$t('message.avatar.btn.no')},on:{"ok":_vm.deleteAvatar}},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.avatar.question')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ALQH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContractSummary',
  props: {
    contract: {
      type: Object,
      required: true
    },
    contractCategories: {
      type: Array,
      required: true
    }
  },
  computed: {
    contractAddress: function contractAddress() {
      return this.contract.address;
    },
    contractPartner: function contractPartner() {
      return this.contract.contractPartner;
    },
    contractCategoryText: function contractCategoryText() {
      var _this = this;

      if (this.contract.contractCategory) {
        var filteredCategories = this.contractCategories.filter(function (contractCategory) {
          return contractCategory.value === _this.contract.contractCategory;
        });
        if (filteredCategories.length > 0) {
          return filteredCategories[0].text;
        }
      }
      return '';
    },
    contractNumberText: function contractNumberText() {
      return this.contract.contractCategory === 'INSURANCE' ? this.$t('message.contractInformationForm.label.insuranceNumber') : this.$t('message.contractInformationForm.label.contractNumber');
    },
    fullName: function fullName() {
      var currentUser = this.$store.getters.currentUser;
      if (currentUser) {
        return currentUser.firstName + ' ' + currentUser.lastName;
      } else {
        return '';
      }
    }
  }
});

/***/ }),

/***/ "AeLq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    avatar: {
      required: true
    },
    isReadonly: {
      type: Boolean,
      required: true
    },
    maxFileSize: {
      type: Number,
      default: 6 * 1024 * 1024
    },
    maxHeight: {
      type: Number,
      default: 600
    },
    maxWidth: {
      type: Number,
      default: 600
    },
    size: {
      type: String
    }
  },
  computed: {
    avatarSrc: function avatarSrc() {
      return this.avatar && this.avatar.uuid ? "https://meine-vertraege.net:8080" + 'avatars/' + this.avatar.uuid : this.avatar;
    },
    avatarWidth: function avatarWidth() {
      if (this.size && this.size === 'sm') {
        return 100;
      }
      return 150;
    },
    avatarHeight: function avatarHeight() {
      if (this.size && this.size === 'sm') {
        return 100;
      }
      return 150;
    }
  },
  data: function data() {
    return {
      selectorStyles: {
        'cursor': 'pointer'
      }
    };
  },

  methods: {
    onFileChanged: function onFileChanged(event) {
      var _this = this;

      var selectedFile = event.target.files[0];
      event.target.value = null;
      if (selectedFile) {
        var reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = function (readerEvent) {
          var image = new Image();
          var newAvatar = readerEvent.target.result;
          image.src = newAvatar;
          image.onerror = function () {
            _this.showErrorMsg({
              message: _this.$t('error.avatar.wrongFileType')
            });
          };
          image.onload = function () {
            if (_this.validteImage(selectedFile, image)) {
              _this.$emit('onUpdateAvatar', selectedFile, newAvatar);
              _this.avatarName = selectedFile.name;
            }
          };
        };
      }
    },
    validteImage: function validteImage(file, image) {
      if (file.size > this.maxFileSize) {
        this.showErrorMsg({
          message: this.$t('error.avatar.fileToolarge')
        });
        return false;
      }
      if (image.height > this.maxHeight || image.width > this.maxHeight) {
        this.showErrorMsg({
          message: this.$t('error.avatar.wrongDimensions')
        });
        return false;
      }
      return true;
    }
  },
  notifications: {
    showErrorMsg: {
      type: 'error'
    }
  }
});

/***/ }),

/***/ "ArdV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('cookie-law',{attrs:{"theme":"afterlife","buttonText":_vm.$t('message.cookiePopup.ok'),"message":_vm.$t('message.cookiePopup.message'),"position":"bottom","transitionName":"fade"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AxMl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__ = __webpack_require__("AE0Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Terms',
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__["a" /* default */]
  }
});

/***/ }),

/***/ "B2yE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form',{staticClass:"mt-2"},[_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v("\n          "+_vm._s(_vm.$t('message.contractInformationForm.label.contractCategory'))+"\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-select',{ref:"contractCategory",staticClass:"rounded-0",attrs:{"id":"contractCategory","value":_vm.contract.contractCategory,"state":_vm.$v.contract.contractCategory.$error ? false : null},on:{"change":_vm.contractCategoryChanged}},[_c('template',{slot:"first"},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("-- "+_vm._s(this.$t('message.contractInformationForm.option.null'))+" --")])]),_vm._v(" "),_vm._l((_vm.contractCategories),function(contractCategory){return _c('option',{key:contractCategory.value,domProps:{"value":contractCategory.value}},[_vm._v("\n            "+_vm._s(contractCategory.text)+"\n          ")])})],2)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v("\n          "+_vm._s(_vm.$t('message.contractInformationForm.label.contractType'))+"\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.contract.contractType.$error ? false : null,"invalid-feedback":_vm.$t('error.contractInformationForm.contractType')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"contractType","placeholder":_vm.getPlaceholderLabel(_vm.contract.contractCategory),"state":_vm.$v.contract.contractType.$error ? false : null},on:{"change":function($event){_vm.$v.contract.contractType.$touch()}},model:{value:(_vm.contract.contractType),callback:function ($$v) {_vm.$set(_vm.contract, "contractType", $$v)},expression:"contract.contractType"}})],1)],1)],1),_vm._v(" "),(_vm.contract.contractCategory === 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT')?_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.username'))+"\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.contract.accountUsername.$error ? false : null,"invalid-feedback":_vm.$t('error.contractInformationForm.username')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"username","state":_vm.$v.contract.accountUsername.$error ? false : null},on:{"change":function($event){_vm.$v.contract.accountUsername.$touch()}},model:{value:(_vm.contract.accountUsername),callback:function ($$v) {_vm.$set(_vm.contract, "accountUsername", $$v)},expression:"contract.accountUsername"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.contract.contractCategory === 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT')?_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.link')))])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.contract.accountLink.$error ? false : null,"invalid-feedback":_vm.$t('error.contractInformationForm.link')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"link","state":_vm.$v.contract.accountLink.$error ? false : null},on:{"change":function($event){_vm.$v.contract.accountLink.$touch()}},model:{value:(_vm.contract.accountLink),callback:function ($$v) {_vm.$set(_vm.contract, "accountLink", $$v)},expression:"contract.accountLink"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.contract.contractCategory !== 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT')?_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v("\n          "+_vm._s(_vm.contractNumberText)+"\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.contract.contractNumber.$error ? false : null,"invalid-feedback":_vm.$t('error.contractInformationForm.contractNumber')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"contractNumber","placeholder":_vm.$t('message.contractInformationForm.contractPlaceholder.universal.exampleUserContractNumber'),"state":_vm.$v.contract.contractNumber.$error ? false : null},on:{"change":function($event){_vm.$v.contract.contractNumber.$touch()}},model:{value:(_vm.contract.contractNumber),callback:function ($$v) {_vm.$set(_vm.contract, "contractNumber", $$v)},expression:"contract.contractNumber"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.contract.contractCategory === 'INSURANCE')?_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v("\n          "+_vm._s(_vm.$t('message.contractInformationForm.label.insuredPersonNumber'))+"\n        ")])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.contract.insuredPersonNumber.$error ? false : null,"invalid-feedback":_vm.$t('error.contractInformationForm.insuredPersonNumber')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"policy-holder-number","placeholder":_vm.$t('message.contractInformationForm.contractPlaceholder.universal.exampleUserContractNumber'),"state":_vm.$v.contract.insuredPersonNumber.$error ? false : null},on:{"change":function($event){_vm.$v.contract.insuredPersonNumber.$touch()}},model:{value:(_vm.contract.insuredPersonNumber),callback:function ($$v) {_vm.$set(_vm.contract, "insuredPersonNumber", $$v)},expression:"contract.insuredPersonNumber"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.contract.contractCategory === 'FINANCE')?_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v("\n          "+_vm._s(_vm.$t('message.contractInformationForm.label.accountNumber'))+"\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.contract.accountNumber.$error ? false : null,"invalid-feedback":_vm.$t('error.contractInformationForm.accountNumber')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"account-number","placeholder":_vm.$t('message.contractInformationForm.contractPlaceholder.universal.exampleUserContractNumber'),"state":_vm.$v.contract.accountNumber.$error ? false : null},on:{"change":function($event){_vm.$v.contract.accountNumber.$touch()}},model:{value:(_vm.contract.accountNumber),callback:function ($$v) {_vm.$set(_vm.contract, "accountNumber", $$v)},expression:"contract.accountNumber"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.contract.contractCategory !== 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT')?_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.conclusionDate')))])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.conclusionDate.$error ? false : null,"invalid-feedback":_vm.$t('error.contractInformationForm.conclusionDate')}},[_c('b-form-input',{staticClass:"rounded-0",attrs:{"id":"conclusionDate","placeholder":"TT.MM.JJJJ","state":_vm.$v.conclusionDate.$error ? false : null},on:{"change":function($event){_vm.$v.conclusionDate.$touch()}},model:{value:(_vm.conclusionDate),callback:function ($$v) {_vm.conclusionDate=$$v},expression:"conclusionDate"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.contract.contractCategory !== 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT')?_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.contractDuration')))])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.contract.contractDuration.$error ? false : null,"invalid-feedback":_vm.$t('error.contractInformationForm.contractDuration')}},[_c('b-input-group',{attrs:{"append":_vm.$t('message.contractInformationForm.label.inMonths')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"contractDuration","type":"number","min":"0","state":_vm.$v.contract.contractDuration.$error ? false : null},on:{"change":function($event){_vm.$v.contract.contractDuration.$touch()}},model:{value:(_vm.contract.contractDuration),callback:function ($$v) {_vm.$set(_vm.contract, "contractDuration", _vm._n($$v))},expression:"contract.contractDuration"}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.contract.contractCategory !== 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT')?_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.cancellationPeriod')))])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.contract.cancellationPeriod.$error ? false : null,"invalid-feedback":_vm.$t('error.contractInformationForm.cancellationPeriod')}},[_c('b-input-group',{attrs:{"append":_vm.$t('message.contractInformationForm.label.inMonths')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"cancellationPeriod","type":"number","min":"0","state":_vm.$v.contract.cancellationPeriod.$error ? false : null},on:{"change":function($event){_vm.$v.contract.cancellationPeriod.$touch()}},model:{value:(_vm.contract.cancellationPeriod),callback:function ($$v) {_vm.$set(_vm.contract, "cancellationPeriod", _vm._n($$v))},expression:"contract.cancellationPeriod"}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.comment')))])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.contract.comment.$error ? false : null,"invalid-feedback":_vm.$t('error.contractInformationForm.comment')}},[_c('b-form-textarea',{staticClass:"rounded-0",attrs:{"id":"comment","rows":5,"max-rows":5,"state":_vm.$v.contract.comment.$error ? false : null},on:{"change":function($event){_vm.$v.contract.comment.$touch()}},model:{value:(_vm.contract.comment),callback:function ($$v) {_vm.$set(_vm.contract, "comment", $$v)},expression:"contract.comment"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3 ",attrs:{"offset":"3"}},[_c('div',{staticClass:"requieredFields text-right"},[_c('span',{domProps:{"innerHTML":_vm._s( _vm.$t('message.contractPartnerDetails.label.requiredFields'))}})])])],1)],1),_vm._v(" "),_c('b-modal',{ref:"contractCategoryModal",attrs:{"id":"contractCategoryModal","modal-class":"rounded-0","title":_vm.$t('message.contractInformationForm.contractCategoryModal.title'),"ok-title":_vm.$t('message.contractInformationForm.contractCategoryModal.btn.ok'),"cancel-title":_vm.$t('message.contractInformationForm.contractCategoryModal.btn.cancel')},on:{"ok":_vm.setContractCategory,"cancel":_vm.revertContractCategory}},[_vm._v("\n    "+_vm._s(_vm.$t('message.contractInformationForm.contractCategoryModal.message'))+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bzl3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue__ = __webpack_require__("Gdf+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778f8820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueGoogleAutocomplete_vue__ = __webpack_require__("rP78");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778f8820_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueGoogleAutocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C2pS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C78q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_simple_spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccountPowerOfAttorneyForm',

  destroyed: function destroyed() {
    this.$store.commit('setPowerOfAttorney', null);
  },

  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_0_vue_simple_spinner___default.a
  },
  computed: {
    fullName: function fullName() {
      var title = this.user.title ? this.user.title : '';
      var firstName = this.user.firstName ? this.user.firstName : '';
      var lastName = this.user.lastName ? this.user.lastName : '';
      return title + ' ' + firstName + ' ' + lastName;
    },
    poa: function poa() {
      return this.$store.getters.powerOfAttorney;
    }
  },
  created: function created() {
    var _this = this;

    if (!this.$store.getters.powerOfAttorney) {
      this.loading = true;
      this.$store.dispatch('getPowerOfAttorney').finally(function () {
        _this.loading = false;
      });
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },

  methods: {
    revoke: function revoke() {
      this.onRevokePoaFn();
    },
    uploadPoa: function uploadPoa(event) {
      var _this2 = this;

      var selectedFile = event.target.files[0];
      if (selectedFile) {
        this.loading = true;
        this.$store.dispatch('uploadPowerOfAttorney', selectedFile).then(function () {
          _this2.showSuccessMsg({
            message: _this2.$t('message.accountPowerOfAttorneyForm.uploadSuccess')
          });
        }).catch(function () {
          _this2.showErrorMsg({
            message: _this2.$t('error.accountPowerOfAttorneyForm.uploadFailure')
          });
        }).finally(function () {
          _this2.loading = false;
        });
      }
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    onPrintPoaFn: {
      type: Function,
      required: true
    },
    onRevokePoaFn: {
      type: Function,
      required: true
    }
  },
  notifications: {
    showSuccessMsg: {
      type: 'success'
    },
    showErrorMsg: {
      type: 'error'
    }
  }
});

/***/ }),

/***/ "C8AS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    item: { required: true }
  }
});

/***/ }),

/***/ "CxbK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',[_c('b-form-group',[_c('template',{slot:"label"},[_vm._v("\n      "+_vm._s(_vm.$t('message.adminContractPartnerDetails.label.name'))+"\n      "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",model:{value:(_vm.contractPartnerName),callback:function ($$v) {_vm.contractPartnerName=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"contractPartnerName"}})],2),_vm._v(" "),_c('b-form-group',[_c('template',{slot:"label"},[_vm._v("\n      "+_vm._s(_vm.$t('message.adminContractPartnerDetails.label.email'))+"\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",model:{value:(_vm.email),callback:function ($$v) {_vm.email=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"email"}})],2),_vm._v(" "),_c('b-form-group',[_c('template',{slot:"label"},[_vm._v("\n      "+_vm._s(_vm.$t('message.adminContractPartnerDetails.label.domain'))+"\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",model:{value:(_vm.domain),callback:function ($$v) {_vm.domain=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"domain"}})],2),_vm._v(" "),_c('b-form-group',[_c('template',{slot:"label"},[_vm._v("\n      "+_vm._s(_vm.$t('message.adminContractPartnerDetails.label.street'))+"\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",model:{value:(_vm.street),callback:function ($$v) {_vm.street=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"street"}})],2),_vm._v(" "),_c('b-form-group',[_c('template',{slot:"label"},[_vm._v("\n      "+_vm._s(_vm.$t('message.adminContractPartnerDetails.label.streetNumber'))+"\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",model:{value:(_vm.streetNumber),callback:function ($$v) {_vm.streetNumber=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"streetNumber"}})],2),_vm._v(" "),_c('b-form-group',[_c('template',{slot:"label"},[_vm._v("\n      "+_vm._s(_vm.$t('message.adminContractPartnerDetails.label.postalCode'))+"\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",model:{value:(_vm.postalCode),callback:function ($$v) {_vm.postalCode=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"postalCode"}})],2),_vm._v(" "),_c('b-form-group',[_c('template',{slot:"label"},[_vm._v("\n      "+_vm._s(_vm.$t('message.adminContractPartnerDetails.label.postOfficeBox'))+"\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",model:{value:(_vm.postOfficeBox),callback:function ($$v) {_vm.postOfficeBox=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"postOfficeBox"}})],2),_vm._v(" "),_c('b-form-row',{staticClass:"mt-5"},[_c('b-col',[_c('b-btn',{staticClass:"rounded-0 px-0",attrs:{"variant":"link"},on:{"click":function($event){_vm.$emit('onCancel')}}},[_vm._v("\n        "+_vm._s(_vm.$t('message.adminContractPartnerDetails.btn.back'))+"\n      ")])],1),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"d-flex flex-row"},[_c('div',{staticClass:"ml-auto"},[(_vm.isDeletable)?_c('b-btn',{attrs:{"variant":"danger"},on:{"click":function($event){_vm.$emit('onDelete')}}},[_vm._v("\n            "+_vm._s(_vm.$t('message.adminContractPartnerDetails.btn.delete'))+"\n          ")]):_vm._e(),_vm._v(" "),_c('b-btn',{staticClass:"ml-4",attrs:{"variant":"primary"},on:{"click":function($event){_vm.$emit('onSave')}}},[_vm._v("\n            "+_vm._s(_vm.$t('message.adminContractPartnerDetails.btn.save'))+"\n          ")])],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__ = __webpack_require__("2DBr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");





var poolData = {
  UserPoolId: "eu-west-1_dOc22sDBM",
  ClientId: "6gfthh7rp5dk0b29bc0dplqqmj"
};

var userPool = new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["a" /* CognitoUserPool */](poolData);

var getCognitoUser = function getCognitoUser(username) {
  var userData = {
    Username: username,
    Pool: userPool
  };

  return new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["b" /* CognitoUser */](userData);
};

var getCognitoUserSession = function getCognitoUserSession(currentUser) {
  var sessionData = {
    IdToken: new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["c" /* CognitoIdToken */]({ IdToken: currentUser.idToken }),
    AccessToken: new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["d" /* CognitoAccessToken */]({ AccessToken: currentUser.accessToken }),
    RefreshToken: new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["e" /* CognitoRefreshToken */]({ RefreshToken: currentUser.refreshToken })
  };
  return new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["f" /* CognitoUserSession */](sessionData);
};

var logoutTimer = null;

var state = {
  autoLogout: {
    isAutoLogout: false,
    salutation: null,
    firstName: null,
    lastName: null
  }
};

var getters = {
  autoLogout: function autoLogout(state) {
    return state.autoLogout;
  }
};

var mutations = {
  setAutoLogout: function setAutoLogout(state, autoLogout) {
    state.autoLogout = autoLogout;
  }
};

var actions = {
  setLogoutTimer: function setLogoutTimer(_ref) {
    var commit = _ref.commit,
        getters = _ref.getters,
        dispatch = _ref.dispatch;

    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
    logoutTimer = setTimeout(function () {
      dispatch('signOut').then(function () {
        commit('setAutoLogout', {
          isAutoLogout: true,
          salutation: getters.currentUser.salutation,
          firstName: getters.currentUser.firstName,
          lastName: getters.currentUser.lastName
        });
        commit('setCurrentUser', {});
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/signin');
      });
    }, 20 * 1000 * 60);
  },
  changePassword: function changePassword(_ref2, data) {
    var getters = _ref2.getters,
        dispatch = _ref2.dispatch,
        commit = _ref2.commit;

    var currentUser = getters.currentUser;
    var cognitoUser = getCognitoUser(currentUser.email);
    cognitoUser.setSignInUserSession(getCognitoUserSession(currentUser));
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      cognitoUser.changePassword(data.oldPassword, data.newPassword, function (err, result) {
        if (!err) {
          dispatch('changedPassword');
          resolve();
        } else {
          reject(err);
        }
      });
    });
  },
  confirmResetPassword: function confirmResetPassword(_ref3, data) {
    var commit = _ref3.commit;

    var cognitoUser = getCognitoUser(data.email);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      cognitoUser.confirmPassword(data.verificationCode, data.password, {
        onSuccess: function onSuccess() {
          resolve();
        },
        onFailure: function onFailure(err) {
          reject(err);
        }
      });
    });
  },
  confirmSignUp: function confirmSignUp(_ref4, data) {
    var commit = _ref4.commit;

    var cognitoUser = getCognitoUser(data.email);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      cognitoUser.confirmRegistration(data.verificationCode, true, function (err, result) {
        if (err) {
          reject(err);
        }
        resolve();
      });
    });
  },
  deleteCognitoUser: function deleteCognitoUser(_ref5) {
    var getters = _ref5.getters,
        dispatch = _ref5.dispatch,
        commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var cognitoUser = getCognitoUser(currentUser.email);
      cognitoUser.setSignInUserSession(getCognitoUserSession(currentUser));
      if (cognitoUser) {
        // Workaround because Cognito will call the callback twice
        var callbackCounter = 0;
        cognitoUser.deleteUser(function (err, result) {
          if (!err && callbackCounter === 0) {
            callbackCounter++;
            dispatch('deleteCurrentUser').then(function () {
              commit('setCurrentUser', {});
              resolve();
            }).catch(function (err) {
              return reject(err);
            });
          } else if (err) {
            reject(err);
          } else {
            resolve();
          }
        });
      } else {
        reject('User is not signed in');
      }
    });
  },
  resendConfirmSignUpCode: function resendConfirmSignUpCode(_ref6, email) {
    var commit = _ref6.commit;

    var cognitoUser = getCognitoUser(email);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      cognitoUser.resendConfirmationCode(function (err, result) {
        if (err) {
          reject(err);
        }
        resolve();
      });
    });
  },
  resetPassword: function resetPassword(_ref7, email) {
    var commit = _ref7.commit;

    var cognitoUser = getCognitoUser(email);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      cognitoUser.forgotPassword({
        onSuccess: function onSuccess(data) {
          resolve();
        },
        onFailure: function onFailure(error) {
          reject(error);
        }
      });
    });
  },
  signIn: function signIn(_ref8, authData) {
    var dispatch = _ref8.dispatch,
        getters = _ref8.getters,
        commit = _ref8.commit;

    var authenticationData = {
      Username: authData.email,
      Password: authData.password
    };
    var authDetails = new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["g" /* AuthenticationDetails */](authenticationData);
    var cognitoUser = getCognitoUser(authenticationData.Username);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      cognitoUser.authenticateUser(authDetails, {
        onSuccess: function onSuccess(session) {
          var cognitoId = cognitoUser.username;
          var idToken = session.idToken.getJwtToken();
          var accessToken = session.accessToken.getJwtToken();
          var refreshToken = session.refreshToken.token;
          var expirationDate = new Date(session.idToken.payload.exp * 1000 - 30 * 60000);
          localStorage.setItem('cognitoId', cognitoId);
          localStorage.setItem('idToken', idToken);
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', refreshToken);
          localStorage.setItem('expirationDate', expirationDate);
          var invitation = getters.invitation;
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(invitation).length > 0) {
            var contactPersonRelation = {
              idToken: idToken,
              invitationUuid: invitation.uuid,
              relationshipType: invitation.relation
            };
            dispatch('createContactPersonRelation', contactPersonRelation).then(function () {
              return dispatch('setCurrentUser', {
                cognitoId: cognitoId,
                idToken: idToken,
                accessToken: accessToken,
                refreshToken: refreshToken,
                expirationDate: expirationDate
              });
            }).then(function () {
              commit('setInvitation', {});
              resolve();
            }).catch(function (err) {
              return reject(err);
            });
          } else {
            dispatch('setCurrentUser', {
              cognitoId: cognitoId,
              idToken: idToken,
              accessToken: accessToken,
              refreshToken: refreshToken,
              expirationDate: expirationDate
            }).then(function () {
              resolve();
            }).catch(function (err) {
              return reject(err);
            });
          }
        },
        onFailure: function onFailure(error) {
          reject(error);
        }
      });
    });
  },
  tryAutoLogin: function tryAutoLogin(_ref9) {
    var dispatch = _ref9.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cognitoId = localStorage.getItem('cognitoId');
      var accessToken = localStorage.getItem('accessToken');
      var refreshToken = localStorage.getItem('refreshToken');
      var idToken = localStorage.getItem('idToken');
      var expirationDate = localStorage.getItem('expirationDate');
      if (!idToken) {
        reject();
      } else {
        dispatch('setCurrentUser', {
          cognitoId: cognitoId,
          idToken: idToken,
          accessToken: accessToken,
          refreshToken: refreshToken,
          expirationDate: expirationDate
        }).then(function () {
          return resolve();
        }).catch(function () {
          return reject();
        });
      }
    });
  },
  signOut: function signOut(_ref10) {
    var getters = _ref10.getters;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      if (currentUser) {
        var cognitoUser = getCognitoUser(currentUser.email);
        cognitoUser.setSignInUserSession(getCognitoUserSession(currentUser));
        cognitoUser.signOut();
        localStorage.clear();
        resolve();
      } else {
        reject();
      }
    });
  },
  signUp: function signUp(_ref11, regData) {
    var dispatch = _ref11.dispatch,
        commit = _ref11.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var attributes = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(regData).map(function (key) {
        switch (key) {
          case 'email':
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'email', Value: regData['email'] }));
            break;
          case 'firstName':
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'given_name', Value: regData['firstName'] }));
            break;
          case 'lastName':
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'name', Value: regData['lastName'] }));
            break;
          case 'salutation':
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'custom:salutation', Value: regData['salutation'] }));
            break;
          case 'dateOfBirth':
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'birthdate', Value: regData['dateOfBirth'] }));
            break;
          case 'contractNumber':
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'custom:contractNumber', Value: regData['contractNumber'] }));
            break;
          case 'roles':
            var roles = regData['roles'];
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'custom:role', Value: roles[0].roleOfUser }));
            break;
          case 'relation':
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'custom:relationship', Value: regData['relation'] }));
            break;
          case 'invitationUuid':
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'custom:invitationUuid', Value: regData['invitationUuid'] }));
            break;
          case 'invitationEmail':
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'custom:invitationEmail', Value: regData['invitationEmail'] }));
            break;
          case 'invitationInviterId':
            attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */]({ Name: 'custom:invitationInviterId', Value: regData['invitationInviterId'].toString() }));
            break;
          default:
            break;
        }
      });

      if (regData.invitationUuid) {
        userPool.signUp(regData.email, regData.password, attributes, null, function (err, data) {
          if (!err) {
            commit('setInvitation', {});
            resolve();
          }
          reject(err);
        });
      } else {
        dispatch('validateContractNumber', regData).then(function () {
          userPool.signUp(regData.email, regData.password, attributes, null, function (err, data) {
            if (!err) {
              resolve();
            }
            reject(err);
          });
        }).catch(function (err) {
          reject(err.response.data);
        });
      }
    });
  },
  updateAttributes: function updateAttributes(_ref12, attributes) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch,
        getters = _ref12.getters;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var cognitoUser = getCognitoUser(currentUser.email);
      cognitoUser.setSignInUserSession(getCognitoUserSession(currentUser));
      var cognitoUserAttributes = attributes.map(function (attr) {
        return new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoUserAttribute */](attr);
      });
      cognitoUser.updateAttributes(cognitoUserAttributes, function (err, result) {
        if (!err) {
          dispatch('refreshSession').then(function () {
            return resolve();
          }).catch(function () {
            return reject();
          });
        } else {
          reject();
        }
      });
    });
  },
  refreshSession: function refreshSession(_ref13) {
    var commit = _ref13.commit,
        getters = _ref13.getters;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var cognitoUser = getCognitoUser(currentUser.email);
      cognitoUser.setSignInUserSession(getCognitoUserSession(currentUser));
      cognitoUser.refreshSession(cognitoUser.signInUserSession.refreshToken, function (err, success) {
        if (!err) {
          currentUser.idToken = success.idToken.getJwtToken();
          currentUser.accessToken = success.accessToken.getJwtToken();
          currentUser.refreshToken = success.refreshToken.token;
          currentUser.expirationDate = new Date(success.idToken.payload.exp * 1000 - 30 * 60000);
          commit('setCurrentUser', currentUser);
          resolve();
        } else {
          reject();
        }
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions,
  state: state,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4395f258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("t3gJ");
function injectStyle (ssrContext) {
  __webpack_require__("fpRT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4395f258_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DGwN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyHolderDetails_vue__ = __webpack_require__("Oai4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a51c4a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyHolderDetails_vue__ = __webpack_require__("2vMh");
function injectStyle (ssrContext) {
  __webpack_require__("xmeH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a51c4a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyHolderDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a51c4a8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyHolderDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DHB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppSidebar',
  computed: {
    isContactPerson: function isContactPerson() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesContactPerson = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'CONTACT_PERSON';
        });
        if (rolesContactPerson.length > 0) {
          return true;
        }
      }
      return false;
    },
    isPolicyHolder: function isPolicyHolder() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesPolicyHolder = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'POLICY_HOLDER';
        });
        if (rolesPolicyHolder.length > 0) {
          return true;
        }
      }
      return false;
    },
    policyHolders: function policyHolders() {
      return this.$store.getters.policyHolders;
    },
    userName: function userName() {
      var currentUser = this.$store.getters.currentUser;
      return currentUser.firstName + ' ' + currentUser.lastName;
    }
  },
  created: function created() {
    if (this.$store.getters.policyHolders.length === 0 && this.isContactPerson) {
      this.$store.dispatch('fetchPolicyHolders');
    }
  }
});

/***/ }),

/***/ "DrUZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractList_vue__ = __webpack_require__("0b9e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba5519a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractList_vue__ = __webpack_require__("gJbj");
function injectStyle (ssrContext) {
  __webpack_require__("yTxD")
  __webpack_require__("eFgi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ba5519a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba5519a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DynV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserStatus_vue__ = __webpack_require__("Efq9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04643626_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserStatus_vue__ = __webpack_require__("mcd1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04643626_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E8ON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-2"},[_c('b-col',[(_vm.contactPersons && _vm.contactPersons.length !== 0)?_c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v("\n        "+_vm._s(_vm.$t('message.adminUserContactPerson.title'))+"\n      ")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","responsive":"","fields":_vm.fields,"items":_vm.contactPersons,"tbody-class":"text-muted"},scopedSlots:_vm._u([{key:"dateOfBirth",fn:function(row){return [_vm._v("\n          "+_vm._s(_vm.$moment(row.item.dateOfBirth, 'YYYY-MM-DD').format('DD.MM.YYYY'))+"\n        ")]}},{key:"city",fn:function(row){return [_c('span',{domProps:{"innerHTML":_vm._s(row.item.addresses.map(function (address) { return address.city; }).join(', <br>'))}})]}},{key:"postalCode",fn:function(row){return [_c('span',{domProps:{"innerHTML":_vm._s(row.item.addresses.map(function (address) { return address.postalCode; }).join(', <br>'))}})]}},{key:"relation",fn:function(row){return [_vm._v("\n          "+_vm._s(row.item.relationshipType? _vm.$t('enums.relationTypes.' + row.item.relationshipType) : null)+"\n        ")]}},{key:"street",fn:function(row){return [_c('span',{domProps:{"innerHTML":_vm._s(row.item.addresses.map(function (address) { return address.street; }).join(', <br>'))}})]}},{key:"streetNumber",fn:function(row){return [_c('span',{domProps:{"innerHTML":_vm._s(row.item.addresses.map(function (address) { return address.streetNumber; }).join(', <br>'))}})]}},{key:"actions",fn:function(row){return [_c('b-form-checkbox',{attrs:{"id":"heirCheckbox"},on:{"change":function($event){_vm.setHeirStatus($event, row.item.id)}},model:{value:(row.item.heir),callback:function ($$v) {_vm.$set(row.item, "heir", $$v)},expression:"row.item.heir"}})]}}])})],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ESy8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EWnC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"p-3 h-100 rounded-0",class:_vm.businessCardStyle,attrs:{"no-body":""}},[_c('div',{staticClass:"d-flex flex-row"},[_c('div',{staticClass:"mr-3 h-100 mb-3"},[_vm._t("bcImage",[_c('div',{staticClass:"circle rounded-circle"},[_c('img',{class:{'rounded-circle' : _vm.imageSrc, 'default-avatar' : !_vm.imageSrc},attrs:{"height":_vm.businessCardImageHeight,"width":_vm.businessCardImageWidth,"alt":_vm.$t('message.avatar.default'),"src":_vm.source}})])])],2),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column pt-1 mt-2 w-100"},[_c('h5',{staticClass:"text-left mb-3"},[_vm._v("\n        "+_vm._s(_vm.name)),_c('br'),_vm._v(" "),(_vm.relation)?_c('small',{staticClass:"text-muted font-italic"},[_vm._v("\n          "+_vm._s(_vm.$t('message.businessCard.relation'))+" "+_vm._s(_vm.relation)+"\n        ")]):_vm._e()]),_vm._v(" "),(_vm.userTitle)?_c('div',{staticClass:"text-left"},[_vm._v("\n        "+_vm._s(_vm.userTitle)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.contractNumber)?_c('div',{staticClass:"text-left"},[_vm._v("\n        "+_vm._s(_vm.contractNumber)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.createdAtFormatted)?_c('div',{staticClass:"text-left"},[_vm._v("\n        "+_vm._s(_vm.createdAtFormatted)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.roles)?_c('div',{staticClass:"text-left"},[_vm._v("\n        "+_vm._s(_vm.roles)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.dateOfBirthFormatted)?_c('div',{staticClass:"text-left"},[_vm._v("\n        "+_vm._s(_vm.dateOfBirthFormatted)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.email)?_c('div',{staticClass:"text-left"},[_vm._v("\n        "+_vm._s(_vm.email)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.phone)?_c('div',{staticClass:"text-left"},[_vm._v("\n        "+_vm._s(_vm.phone)+"\n      ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.status)?_c('div',{staticClass:"text-left"},[_vm._v("\n        "+_vm._s(_vm.$t('message.businessCard.status'))+" "+_vm._s(_vm.status)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.dateOfDeathFormatted)?_c('div',{staticClass:"text-left"},[_vm._v("\n        "+_vm._s(_vm.$t('message.businessCard.deceased'))+" "+_vm._s(_vm.dateOfDeathFormatted)+"\n      ")]):_vm._e()]),_vm._v(" "),(_vm.showIcon)?_c('div',[_c('span',{staticClass:"cross"},[_vm._v("†")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-left"},[_vm._t("bcFooter")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Efq9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("L/hj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminUserStatus',
  components: {},
  computed: {
    user: function user() {
      return this.$store.getters.userById || {};
    },
    userIsPolicyHolder: function userIsPolicyHolder() {
      var user = this.$store.getters.userById;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(user).length > 0) {
        var rolesPolicyHolder = user.roles.filter(function (role) {
          return role.roleOfUser === 'POLICY_HOLDER';
        });
        if (rolesPolicyHolder.length > 0) {
          return true;
        }
      }
      return false;
    },

    dateOfDeathField: {
      get: function get() {
        return this.user.dateOfDeath ? this.$moment(this.user.dateOfDeath, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
      },
      set: function set(newValue) {
        this.newDateOfDeath = newValue;
      }
    },
    aliveSelected: {
      get: function get() {
        if (this.user.dateOfDeath) {
          return false;
        }
        return this.aliveSelected2;
      },
      set: function set(newValue) {
        this.aliveSelected2 = newValue;
      }
    },
    doaOptions: function doaOptions() {
      return [{ text: this.$t('message.adminUserDetail.alive'), value: true, disabled: !!this.user.dateOfDeath }, { text: this.$t('message.adminUserDetail.dead'), value: false }];
    },

    legiSelected: {
      get: function get() {
        return this.user.isAuthorized;
      },
      set: function set(newValue) {
        this.user.isAuthorized = newValue;
      }
    },
    legiOptions: function legiOptions() {
      return [{ text: this.$t('message.adminUserDetail.yes'), value: true }, { text: this.$t('message.adminUserDetail.no'), value: false }];
    }
  },
  data: function data() {
    return {
      aliveSelected2: true,
      newDateOfDeath: null
    };
  },

  methods: {
    submitStatus: function submitStatus() {
      var _this = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (!(this.user.dateOfDeath || this.aliveSelected2)) {
          this.$store.dispatch('markAsDead', {
            id: this.user.id,
            dateOfDeath: this.$moment(this.newDateOfDeath, 'DD.MM.YYYY').format('YYYY-MM-DD')
          }).then(function () {
            _this.user.dateOfDeath = _this.user.dateOfDeath || _this.aliveSelected2 ? _this.user.dateOfDeath : _this.newDateOfDeath;
            _this.showSuccessMsg({
              message: _this.$t('message.adminUserStatus.update.death')
            });
          }).catch(function () {
            _this.showErrorMsg({
              message: _this.$t('error.adminUserStatus.update.death')
            });
          });
        }
        if (this.userIsPolicyHolder) {
          this.$store.dispatch('authorize', {
            id: this.user.id,
            isAuthorized: this.legiSelected
          }).then(function () {
            _this.user.isAuthorized = _this.legiSelected;
            _this.showSuccessMsg({
              message: _this.$t('message.adminUserStatus.update.legi')
            });
          }).catch(function () {
            _this.showErrorMsg({
              message: _this.$t('error.adminUserStatus.update.legi')
            });
          });
        } else {
          this.showErrorMsg({
            message: this.$t('error.adminUserStatus.update.legi')
          });
        }
      }
    }
  },
  validations: {
    newDateOfDeath: {
      isValidDate: __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].validators.isValidDate,
      required: function required(value) {
        if (this.aliveSelected2) {
          return true;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"])(value);
        }
      }
    }
  },
  notifications: {
    showSuccessMsg: {
      type: 'success'
    },
    showErrorMsg: {
      type: 'error'
    }
  }
});

/***/ }),

/***/ "F/9l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-group',{staticClass:"mt-4",attrs:{"state":_vm.$v.passwordData.oldPassword.$error ? false : null,"invalid-feedback":_vm.$t('error.changePasswordForm.oldPassword')}},[_c('label',[_vm._v("\n      "+_vm._s(_vm.$t('message.changePasswordForm.label.oldPassword'))+"\n      "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"type":"password","state":_vm.$v.passwordData.oldPassword.$error ? false : null},on:{"change":function($event){_vm.$v.passwordData.oldPassword.$touch()}},model:{value:(_vm.passwordData.oldPassword),callback:function ($$v) {_vm.$set(_vm.passwordData, "oldPassword", $$v)},expression:"passwordData.oldPassword"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mt-4",attrs:{"state":_vm.$v.passwordData.newPassword.$error ? false : null,"invalid-feedback":_vm.$t('error.changePasswordForm.newPassword')}},[_c('label',[_vm._v("\n      "+_vm._s(_vm.$t('message.changePasswordForm.label.newPassword'))+"\n      "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"type":"password","state":_vm.$v.passwordData.newPassword.$error ? false : null},on:{"change":function($event){_vm.$v.passwordData.newPassword.$touch()}},model:{value:(_vm.passwordData.newPassword),callback:function ($$v) {_vm.$set(_vm.passwordData, "newPassword", $$v)},expression:"passwordData.newPassword"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mt-4",attrs:{"state":_vm.$v.passwordData.newPasswordConfirm.$error ? false : null,"invalid-feedback":_vm.$t('error.changePasswordForm.newPasswordConfirm')}},[_c('label',[_vm._v("\n      "+_vm._s(_vm.$t('message.changePasswordForm.label.newPasswordConfirm'))+"\n      "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"type":"password","state":_vm.$v.passwordData.newPasswordConfirm.$error ? false : null},on:{"change":function($event){_vm.$v.passwordData.newPasswordConfirm.$touch()}},model:{value:(_vm.passwordData.newPasswordConfirm),callback:function ($$v) {_vm.$set(_vm.passwordData, "newPasswordConfirm", $$v)},expression:"passwordData.newPasswordConfirm"}})],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary","type":"submit"}},[_c('span',{staticClass:"ti-save mr-2"}),_vm._v("\n        "+_vm._s(_vm.$t('message.changePasswordForm.btn.save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F3JS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminContractPartnerForm',
  computed: {
    contractPartner: function contractPartner() {
      return this.$store.getters.adminContractPartner;
    },
    isDeletable: function isDeletable() {
      var isDeletable = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.contractPartner).find(function (key) {
        return key === 'isDeletable';
      });
      if (isDeletable && this.contractPartner.isDeletable) {
        return true;
      }
      return false;
    },

    city: {
      get: function get() {
        return this.contractPartner.city;
      },
      set: function set(city) {
        this.$store.commit('updateAdminContractPartnerCity', city);
      }
    },
    contractPartnerName: {
      get: function get() {
        return this.contractPartner.contractPartnerName;
      },
      set: function set(contractPartnerName) {
        this.$store.commit('updateAdminContractPartnerName', contractPartnerName);
      }
    },
    country: {
      get: function get() {
        return this.contractPartner.country;
      },
      set: function set(country) {
        this.$store.commit('updateAdminContractPartnerCountry', country);
      }
    },
    domain: {
      get: function get() {
        return this.contractPartner.domain;
      },
      set: function set(domain) {
        this.$store.commit('updateAdminContractPartnerDomain', domain);
      }
    },
    email: {
      get: function get() {
        return this.contractPartner.email;
      },
      set: function set(email) {
        this.$store.commit('updateAdminContractPartnerEmail', email);
      }
    },
    street: {
      get: function get() {
        return this.contractPartner.street;
      },
      set: function set(street) {
        this.$store.commit('updateAdminContractPartnerStreet', street);
      }
    },
    streetNumber: {
      get: function get() {
        return this.contractPartner.streetNumber;
      },
      set: function set(streetNumber) {
        this.$store.commit('updateAdminContractPartnerStreetNumber', streetNumber);
      }
    },
    postOfficeBox: {
      get: function get() {
        return this.contractPartner.postOfficeBox;
      },
      set: function set(postOfficeBox) {
        this.$store.commit('updateAdminContractPartnerPostOfficeBox', postOfficeBox);
      }
    },
    postalCode: {
      get: function get() {
        return this.contractPartner.postalCode;
      },
      set: function set(postalCode) {
        this.$store.commit('updateAdminContractPartnerPostalCode', postalCode);
      }
    }
  }
});

/***/ }),

/***/ "FXEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_AccountDeactivationForm__ = __webpack_require__("rWj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_account_AccountPowerOfAttorneyForm__ = __webpack_require__("WHS1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_account_AccountChangeEmailForm__ = __webpack_require__("u9Pz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account_ChangePasswordForm__ = __webpack_require__("Vwsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_account_PersonalInformationForm__ = __webpack_require__("I0lT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__("L/hj");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccountDetails',
  components: {
    AccountDeactivationForm: __WEBPACK_IMPORTED_MODULE_2__components_account_AccountDeactivationForm__["a" /* default */],
    AccountPowerOfAttorneyForm: __WEBPACK_IMPORTED_MODULE_3__components_account_AccountPowerOfAttorneyForm__["a" /* default */],
    AccountChangeEmailForm: __WEBPACK_IMPORTED_MODULE_4__components_account_AccountChangeEmailForm__["a" /* default */],
    ChangePassswordForm: __WEBPACK_IMPORTED_MODULE_5__components_account_ChangePasswordForm__["a" /* default */],
    PersonalInformationForm: __WEBPACK_IMPORTED_MODULE_6__components_account_PersonalInformationForm__["a" /* default */]
  },
  computed: {
    isPolicyHolder: function isPolicyHolder() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesPolicyHolder = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'POLICY_HOLDER';
        });
        if (rolesPolicyHolder.length > 0) {
          return true;
        }
      }
      return false;
    },
    personalInfo: function personalInfo() {
      var user = this.$store.getters.currentUser;
      return {
        salutation: user ? user.salutation : '',
        title: user ? user.title : '',
        firstName: user ? user.firstName : '',
        lastName: user ? user.lastName : '',
        dateOfBirth: user ? user.dateOfBirth : ''
      };
    }
  },
  data: function data() {
    return {
      user: this.$store.getters.currentUser,
      passwordData: {
        oldPassword: null,
        newPassword: null,
        newPasswordConfirm: null
      }
    };
  },

  methods: {
    deactivateAccount: function deactivateAccount() {
      var _this = this;

      this.$store.dispatch('deleteCognitoUser').then(function () {
        _this.$router.push('/signin');
      });
    },
    deleteAvatar: function deleteAvatar() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.$store.dispatch('deleteAvatar').then(function () {
          _this2.showSuccessMsg({
            message: _this2.$t('message.avatar.delete')
          });
          resolve();
        }).catch(function (err) {
          _this2.showErrorMsg({
            message: _this2.$t('error.avatar.delete')
          });
          reject(err);
        });
      });
    },
    printPoa: function printPoa() {
      __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].download(this.$store.getters.powerOfAttorney);
    },
    revokePoa: function revokePoa() {
      var _this3 = this;

      this.$store.dispatch('deletePowerOfAttorney').then(function () {
        _this3.showSuccessMsg({
          message: _this3.$t('message.accountDetails.deletePowerOfAttorney')
        });
      }).catch(function (err) {
        if (err.response.status === 404) {
          _this3.showErrorMsg({
            message: _this3.$t('error.accountDetails.deletePowerOfAttorney.notFound')
          });
        } else {
          _this3.showErrorMsg({
            message: _this3.$t('error.accountDetails.deletePowerOfAttorney.common')
          });
        }
      });
    },
    uploadAvatar: function uploadAvatar(avatarFile) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$store.dispatch('uploadAvatar', avatarFile).then(function () {
          _this4.showSuccessMsg({
            message: _this4.$t('message.avatar.upload')
          });
          resolve();
        }).catch(function (err) {
          _this4.showErrorMsg({
            message: _this4.$t('error.avatar.uploadFail')
          });
          reject(err);
        });
      });
    },
    savePersonalInfo: function savePersonalInfo(personalInfo) {
      var _this5 = this;

      var user = this.$store.getters.currentUser;
      user.firstName = personalInfo.firstName;
      user.lastName = personalInfo.lastName;
      user.title = personalInfo.title;
      user.salutation = personalInfo.salutation;
      user.dateOfBirth = personalInfo.dateOfBirth;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.$store.dispatch('updateUser', user).then(function () {
          _this5.showSuccessMsg({
            message: _this5.$t('message.accountDetails.savePersonalInfo')
          });
          resolve();
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    saveChangedEmail: function saveChangedEmail(email) {
      var _this6 = this;

      this.$store.dispatch('changeEmail', email).then(function () {
        _this6.$refs.accountChangeEmailForm.reset();
        _this6.showSuccessMsg({
          message: _this6.$t('message.accountDetails.saveChangedEmail')
        });
      }).catch(function () {
        _this6.showErrorMsg({
          message: _this6.$t('error.accountDetails.saveChangedEmail')
        });
      });
    },
    saveChangedPassword: function saveChangedPassword(passwordData) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.$store.dispatch('changePassword', passwordData).then(function () {
          _this7.passwordData = {
            oldPassword: null,
            newPassword: null,
            newPasswordConfirm: null
          };

          _this7.showSuccessMsg({
            message: _this7.$t('message.accountDetails.saveChangedPassword')
          });

          resolve();
        }).catch(function (err) {
          if (err && err.code === 'LimitExceededException') {
            _this7.showErrorMsg({
              message: _this7.$t('error.accountDetails.saveChangedPassword.limitExceeded')
            });
          } else {
            _this7.showErrorMsg({
              message: _this7.$t('error.accountDetails.saveChangedPassword.common')
            });
          }
          reject(err);
        });
      });
    }
  },
  notifications: {
    showSuccessMsg: {
      type: 'success'
    },
    showErrorMsg: {
      type: 'error'
    }
  }
});

/***/ }),

/***/ "FeJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsFooter_vue__ = __webpack_require__("jJRv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070695e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsFooter_vue__ = __webpack_require__("xF8D");
function injectStyle (ssrContext) {
  __webpack_require__("cbW9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-070695e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070695e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ffcp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dashboard_DashboardContent__ = __webpack_require__("p7WO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dashboard_DashboardContentContactPerson__ = __webpack_require__("/8zH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Infobox__ = __webpack_require__("AHrk");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    DashboardContent: __WEBPACK_IMPORTED_MODULE_1__components_dashboard_DashboardContent__["a" /* default */],
    DashboardContentContactPerson: __WEBPACK_IMPORTED_MODULE_2__components_dashboard_DashboardContentContactPerson__["a" /* default */],
    Infobox: __WEBPACK_IMPORTED_MODULE_3__components_common_Infobox__["a" /* default */]
  },
  computed: {
    isContactPerson: function isContactPerson() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesContactPerson = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'CONTACT_PERSON';
        });
        if (rolesContactPerson.length > 0) {
          return true;
        }
      }
      return false;
    },
    isPolicyHolder: function isPolicyHolder() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesPolicyHolder = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'POLICY_HOLDER';
        });
        if (rolesPolicyHolder.length > 0) {
          return true;
        }
      }
      return false;
    },
    userName: function userName() {
      var user = this.$store.getters.currentUser;
      return this.$t('enums.salutations.' + user.salutation) + ' ' + user.firstName + ' ' + user.lastName;
    }
  }
});

/***/ }),

/***/ "Fmg7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.$t('message.faq.title'),"icon":'ti-help'}})],1)],1),_vm._v(" "),_c('b-card',{staticClass:"rounded-0 mt-3"},[_c('h4',[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"accordion1"}},[_c('h4',[_vm._v("Trauer - Was ist das?")])]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"accordion1"}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"pl-2 pr-2"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text1_0)}})]),_vm._v(" "),_c('div',{staticClass:"pt-3 text-left"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion1",modifiers:{"accordion1":true}}],staticClass:"btn-primary rounded-0 weiter",attrs:{"size":"md","variant":"primary","aria-controls":"accordion1"}},[_vm._v(_vm._s(_vm.$t('message.faq.collapse'))+"\n      ")])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-0",attrs:{"id":"accordion1","accordion":"my-accordion"}},[_c('b-table',{attrs:{"striped":"","responsive":""}}),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetrauer1",modifiers:{"collapsetrauer1":true}}],staticClass:" rounded-0 col-lg-12 text-left mt-2",attrs:{"variant":"light"}},[_vm._v(" Was ist\n          Trauer\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetrauer1"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text1_1)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetrauer2",modifiers:{"collapsetrauer2":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v(" Trauerplan und\n          Traueraufgabe?\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetrauer2"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text1_2)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetrauer3",modifiers:{"collapsetrauer3":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v(" Trauer bei\n          Kindern und Jugendlichen\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetrauer3"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text1_3)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetrauer4",modifiers:{"collapsetrauer4":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v(" Gedankenräume\n          im Internet\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetrauer4"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text1_4)}})])],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"rounded-0 mt-2"},[_c('h4',[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion2",modifiers:{"accordion2":true}}],staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"accordion2"}},[_c('h4',[_vm._v("Der Todesfall - was ist zu tun?")])]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion2",modifiers:{"accordion2":true}}],staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"accordion2"}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"pl-2 pb-0 mb-0 text-left"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text2)}})]),_vm._v(" "),_c('div',{staticClass:"pt-3 text-left"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion2",modifiers:{"accordion2":true}}],staticClass:"btn-primary rounded-0 weiter",attrs:{"size":"md","variant":"primary","aria-controls":"accordion2"}},[_vm._v(_vm._s(_vm.$t('message.faq.collapse'))+"\n      ")])],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-0",attrs:{"id":"accordion2","accordion":"my-accordion"}},[_c('b-table',{attrs:{"striped":"","responsive":""}}),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetodesfall1",modifiers:{"collapsetodesfall1":true}}],staticClass:" rounded-0  col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v(" 1. Arzt\n          benachrichtigen\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetodesfall1"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text2_1)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetodesfall2",modifiers:{"collapsetodesfall2":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("2. Bestatter\n          benachrichtigen\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetodesfall2"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text2_2)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetodesfall3",modifiers:{"collapsetodesfall3":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("3. Wichtige\n          Dokumente im Trauerfall\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetodesfall3"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text2_3)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetodesfall4",modifiers:{"collapsetodesfall4":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("4. Erledigung\n          der Formalitäten\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetodesfall4"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text2_4)}})])],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"rounded-0 mt-2"},[_c('h4',[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion3",modifiers:{"accordion3":true}}],staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"accordion3"}},[_c('h4',[_vm._v("Formen der Bestattung")])]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion3",modifiers:{"accordion3":true}}],staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"accordion3"}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"pl-2 text-left"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text3_0)}})]),_vm._v(" "),_c('div',{staticClass:"pt-3 text-left"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion3",modifiers:{"accordion3":true}}],staticClass:"btn-primary rounded-0 weiter",attrs:{"size":"md","variant":"primary","aria-controls":"accordion3"}},[_vm._v(" "+_vm._s(_vm.$t('message.faq.collapse'))+"\n      ")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion3","accordion":"my-accordion"}},[_c('b-table',{attrs:{"striped":"","responsive":""}}),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebestattung1",modifiers:{"collapsebestattung1":true}}],staticClass:" rounded-0  col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v(" Erde, Feuer,\n          Wasser\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebestattung1"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text3_1)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebestattung2",modifiers:{"collapsebestattung2":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("\n          Feuerbestattung\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebestattung2"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text3_2)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebestattung3",modifiers:{"collapsebestattung3":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("\n          Seebestattung\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebestattung3"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text3_3)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebestattung4",modifiers:{"collapsebestattung4":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Sonderformen\n          der Bestattung\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebestattung4"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text3_4)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebestattung5",modifiers:{"collapsebestattung5":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("\n          Preisgestaltung\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebestattung5"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text3_5)}})])],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"rounded-0 mt-2"},[_c('h4',[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion4",modifiers:{"accordion4":true}}],staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"accordion4"}},[_c('h4',[_vm._v("Todesanzeigen")])]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion4",modifiers:{"accordion4":true}}],staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"accordion4"}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"pl-2 text-left"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text4_0)}})]),_vm._v(" "),_c('div',{staticClass:"pt-3 text-left"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion4",modifiers:{"accordion4":true}}],staticClass:"btn-primary rounded-0 weiter",attrs:{"size":"md","variant":"primary","aria-controls":"accordion4"}},[_vm._v(" "+_vm._s(_vm.$t('message.faq.collapse'))+"\n      ")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion4","accordion":"my-accordion"}},[_c('b-table',{attrs:{"striped":"","responsive":""}}),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetodesanzeige1",modifiers:{"collapsetodesanzeige1":true}}],staticClass:" rounded-0  col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v(" Was sollten\n          sie unbedingt beachten?\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetodesanzeige1"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text4_1)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetodesanzeige2",modifiers:{"collapsetodesanzeige2":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Statt\n          besonderer Anzeige\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetodesanzeige2"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text4_2)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetodesanzeige3",modifiers:{"collapsetodesanzeige3":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Die Bitte\n          um eine Spende\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetodesanzeige3"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text4_3)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsetodesanzeige4",modifiers:{"collapsetodesanzeige4":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("\n          Danksagungen\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsetodesanzeige4"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text4_4)}})])],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"rounded-0 mt-2"},[_c('h4',[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion5",modifiers:{"accordion5":true}}],staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"accordion5"}},[_c('h4',[_vm._v("Beileidsbekundungen")])]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion5",modifiers:{"accordion5":true}}],staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"accordion5"}})],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"pl-2 text-left"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text5_0)}})]),_vm._v(" "),_c('div',{staticClass:"pt-3 text-left"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion5",modifiers:{"accordion5":true}}],staticClass:"btn-primary rounded-0 weiter ",attrs:{"size":"md","variant":"primary","aria-controls":"accordion5"}},[_vm._v(" "+_vm._s(_vm.$t('message.faq.collapse'))+"\n      ")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion5","accordion":"my-accordion"}},[_c('b-table',{attrs:{"striped":"","responsive":""}}),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebeileid1",modifiers:{"collapsebeileid1":true}}],staticClass:" rounded-0  col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v(" Trauerfall im\n          Kreis der Familie\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebeileid1"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text5_1)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebeileid2",modifiers:{"collapsebeileid2":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Trauerfall nach\n          glücklichem und erfülltem Leben\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebeileid2"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text5_2)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebeileid3",modifiers:{"collapsebeileid3":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Vorlage für\n          Trauerfall im Bekanntenkreis\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebeileid3"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text5_3)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebeileid4",modifiers:{"collapsebeileid4":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Trauerfall bei\n          flüchtig bekannten Personen\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebeileid4"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text5_4)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebeileid5",modifiers:{"collapsebeileid5":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Trauerfall im\n          beruflichen Umfeld\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebeileid5"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text5_5)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebeileid6",modifiers:{"collapsebeileid6":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Trauerfall in\n          extremen Situationen (Kind)\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebeileid6"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text5_6)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebeileid7",modifiers:{"collapsebeileid7":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Trauerfall in\n          extremen Situationen (Selbsttötung)\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebeileid7"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text5_7)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebeileid8",modifiers:{"collapsebeileid8":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Trauerfall in\n          extremen Situationen (Unfall)\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebeileid8"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text5_8)}})])],1),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapsebeileid9",modifiers:{"collapsebeileid9":true}}],staticClass:" rounded-0 mt-2 col-lg-12 text-left",attrs:{"variant":"light"}},[_vm._v("Trauerfall in\n          extremen Situationen (Verbrechen)\n        ")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2 rounded-0",attrs:{"id":"collapsebeileid9"}},[_c('b-card',{staticClass:"rounded-0"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text5_9)}})])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GDfv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GRDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__ = __webpack_require__("AE0Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminContractPartnerList',
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__["a" /* default */]
  },
  computed: {
    contractPartners: function contractPartners() {
      return this.$store.getters.adminContractPartnerList;
    },
    contractPartnerTemplates: function contractPartnerTemplates() {
      return this.$store.getters.adminContractPartnerTemplateList;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchAdminContractPartnerList');
    this.$store.dispatch('fetchAdminContractPartnerTemplateList');
  },
  data: function data() {
    var _this = this;

    return {
      fields: [{
        key: 'contractPartnerName',
        label: this.$t('message.adminContractPartnerList.table.name')
      }, {
        key: 'email',
        label: this.$t('message.adminContractPartnerList.table.email')
      }, {
        key: 'domain',
        label: this.$t('message.adminContractPartnerList.table.domain')
      }, {
        key: 'address',
        label: this.$t('message.adminContractPartnerList.table.address')
      }, {
        key: 'isApprovedByAdmin',
        label: this.$t('message.adminContractPartnerList.table.approved'),
        formatter: function formatter(value) {
          if (value) {
            return _this.$t('message.adminContractPartnerList.yes');
          }
          return _this.$t('message.adminContractPartnerList.no');
        }
      }, {
        key: 'actions',
        label: ''
      }]
    };
  },

  methods: {
    showDetails: function showDetails(data) {
      this.$router.push('/admin/contractpartners/' + data.item.id);
    },
    showContractPartnerTemplate: function showContractPartnerTemplate(data) {
      this.$router.push('/admin/contractpartners/template/' + data.item.id);
    }
  }
});

/***/ }),

/***/ "GZFa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gdf+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ADDRESS_TYPES = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  administrative_area_level_2: 'county',
  country: 'long_name',
  postal_code: 'short_name'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueGoogleAutocomplete',
  props: {
    id: {
      type: String,
      required: true
    },
    className: String,
    placeholder: String,
    value: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      autocomplete: null,
      autocompleteValue: ''
    };
  },

  methods: {
    blur: function blur() {
      this.$refs.autocomplete.blur();
    },
    clear: function clear() {
      this.autocompleteValue = '';
    },
    focus: function focus() {
      this.$refs.autocomplete.focus();
    },
    getFormattedPlace: function getFormattedPlace(place) {
      var formattedPlace = {};
      place.address_components.forEach(function (addressComponent) {
        var addressType = addressComponent.types[0];
        if (ADDRESS_TYPES[addressType]) {
          var value = addressComponent[ADDRESS_TYPES[addressType]];
          formattedPlace[addressType] = value;
        }
      });
      return formattedPlace;
    },
    onBlur: function onBlur() {
      this.$emit('blur');
    },
    onChange: function onChange() {
      this.$emit('change', this.autocompleteValue);
    },
    onFocus: function onFocus() {
      this.$emit('focus');
    },
    onKeyPress: function onKeyPress(event) {
      this.$emit('keypress', event);
    },
    onKeyUp: function onKeyUp(event) {
      this.$emit('keyup', event);
    },
    placeChanged: function placeChanged() {
      var place = this.autocomplete.getPlace();

      if (!place.geometry) {
        this.$emit('noPlaceFound', place, this.id);
        return;
      }

      if (place.address_components) {
        this.$emit('placeChanged', this.getFormattedPlace(place), place, this.id);
        this.$emit('input', this.getFormattedPlace(place));
        this.autocompleteValue = this.$refs.autocomplete.value;
        this.onChange();
      }
    }
  },
  watch: {
    autocompleteValue: function autocompleteValue(newVal, oldVal) {
      this.$emit('inputChange', { newVal: newVal, oldVal: oldVal }, this.id);
    }
  },
  mounted: function mounted() {
    /* eslint-disable */
    this.autocomplete = new google.maps.places.Autocomplete(this.$refs.autocomplete, {});
    this.autocomplete.addListener('place_changed', this.placeChanged);
    /* eslint-enable */
  }
});

/***/ }),

/***/ "GeN8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminUserContactPerson',
  computed: {
    contactPersons: function contactPersons() {
      return this.$store.getters.adminContactPersons;
    }
  },
  data: function data() {
    return {
      fields: [{
        key: 'firstName',
        label: this.$t('message.adminUserContactPerson.table.firstName')
      }, {
        key: 'lastName',
        label: this.$t('message.adminUserContactPerson.table.lastName')
      }, {
        key: 'email',
        label: this.$t('message.adminUserContactPerson.table.email')
      }, {
        key: 'relation',
        label: this.$t('message.adminUserContactPerson.table.relation')
      }, {
        key: 'dateOfBirth',
        label: this.$t('message.adminUserContactPerson.table.dateOfBirth')
      }, {
        key: 'city',
        label: this.$t('message.adminUserContactPerson.table.city')
      }, {
        key: 'street',
        label: this.$t('message.adminUserContactPerson.table.street')
      }, {
        key: 'streetNumber',
        label: this.$t('message.adminUserContactPerson.table.streetNumber')
      }, {
        key: 'postalCode',
        label: this.$t('message.adminUserContactPerson.table.postalCode')
      }, {
        key: 'actions',
        label: this.$t('message.adminUserContactPerson.table.heir')
      }]
    };
  },

  methods: {
    setHeirStatus: function setHeirStatus(event, contactPersonId) {
      var _this = this;

      this.$store.dispatch('setHeirStatus', {
        phId: parseInt(this.$route.params.id),
        isCertificateOfInheritanceApproved: event,
        isEntitledInCertificateOfInheritance: event,
        contactPersonId: contactPersonId
      }).then(function () {
        _this.contactPersons.filter(function (contactPerson) {
          return contactPerson.id === contactPersonId;
        })[0].heir = event;
      }).catch(function () {
        _this.contactPersons.filter(function (contactPerson) {
          return contactPerson.id === contactPersonId;
        })[0].heir = false;
      });
    }
  }
});

/***/ }),

/***/ "GyvN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H6bv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HKXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyHolderContracts_vue__ = __webpack_require__("dSu5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4424125f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyHolderContracts_vue__ = __webpack_require__("VSjg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PolicyHolderContracts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4424125f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PolicyHolderContracts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hldr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law__ = __webpack_require__("xvGj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cookie_law__);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { CookieLaw: __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law___default.a }
});

/***/ }),

/***/ "I0lT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonalInformationForm_vue__ = __webpack_require__("/KeR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7b7cd48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonalInformationForm_vue__ = __webpack_require__("AIXB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonalInformationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7b7cd48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonalInformationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I75R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',[_c('b-nav',{attrs:{"vertical":""}},[_c('b-nav-text',{staticClass:"text-uppercase text-muted"},[_vm._v("\n      "+_vm._s(_vm.userName)+"\n    ")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/dashboard"}},[_c('i',{staticClass:"noOutline ti-dashboard mx-2"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.appSidebar.navItem.dashboard')))])]),_vm._v(" "),(_vm.isPolicyHolder)?_c('b-nav-item',{attrs:{"to":"/contracts"}},[_c('i',{staticClass:"noOutline ti-receipt mx-2"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.appSidebar.navItem.contracts')))])]):_vm._e(),_vm._v(" "),(_vm.isPolicyHolder)?_c('b-nav-item',{attrs:{"to":"/contactpersons"}},[_c('i',{staticClass:"noOutline ti-user mx-2"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.appSidebar.navItem.contactPersons')))])]):_vm._e(),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/addresses"}},[_c('i',{staticClass:"noOutline ti-home mx-2"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.appSidebar.navItem.addresses')))])]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/faq"}},[_c('i',{staticClass:"noOutline ti-help mx-2"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.appSidebar.navItem.faq')))])]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/account"}},[_c('i',{staticClass:"noOutline ti-settings mx-2"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.appSidebar.navItem.account')))])]),_vm._v(" "),(_vm.isContactPerson && _vm.policyHolders.length > 0)?_c('div',[_c('hr'),_vm._v(" "),_c('b-nav-text',{staticClass:"text-muted"},[_vm._v("\n        "+_vm._s(_vm.$t('message.appSidebar.navItem.contactPersonOf'))+"\n      ")]),_vm._v(" "),_vm._l((_vm.policyHolders),function(policyHolder){return _c('b-nav-item',{key:policyHolder.id,attrs:{"to":'/policyHolders/' + policyHolder.id}},[(!policyHolder.dateOfDeath)?_c('i',{staticClass:"ti-user mx-2"}):_vm._e(),_vm._v(" "),(policyHolder.dateOfDeath)?_c('img',{staticClass:"cross mx-2",attrs:{"src":__webpack_require__("PUL0"),"width":"16"}}):_vm._e(),_vm._v("\n        "+_vm._s(policyHolder.firstName + ' ' + policyHolder.lastName)+"\n      ")])})],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IDhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('h5',[_vm._v(_vm._s(_vm.$t('message.dashboardContentContactPerson.message')))])])],1),_vm._v(" "),_vm._l((Math.ceil(_vm.policyHolders.length / 2)),function(i){return _c('b-row',{key:i,staticClass:"mt-3"},_vm._l((_vm.policyHolders.slice((i - 1) * 2, i * 2)),function(policyHolder){return _c('b-col',{key:policyHolder.id,attrs:{"cols":"12","xl":"6"}},[_c('b-btn',{staticClass:"p-0 m-0 w-100",attrs:{"variant":"transparent","router-tag":"div","to":'/policyHolders/' + policyHolder.id}},[_c('business-card',{staticClass:"rounded-0 h-100",attrs:{"name":policyHolder.firstName + ' ' + policyHolder.lastName,"relation":_vm.$t('enums.relationTypes.' + policyHolder.relationshipType),"email":policyHolder.email,"imageSrc":policyHolder.avatarUuid,"showIcon":!!policyHolder.dateOfDeath,"dateOfDeath":policyHolder.dateOfDeath}},[_c('div',{attrs:{"slot":"bcFooter"},slot:"bcFooter"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row"},[_c('b-badge',{staticClass:"p-2 mr-2"},[_vm._v("\n                "+_vm._s(policyHolder.numberOfAssignedContracts)+"\n              ")]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm.getNumberOfAssignedContractsText(policyHolder))+"\n              ")])],1)])])],1)],1)}))}),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0",attrs:{"title":_vm.$t('message.dashboardContentContactPerson.insurance.title')}},[_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('message.dashboardContentContactPerson.insurance.message'))+"\n        ")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label-for":"dateOfBirth","state":_vm.$v.regData.dateOfBirth.$error ? false : null,"invalid-feedback":_vm.$t('error.dashboardContentContactPerson.dateOfBirth')}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('label',[_vm._v("\n                    "+_vm._s(_vm.$t('message.dashboardContentContactPerson.insurance.label.dateOfBirth'))+"\n                    "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"id":"dateOfBirth","placeholder":"TT.MM.JJJJ","state":_vm.$v.regData.dateOfBirth.$error ? false : null},on:{"change":function($event){_vm.$v.regData.dateOfBirth.$touch()}},model:{value:(_vm.regData.dateOfBirth),callback:function ($$v) {_vm.$set(_vm.regData, "dateOfBirth", $$v)},expression:"regData.dateOfBirth"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label-for":"contractNumber","state":_vm.$v.regData.contractNumber.$error ? false : null,"invalid-feedback":_vm.$t('error.dashboardContentContactPerson.contractNumber')}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_c('label',[_vm._v("\n                    "+_vm._s(_vm.$t('message.dashboardContentContactPerson.insurance.label.contractNumber'))+"\n                    "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"id":"contractNumber","state":_vm.$v.regData.contractNumber.$error ? false : null},on:{"change":function($event){_vm.$v.regData.contractNumber.$touch()}},model:{value:(_vm.regData.contractNumber),callback:function ($$v) {_vm.$set(_vm.regData, "contractNumber", $$v)},expression:"regData.contractNumber"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"text-right"},[_c('b-btn',{staticClass:"rounded-0",attrs:{"variant":"primary","type":"submit"}},[_vm._v("\n                "+_vm._s(_vm.$t('message.dashboardContentContactPerson.insurance.btn.submit'))+"\n              ")])],1)],1)],1)],1)],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IImP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{staticClass:"p-5",attrs:{"variant":"danger","dismissible":"","show":_vm.error.isVisible},on:{"dismissed":function($event){_vm.error.isVisible=false}}},[_c('i18n',{attrs:{"path":"error.resetPasswordConfirm.submit"}},[_c('b-link',{attrs:{"href":"mailto:support@meine-vertraege.net","place":"supportLink"}},[_vm._v("support@meine-vertraege.net")])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v(_vm._s(_vm.$t('message.resetPasswordConfirm.title')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('message.resetPasswordConfirm.message')))]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.confirmData.password.$error ? false : null,"invalid-feedback":_vm.$t('error.resetPasswordConfirm.password')}},[_c('label',[_vm._v("\n              "+_vm._s(_vm.$t('message.resetPasswordConfirm.label.password'))+"\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password","placeholder":_vm.$t('message.resetPasswordConfirm.input.placeholder.password'),"state":_vm.$v.confirmData.password.$error ? false : null},on:{"change":function($event){_vm.$v.confirmData.password.$touch()}},model:{value:(_vm.confirmData.password),callback:function ($$v) {_vm.$set(_vm.confirmData, "password", $$v)},expression:"confirmData.password"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.confirmData.passwordConfirm.$error ? false : null,"invalid-feedback":_vm.$t('error.resetPasswordConfirm.passwordConfirm')}},[_c('label',[_vm._v("\n              "+_vm._s(_vm.$t('message.resetPasswordConfirm.label.passwordConfirm'))+"\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password","placeholder":_vm.$t('message.resetPasswordConfirm.input.placeholder.passwordConfirm'),"state":_vm.$v.confirmData.passwordConfirm.$error ? false : null},on:{"change":function($event){_vm.$v.confirmData.passwordConfirm.$touch()}},model:{value:(_vm.confirmData.passwordConfirm),callback:function ($$v) {_vm.$set(_vm.confirmData, "passwordConfirm", $$v)},expression:"confirmData.passwordConfirm"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-5"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.confirmData.verificationCode.$error ? false : null,"invalid-feedback":_vm.$t('error.resetPasswordConfirm.verificationCode')}},[_c('label',[_vm._v("\n              "+_vm._s(_vm.$t('message.resetPasswordConfirm.label.verificationCode'))+"\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{attrs:{"placeholder":_vm.$t('message.resetPasswordConfirm.input.placeholder.verificationCode'),"state":_vm.$v.confirmData.verificationCode.$error ? false : null},on:{"change":function($event){_vm.$v.confirmData.verificationCode.$touch()}},model:{value:(_vm.confirmData.verificationCode),callback:function ($$v) {_vm.$set(_vm.confirmData, "verificationCode", $$v)},expression:"confirmData.verificationCode"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-5"},[_c('b-col',[_c('b-btn',{attrs:{"variant":"link"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('message.resetPasswordConfirm.btn.back')))])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary","type":"submit"}},[_vm._v(_vm._s(_vm.$t('message.resetPasswordConfirm.btn.send')))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IKVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.invitations.length !== 0)?_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v("\n        "+_vm._s(_vm.$t('message.adminUserInvitation.title'))+"\n      ")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","responsive":"","fields":_vm.fields,"items":_vm.invitations,"tbody-class":"text-muted"},scopedSlots:_vm._u([{key:"createdAt",fn:function(row){return [_vm._v("\n          "+_vm._s(_vm.$moment(row.item.createdAt, 'YYYY-MM-DD').format('DD.MM.YYYY'))+"\n        ")]}},{key:"status",fn:function(row){return [_vm._v("\n          "+_vm._s(_vm.$t('enums.invitationStatus.' + row.item.status))+"\n        ")]}}])})],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_admin__ = __webpack_require__("/uTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_addresses__ = __webpack_require__("UpCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_contactPersons__ = __webpack_require__("VO/F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_contracts__ = __webpack_require__("gmY0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_contractPartners__ = __webpack_require__("xYEv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_users__ = __webpack_require__("xSZb");










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    admin: __WEBPACK_IMPORTED_MODULE_2__modules_admin__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_3__modules_auth__["a" /* default */],
    addresses: __WEBPACK_IMPORTED_MODULE_4__modules_addresses__["a" /* default */],
    contracts: __WEBPACK_IMPORTED_MODULE_6__modules_contracts__["a" /* default */],
    contractPartners: __WEBPACK_IMPORTED_MODULE_7__modules_contractPartners__["a" /* default */],
    contactPersons: __WEBPACK_IMPORTED_MODULE_5__modules_contactPersons__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_8__modules_users__["a" /* default */]
  }
}));

/***/ }),

/***/ "Ie+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"fixed":"top","variant":"white"}},[_c('b-navbar-brand',{staticClass:"app-sidebar-brand text-center py-0",attrs:{"to":"/"}},[_c('span',[_c('img',{staticClass:"dark-logo",attrs:{"src":__webpack_require__("7Otq"),"alt":"logo-text","height":"40"}})])]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto px-4"},[(_vm.isSignedIn)?_c('b-nav-item',{attrs:{"href":"#"},on:{"click":_vm.signOut}},[_c('span',{staticClass:"ti-power-off"}),_vm._v("\n      "+_vm._s(_vm.$t('message.appHeader.btn.signOut'))+"\n    ")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IeG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Imprint_vue__ = __webpack_require__("igVF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2084481e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Imprint_vue__ = __webpack_require__("sWcI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Imprint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2084481e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Imprint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JCnD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpConfirm_vue__ = __webpack_require__("U2x6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_479352aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpConfirm_vue__ = __webpack_require__("U386");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_479352aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JkXQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSidebar_vue__ = __webpack_require__("o7xE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc61c5f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSidebar_vue__ = __webpack_require__("roUy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc61c5f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JqOT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K0aD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpContactPerson_vue__ = __webpack_require__("TL+w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10d39dc1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpContactPerson_vue__ = __webpack_require__("vfBd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpContactPerson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10d39dc1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpContactPerson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KLHI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    address: {
      type: Object,
      required: true
    },
    onSubmitFn: {
      type: Function,
      required: true
    }
  },
  validations: {
    address: {
      street: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      streetNumber: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      additionalAddress: {
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(325)
      },
      postalCode: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      city: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      country: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),

/***/ "L/hj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser__ = __webpack_require__("O/+C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bowser__);


/* harmony default export */ __webpack_exports__["a"] = ({
  isMicrosoft: function isMicrosoft() {
    return __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.name === 'Microsoft Edge' || __WEBPACK_IMPORTED_MODULE_0_bowser___default.a.name === 'Internet Explorer';
  },
  download: function download(resource) {
    if (resource) {
      var contentType = resource.mimeType;
      var blob = new Blob([resource.file], { type: contentType });
      this.downloadBlob(blob, resource.filename);
    }
  },
  downloadBlob: function downloadBlob(blob, name) {
    if (this.isMicrosoft()) {
      window.navigator.msSaveOrOpenBlob(blob, name);
    } else {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
    }
  },
  contentDispositionToMeta: function contentDispositionToMeta(response) {
    var meta = {};
    var contentDis = response.headers['content-disposition'];
    meta.filename = contentDis.substr(contentDis.lastIndexOf('=') + 2).substring(0, contentDis.length - 1);
    meta.filename = meta.filename.substring(0, meta.filename.length - 1);
    meta.mimeType = response.headers['content-type'];
    return meta;
  },
  getTranslatedRoles: function getTranslatedRoles(context, roles) {
    var translatedRoles = roles.map(function (role) {
      if (role.roleOfUser === 'ADMIN') {
        return context.$t('enums.roles.ADMIN');
      } else if (role.roleOfUser === 'CONTACT_PERSON') {
        return context.$t('enums.roles.CONTACT_PERSON');
      } else if (role.roleOfUser === 'POLICY_HOLDER') {
        return context.$t('enums.roles.POLICY_HOLDER');
      }
    });
    return translatedRoles;
  },

  validators: {
    isCharactersOnly: function isCharactersOnly(value) {
      if (value) {
        var matches = value.match(/[a-zA-ZäöüßÄÖÜ]+/);
        if (matches) {
          return true;
        }
      }
      return false;
    },
    isValidPassword: function isValidPassword(value) {
      if (value) {
        var matches = value.match(/^(?=.*[!@#$%^&*_0-9])(?=.{0,}[A-Z])(?=.*[a-zA-Z!@#$%^&*_0-9]).{6,}$/gm);
        if (matches) {
          return true;
        }
      }
      return false;
    },
    isValidContractNumber: function isValidContractNumber(value, vm) {
      var dateOfBirth = vm.regData.dateOfBirth;
      if (dateOfBirth && value) {
        var contractNumberPrefix = vm.$moment(dateOfBirth, 'DD.MM.YYYY').format('DDMMYY');
        if ((value.startsWith(contractNumberPrefix) || value.startsWith('222')) && value.length === 12) {
          return true;
        }
      }
      return false;
    },
    isValidDate: function isValidDate(value) {
      if (!value) {
        return true;
      }
      var isValidYear = this.$moment(value, 'DD.MM.YYYY', true).isValid();
      var isValidContractYear = this.$moment(value, 'DD.MM.YYYY', true).year() >= 1900;
      var enteredYear = this.$moment(value, 'DD.MM.YYYY', true).year();
      var currentYear = new Date().getFullYear();
      var validYear = true;

      if (enteredYear >= currentYear + 20) {
        validYear = false;
      }

      return isValidYear && isValidContractYear && validYear;
    },
    isValidDomain: function isValidDomain(value) {
      var urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
      if (value) {
        var matches = value.match(urlRegex);
        if (matches) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }
  }
});

/***/ }),

/***/ "L8Ho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppHeader',
  computed: {
    isSignedIn: function isSignedIn() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.currentUser).length > 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    signOut: function signOut() {
      var _this = this;

      this.$store.dispatch('signOut').then(function () {
        _this.$store.commit('setCurrentUser', {});
        _this.$router.replace('/signin');
      });
    }
  }
});

/***/ }),

/***/ "LNCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"rounded-0 h-100",class:_vm.getStyle.bgColor},[_c('b-media',[_vm._t("default",null,{slot:"aside"}),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('h3',{class:_vm.getStyle.title},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h6',{class:_vm.getStyle.subtitle},[_vm._v(_vm._s(_vm.subtitle))]),_vm._v(" "),_c('div',[_c('i',{class:_vm.getStyle.message},[_vm._v(_vm._s(_vm.message))])])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LsK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignUpContactPersonRejected',
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.invitation).length === 0) {
      this.$router.replace('/');
    }
  },

  computed: {
    invitation: function invitation() {
      return this.$store.getters.invitation;
    },
    message: function message() {
      return this.$t('message.signUpContactPersonRejected.message');
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b779aff6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("wiRz");
function injectStyle (ssrContext) {
  __webpack_require__("aQ/i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b779aff6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZE8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractOverview_vue__ = __webpack_require__("Zemm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff8f481a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractOverview_vue__ = __webpack_require__("z2pm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff8f481a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mhcg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__ = __webpack_require__("AE0Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Info',
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__["a" /* default */]
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__ = __webpack_require__("rplX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mini_toastr__ = __webpack_require__("EMpD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment__ = __webpack_require__("mjDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notifications__ = __webpack_require__("GB2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_messages__ = __webpack_require__("6tIf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ti_icons_css_themify_icons_css__ = __webpack_require__("H6bv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ti_icons_css_themify_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_ti_icons_css_themify_icons_css__);



// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


 // https://github.com/se-panfilov/mini-toastr












var toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
};

__WEBPACK_IMPORTED_MODULE_4_mini_toastr__["a" /* default */].init({ types: toastTypes });

function toast(_ref) {
  var title = _ref.title,
      message = _ref.message,
      type = _ref.type,
      timeout = _ref.timeout,
      cb = _ref.cb;

  return __WEBPACK_IMPORTED_MODULE_4_mini_toastr__["a" /* default */][type](message, title, timeout, cb);
}

var options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_notifications___default.a, options);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

var i18n = new __WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]({
  locale: 'de', // set locale
  messages: __WEBPACK_IMPORTED_MODULE_10__i18n_messages__["a" /* default */] // set locale messages
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  i18n: i18n,
  router: __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */] }
});

/***/ }),

/***/ "NQQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"rounded-0"},[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("\n        "+_vm._s(_vm.$t('message.addressConfirmForm.title'))+"\n        "),_c('small',{staticClass:"text-muted mx-2"},[_vm._v("\n          "+_vm._s(_vm.$t('message.addressConfirmForm.subtitle'))+"\n        ")])])])],1),_vm._v(" "),_c('b-row',{staticClass:"d-flex justify-content-center mt-4"},[_c('b-col',{attrs:{"cols":"6"}},[_c('address-form',{ref:"addressForm",attrs:{"address":_vm.currentAddress,"onSubmitFn":_vm.submit}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('message.addressConfirmForm.btn.back')))])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"6"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$t('message.addressConfirmForm.btn.submit')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NRP4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"rounded-0 border-0",attrs:{"bg-variant":"light"}},[_c('address',{staticClass:"text-right"},[(_vm.contractPartner)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.contractPartner.contractPartnerName))]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.contractPartner.street)+" "+_vm._s(_vm.contractPartner.streetNumber)),_c('br'),_vm._v("\n        "+_vm._s(_vm.contractPartner.postalCode + ' ' + _vm.contractPartner.city)),_c('br'),_vm._v("\n        "+_vm._s(_vm.contractPartner.postOfficeBox)+"\n      ")])]):_vm._e()]),_vm._v(" "),_c('address',[(_vm.contractAddress)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.fullName))]),_vm._v(" "),(_vm.contractAddress.street)?_c('span',[_vm._v(_vm._s(_vm.contractAddress.street))]):_vm._e(),_vm._v(" "),(_vm.contractAddress.streetNumber)?_c('span',[_vm._v(_vm._s(_vm.contractAddress.streetNumber))]):_vm._e(),_vm._v(" "),(_vm.contractAddress.postalCode)?_c('div',[_vm._v(_vm._s(_vm.contractAddress.postalCode)+" "),(_vm.contractAddress.city)?_c('span',[_vm._v(_vm._s(_vm.contractAddress.city))]):_vm._e()]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',[_c('div',{staticClass:"mb-3"},[_c('b',[_vm._v(_vm._s(_vm.contractCategoryText))])]),_vm._v(" "),(_vm.contract.contractType)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.contractType'))+":\n      "+_vm._s(_vm.contract.contractType)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.contract.contractNumber)?_c('div',[_vm._v(_vm._s(_vm.contractNumberText)+":\n      "+_vm._s(_vm.contract.contractNumber)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.contract.accountNumber)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.accountNumber'))+":\n      "+_vm._s(_vm.contract.accountNumber)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.contract.insuredPersonNumber)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.insuredPersonNumber'))+":\n      "+_vm._s(_vm.contract.insuredPersonNumber)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.contract.conclusionDate)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.conclusionDate'))+":\n      "+_vm._s(_vm._f("moment")(_vm.contract.conclusionDate,'DD.MM.YYYY'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.contract.contractDuration)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.contractDuration'))+":\n      "+_vm._s(_vm.contract.contractDuration)+" "+_vm._s(_vm.$t('message.contractInformationForm.label.months'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.contract.cancellationPeriod)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.cancellationPeriod'))+":\n      "+_vm._s(_vm.contract.cancellationPeriod)+"\n      "+_vm._s(_vm.$t('message.contractInformationForm.label.months'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.contract.accountUsername)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.username'))+":\n      "+_vm._s(_vm.contract.accountUsername)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.contract.accountLink)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.link'))+":\n      "+_vm._s(_vm.contract.accountLink)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.contract.link)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.link'))+": "+_vm._s(_vm.contract.link))]):_vm._e(),_vm._v(" "),(_vm.contract.comment)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.comment'))+": "+_vm._s(_vm.contract.comment)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NeuU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NhAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPasswordConfirm_vue__ = __webpack_require__("XJ56");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca91a25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPasswordConfirm_vue__ = __webpack_require__("IImP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPasswordConfirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca91a25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPasswordConfirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nllq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.$t('message.adminUserList.title'),"icon":"ti-receipt"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0"},[_c('b-form-input',{staticClass:"rounded-0 ml-auto w-25",attrs:{"placeholder":"Filter"},nativeOn:{"blur":function($event){_vm.getFilteredUsers(_vm.filterValue)}},model:{value:(_vm.filterValue),callback:function ($$v) {_vm.filterValue=$$v},expression:"filterValue"}}),_vm._v(" "),_c('b-table',{staticClass:"mt-4 admin-user-table",attrs:{"striped":"","hover":"","responsive":"","tbody-tr-class":"admin-user-table","current-page":_vm.currentPage,"per-page":_vm.perPage,"fields":_vm.fields,"items":_vm.getFilteredUsers(_vm.filterValue)},on:{"row-hovered":function($event){},"row-clicked":_vm.showDetails},scopedSlots:_vm._u([{key:"roles",fn:function(data){return _vm._l((_vm.translatedRoles(data.item.roles)),function(role){return _c('div',[_vm._v("\n              "+_vm._s(role)+"\n            ")])})}}])})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0 rounded-0",attrs:{"total-rows":_vm.getFilteredUsers(_vm.filterValue).length,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"my-1 text-right",attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"horizontal":"","label":_vm.$t('message.adminUserList.perPage'),"label-cols":9}},[_c('b-form-select',{staticClass:"rounded-0",attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NwdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");




var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "https://meine-vertraege.net:8080"
});

instance.interceptors.request.use(function (config) {
  var currentUser = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.currentUser;
  var now = new Date();
  if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0 && now >= new Date(currentUser.expirationDate)) {
    __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('refreshSession');
  }

  return config;
});

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),

/***/ "O6na":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"variant":"warning","dismissible":"","show":_vm.autoLogout.isAutoLogout}},[(_vm.autoLogout.isAutoLogout)?_c('div',[_vm._v("\n      "+_vm._s(_vm.$t('message.signIn.autoLogout', {salutation: _vm.$t('enums.salutations.' +  _vm.autoLogout.salutation), firstName: _vm.autoLogout.firstName, lastName: _vm.autoLogout.lastName}))+"\n    ")]):_vm._e()]),_vm._v(" "),_c('b-card',{staticClass:"rounded-0"},[_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('message.signIn.title')))]),_vm._v(" "),_c('b-form',{staticClass:"mt-3 p-3",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-group',{attrs:{"state":_vm.$v.authData.email.$error ? false : null,"invalid-feedback":_vm.$t('error.signIn.email')}},[_c('label',[_vm._v("\n          "+_vm._s(_vm.$t('message.signIn.label.email'))+"\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"id":"email","autofocus":"","placeholder":_vm.$t('message.signIn.input.placeholder.email'),"state":_vm.$v.authData.email.$error ? false : null},on:{"change":function($event){_vm.$v.authData.email.$touch()}},model:{value:(_vm.authData.email),callback:function ($$v) {_vm.$set(_vm.authData, "email", $$v)},expression:"authData.email"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mt-4",attrs:{"state":_vm.$v.authData.password.$error ? false : null,"invalid-feedback":_vm.$t('error.signIn.password')}},[_c('label',[_vm._v("\n          Passwort\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"id":"password","type":"password","placeholder":_vm.$t('message.signIn.input.placeholder.password'),"state":_vm.$v.authData.password.$error ? false : null},on:{"change":function($event){_vm.$v.authData.password.$touch()}},model:{value:(_vm.authData.password),callback:function ($$v) {_vm.$set(_vm.authData, "password", $$v)},expression:"authData.password"}})],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',{staticClass:"text-right"},[_c('router-link',{attrs:{"to":"/resetPassword"}},[_vm._v(_vm._s(_vm.$t('message.resetPassword.title')))])],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-btn',{staticClass:"w-100 p-3 rounded-0",attrs:{"type":"submit","variant":"primary","disabled":_vm.$v.$invalid}},[_vm._v(_vm._s(_vm.$t('message.signIn.title'))+"\n          ")])],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',{staticClass:"text-center"},[_c('p',[_vm._v(_vm._s(_vm.$t('message.signUp.question'))+"\n            "),_c('router-link',{attrs:{"to":"/signup"}},[_vm._v(_vm._s(_vm.$t('message.signUp.link')))])],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Oai4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_b64_to_blob__ = __webpack_require__("ibJL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_b64_to_blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_b64_to_blob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_HeaderView__ = __webpack_require__("AE0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_policyholder_PolicyHolderContracts__ = __webpack_require__("HKXj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_BusinessCard__ = __webpack_require__("ReR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("L/hj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PolicyHolderDetails',
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this = this;

    this.$store.commit('setCertificateOfDeath', null);
    this.$store.commit('setCertificateOfInheritance', null);
    this.$store.dispatch('fetchPolicyHolderById', to.params.id).then(function () {
      _this.$store.dispatch('fetchContractsByPolicyHolderId', to.params.id).then(function () {
        _this.loadingCertificateOfDeath = true;
        _this.loadingCertificateOfInheritance = true;
        return _this.$store.dispatch('fetchDocuments', to.params.id).finally(function () {
          _this.loadingCertificateOfDeath = false;
          _this.loadingCertificateOfInheritance = false;
        });
      });
    }).then(function () {
      next();
    }).catch(function () {
      _this.showErrorMsg({
        message: _this.$t('error.policyHolderDetails.policyHolderById')
      });
      _this.$router.replace('/policyHolders');
    });
  },

  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_2__components_common_HeaderView__["a" /* default */],
    PolicyHolderContracts: __WEBPACK_IMPORTED_MODULE_3__components_policyholder_PolicyHolderContracts__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a,
    BusinessCard: __WEBPACK_IMPORTED_MODULE_4__components_common_BusinessCard__["a" /* default */]
  },
  computed: {
    certificateOfDeath: function certificateOfDeath() {
      return this.$store.getters.certificateOfDeath;
    },
    codOrCoiApproved: function codOrCoiApproved() {
      return this.$store.getters.policyHolderContracts;
    },
    codApproved: function codApproved() {
      return this.policyHolder.certificateOfDeathApproved;
    },
    coiApproved: function coiApproved() {
      return this.policyHolder.certificateOfInheritanceApproved;
    },
    certificateOfInheritance: function certificateOfInheritance() {
      return this.$store.getters.certificateOfInheritance;
    },
    isCodOwner: function isCodOwner() {
      return this.$store.getters.certificateOfDeath.uploaderId === this.$store.getters.currentUser.id;
    },
    policyHolder: function policyHolder() {
      return this.$store.getters.policyHolder;
    },
    policyHolderName: function policyHolderName() {
      return this.policyHolder.firstName + ' ' + this.policyHolder.lastName;
    },
    title: function title() {
      return this.$t('message.policyHolderDetails.title', {
        firstName: this.policyHolder.firstName,
        lastName: this.policyHolder.lastName
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var id = parseInt(this.$route.params.id);
    if (id) {
      var filteredPolicyHolders = this.$store.getters.policyHolders.filter(function (contactPerson) {
        return contactPerson.id === id;
      });
      if (filteredPolicyHolders.length === 0) {
        this.$store.dispatch('fetchPolicyHolderById', id).catch(function () {
          _this2.showErrorMsg({
            message: _this2.$t('error.policyHolderDetails.policyHolderById')
          });
          _this2.$router.replace('/policyHolders');
        });
      } else {
        this.$store.commit('setPolicyHolder', filteredPolicyHolders[0]);
      }
      if (!this.certificateOfDeath || !this.certificateOfInheritance) {
        this.loadingCertificateOfDeath = true;
        this.loadingCertificateOfInheritance = true;
        this.$store.dispatch('fetchCertificateOfDeath', id).finally(function () {
          _this2.loadingCertificateOfDeath = false;
        });
        this.$store.dispatch('fetchCertificateOfInheritance', id).finally(function () {
          _this2.loadingCertificateOfInheritance = false;
        });
      }
      this.$store.dispatch('fetchContractsByPolicyHolderId', id);
    } else {
      this.router.replace('/policyHolders');
    }
  },
  data: function data() {
    return {
      loadingCertificateOfDeath: false,
      loadingCertificateOfInheritance: false
    };
  },

  methods: {
    getNumberOfAssignedContractsText: function getNumberOfAssignedContractsText(policyHolder) {
      if (policyHolder.numberOfAssignedContracts === 1) {
        return this.$t('message.dashboardContentContactPerson.numberOfAssignedContract');
      } else {
        return this.$t('message.dashboardContentContactPerson.numberOfAssignedContracts');
      }
    },
    deleteCertificateOfDeath: function deleteCertificateOfDeath() {
      var _this3 = this;

      this.$store.dispatch('deleteCertificateOfDeath', this.policyHolder.id).catch(function () {
        _this3.showErrorMsg({
          message: _this3.$t('error.policyHolderDetails.deleteCertificateOfDeath')
        });
      });
    },
    printCertificateOfDeath: function printCertificateOfDeath() {
      __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].download(this.certificateOfDeath);
    },
    deleteCertificateOfInheritance: function deleteCertificateOfInheritance() {
      var _this4 = this;

      this.$store.dispatch('deleteCertificateOfInheritance', this.policyHolder.id).catch(function () {
        _this4.showErrorMsg({
          message: _this4.$t('error.policyHolderDetails.deleteCertificateOfInheritance')
        });
      });
    },
    printCertificateOfInheritance: function printCertificateOfInheritance() {
      var certificateOfInheritance = this.certificateOfInheritance;
      if (certificateOfInheritance) {
        var contentType = 'application/pdf';
        var blob = __WEBPACK_IMPORTED_MODULE_0_b64_to_blob___default()(certificateOfInheritance.file, contentType);
        __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].downloadBlob(blob, this.$t('message.policyHolderDetails.certificateOfInheritance'));
      }
    },
    uploadCertificateOfDeath: function uploadCertificateOfDeath(fileEvent) {
      var _this5 = this;

      var file = null;
      try {
        if (fileEvent.target.files.length > 0) {
          file = fileEvent.target.files[0];
        }
      } catch (ex) {
        file = null;
      }
      if (file) {
        this.loadingCertificateOfDeath = true;
        this.$store.dispatch('uploadCertificateOfDeath', {
          policyHolderId: this.policyHolder.id,
          certificateOfDeath: file
        }).then(function () {
          _this5.showSuccessMsg({
            message: _this5.$t('message.policyHolderDetails.uploadCertificateOfDeath')
          });
        }).catch(function () {
          _this5.showErrorMsg({
            message: _this5.$t('error.policyHolderDetails.uploadCertificateOfDeath')
          });
        }).finally(function () {
          _this5.loadingCertificateOfDeath = false;
        });
      }
    },
    uploadCertificateOfInheritance: function uploadCertificateOfInheritance(fileEvent) {
      var _this6 = this;

      var file = null;
      try {
        if (fileEvent.target.files.length > 0) {
          file = fileEvent.target.files[0];
        }
      } catch (ex) {
        file = null;
      }
      if (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var base64Value = reader.result.split(',')[1];
          _this6.$store.dispatch('uploadCertificateOfInheritance', {
            policyHolderId: _this6.policyHolder.id,
            documents: {
              certificateOfInheritance: base64Value
            }
          }).then(function () {
            _this6.showSuccessMsg({
              message: _this6.$t('message.policyHolderDetails.uploadCertificateOfInheritance')
            });
          }).catch(function () {
            _this6.showErrorMsg({
              message: _this6.$t('error.policyHolderDetails.uploadCertificateOfInheritance')
            });
          }).finally(function () {
            _this6.loadingCertificateOfInheritance = false;
          });
        };
        reader.onerror = function () {
          _this6.showErrorMsg({
            message: _this6.$t('error.policyHolderDetails.fileReaderError')
          });
        };
      }
    }
  },
  notifications: {
    showErrorMsg: {
      type: 'error'
    },
    showSuccessMsg: {
      type: 'success'
    }
  }
});

/***/ }),

/***/ "PUL0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "PY2h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountDetails_vue__ = __webpack_require__("FXEV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79331782_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountDetails_vue__ = __webpack_require__("7uXA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79331782_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PZAq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PZiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContractsCard',
  props: {
    collapseId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      showCollapse: true,
      fields: [{
        key: 'contractType',
        label: this.$t('message.adminContractsCard.type')
      }, {
        key: 'contractPartner.contractPartnerName',
        label: this.$t('message.adminContractsCard.company')
      }, {
        key: 'contractNumber',
        label: this.items[0].contractType ? this.$t('message.adminContractsCard.insuranceNumber') : this.$t('message.adminContractsCard.contractNumber')
      }, {
        key: 'insuredPersonNumber',
        label: this.$t('message.adminContractsCard.insuredPersonNumber')
      }, {
        key: 'conclusionDate',
        label: this.$t('message.adminContractsCard.conclusionDate')
      }, {
        key: 'contractType',
        label: this.$t('message.adminContractsCard.type')
      }, {
        key: 'contractDuration',
        label: this.$t('message.adminContractsCard.contractDuration'),
        formatter: function formatter(value) {
          if (value && value === 1) {
            return _this.$t('message.adminContractsCard.time.month', { value: value });
          } else if (value && value > 1) {
            return _this.$t('message.adminContractsCard.time.months', { value: value });
          }
          return value;
        }
      }, {
        key: 'cancellationPeriod',
        label: this.$t('message.adminContractsCard.cancellationPeriod'),
        formatter: function formatter(value) {
          if (value && value === 1) {
            return _this.$t('message.adminContractsCard.time.month', { value: value });
          } else if (value && value > 1) {
            return _this.$t('message.adminContractsCard.time.months', { value: value });
          }
          return value;
        }
      }, {
        key: 'actions',
        label: ''
      }]
    };
  },

  methods: {
    getCancellationPeriodText: function getCancellationPeriodText(value) {
      if (value && value === 1) {
        return this.$t('message.contractsCard.cancellationPeriod.month', { value: value });
      } else if (value && value > 1) {
        return this.$t('message.contractsCard.cancellationPeriod.months', { value: value });
      }
      return value;
    },
    showDetails: function showDetails(row) {
      this.$emit('showDetails', row.item);
    }
  }
});

/***/ }),

/***/ "Qaka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderView',
  props: {
    icon: {
      type: String
    },
    title: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "QgH0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContractsCard',
  props: {
    collapseId: {
      type: String,
      required: true
    },
    phView: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      showCollapse: true,
      fields: [{
        key: 'contractPartner.contractPartnerName',
        label: this.$t('message.contactPersonDetails.contractsCard.company')
      }, {
        key: 'contractType',
        label: this.$t('message.contactPersonDetails.contractsCard.type')
      }, {
        key: 'cancellationPeriod',
        label: this.$t('message.contactPersonDetails.contractsCard.cancellationPeriod'),
        formatter: function formatter(value) {
          if (value && value === 1) {
            return _this.$t('message.contractsCard.cancellationPeriod.month', { value: value });
          } else if (value && value > 1) {
            return _this.$t('message.contractsCard.cancellationPeriod.months', { value: value });
          }
          return value;
        }
      }, {
        key: 'actions',
        label: ''
      }]
    };
  },

  methods: {
    getCancellationPeriodText: function getCancellationPeriodText(value) {
      if (value && value === 1) {
        return this.$t('message.contractsCard.cancellationPeriod.month', { value: value });
      } else if (value && value > 1) {
        return this.$t('message.contractsCard.cancellationPeriod.months', { value: value });
      }
      return value;
    },
    showDetails: function showDetails(row) {
      this.$emit('showDetails', row.item);
    }
  }
});

/***/ }),

/***/ "R7ap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmitFn($event)}}},[_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.addressForm.label.street'))+"\n        "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.address.street.$error ? false : null,"invalid-feedback":_vm.$t('error.addressForm.street')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.address.street.$error ? false : null},on:{"changed":function($event){_vm.$v.address.street.$touch()}},model:{value:(_vm.address.street),callback:function ($$v) {_vm.$set(_vm.address, "street", $$v)},expression:"address.street"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.addressForm.label.streetNumber'))+"\n        "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.address.streetNumber.$error ? false : null,"invalid-feedback":_vm.$t('error.addressForm.streetNumber')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.address.streetNumber.$error ? false : null},on:{"changed":function($event){_vm.$v.address.streetNumber.$touch()}},model:{value:(_vm.address.streetNumber),callback:function ($$v) {_vm.$set(_vm.address, "streetNumber", $$v)},expression:"address.streetNumber"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.addressForm.label.additionalAddress')))])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',[_c('b-input',{staticClass:"rounded-0",model:{value:(_vm.address.additionalAddress),callback:function ($$v) {_vm.$set(_vm.address, "additionalAddress", $$v)},expression:"address.additionalAddress"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.addressForm.label.postalCode'))+"\n        "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.address.postalCode.$error ? false : null,"invalid-feedback":_vm.$t('error.addressForm.postalCode')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.address.postalCode.$error ? false : null},on:{"changed":function($event){_vm.$v.address.postalCode.$touch()}},model:{value:(_vm.address.postalCode),callback:function ($$v) {_vm.$set(_vm.address, "postalCode", $$v)},expression:"address.postalCode"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.addressForm.label.city'))+"\n        "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.address.city.$error ? false : null,"invalid-feedback":_vm.$t('error.addressForm.city')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.address.city.$error ? false : null},on:{"changed":function($event){_vm.$v.address.city.$touch()}},model:{value:(_vm.address.city),callback:function ($$v) {_vm.$set(_vm.address, "city", $$v)},expression:"address.city"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.addressForm.label.country'))+"\n      ")])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.address.country.$error ? false : null,"invalid-feedback":_vm.$t('error.addressForm.country')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.address.country.$error ? false : null},on:{"changed":function($event){_vm.$v.address.country.$touch()}},model:{value:(_vm.address.country),callback:function ($$v) {_vm.$set(_vm.address, "country", $$v)},expression:"address.country"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3 ",attrs:{"offset":"3"}},[_c('div',{staticClass:"requieredFields text-right"},[_c('span',{domProps:{"innerHTML":_vm._s( _vm.$t('message.contractPartnerDetails.label.requiredFields'))}})])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R9PX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RT2X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RUcB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ReR+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessCard_vue__ = __webpack_require__("3K5H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ff22d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessCard_vue__ = __webpack_require__("EWnC");
function injectStyle (ssrContext) {
  __webpack_require__("T6Pq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64ff22d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BusinessCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ff22d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BusinessCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S5bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_address_AddressForm__ = __webpack_require__("Sm2i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contracts_ContractsCard__ = __webpack_require__("hZwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Infobox__ = __webpack_require__("AHrk");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccountDetails',
  components: {
    AddressForm: __WEBPACK_IMPORTED_MODULE_1__components_address_AddressForm__["a" /* default */],
    ContractsCard: __WEBPACK_IMPORTED_MODULE_2__components_contracts_ContractsCard__["a" /* default */],
    Infobox: __WEBPACK_IMPORTED_MODULE_3__components_common_Infobox__["a" /* default */]
  },
  computed: {
    isSingleAddress: function isSingleAddress() {
      if (this.addresses.length === 1) {
        return true;
      }
      return false;
    },
    addresses: function addresses() {
      return this.$store.getters.addresses;
    },
    filteredAddresses: function filteredAddresses() {
      var _this = this;

      return this.$store.getters.addresses.filter(function (address) {
        return address.id !== _this.currentAddress.id;
      });
    },
    contractsByAddress: function contractsByAddress() {
      return this.$store.getters.contractsByAddress;
    },
    currentAddress: function currentAddress() {
      return this.$store.getters.currentAddress;
    },
    isContactPerson: function isContactPerson() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesContactPerson = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'CONTACT_PERSON';
        });
        if (rolesContactPerson.length > 0) {
          return true;
        }
      }
      return false;
    },
    isPolicyHolder: function isPolicyHolder() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesPolicyHolder = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'POLICY_HOLDER';
        });
        if (rolesPolicyHolder.length > 0) {
          return true;
        }
      }
      return false;
    },
    title: function title() {
      return this.currentAddress.street + ' ' + this.currentAddress.streetNumber;
    },
    subtitle: function subtitle() {
      return this.currentAddress.postalCode + ' ' + this.currentAddress.city;
    }
  },
  data: function data() {
    return {
      isEditable: false,
      newAddress: null
    };
  },
  created: function created() {
    var _this2 = this;

    var id = parseInt(this.$route.params.id);
    if (id) {
      var filteredAddresses = this.addresses.filter(function (address) {
        return address.id === id;
      });
      if (filteredAddresses.length === 0) {
        this.$store.dispatch('fetchAddressById', id).catch(function () {
          _this2.showErrorMsg({
            message: _this2.$t('error.addressDetails.fetchAddressById')
          });
        });
      } else {
        this.$store.commit('setCurrentAddress', filteredAddresses[0]);
      }

      if (this.isPolicyHolder) {
        this.$store.dispatch('fetchAddresses');
        this.$store.dispatch('fetchContractsByAddress', id).catch(function () {
          _this2.showErrorMsg({
            message: _this2.$t('error.addressDetails.contractsByAddress')
          });
        });
      }
    } else {
      this.$router.replace('/addresses');
    }
  },
  destroyed: function destroyed() {
    this.$store.commit('setCurrentAddress', {});
  },

  methods: {
    back: function back() {
      this.$router.push('/addresses');
    },
    cancel: function cancel() {
      this.isEditable = false;
    },
    updateContractsWithAddress: function updateContractsWithAddress() {
      var _this3 = this;

      this.$store.dispatch('updateContractsWithAddress', {
        oldAddressId: this.currentAddress.id,
        newAddressId: this.newAddress.id
      }).then(function () {
        _this3.showSuccessMsg({
          message: _this3.$t('message.addressDetails.changedAdresses')
        });
      }).catch(function () {
        _this3.showErrorMsg({
          message: _this3.$t('error.addressDetails.changedAdresses')
        });
      });
    },
    deleteAddress: function deleteAddress() {
      var _this4 = this;

      this.$store.dispatch('deleteAddressById', this.currentAddress.id).then(function () {
        _this4.showSuccessMsg({
          message: _this4.$t('message.addressDetails.deleteAddress')
        });
        _this4.$router.push('/addresses');
      }).catch(function () {
        _this4.showErrorMsg({
          message: _this4.$t('error.addressDetails.deleteAddress')
        });
      });
    },
    editAddress: function editAddress() {
      this.isEditable = true;
    },
    getAddressBoxClass: function getAddressBoxClass(address) {
      if (this.newAddress && this.newAddress.id === address.id) {
        return 'address-box__selected';
      }
      return 'address-box_un_selected';
    },
    getTitle: function getTitle(address) {
      return address.street + ' ' + address.streetNumber;
    },
    onSelectAddressbox: function onSelectAddressbox(address) {
      this.newAddress = address;
    },
    onShowDetails: function onShowDetails(item) {
      this.$router.push('/contracts/' + item.id);
    },
    saveAddress: function saveAddress() {
      var _this5 = this;

      this.$store.dispatch('updateAddress', this.currentAddress).then(function () {
        _this5.showSuccessMsg({
          message: _this5.$t('message.addressDetails.saveAddress')
        });
        _this5.isEditable = false;
      }).catch(function () {
        _this5.showErrorMsg({
          message: _this5.$t('error.addressDetails.saveAddress')
        });
      });
    }
  },
  notifications: {
    showSuccessMsg: {
      type: 'success'
    },
    showErrorMsg: {
      type: 'error'
    }
  }
});

/***/ }),

/***/ "S7IL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Nuernberger-logo.9eb6fcc.png";

/***/ }),

/***/ "SOJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('spinner',{attrs:{"size":"80","line-size":12,"line-fg-color":"grey","line-bg-color":"lightgrey","speed":1.5}}):_vm._e(),_vm._v(" "),(!_vm.poa && !_vm.loading)?_c('div',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.accountPowerOfAttorneyForm.pleaseUpload')))]):_vm._e(),_vm._v(" "),(_vm.poa)?_c('div',[_c('b-btn',{on:{"click":_vm.onPrintPoaFn}},[_c('span',{staticClass:"ti-printer"}),_vm._v(" "),_c('span',{staticClass:"mx-2"},[_vm._v("|")]),_vm._v("\n      "+_vm._s(_vm.fullName)+" "+_vm._s(_vm.$t('message.accountPowerOfAttorneyForm.btn.printPoa'))+"\n    ")])],1):_vm._e(),_vm._v(" "),(_vm.poa)?_c('div',[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.revoke_poa",modifiers:{"revoke_poa":true}}],staticClass:"mt-4 text-muted font-weight-light p-0",attrs:{"variant":"link"}},[_vm._v("\n      "+_vm._s(_vm.$t('message.accountPowerOfAttorneyForm.btn.revokePoa'))+"\n    ")])],1):_vm._e(),_vm._v(" "),(!_vm.poa && !_vm.loading)?_c('div',{staticClass:"mt-4"},[_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticClass:"text-right"},[_c('label',{staticClass:"btn btn-primary mb-0"},[_vm._v("\n          "+_vm._s(_vm.$t('message.accountPowerOfAttorneyForm.btn.browse'))+"\n          "),_c('input',{attrs:{"type":"file","hidden":"","accept":"application/pdf, image/*"},on:{"change":_vm.uploadPoa}})])])],1)],1):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"revoke_poa","cancel-variant":"primary","ok-variant":"danger","title":_vm.$t('message.accountPowerOfAttorneyForm.title'),"ok-title":_vm.$t('message.accountPowerOfAttorneyForm.btn.ok'),"cancel-title":_vm.$t('message.accountPowerOfAttorneyForm.btn.cancel')},on:{"ok":_vm.revoke}},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.accountPowerOfAttorneyForm.message')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SgFV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-wizard',{ref:"contractWizard",attrs:{"title":"","subtitle":"","color":"#007bff","stepSize":"xs"},on:{"on-change":_vm.onWizardTabChange,"on-complete":_vm.onCompleteContractWizard}},[_c('tab-content',{attrs:{"title":_vm.$t('message.contractWizard.tabContent.contractPartner'),"icon":"ti-agenda","before-change":_vm.validateContractPartner}},[_c('contract-partner-details',{ref:"contractPartnerDetails"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":_vm.$t('message.contractWizard.tabContent.contractInformation'),"icon":"ti-id-badge","before-change":_vm.validateContractInformation}},[_c('contract-information-details',{ref:"contractInformationDetails"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":_vm.$t('message.contractWizard.tabContent.contractAddress'),"icon":"ti-home","before-change":_vm.validateContractAddress,"after-change":_vm.verifyContractInformation}},[_c('contract-address-details')],1),_vm._v(" "),_c('tab-content',{attrs:{"title":_vm.$t('message.contractWizard.tabContent.contractEstate'),"icon":"ti-files","beforeChange":_vm.validateContractEstate}},[_c('contract-estate-details')],1),_vm._v(" "),_c('div',{attrs:{"slot":"custom-buttons-left"},slot:"custom-buttons-left"},[(_vm.showBtnContractPartnerCancel)?_c('b-btn',{staticClass:"rounded-0",attrs:{"variant":"danger"},on:{"click":_vm.onCancelWizard}},[_vm._v("\n        "+_vm._s(_vm.$t('message.contractWizard.btn.cancel'))+"\n      ")]):_vm._e()],1),_vm._v(" "),(_vm.currentContract.id && _vm.currentContract.id != -1)?_c('div',{staticClass:"float-left mr-3",attrs:{"slot":"custom-buttons-right"},slot:"custom-buttons-right"},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.deleteContractModal",modifiers:{"deleteContractModal":true}}],staticClass:"rounded-0"},[_vm._v("\n        "+_vm._s(_vm.$t('message.contractWizard.btn.delete'))+"\n      ")])],1):_vm._e(),_vm._v(" "),_c('b-btn',{staticClass:"rounded-0",attrs:{"slot":"prev","variant":"link"},on:{"click":_vm.onWizardPrevClicked},slot:"prev"},[_vm._v("\n      "+_vm._s(_vm.$t('message.contractWizard.btn.prev'))+"\n    ")]),_vm._v(" "),_c('b-btn',{staticClass:"rounded-0",attrs:{"slot":"next","variant":"primary"},slot:"next"},[_vm._v("\n      "+_vm._s(_vm.$t('message.contractWizard.btn.next'))+"\n    ")]),_vm._v(" "),_c('b-btn',{staticClass:"rounded-0",attrs:{"slot":"finish","variant":"primary"},slot:"finish"},[_vm._v("\n      "+_vm._s(_vm.$t('message.contractWizard.btn.finish'))+"\n    ")])],1),_vm._v(" "),_c('b-modal',{ref:"deleteContractModal",attrs:{"id":"deleteContractModal","centered":"","ok-variant":"primary","title":_vm.$t('message.contractWizard.deleteContractModal.title'),"ok-title":_vm.$t('message.contractWizard.deleteContractModal.btn.ok'),"cancel-title":_vm.$t('message.contractWizard.deleteContractModal.btn.cancel')},on:{"ok":_vm.onDeleteContract}},[_vm._v("\n    "+_vm._s(_vm.$t('message.contractWizard.deleteContractModal.message'))+"\n  ")]),_vm._v(" "),_c('b-modal',{ref:"contractWizardModal",attrs:{"id":"contractWizardModal","centered":"","ok-only":"","ok-variant":"primary","title":_vm.$t('message.contractWizard.contractWizardModal.title'),"ok-title":_vm.$t('message.contractWizard.contractWizardModal.btn.submit')}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('message.contractWizard.contractWizardModal.message'))}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SlQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__ = __webpack_require__("AE0Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Faq',
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__["a" /* default */]
  },
  data: function data() {
    return { // the texts are here
      text1_0: 'Der Tod eines nahestehenden Menschen bedeutet eine Verlusterfahrung und ist mit Trauer verbunden. Der Tod zerrei\xDFt das Geflecht von Rollen, Funktionen und Beziehungsstrukturen und ver\xE4ndert tiefgreifend die Dynamik und das seelische Gleichgewicht von Familien, Partnerschaften oder auch jedes Einzelnen. Doch Sie m\xFCssen mit Ihrer Trauer nicht allein bleiben.<br><br> Trauerbegleitung leisten Angeh\xF6rige, Freunde oder Bekannte ebenso wie professionelle Helfer und die beiden gro\xDFen Kirchen. In vielen Orten gibt es Selbsthilfegruppen, deren Adressen bzw. Kontaktpersonen Ihrem Bestatter bekannt sind. Er wird Ihnen, wenn Sie sich an ihn wenden, Zugang zu diesen Gruppen vermitteln oder Adressen nennen, bei denen Ihnen geholfen werden kann. ',
      text1_1: 'Unter Trauer sind die psychischen Reaktionen zu verstehen, die nach dem Verlust eines nahestehenden Menschen durch dessen Tod auftreten k\xF6nnen. Trauer ist keine Krankheit, sondern eine lebenswichtige Reaktion. Sie geh\xF6rt zum Leben und zur Abschiednahme. Trauer ist bereits ein Teil der Verarbeitung eines Verlusts. Sie wird von jedem individuell erlebt. Der Trauer muss Raum und Zeit gegeben werden. Sie sollte nicht verdr\xE4ngt werden, denn es ist eine unter \xC4rzten und Psychologen anerkannte Tatsache, dass unverarbeitete Trauer zu Krankheiten und seelischen Sch\xE4den f\xFChren kann. <br><br>Trauer \xE4u\xDFert sich in Form von k\xF6rperlichen Reaktionen und Verhaltensweisen, die von den Einstellungen des Einzelnen zum Tod abh\xE4ngen, aber auch von der Einstellung der Gesellschaft zum Umgang mit Tod und Trauer beeinflusst werden. <br> <br> Zu den mit der Trauer verbundenen Gef\xFChlen geh\xF6ren Verlassenheit, Einsamkeit, Hilflosigkeit, Beklemmung, Wut, Angst, Zorn und manchmal auch Erleichterung. Trauer kann sich jedoch auch k\xF6rperlich auswirken, und zwar in M\xFCdigkeit, \xDCberempfindlichkeit gegen L\xE4rm, Muskelschw\xE4che, Magenschmerzen, Atemnot und Sch\xFCttelfrost. Zur Trauer geh\xF6ren Tr\xE4nen. Tr\xE4nen sind der Beginn des Trostes, sie machen uns frei zu neuem Handeln.<br><br>Wichtig f\xFCr die Verarbeitung von Trauer ist es, dass der erlittene Verlust vergegenw\xE4rtigt und akzeptiert wird. Verzichten Sie deshalb nicht darauf, von Ihrem Verstorbenen Abschied zu nehmen, ber\xFChren sie ihn und nehmen Sie ihn ein letztes Mal in den Arm.<br><br>Der Bestatter Ihres Vertrauens hilft Ihnen dabei. Er sorgt daf\xFCr, dass der Verstorbene hygienisch versorgt wird, dass Sie im Trauerhaus, im Abschiedsraum des Bestatters oder auch auf dem Friedhof den Verstorbenen noch einmal sehen und Zwiesprache mit ihm halten k\xF6nnen.',
      text1_2: '\n         Die Trauerpsychologie unterscheidet bei der Bew\xE4ltigung der Trauer mehrere Phasen, die jedoch nicht in jedem Trauerfall zwingend gleichartig ablaufen. Die gegenw\xE4rtige psychologische Forschung vertritt zwar immer noch das sogenannte \u201EPhasen-Modell\u201C, hat aber erkannt, dass Trauer auch eine Aufgabe darstellt, die es zu meistern gilt. Daher wird neben den Trauerphasen in den letzten Jahren verst\xE4rkt auch von Traueraufgaben gesprochen. Unter den Trauerphasen versteht man:\n         <br><br>&nbsp;\u2022&nbsp; Phase des Schocks: Der Betroffene ist wie gel\xE4hmt und zu keinen Gef\xFChlsregungen f\xE4hig, der Ausdruck der Ungl\xE4ubigkeit und des Nichtwahrhabenwollens herrscht vor. Wird der Zustand nicht \xFCberwunden und weiterhin das Eingetretene geleugnet, spricht man im Allgemeinen\n         von einer "Behinderung der Trauer", die zu ernsthaften St\xF6rungen f\xFChren kann.\n         <br><br>&nbsp;\u2022&nbsp; Kontrollierte Phase: Der Trauernde erh\xE4lt \xE4u\xDFeren Halt durch die F\xFClle der mit der Beerdigung verbundenen Aufgaben, die Beerdigung, die Ansprache des Pfarrers oder Redners, der Beistand von Menschen, die dem Trauernden besonders verbunden sind. All dies kann f\xFCr den weiteren Verlauf des Trauerprozesses von Bedeutung sein.\n         <br><br>&nbsp;\u2022&nbsp; Regressive Phase: Nach der Beerdigung kann ein Zusammenbruch der psychischen Organisation erfolgen, der Trauernde stirbt einen symbolischen Tod (apathisches Verhalten, das eigene Ich ist in seiner ganzen inneren Organisation betroffen).\n         <br><br>&nbsp;\u2022&nbsp; Phase der Neuorientierung: Erneute Zuwendung zur Umwelt und zur Gesellschaft, der Prozess der Trauer wird abgeschlossen (Aufnahme einer Berufst\xE4tigkeit, neue Partnerbeziehungen). <br>\n          <br> Um Trauer zu bearbeiten, ist das Gespr\xE4ch erforderlich. Wenn sich die Umwelt nach einigen Tagen oder Wochen wieder dem Alltagsgeschehen zuwendet, dann braucht der Trauernde Gespr\xE4chspartner, die ihm zuh\xF6ren und mit ihm \xFCber den Verstorbenen sprechen k\xF6nnen. Scheuen Sie sich nicht, sich auch nach 1-2 Wochen oder nach Monaten an den Bestatter Ihres Vertrauens zu wenden, um mit ihm \xFCber Ihr Verh\xE4ltnis zum Verstorbenen, \xFCber die Reaktion in Ihrer Umwelt sowie \xFCber Ihre allt\xE4glichen Sorgen zu sprechen. Der Bestatter wird sich Ihrer annehmen, er wird Ihnen zuh\xF6ren und Sie f\xFCr den Fall, dass er nicht selber helfen kann, an Personen verweisen, die Ihnen professionell weiterhelfen k\xF6nnen oder die gleichen Erfahrungen gemacht haben. ',

      text1_3: 'Manchmal betreffen Trauer und Tod auch die Lebenswelt von Kindern, z. B. wenn Kinder einen Elternteil oder Angehörige verlieren. Oft müssen Bestatter aber auch Eltern beistehen, die ihr Kind verloren haben – eine sehr schmerzliche Erfahrung, die auch Paare treffen kann, die ein totgeborenes Kind beklagen. In diesem Bereich gibt es inzwischen verschiedene Hilfsangebote für „Sternenkinder“, wo verwaiste Eltern Rat und Trost finden können. <br> Grundsätzlich trauern Kinder anders als Erwachsene. Die kindliche Trauer zeigt sich oft sprunghaft: Die Kinder weinen und im nächsten Moment sind sie wieder fröhlich. Sie agieren oftmals spontan, ziehen sich zurück oder sind aggressiv. Wenn Angehörige stark mit ihrer eigenen Trauer beschäftigt sind, spüren Kinder das sehr genau. Oftmals leugnen sie deshalb ihre eigenen Trauergefühle, um die Angehörigen nicht noch mehr zu belasten. <br><br> <strong>Trauer bei Kindern in verschiedenen Altersstufen </strong> <br> Die Reaktionen auf den Verlust sind altersabhängig: Säuglinge und Kleinkinder haben kein reflektiertes Verhältnis zum Tod; sie empfinden eher Trennungsschmerz, wenn eine vertraute Person fehlt. Kinder im Alter von 3 bis 6 Jahren entwickeln erst langsam ein Verständnis der zeitlichen Dimension „für immer“; oft wehren sie schmerzliche Gefühle mit übertriebener Albernheit ab. Erst ab einem Alter von 10, 12 Jahren kann von kindlicher Trauer gesprochen werden. Nun können sie auch bewusst von einem Verstorbenen Abschied nehmen: Denn das Kind gehört zur Familie und teilt deren Schmerz. Es braucht keine Schonung, sondern authentische Wegbegleiter, die ehrliche Antworten geben. Vielleicht wollen Kinder ein gemaltes Bild mit in den Sarg legen? Nicht nur Eltern können ihre Kinder trösten, auch umgekehrt ist das möglich. Auch sollten Eltern ihre Kinder ruhig an der Trauerfeier teilnehmen lassen.',

      text1_4: 'Moderne Zeiten bringen auch neue und bislang ungewohnte Formen der Trauer, des Gedenkens und der Auseinandersetzung mit dem Tod und der menschlichen Sterblichkeit mit sich. <br>Wenn sich im Internet auch seit Jahren sogenannte virtuelle Friedhöfe formiert haben, in denen man der Verstorbenen durch einen Text oder das symbolische Entzünden einer Kerze gedenken kann, so ist das keineswegs die einzige Form der Erinnerung an einen Menschen auf digitaler Ebene. <br><br> In einer Vielzahl sozialer Netzwerke gibt es inzwischen Gedenkorte für verstorbene frühere Mitglieder einer Community oder einer Interessenplattform im Internet. Auch sogenannte QR-Codes auf Grabsteinen führen nach einem Scan des Codes mit einem Smartphone direkt auf digitale Gedenkseiten, in denen Bilder, Texte und musikalische Erinnerungen festgehalten werden können. <br><br> Diese neuen Formen der Trauerkultur sind zum Teil noch ungewohnt und wirken irritierend, können aber eine hilfreiche Ergänzung auf dem Weg eines gelungenen Trauerprozesses sein. Entscheidend ist aber die Feststellung, dass solche Formen des Gedenkens ergänzenden Charakter haben, keinesfalls die reale Trauer an einem Grab oder einem Bestattungsplatz ersetzen können. Im Letzten braucht der Mensch auch im 21. Jahrhundert konkrete Orte für seine Gefühle, ein greifbares Andenken jenseits digitaler Welten.<br><br> Eine weitere Fragestellung, die sich durch die Aktivität von Verstorbenen zu ihren Lebzeiten im Internet ergibt: Was passiert mit den digitalen Spuren privater, beruflicher und persönlicher Aktivität im Internet und in sozialen Netzwerken? <br><br>Inzwischen gibt es auch hier Anbieter, die für Angehörige Abmeldungen in Online-Foren, Shops und Netzwerken vornehmen, um auch dort den Tod eines Menschen zu dokumentieren und Angehörige vor belastenden E-Mails und Internetinhalten bewahren. ',
      text2: 'Im Trauerfall werden wichtige Dokumente ben\xF6tigt, die bereits im Vorfeld in einem Vorsorge-Ordner zusammengestellt werden sollten, um eine zeitaufwendige Suche vor einer Beerdigung zu vermeiden. Nach der Zusammenstellung m\xFCssen Bestattung und Trauerfeier geplant werden. <br><br> Zun\xE4chst muss entschieden werden, welche Formalit\xE4ten selbst \xFCbernommen und welche an ein Bestattungsinstitut delegiert werden sollen.<br><br> ',
      text2_1: ' Bei einem Sterbefall zu Hause, im Alten- oder Pflegeheim ist ein Arzt zu benachrichtigen, damit dieser die Todesbescheinigung ausstellen kann. <br>Bei einem Sterbefall im Krankenhaus wird diese durch die Krankenhausverwaltung ausgestellt. Wenn der Arzt nicht bescheinigen kann, dass eine natürlich Todesursache vorliegt, muss die Polizei benachrichtigt werden. Das hat jedoch nichts mit einer möglichen Straftat oder einer unterstellenden Vermutung zu tun. <br><br>',
      text2_2: '  Es ist sinnvoll, einen Bestatter zu einem möglichst frühen Zeitpunkt zu benachrichtigen, damit er den Angehörigen behilflich sein und sie beraten kann. Es ist dagegen nicht erforderlich, dass der Verstorbene sofort ins Bestattungsinstitut überführt wird. Er kann bis zu 36 Stunden zu Hause aufgebahrt werden, damit die Angehörigen von ihm Abschied nehmen können. Bestatter klären Angehörige darüber auf, was dabei zu beachten ist. Bevor ein Bestatter benachrichtigt wird, ist zu prüfen, ob der Verstorbene mit einem bestimmten Bestatter bereits einen Bestattungsvorsorgevertrag abgeschlossen hat. Im Beratungsgespräch mit dem jeweiligen Bestatter sollte anschließend geklärt werden, welche Festlegungen getroffen wurden. <br><br>Einen Bestatter in der Nähe zu finden, ist vielleicht gar nicht so einfach, wie man zunächst annehmen möchte, gerade unmittelbar nach einem Todesfall in der Familie. Sie sollten dann in naher Zeit einen Bestatter in der Nähe finden, der Ihnen bei allen weiteren Schritten hilft.<br><br> Diesen finden Sie leicht auf www.bestatter.de . Für Ihre Suche geben Sie ganz einfach auf der Startseite Ihre Adresse oder Postleitzahl ein, anschließend werden Ihnen Bestatter in der Nähe angezeigt, die Sie kontaktieren können. <br><br> <strong>Todesfall im Ausland</strong><br><br>Es kommt durch die Möglichkeiten des modernen Massentourismus immer häufiger vor, dass Menschen im Urlaub oder einer Auslandsreise versterben. Zur Trauer und dem Schock kommen dann auf die Angehörigen hohe Kosten der Überführung nach Deutschland zu. In einem derartigen Fall empfiehlt es sich, mit der Botschaft oder dem Konsulat der Bundesrepublik Deutschland im Urlaubsland Kontakt aufzunehmen. Die aktuellen Adressen finden Sie auf der Internetseite des Bundesministerium des Äußeren: www.auswaertiges-amt.de<br><br> Bei der vorliegenden Bestattungsvorsorgeversicherung der NÜRNBERGER Versicherung besitzt der Vorsorgende Versicherungsschutz für eine Auslandsrückholung im Todesfall.<br><br><strong>Transrep International hilft bei Auslandsüberführungen</strong><br><br>Das Kuratorium Deutsche Bestattungskultur empfiehlt, bei einem Todesfall im Ausland für die notwendige Überführung nach Deutschland die Firma TransRep International GmbH über einen Bestatter, der Mitglied im Bundesverband ist, mit dieser vertrauensvollen und fachlich sehr spezifischen Dienstleistung zu beauftragen.<br><br><strong>Die Schlichtungsstelle bei Differenzen mit einem Bestatter</strong><br><br>Ein Fehler in der Traueranzeige, eine missverständliche Rechnung: Jeder tatsächliche oder auch nur so empfundene Mangel kann bei einer Bestattung schnell zu Unstimmigkeiten zwischen Angehörigen und einem Bestatter führen. Damit es nicht gleich zu einem Streit vor Gericht kommt, hat das Kuratorium Deutsche Bestattungskultur eine Schlichtungsstelle eingerichtet. Um unnötige Kosten und unerfreuliche Gerichtsverfahren zu vermeiden, ist es das Ziel der Schlichtungsstelle, mithilfe eines unabhängigen Gremiums Streitfälle zwischen Bestattern und Auftraggebern im Einvernehmen und ohne Gerichtsprozess zu klären – kostenlos. <br><br>Im Schlichtungsverfahren äußern sich der Bestatter und der Kunde schriftlich zu der im Raum stehenden Reklamation. Sind klärende Gutachten zu erstellen, werden vereidigte Sachverständige der Handwerkskammern herangezogen. Wie auch immer die Schlichtungsstelle entscheidet, der Rechtsweg bleibt den Streitenden offen. Doch die Erfolgsquote ist hoch. <br><br>Wenden Sie sich im Fall der Fälle an die Schlichtungsstelle.<br><br> <strong> Engste Angehörige benachrichtigen</strong> <br><br>',
      text2_3: '\u2022&nbsp;Nachweis \xFCber den letzten Wohnsitz\n\n      <br><br>\u2022&nbsp;Todesbescheinigung vom Arzt\n\n      <br><br>\u2022&nbsp;Personenstandsurkunden\n\n      <br><br>&nbsp;o&nbsp;&nbsp;bei Ledigen: Geburtsurkunde\n\n      <br><br>&nbsp;o&nbsp;&nbsp;bei Verheirateten: Heiratsurkunde\n\n      <br><br>&nbsp;o&nbsp;&nbsp;bei Geschiedenen: Heiratsurkunde und Scheidungsurteil mit Rechtskraftvermerk\n\n      <br><br>&nbsp;o&nbsp;&nbsp;bei Verwitweten: Heiratsurkunde und Sterbeurkunde des Ehepartners\n\n      <br><br>&nbsp;o&nbsp;&nbsp;bei gleichgeschlechtlichen Partnerschaften ist anstelle der Heiratsurkunde die entsprechende Urkunde vorzulegen\n\n      <br><br>\u2022&nbsp;Bestattungsvorsorgevertrag (falls vorhanden)\n\n      <br><br>\u2022&nbsp;Versicherungsunterlagen (Sterbegeld-, Lebens-, Unfallversicherungen)\n\n      <br><br>\u2022&nbsp;Private Sterbegeldversicherungen, Nachbarschaftshilfevereine etc.\n\n      <br><br>\u2022&nbsp;Rentennummer: Diese befindet sich auf dem Rentenbescheid bzw. auf dem Rentenausweis. Die Rentennummer findet sich auch auf dem Kontoauszug des Girokontos, da die Renten stets unter Angabe der Rentennummer \xFCberwiesen werden.\n\n      <br><br>\u2022&nbsp;Angaben zu betrieblichen Renten\n\n      Der Bestatter h\xE4lt \xFCblicherweise die Formulare f\xFCr die Beantragung der sogenannten Drei-Monats-Rente (Sterbevierteljahr) f\xFCr die Witwe oder den Witwer vor.\n\n      <br><br>\u2022&nbsp;Grabdokumente, sofern bereits eine Grabstelle vorhanden oder reserviert ist.\n\n      <br><br>\u2022&nbsp;Testament, Erbvertrag, Hinterlegungsschein f\xFCr das Amtsgericht oder den Notar.\n\n      <br><br>\u2022&nbsp;Letztwillige Verf\xFCgung \xFCber die vom Verstorbenen zu Lebzeiten gew\xFCnschte Bestattungsart (Erdbestattung, Feuerbestattung, Seebestattung etc.)',
      text2_4: '\u2022&nbsp;Besorgung der Sterbeurkunden beim Standesamt des Sterbeortes, die sogenannte Abmeldung. Es muss nicht \xFCberall ein Original vorgelegt werden - bei der Abmeldung von bestimmten Versicherungen, wie beispielsweise bei Autoversicherungen - reicht eine Fotokopie. Bei Sterbegeld-, Lebens- oder Rentenversicherungen muss ein Original vorliegen.\n\n      <br><br>\u2022&nbsp;Erwerb oder Wiedererwerb der Grabst\xE4tte\n\n      <br><br>\u2022&nbsp;Terminfestlegung bei der Gemeinde und/oder Kirche f\xFCr die Trauerfeier und Beerdigung\n\n      <br><br>\u2022&nbsp;Terminfestlegung mit dem Pfarrer/dem Trauerredner\n\n      <br><br>\u2022&nbsp;Musikalischer Rahmen f\xFCr die Trauerfeier (Organist, Musiker, CD, digitale Speichermedien)\n\n      <br><br>\u2022&nbsp;Dekoration/Kerzenbeleuchtung f\xFCr die Trauerfeier in der Kapelle\n\n      <br><br>\u2022&nbsp;Auslegung einer Kondolenzliste\n\n      <br><br>\u2022&nbsp;Bestellung von Blumenschmuck, Kr\xE4nzen, Handstr\xE4u\xDFen und ggf. Blumen f\xFCr die letzte Verabschiedung anstelle einer Handvoll Erde, wenn gew\xFCnscht\n\n      <br><br>\u2022&nbsp;Druck von Traueranzeigen und Danksagungen\n\n      <br><br>\u2022&nbsp;Druck von Sterbebildchen, wo regional \xFCblich\n\n      <br><br>\u2022&nbsp;Aufgabe von Traueranzeigen in der Tagespresse\n\n      <br><br>\u2022&nbsp;Vereinbarung eines Beerdigungskaffees in einer Gastst\xE4tte\n\n      <br><br>\u2022&nbsp;Abrechnung mit den Lebensversicherungen bzw. Sterbekassen\n\n      ',

      text3_0: ' Wer den Tod zu Lebzeiten tabuisiert, konfrontiert seine Angehörigen nach dem Todesfall mit Entscheidungen, die dann oft in aller Schnelle zu treffen sind. Die Frage der Entscheidung für eine Erd- oder eine Feuerbestattung hängt mit den persönlichen Vorstellungen und Überzeugungen zusammen. Der Wunsch einer bestimmten Bestattungsart muss in Form einer letztwilligen Verfügung auch dokumentiert sein. Fehlt eine entsprechende schriftliche Erklärung, entscheiden die Angehörigen.',
      text3_1: 'Bei einer Erdbestattung wird der Körper in einem Sarg der Erde übergeben. Während die Unversehrtheit des Körpers im Islam und Judentum nach wie vor zentral ist, sind Erd- und Feuerbestattung im Christentum inzwischen weitgehend gleichbedeutend.',
      text3_2: 'Bei der Feuerbestattung wird der Körper ebenfalls in einem Sarg in einem Krematorium dem Feuer übergeben. Die Einäscherung wurde bereits im Altertum bei Griechen und Römern praktiziert. Erst seit dem 19. Jahrhundert hat sich die Feuerbestattung zunehmend verbreitet und ist heutzutage der Erdbestattung gleichgestellt. Die Identität des Verstorbenen wird bei der Einäscherung gewahrt.<br><br> Die Kremation ist die Voraussetzung für weitere Formen der Bestattung: Die Seebeisetzung oder auch die Beisetzungsform an den Wurzeln von Bäumen.<br><br> Für viele Trauernde waren Gräber auf Friedhöfen lange Zeit wichtige Orte der Trauer, zu denen sie zurückkehren konnten, um sich an den Verstorbenen zu erinnern. In Deutschland besteht nicht nur bei einer Erd-, sondern auch bei einer Feuerbestattung eine Beisetzungspflicht, sei es in einem klassischen Grab, in einem Kolumbarium (Grabeskirche), auf See, in einem Bestattungswald, einer pflegefreien Gemeinschaftsgrabanlage oder auf einem namenlosen Urnenfeld. Dies hat gewichtige trauerpsychologische und kulturelle Gründe und sollte nicht als Reglementierung und Einschränkung der persönlichen Freiheit interpretiert werden.',
      text3_3: 'Bei der Seebestattung wird die Asche in einer biologisch abbaubaren Spezialurne, die sich im Wasser vollständig auflöst, von einem Schiff aus ins Meer gelassen. Die Angehörigen, die diese Zeremonie auf See begleiten können, erhalten eine Seekarte mit der genauen Angabe des Beisetzungsortes. Es gibt mehrere Beisetzungsgebiete in der Ost- und Nordsee, aber auch im Pazifik, Atlantik oder Mittelmeer.',
      text3_4: ' Bei besonderen Wünschen, etwa der Verarbeitung der Asche eines Verstorbenen zu einem synthetischen Diamanten oder einer Luftbestattung (Verstreuen der Asche in der Luft von Heißluftballon) ist es wichtig, seinen Wunsch rechtzeitig zu Lebzeiten festzuhalten und diesen auch genau zu bedenken. Auch gesetzliche Bestimmungen in Deutschland sind hierbei zu beachten. Nicht alle angebotenen Formen sind im Letzten tragfähig und für einen guten Trauerprozess bei Angehörigen förderlich.',
      text3_5: 'Der Bestatter Ihres Vertrauens ist verpflichtet, Ihnen auf Wunsch einen transparenten Kostenvoranschlag zu erstellen. Das Angebot eines Bestatters setzt sich aus drei Kostenblöcken zusammen:<br><br>&nbsp;•&nbsp;&nbsp; eigene Dienstleistungen und Lieferungen <br>&nbsp;•&nbsp;&nbsp; Fremdleistungen (Todesanzeigen, Blumen usw.) <br>&nbsp;•&nbsp;&nbsp; Friedhofs- und sonstige Gebühren <br><br> Bei der Bestattung handelt es sich um eine sehr individuelle und hochkomplexe Dienstleistung, für die eine seriöse und eingehende Beratung nötig ist. Lockvogelangebote zu vermeintlichen „Billig- und Pauschalpreisen“ halten nicht, was sie versprechen. So rät der Bundesverband Deutscher Bestatter dazu, rechtzeitig bei einem Bestattungsinstitut einen Kostenvoranschlag einzuholen, gegebenenfalls auch Vergleichsangebote. Der Anteil der Fremdleistungen kann bei 60% und höher liegen. Deshalb kann kein seriöses Unternehmen ohne genaue Informationen einen Festpreis vorab nennen. <br>Vergleichsportale im Internet können aufgrund preislich starker regionaler Unterschiede bei den Fremdleistungen und der Bandbreite von Bestattungsdienstleistungen sowie Bestattungsartikel kaum zu einer Preistransparenz beitragen. Es ist ratsam, hiervon Abstand zu nehmen zumal die Portale von dem beauftragten Bestatter auch zum Teil hohe Provisionszahlungen verlangen, die letztlich auf die Angehörigen umgelegt werden müssen. <br>Es ist zu empfehlen auf der Grundlage detailliert ermittelter Kosten einen Bestattungsvorsorgevertrag mit einem Bestatter bereits zu Lebzeiten abzuschließen.',
      text4_0: 'Todesanzeigen müssen neben inhaltlichen auch formalen Kriterien genügen. Da die Anzeigengröße maßgeblich den Preis bestimmt, muss man sich bei der Textgestaltung deutlich kürzer fassen als in einem Trauerbrief. Trauerbriefe werden an ausgewählte, dem Verstorbenen auf unterschiedliche Art Nahestehende versendet. <br><br> Die Zeitungsanzeige sollte an dem Tag erscheinen, an dem auch die Trauerbriefe bei den angeschriebenen Personen eintreffen, es sei denn, die Familie möchte nur einen ausgewählten Personenkreis an der Beerdigung teilnehmen lassen. <br><br> Die Zeitungsanzeige sollte dann nach der Beerdigung mit folgendem oder ähnlichem Text erscheinen: "Die Beerdigung (oder Trauerfeier) hat im engsten Familien- und Freundeskreis stattgefunden". Diese Abwicklung sollte in der Familie genauestens überlegt werden, da sie leicht zu Unstimmigkeiten innerhalb der Familie und/oder des Freundeskreises führen kann, wenn der Eine mit einem Trauerbrief bedacht wird und ein Anderer nicht. ',
      text4_1: 'a) Name des Verstorbenen (der Geburtsname der Frau sollte auf jeden Fall erwähnt werden, wenn er weitgehend bekannt ist), zusätzlich Titel, die zum Namen gehören wie z.B. der Doktortitel. Bei mehreren Titeln, beispielsweise Professor Dr. Dr. können alle aufgeführt werden, ebenso auch mit Zusätzen wie Dr. jur., Dr. med., Dr. h.c. Auch besondere Ehrungen oder Auszeichnungen wie: Trägerin des Bundesverdienstkreuzes – Inhaber des Verdienstordens des Landes... – Träger des Ehrenringes der Stadt... können mit aufgeführt werden, müssen aber nicht. Manchmal stellt sich die Frage, ob der Beruf der/des Verstorbenen erwähnt werden soll. Wenn dieser Beruf zur Persönlichkeit des Menschen gehört hat oder er/sie besonders stolz auf seinen/ihren Beruf war, sollte er erwähnt werden. <br><br> b) Das Datum des Todes und, wenn gewünscht, das Alter bzw. der Geburtstag der/des Verstorbenen. Das Alter oder der Geburtstag steht in den meisten Todesanzeigen. Diese Angabe ist allerdings eine individuelle Entscheidung. <br><br>c) Bei den Namen der Angehörigen ist es durchaus möglich, dass in der Zeitungsanzeige nur die Namen der engsten Angehörigen erscheinen, während im Trauerbrief auch die Namen der weiteren Angehörigen aufgeführt werden können. Erscheinen bei den Todesanzeigen nur die Namen der engsten Angehörigen, ist es durchaus üblich, dass zum Beispiel dazugeschrieben wird "Im Namen aller Angehörigen" oder "Im Namen der Hinterbliebenen" oder "und alle Angehörigen". Wenn alle Namen aufgeführt werden, sollte folgende Reihenfolge beachtet werden: Bei Verstorbenen, die verheiratet waren, kommt zuerst der Name des Ehepartners, dann die Namen der Kinder dem Alter nach mit Schwiegerkindern, die Enkel- und Urenkelkinder, die evtl. noch lebenden Eltern und Schwiegereltern und dem Alter nach die Geschwister und Schwäger. Titel der Angehörigen, die zum Namen gehören, zum Beispiel der Doktortitel, können wie üblich vor den Namen gesetzt werden. Hat nur einer der Ehepartner einen Titel, sollte formuliert werden: "Dr. Bernd Müller und Barbara Müller" oder "Bernd Müller und Dr. Barbara Müller". Auf Titel kann in der Zeitungsanzeige oder im Trauerbrief auch verzichtet werden. Der Zusatz des Geburtsnamens ist ebenfalls möglich.<br><br>d) Die letzte Anschrift des/der Verstorbenen bzw. die Anschrift der Angehörigen. <br><br> e) Ort, Datum, Uhrzeit der Trauerfeier. Wenn es dem Wunsche des/der Verstorbenen entspricht, kann geschrieben werden:<br><br>&nbsp;•&nbsp;&nbsp;"Die Beerdigung hat im engsten Familienkreis stattgefunden".<br>&nbsp;•&nbsp;&nbsp;"Die Beerdigung findet im engsten Familienkreis statt".<br><br>f) In manchen Regionen Deutschlands ist es üblich, wegen der Kranz- und Blumenspenden unter die Anzeige den Namen des Bestattungsunternehmens zu setzen. Dieser Hinweis hilft, dass die Blumenspenden von den Floristen nicht ins Trauerhaus, sondern in das Bestattungsunternehmen gebracht werden, wo sie im Interesse der Angehörigen ordnungsgemäß der späteren Danksagungen wegen registriert werden. Das hilft auch den Angehörigen, da sie nicht nach Erscheinen der Todesnachricht von Floristen oder Bekannten mit telefonischen Nachfragen belastet werden. Beim Aufsetzen einer Traueranzeige sollte auf zu großspurige Worte verzichtet werden, die den wahren Schmerz meistens nicht ausdrücken können. Sachliche Aussagen klingen nicht nur glaubhafter, sondern das Einfache ist oft auch würdiger und angemessener. Wer Wert darauf legt, die Todesursache in der Anzeige oder dem Brief zu verdeutlichen, hat dazu verschiedene Möglichkeiten. Hier einige Beispiele für tragfähige Formulierungen: <br><br>&nbsp;•&nbsp;&nbsp;nach kurzer, schwerer Krankheit <br>&nbsp;•&nbsp;&nbsp;unerwartet <br>&nbsp;•&nbsp;&nbsp;infolge eines Herzinfarktes <br>&nbsp;•&nbsp;&nbsp;nach langer, schwerer Krankheit <br>&nbsp;•&nbsp;&nbsp;nach langem, mit großer Geduld ertragenem Leiden <br>&nbsp;•&nbsp;&nbsp;durch ein tragisches Unglück <br>&nbsp;•&nbsp;&nbsp;nach unheilbarer Krankheit ',
      text4_2: 'Oft steht \xFCber einer Todesanzeige "Statt besonderer Anzeige". Folgende Gr\xFCnde sprechen daf\xFCr: <br><br>&nbsp;&nbsp;\u2022&nbsp;Die Familie verschickt keine Trauerbriefe und somit ist die Zeitungsanzeige die einzige Bekanntmachung des Todesfalles. <br>&nbsp;&nbsp;\u2022&nbsp;Die Familie kennt nicht alle Anschriften der Freunde oder Bekannten des/der Verstorbenen. <br><br>Zu vermeiden ist der Ausdruck "Statt Karten", da bei einem Todesfall Beileidsbriefe verschickt werden und keine Karten. ',
      text4_3: 'Immer h\xE4ufiger finden sich in Todesanzeigen und Trauerbriefen Zus\xE4tze, die den Wunsch der/des Verstorbenen nach einer Spende zum Ausdruck bringen. Blumen und Kr\xE4nze sind ein wertvolles und tiefes Zeichen der Wertsch\xE4tzung und einer guten Bestattungskultur. F\xFCr fast alle Menschen sind Blumen daher weitaus mehr als ein \xE4u\xDFeres Zeichen, sondern Symbol der Dankbarkeit, Zuneigung oder Trauer. Falls Sie sich dennoch im Trauerfall f\xFCr die Alternative einer Geldspende entscheiden sollten, k\xF6nnte man in einer Todesanzeige etwa so formulieren: <br><br>&nbsp;&nbsp;\u2022&nbsp;Wir bitten im Sinne der Verstorbenen um eine \xDCberweisung f\xFCr ... (Angabe der Institution oder wohlt\xE4tigen Vereinigung), Sparkasse Musterstadt, IBAN DE 123456789 00<br>&nbsp;&nbsp;\u2022&nbsp;Neben Blumen bitten wir um eine Spende zugunsten behinderter Kinder des Kinderheimes in Musterstadt. IBAN DE 123456789 00 bei der Musterbank. Vermerk: Friedrich Mustermann. <br>&nbsp;&nbsp;\u2022&nbsp;Auf Wunsch unserer lieben Verstorbenen kann alternativ zu Blumen eine Spende f\xFCr die ...Blindenmission e.V. auf das Spendenkonto Friedrich Mustermann, IBAN DE 123456789 00 bei der Sparkasse Musterstadt \xFCberwiesen werden.',
      text4_4: 'Drei Wochen nach dem Tode sollten sich die Hinterbliebenen f\xFCr die Beileidsbezeigungen bedanken. Daf\xFCr gibt es folgende M\xF6glichkeiten:<br><br>&nbsp;\u2022&nbsp;&nbsp;eine Danksagung in den Tageszeitungen <br>&nbsp;\u2022&nbsp;&nbsp;gedruckte Karten oder Briefe (wie Trauerbriefe) <br><br> Man kann sich auch mit einem pers\xF6nlichen, handgeschriebenen Brief bedanken, was allerdings bei einer gro\xDFen Zahl von Beileidsbezeigungen kaum m\xF6glich ist. Beim Aufsetzen der Danksagung ist das Bestattungsunternehmen auf Wunsch der Angeh\xF6rigen behilflich. <br><br>In den Bestattungsunternehmen liegen sowohl Textvorschl\xE4ge als auch verschiedene Muster f\xFCr Danksagungen aus. Die Angeh\xF6rigen bedanken sich f\xFCr die "Blumen- oder Kranzspenden" oder "f\xFCr die Anteil nehmenden Zeilen" oder "f\xFCr die herzliche Anteilnahme". Den anwesenden Bekannten bei der Trauerfeier dankt man, dass sie "dem Entschlafenen das letzte Geleit gaben". Der Text aller Danksagungen, ob bei Zeitungsanzeige, Karte oder Trauerbrief, sollte m\xF6glichst pers\xF6nlich abgefasst sein. Besonders positiv ist es, wenn die gedruckten Danksagungen pers\xF6nlich unterschrieben werden oder wenn die pers\xF6nliche Unterschrift gedruckt wird. <br><br> Beispiele f\xFCr Danksagungstexte<br>&nbsp;\u2022&nbsp;&nbsp;Allen, die sich in stiller Trauer mit uns verbunden f\xFChlen und ihre liebevolle Anteilnahme auf so vielf\xE4ltige Art zum Ausdruck brachten, danken wir von Herzen. <br>&nbsp;\u2022&nbsp;&nbsp;Allen, die beim Heimgang unserer lieben Verstorbenen ihre Anteilnahme und Verbundenheit auf vielf\xE4ltige Art bekundeten, spreche ich meinen herzlichen Dank aus. <br>&nbsp;\u2022&nbsp;&nbsp;Es ist so schwer, einen lieben Menschen zu verlieren; es ist wohltuend, so viel Anteilnahme zu empfangen. Daf\xFCr danken wir von Herzen. <br>&nbsp;\u2022&nbsp;&nbsp;Danke f\xFCr das tr\xF6stende Wort, gesprochen oder geschrieben; f\xFCr einen H\xE4ndedruck, wenn Worte fehlten; f\xFCr alle Zeichen der Liebe und Freundschaft; f\xFCr ein stilles Gebet. Die vielen Beweise der Anteilnahme waren uns ein Trost in den schweren Stunden. <br>&nbsp;\u2022&nbsp;&nbsp;F\xFCr die vielen Beweise herzlicher Anteilnahme durch Wort, Schrift, Geld-, Kranz- und Blumenspenden sowie allen, die unserer lieben Verstorbenen das letzte Geleit gaben, sagen wir auf diesem Wege unseren aufrichtigen Dank. <br>&nbsp;\u2022&nbsp;&nbsp;Herzlichen Dank allen, die meinen lieben Mann auf seinem letzten Weg begleiteten, ihn durch Blumen, Kr\xE4nze und Geldspenden ehrten und mir durch Wort und Schrift ihre Anteilnahme bekundeten. Die damit zum Ausdruck gebrachte Verbundenheit hat mich tief bewegt. ',
      text5_0: 'Angesichts des Todes werden wir Menschen schnell sprachlos und wissen nicht, was wir sagen sollen. Oft wird es dann fast schon unm\xF6glich, in einer Beileidskarte oder einem Brief ehrlich auszudr\xFCcken, was wir empfinden.<br><br>Das Wort Kondolenz oder auch Kondolenzschreiben leitet sich von dem lateinischen Wort \u201Econdolere\u201C ab. Es meint so viel wie: mit einem anderen mitleiden. Das setzt nat\xFCrlich voraus, dass Sie in wirklicher Weise vom Tod des Bekannten, Freundes oder Verwandten betroffen sind.<br><br>Lange Briefe sollte man auf sehr gute Bekannte und deren Hinterbliebene beschr\xE4nken.<br><br>Halten Sie ein Kondolenzschreiben niemals f\xFCr eine l\xE4stige Pflicht! Dann kann es besser sein, es ganz zu lassen.',
      text5_1: 'Lieber ___________, <br><br>wieder einmal ist der Tod in unserer Familie eingekehrt, er m\xF6ge bei allem Schmerz nicht das letzte Wort haben! <br><br>Jeder in der Familie hat zu _______ ein anderes pers\xF6nliches Verh\xE4ltnis gehabt, jeder hat _________ anders gesehen, wertgesch\xE4tzt, ist ihm anders begegnet.<br><br>Ich empfand es immer als sehr wohltuend, wenn ich im Zusammensein erfahren durfte, was ______ besonders wichtig war: ________________________________________________________________________________ <br><br>In diesen Tagen ist es besonders Deine Aufgabe, die Beerdigung und die Vorbereitungen des Abschieds zu organisieren. Ich will Dir dabei nicht noch \u201Ekluge Ratschl\xE4ge\u201C geben, Dir vielmehr signalisieren: Wenn Du konkrete Hilfe und Unterst\xFCtzung brauchst, sag mir, was ich tun kann. <br><br>Meine pers\xF6nliche \xDCberzeugung ist, dass wir mit dem Tod nur unsere \xE4u\xDFere Rolle wechseln, die Toten aber weiterhin fest zum Kreis unserer Verwandtschaft z\xE4hlen und geh\xF6ren. In diesen Tagen wollen wir zusammenstehen und in Liebe und Wertsch\xE4tzung an _________ denken. <br><br>Alle guten W\xFCnsche sendet',
      text5_2: 'Sehr geehrte ___________, <br><br>ein langes und erf\xFClltes Leben Ihres Angeh\xF6rigen ______________ ging nun friedvoll und in Dankbarkeit zu Ende. Ich m\xF6chte Ihnen, auch im Namen meiner Familie, Mitgef\xFChl und Anteilnahme aussprechen. <br><br>Mehr als diese Anteilnahme wiegt aber f\xFCr mich Respekt und Hochachtung vor der Art, wie Ihr ____________ aufrichtig und geradlinig das Leben gemeistert hat. Jeden Tag erfahren wir aus der ganzen Welt \xFCber die Medien, wie viele Lebensentw\xFCrfe scheitern, wie viele Biographien pl\xF6tzlich abgerissen werden, wie viel ungelebtes Leben oft unvers\xF6hnt und gewaltsam endet. Da ist es umso trostreicher auf die positive Grundeinstellung von ____________ zu schauen. <br><br>M\xF6ge Ihnen in aller Trauer doch auch die tiefe innere Gewissheit zuteilwerden, dass Ihr Verstorbener das Leben in gro\xDFer F\xFClle aussch\xF6pfen durfte, in H\xF6hen und Tiefen, in Licht und Schatten. <br><br>So gr\xFC\xDFt Sie herzlich ________.',
      text5_3: 'Lieber _______,<br><br>Als ich vom Tod von _________ h\xF6rte, konnte ich es erst gar nicht glauben. <br><br>Jeder wei\xDF um den Tod und die menschliche Sterblichkeit, wenn es aber im Kreis enger Freunde und Bekannte geschieht, l\xE4sst es einen richtig erschaudern. <br><br>Immer sterben nur die anderen, so denkt man. Jetzt ist der Tod in _____ Haus eingekehrt, er m\xF6ge aber nicht das letzte Wort haben. <br><br>Von ganzem Herzen will ich _____ meine tief empfundene Anteilnahme aussprechen. Anteilnahme ist ein gro\xDFes Wort, wo doch jetzt vor allem _____ diesen schweren Verlust zu erleiden und auszuhalten ______. <br><br>Gerne erinnere ich mich an viele sch\xF6ne und tiefe Momente, in denen mir _______ begegnet ist. <br><br>Besonders ist mir in bleibender Erinnerung: ________________________________________________________________________________ Ich habe ________ in vielen Begegnungen sehr sch\xE4tzen gelernt. Zu seinen positiven Eigenschaften z\xE4hle ich: ________________________________________________________________________________ <br><br>Alle guten W\xFCnsche in diesen Tagen der Trauer, des Nachdenkens und Abschiednehmens!',
      text5_4: 'Sehr geehrte __________, <br><br>ich habe erfahren m\xFCssen, dass _______ f\xFCr immer von uns gegangen ist. <br><br>Wenn wir uns auch nur durch ______________ gekannt haben, darf ______ Ihnen versichern, dass ich ___________ als sehr angenehmen und bemerkenswerten Menschen wahrgenommen habe. Seine _____________________________, machten alle Kontakte mit ____________ f\xFCr mich zu erfreulichen und positiven Begegnungen. <br><br>Bitte erlauben Sie mir, Ihnen und Ihrer Familie meine aufrichtige Anteilnahme zu \xFCbermitteln.<br><br>Mit stillen Gr\xFC\xDFen',
      text5_5: 'Sehr geehrte ____________, <br><br>in diesen Tagen habe ich vom Tod unseres _____________ geh\xF6rt. <br><br>Die Zeit dreht sich immer schneller, so empfinden es sehr viele Menschen in der Gegenwart. Umso schneller geht im t\xE4glichen Getriebe alles wieder seinen Gang, als ob der Tod gar kein Anlass w\xE4re, auch einmal inne zu halten. <br><br>Ich will Ihnen meine aufrichtige Anteilnahme aussprechen und tue dies auch im Namen von _____________. <br><br>Als berufliche Weggef\xE4hrten haben wir freilich nicht die gleiche pers\xF6nliche Bindung zu ____________ wie Sie im Kreis der Familie. Ich will Ihnen aber sagen, dass ich Ihren Angeh\xF6rigen sehr gesch\xE4tzt habe. Besonders positiv ist uns allen in Erinnerung: ________________________________________________________________________________ <br><br>Jede Arbeit lebt nicht vom Verdienst alleine, sondern von den Menschen, die hinter dieser Arbeit stehen und f\xFCr diese Arbeit einstehen. In diesem Sinne bleibt ein Teil der Lebensleistung Ihres _________ immer auch Teil unserer __________________. Im Buch der Geschichte hat jeder seinen Platz, auch _____________ geh\xF6rt dazu! <br><br>Ihnen in den Tagen des Abschieds und der Trauer Kraft, Mut und Perspektive! In herzlicher Verbundenheit!',
      text5_6: 'Sehr geehrte Familie ___________, <br><br> fassungslos und tief betroffen stehe ich mit ______vor dem schlimmsten Schicksalsschlag, der Menschen treffen kann: dem Tod der eigenen Kinder! <br><br> Sie haben __________ verloren. Es ist so furchtbar hart und gegen die Natur, wenn Kinder vor ihren Eltern gehen m\xFCssen. In das Grab der Kinder zu schauen, ist ein Blick in den Abgrund! <br><br> Zum Tod Ihres kleinen Sonnenscheins spreche ich Ihnen meine aufrichtige Anteilnahme und mein tief empfundenes Mitgef\xFChl aus. <br><br>_________ war so fr\xF6hlich, so unbeschwert, so voller Leben und guter Anlagen! <br><br>Wir alle wissen, wie stolz Sie auf _______ waren und wie sehr Sie Ihr Kind umsorgt und gef\xF6rdert haben. <br><br>Der Tod eines so jungen, hoffnungsvollen Menschen ist f\xFCr uns alle unbegreiflich. <br><br>Ihnen gilt mein Beileid und unsere Trauer.',
      text5_7: 'Liebe ___________, <br><br>der Freitod von ___________ hat _______ in eine der schlimmsten menschlichen Herausforderungen gef\xFChrt. <br><br>Keiner kann in das Herz eines anderen Menschen vollkommen hineinschauen und so werden wohl immer bange Fragen offen bleiben. <br><br>Ich w\xFCnsche ______ aber so gut ich kann: Verlieren Sie sich nicht in Selbstvorw\xFCrfen, marternden Anklagen und Vermutungen. <br><br>Ich w\xFCnsche ______ Kraft, ehrliche Menschen an ________ Seite und die schwere aber doch tiefe Wahrheit: Der Mensch ist in seinem Tun frei. <br><br>In diesen Tagen der Best\xFCrzung, des bohrenden Schmerzes Kraft und langen Atem.',
      text5_8: 'Liebe ___________, <br><br>mit Best\xFCrzung habe ich vom tragischen Tod von ___________ geh\xF6rt. Was aber hei\xDFt Best\xFCrzung, wo doch Sie nun diese entsetzliche Last zu tragen haben?! <br><br>So m\xF6chte ich nicht \xFCber Ursachen des Ungl\xFCckes spekulieren, auch nicht die allzu verst\xE4ndliche Frage stellen: \u201EWas w\xE4re gewesen, wenn\u2026?\u201C <br><br>Wieder einmal m\xFCssen wir erschaudernd erkennen, wie d\xFCnn das Eis ist, auf dem wir Menschen uns oft mit einer so gro\xDFen Selbstsicherheit bewegen. <br><br>Gerne erinnere ich mich mit Blick auf ____________ an viele sch\xF6ne und gl\xFCckliche Lebensmomente: ________________________________________________________________________________ <br><br>Viele gute Erlebnisse kann auch Ihnen niemand mehr nehmen. <br><br>Bitte sagen Sie mir, wenn ich Ihnen konkret helfen kann. <br><br>Ich f\xFChle und trauere mit ________ und ________ Familie.',
      text5_9: 'Liebe ___________, <br><br>mit fassungslosem Entsetzen habe ich h\xF6ren m\xFCssen, welch schreckliches Verbrechen ______ heimgesucht hat. <br><br>T\xE4glich sehen wir Mord und Totschlag in Bild, Ton und Wort. Und doch sind es scheinbar immer die anderen. Jetzt hat die dunkelste Seite des Menschseins auch _________ getroffen. <br><br>Ich will nicht sensationsbegierig Fragen nach den Umst\xE4nden und Vermutungen \xFCber Hintergr\xFCnde anstellen. <br><br>Es bleibt ein Abgrund, der sich hier f\xFCr ______ zeigt. <br><br>Egal wie man religi\xF6s eingestellt sein mag, es bleibt zutiefst wahr, was das 5. Gebot sagt: \u201EDu sollst nicht t\xF6ten!\u201C <br><br>Bei allem Hass und aller ohnm\xE4chtigen Wut auf den T\xE4ter, w\xFCnsche ich Ihnen doch: Bleiben Sie bei sich und Ihren Gef\xFChlen. <br><br>F\xFCr die Zeit des Abschieds w\xFCnsche ich Ihnen den R\xFCckblick auf viele gute Jahre und Tage zusammen mit ______________. <br><br>Seien Sie versichert, dass wir Anteil an _______ Leid nehmen!'

    };
  }
});

/***/ }),

/***/ "Sm2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressForm_vue__ = __webpack_require__("KLHI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a90400c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressForm_vue__ = __webpack_require__("R7ap");
function injectStyle (ssrContext) {
  __webpack_require__("sDRF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a90400c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T6Pq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TL+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SignUpContactPerson',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (to.query.invitationId) {
        vm.$store.dispatch('fetchInvitationByUuid', to.query.invitationId).catch(function () {
          next('/');
        });
      } else {
        next('/');
      }
    });
  },

  computed: {
    invitation: function invitation() {
      return this.$store.getters.invitation;
    },
    relationText: function relationText() {
      return this.$t('message.signUpContactPerson.label.relation', {
        firstName: this.invitation.policyHolderFirstName,
        lastName: this.invitation.policyHolderLastName,
        salutation: this.invitation.policyHolderSalutation ? this.$t('enums.salutations.' + this.invitation.policyHolderSalutation) : undefined
      });
    },
    relationTypes: function relationTypes() {
      var _this = this;

      return this.$store.getters.relationTypes.map(function (relationType) {
        return {
          value: relationType,
          text: _this.$t('enums.relationTypes.' + relationType)
        };
      });
    },
    title: function title() {
      return this.$t('message.signUpContactPerson.title', {
        firstName: this.invitation.policyHolderFirstName,
        lastName: this.invitation.policyHolderLastName,
        salutation: this.invitation.policyHolderSalutation ? this.$t('enums.salutations.' + this.invitation.policyHolderSalutation) : undefined
      });
    }
  },
  data: function data() {
    return {
      accountOptions: [{ value: 'true', text: this.$t('message.signUpContactPerson.accountOptions.yes') }, { value: 'false', text: this.$t('message.signUpContactPerson.accountOptions.no') }],
      contactPersonRequest: {},
      relation: this.$store.getters.relationTypes[0],
      requestOptions: [{ value: 'true', text: this.$t('message.signUpContactPerson.requestOptions.yes') }, { value: 'false', text: this.$t('message.signUpContactPerson.requestOptions.no') }]
    };
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.contactPersonRequest.isAccepted === 'true' && this.contactPersonRequest.hasAccount === 'true') {
          this.invitation.relation = this.relation;
          this.$store.commit('setInvitation', this.invitation);
          this.$router.replace('/signin');
        } else if (this.contactPersonRequest.isAccepted === 'true' && this.contactPersonRequest.hasAccount === 'false') {
          this.$router.replace('/signup');
        } else {
          this.$store.dispatch('deleteInvitation', this.invitation.uuid).then(function () {
            _this2.$router.replace('/signUpContactPersonRejected');
          }).catch(function () {
            _this2.showErrorMsg({
              message: _this2.$t('error.signUpContactPerson.delete')
            });
          });
        }
      }
    }
  },
  validations: {
    contactPersonRequest: {
      hasAccount: {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function (vueInstance) {
          return vueInstance.isAccepted === 'true';
        })
      },
      isAccepted: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      }
    },
    relation: {
      required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function (vueInstance) {
        return vueInstance.isAccepted === 'true' && vueInstance.hasAccount === 'true';
      })
    }
  }
});

/***/ }),

/***/ "U2x6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.confirmData.email = to.query.email;
      vm.fromPath = from.path;
    });
  },
  data: function data() {
    return {
      confirmData: {
        email: null,
        verificationCode: null
      },
      error: {
        path: '',
        isVisible: false
      },
      fromPath: '/'
    };
  },

  methods: {
    back: function back() {
      this.$router.replace(this.fromPath);
    },
    resendConfirmationCode: function resendConfirmationCode() {
      var _this = this;

      this.$store.dispatch('resendConfirmSignUpCode', this.confirmData.email).catch(function (err) {
        _this.error.code = err.code;
        _this.error.isVisible = true;
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('confirmSignUp', this.confirmData).then(function () {
          _this2.showSuccessMsg({
            message: _this2.$t('message.signUpConfirm.activated')
          });
          _this2.$router.push({ path: '/signin', query: { email: _this2.confirmData.email } });
        }).catch(function (err) {
          if (err && err.code === 'UserNotFoundException') {
            _this2.error.path = 'error.signUpConfirm.resend';
          } else if (err && err.code === 'ExpiredCodeException') {
            _this2.error.path = 'error.signUpConfirm.submit';
          } else {
            _this2.error.path = 'error.signUpConfirm.submit';
          }
          _this2.error.isVisible = true;
        });
      }
    }
  },
  validations: {
    confirmData: {
      verificationCode: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      }
    }
  },
  notifications: {
    showSuccessMsg: {
      type: 'success'
    }
  }
});

/***/ }),

/***/ "U386":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{staticClass:"p-5",attrs:{"variant":"danger","dismissible":"","show":_vm.error.isVisible},on:{"dismissed":function($event){_vm.error.isVisible=false}}},[_c('i18n',{attrs:{"path":_vm.error.path,"tag":"div"}},[_c('b-link',{attrs:{"href":"mailto:support@meine-vertraege.net","place":"supportLink"}},[_vm._v(_vm._s(_vm.$t('message.support.email')))])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v(_vm._s(_vm.$t('message.signUpConfirm.title')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('message.signUpConfirm.message')))]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-row',{staticClass:"mt-3"},[_c('b-col',[_c('b-form-group',{attrs:{"state":_vm.$v.confirmData.verificationCode.$error ? false : null,"invalid-feedback":_vm.$t('error.signUpConfirm.verificationCode')}},[_c('b-form-input',{attrs:{"placeholder":_vm.$t('message.signUpConfirm.input.placeholder.verificationCode'),"state":_vm.$v.confirmData.verificationCode.$error ? false : null},on:{"change":function($event){_vm.$v.confirmData.verificationCode.$touch()}},model:{value:(_vm.confirmData.verificationCode),callback:function ($$v) {_vm.$set(_vm.confirmData, "verificationCode", $$v)},expression:"confirmData.verificationCode"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',[_c('i18n',{attrs:{"path":"message.signUpConfirm.again","tag":"p"}},[_c('b-link',{attrs:{"href":"#","place":"resendLink"},on:{"click":_vm.resendConfirmationCode}},[_vm._v(_vm._s(_vm.$t('message.signUpConfirm.btn.resend'))+"\n            ")]),_vm._v(" "),_c('b-link',{attrs:{"href":"mailto:support@meine-vertraege.net","place":"supportLink"}},[_vm._v(_vm._s(_vm.$t('message.support.email'))+"\n            ")])],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-btn',{attrs:{"variant":"link"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('message.signUpConfirm.btn.back')))])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary","type":"submit"}},[_vm._v(_vm._s(_vm.$t('message.signUpConfirm.btn.send')))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UE3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("Ffcp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0cef7ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("mqSa");
function injectStyle (ssrContext) {
  __webpack_require__("JqOT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c0cef7ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0cef7ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "URMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractSummary_vue__ = __webpack_require__("ALQH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5b863c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractSummary_vue__ = __webpack_require__("NRP4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5b863c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UpCd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios_auth__ = __webpack_require__("NwdG");





var state = {
  addresses: [],
  currentAddress: {}
};

var getters = {
  addresses: function addresses(state) {
    return state.addresses;
  },
  currentAddress: function currentAddress(state) {
    return state.currentAddress;
  }
};

var actions = {
  deleteAddressById: function deleteAddressById(_ref, id) {
    var commit = _ref.commit,
        getters = _ref.getters,
        dispatch = _ref.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].delete('/addresses/' + id, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        commit('setCurrentAddress', {});
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  fetchAddressById: function fetchAddressById(_ref2, id) {
    var commit = _ref2.commit,
        getters = _ref2.getters,
        dispatch = _ref2.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].get('/addresses/' + id, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setCurrentAddress', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  fetchAddresses: function fetchAddresses(_ref3) {
    var commit = _ref3.commit,
        getters = _ref3.getters,
        dispatch = _ref3.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].get('/addresses', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setAddresses', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  storeAddress: function storeAddress(_ref4, address) {
    var commit = _ref4.commit,
        getters = _ref4.getters,
        dispatch = _ref4.dispatch;

    var currentUser = getters.currentUser;
    address.user = {
      id: currentUser.id
    };
    var idToken = currentUser.idToken;
    var authValue = 'Bearer '.concat(idToken);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].post('/addresses', address, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('addAddress', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, address, {
          id: response.data.id,
          numberOfContracts: 0
        }));
        commit('setCurrentAddress', {});
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (response) {
        reject(response);
      });
    });
  },
  updateAddress: function updateAddress(_ref5, data) {
    var getters = _ref5.getters,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      var address = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
        user: {
          id: currentUser.id
        }
      });
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].put('/addresses/' + address.id, address, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('updateAddress', data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};

var mutations = {
  addAddress: function addAddress(state, address) {
    state.addresses.push(address);
  },
  setAddresses: function setAddresses(state, addresses) {
    state.addresses = addresses;
  },
  setCurrentAddress: function setCurrentAddress(state, address) {
    state.currentAddress = address;
  },
  updateAddress: function updateAddress(state, address) {
    var addressToUpdateIndex = state.addresses.findIndex(function (addressToUpdate) {
      return addressToUpdate.id === address.id;
    });
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.addresses, addressToUpdateIndex, address);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "VO/F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios_auth__ = __webpack_require__("NwdG");




var state = {
  certificateOfDeath: null,
  certificateOfInheritance: null,
  contactPersons: [],
  contactPerson: {},
  invitations: [],
  invitation: {},
  policyHolders: [],
  policyHolder: {},
  policyHolderContracts: [],
  relationTypes: ['SPOUSE', 'COMPANION', 'FRIEND', 'EXTENDED_FAMILY', 'CHILD', 'SIBLING']
};

var getters = {
  certificateOfDeath: function certificateOfDeath(state) {
    return state.certificateOfDeath;
  },
  certificateOfInheritance: function certificateOfInheritance(state) {
    return state.certificateOfInheritance;
  },
  contactPersons: function contactPersons(state) {
    return state.contactPersons;
  },
  contactPerson: function contactPerson(state) {
    return state.contactPerson;
  },
  invitations: function invitations(state) {
    return state.invitations;
  },
  invitation: function invitation(state) {
    return state.invitation;
  },
  policyHolders: function policyHolders(state) {
    return state.policyHolders;
  },
  policyHolder: function policyHolder(state) {
    return state.policyHolder;
  },
  policyHolderContracts: function policyHolderContracts(state) {
    return state.policyHolderContracts;
  },
  relationTypes: function relationTypes(state) {
    return state.relationTypes;
  }
};

var actions = {
  createContactPersonRelation: function createContactPersonRelation(_ref, contactPersonRelation) {
    var dispatch = _ref.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var authValue = 'Bearer '.concat(contactPersonRelation.idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].post('/users/createContactPersonRelation', contactPersonRelation, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  deleteInvitation: function deleteInvitation(_ref2, uuid) {
    var dispatch = _ref2.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].delete('/invitations/' + uuid).then(function () {
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  deleteContactPerson: function deleteContactPerson(_ref3, id) {
    var getters = _ref3.getters,
        commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].delete('/users/' + currentUser.id + '/contactPersons/' + id, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        commit('deleteContactPerson', id);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchContactPersons: function fetchContactPersons(_ref4) {
    var getters = _ref4.getters,
        commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/users/' + currentUser.id + '/contactPersons', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setContactPersons', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchContactPersonById: function fetchContactPersonById(_ref5, id) {
    var getters = _ref5.getters,
        commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/users/' + currentUser.id + '/contactPersons/' + id, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setContactPerson', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchContractsByPolicyHolderId: function fetchContractsByPolicyHolderId(_ref6, policyHolderId) {
    var getters = _ref6.getters,
        commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/contracts', {
        params: {
          policyHolderId: policyHolderId
        },
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setPolicyHolderContracts', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        switch (err.response.status) {
          case 403:
            {
              // certificate of death or certificate of inheritance not approved yet
              commit('setPolicyHolderContracts', null);
              dispatch('setLogoutTimer');
              resolve();
              break;
            }
          default:
            {
              reject(err);
            }
        }
      });
    });
  },
  fetchCertificateOfDeath: function fetchCertificateOfDeath(_ref7, policyHolderId) {
    var getters = _ref7.getters,
        commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    var currentUser = getters.currentUser;
    var idToken = currentUser.idToken;
    var authValue = 'Bearer '.concat(idToken);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/users/' + policyHolderId + '/certificateOfDeath/meta', {
        headers: {
          Authorization: authValue,
          'Content-Type': 'application/json'
        }
      }).then(function (metaResponse) {
        __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/users/' + policyHolderId + '/certificateOfDeath', {
          responseType: 'arraybuffer',
          headers: {
            Authorization: authValue,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          metaResponse.data.file = response.data;
          commit('setCertificateOfDeath', metaResponse.data);
          dispatch('setLogoutTimer');
          resolve();
        }).catch(function () {
          commit('setCertificateOfDeath', null);
        });
      }).catch(function (err) {
        switch (err.response.status) {
          case 404:
            {
              // no certificate of death uploaded yet
              dispatch('setLogoutTimer');
              resolve();
              break;
            }
          default:
            {
              reject(err);
            }
        }
      });
    });
  },
  fetchCertificateOfInheritance: function fetchCertificateOfInheritance(_ref8, policyHolderId) {
    var getters = _ref8.getters,
        commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    var currentUser = getters.currentUser;
    var idToken = currentUser.idToken;
    var authValue = 'Bearer '.concat(idToken);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/users/' + policyHolderId + '/contactPersons/' + currentUser.id + '/certificateOfInheritance', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        if (response.data.certificateOfInheritance) {
          var certificateOfInheritanceMeta = {};
          certificateOfInheritanceMeta.file = response.data.certificateOfInheritance;
          commit('setCertificateOfInheritance', certificateOfInheritanceMeta);
        } else {
          commit('setCertificateOfInheritance', null);
        }
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        commit('setCertificateOfInheritance', null);
        reject(err);
      });
    });
  },
  fetchDocuments: function fetchDocuments(_ref9, policyHolderId) {
    var getters = _ref9.getters,
        commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    return dispatch('fetchCertificateOfDeath', policyHolderId).then(function () {
      dispatch('fetchCertificateOfInheritance', policyHolderId);
    });
  },
  fetchInvitations: function fetchInvitations(_ref10) {
    var getters = _ref10.getters,
        commit = _ref10.commit,
        dispatch = _ref10.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/invitations', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setInvitations', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchInvitationByUuid: function fetchInvitationByUuid(_ref11, uuid) {
    var commit = _ref11.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/invitations/' + uuid).then(function (response) {
        commit('setInvitation', response.data);
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  fetchPolicyHolders: function fetchPolicyHolders(_ref12) {
    var getters = _ref12.getters,
        commit = _ref12.commit,
        dispatch = _ref12.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/users/' + currentUser.id + '/policyHolders', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setPolicyHolders', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchPolicyHolderById: function fetchPolicyHolderById(_ref13, id) {
    var getters = _ref13.getters,
        commit = _ref13.commit,
        dispatch = _ref13.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/users/' + currentUser.id + '/policyHolders/' + id, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setPolicyHolder', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  inviteContactPerson: function inviteContactPerson(_ref14, contactPerson) {
    var getters = _ref14.getters,
        commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var invitation = {
        contactPersonEmail: contactPerson.email,
        contactPersonFirstname: contactPerson.firstName,
        contactPersonLastname: contactPerson.lastName,
        contactPersonSalutation: contactPerson.salutation
      };
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].post('/invitations', invitation, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('addInvitation', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  deleteCertificateOfDeath: function deleteCertificateOfDeath(_ref15, policyHolderId) {
    var getters = _ref15.getters,
        commit = _ref15.commit,
        dispatch = _ref15.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].delete('/users/' + policyHolderId + '/certificateOfDeath', {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        commit('setCertificateOfDeath', null);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  uploadCertificateOfDeath: function uploadCertificateOfDeath(_ref16, data) {
    var getters = _ref16.getters,
        commit = _ref16.commit,
        dispatch = _ref16.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      var formData = new FormData();
      formData.append('file', data.certificateOfDeath);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].post('/users/' + data.policyHolderId + '/certificateOfDeath', formData, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        var certificateOfDeathMeta = {};
        certificateOfDeathMeta.uploaderId = currentUser.id;
        certificateOfDeathMeta.filename = data.certificateOfDeath.name;
        certificateOfDeathMeta.file = data.certificateOfDeath;
        commit('setCertificateOfDeath', certificateOfDeathMeta);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  deleteCertificateOfInheritance: function deleteCertificateOfInheritance(_ref17, policyHolderId) {
    var getters = _ref17.getters,
        commit = _ref17.commit,
        dispatch = _ref17.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].delete('/users/' + policyHolderId + '/contactPersons/' + currentUser.id + '/certificateOfInheritance', {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        commit('setCertificateOfInheritance', null);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  uploadCertificateOfInheritance: function uploadCertificateOfInheritance(_ref18, data) {
    var getters = _ref18.getters,
        commit = _ref18.commit,
        dispatch = _ref18.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].put('/users/' + data.policyHolderId + '/contactPersons/' + currentUser.id + '/certificateOfInheritance', data.documents, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        var certificateOfInheritanceMeta = {};
        certificateOfInheritanceMeta.file = response.data.certificateOfInheritance;
        certificateOfInheritanceMeta.filename = response.data.certificateOfInheritance.name;
        commit('setCertificateOfInheritance', certificateOfInheritanceMeta);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  }
};
var mutations = {
  addContactPerson: function addContactPerson(state, contactPerson) {
    state.contactPersons.push(contactPerson);
  },
  addInvitation: function addInvitation(state, invitation) {
    state.invitations.push(invitation);
  },
  deleteContactPerson: function deleteContactPerson(state, id) {
    var indexToDelete = state.contactPersons.findIndex(function (contactPerson) {
      return contactPerson.id === id;
    });
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete(state.contactPersons, indexToDelete);
  },
  setContactPersons: function setContactPersons(state, contactPersons) {
    state.contactPersons = contactPersons;
  },
  setContactPerson: function setContactPerson(state, contactPerson) {
    state.contactPerson = contactPerson;
  },
  setCertificateOfDeath: function setCertificateOfDeath(state, certificateOfDeath) {
    state.certificateOfDeath = certificateOfDeath;
  },
  setCertificateOfInheritance: function setCertificateOfInheritance(state, certificateOfInheritance) {
    state.certificateOfInheritance = certificateOfInheritance;
  },
  setInvitations: function setInvitations(state, invitations) {
    state.invitations = invitations;
  },
  setInvitation: function setInvitation(state, invitation) {
    state.invitation = invitation;
  },
  setPolicyHolders: function setPolicyHolders(state, policyHolders) {
    state.policyHolders = policyHolders;
  },
  setPolicyHolder: function setPolicyHolder(state, policyHolder) {
    state.policyHolder = policyHolder;
  },
  setPolicyHolderContracts: function setPolicyHolderContracts(state, policyHolderContracts) {
    state.policyHolderContracts = policyHolderContracts;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "VOCW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("L8Ho");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e176624e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("Ie+u");
function injectStyle (ssrContext) {
  __webpack_require__("NeuU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e176624e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e176624e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VSjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.contractId)?_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.policyHolderName,"icon":'ti-user'}})],1)],1):_vm._e(),_vm._v(" "),(_vm.$route.params.contractId && _vm.contract)?_c('ContractOverview',{staticClass:"mt-4",attrs:{"contract":_vm.contract,"contractCategories":_vm.contractCategories,"policyHolder":_vm.policyHolder}}):_vm._e(),_vm._v(" "),(_vm.$route.params.contractId)?_c('b-btn',{staticClass:"mt-4",attrs:{"variant":"link","to":'/policyHolders/' + _vm.$route.params.id}},[_vm._v("\n    "+_vm._s(_vm.$t('message.policyHolderContracts.back'))+"\n  ")]):_vm._e(),_vm._v(" "),(!_vm.$route.params.contractId)?_c('b-row',[_c('b-col',_vm._l((_vm.contractCategories),function(category){return (_vm.getContractsByCategory(category.value).length > 0)?_c('b-row',{key:category.value,staticClass:"mt-4"},[_c('b-col',[_c('ContractsCard',{attrs:{"collapseId":category.value + 'Id',"title":category.text,"items":_vm.getContractsByCategory(category.value),"phView":false},on:{"showDetails":_vm.onShowDetails}})],1)],1):_vm._e()}))],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VjwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactPersonDialog_vue__ = __webpack_require__("sk3E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15fe1e33_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactPersonDialog_vue__ = __webpack_require__("mXTA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactPersonDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15fe1e33_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactPersonDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vwsi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePasswordForm_vue__ = __webpack_require__("uhAE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bde9819_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePasswordForm_vue__ = __webpack_require__("F/9l");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePasswordForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bde9819_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePasswordForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WAKv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('ContractSummary',{staticClass:"mt-2",attrs:{"contract":_vm.contract,"contractCategories":_vm.contractCategories}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[(_vm.addressText)?_c('p',{staticClass:"text-muted mt-2"},[_vm._v(" "+_vm._s(_vm.$t('message.contractAddressDetails.question'))+" ")]):_vm._e(),_vm._v(" "),(!_vm.addressText)?_c('p',{staticClass:"text-muted mt-2"},[_vm._v(" "+_vm._s(_vm.$t('message.contractAddressDetails.noAddressHint'))+" ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.addresses),function(address){return _c('b-btn',{key:address.id,staticClass:"hoverIE p-0 my-2 mr-4 rounded-0 btn-address",attrs:{"variant":"transparent"},on:{"click":function($event){_vm.onSelectAddressbox(address)}}},[_c('Infobox',{class:_vm.getAddressBoxClass(address),attrs:{"title":_vm.getTitle(address),"subtitle":address.postalCode + ' ' + address.city}},[_c('span',{staticClass:"infobox-icon ti-home"})])],1)}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WHS1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountPowerOfAttorneyForm_vue__ = __webpack_require__("C78q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f33db5e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountPowerOfAttorneyForm_vue__ = __webpack_require__("SOJH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountPowerOfAttorneyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f33db5e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountPowerOfAttorneyForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X/yy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractInformationForm_vue__ = __webpack_require__("yhgE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632357bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractInformationForm_vue__ = __webpack_require__("B2yE");
function injectStyle (ssrContext) {
  __webpack_require__("ZiaC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-632357bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractInformationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632357bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractInformationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X69m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_BusinessCard__ = __webpack_require__("ReR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("L/hj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardContentContactPerson',
  components: {
    BusinessCard: __WEBPACK_IMPORTED_MODULE_1__components_common_BusinessCard__["a" /* default */]
  },
  computed: {
    policyHolders: function policyHolders() {
      return this.$store.getters.policyHolders;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchPolicyHolders');
  },
  data: function data() {
    return {
      regData: {}
    };
  },

  methods: {
    getNumberOfAssignedContractsText: function getNumberOfAssignedContractsText(policyHolder) {
      if (policyHolder.numberOfAssignedContracts === 1) {
        return this.$t('message.dashboardContentContactPerson.numberOfAssignedContract');
      } else {
        return this.$t('message.dashboardContentContactPerson.numberOfAssignedContracts');
      }
    },
    submit: function submit() {
      var _this = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        var payload = {
          dateOfBirth: this.$moment(this.regData.dateOfBirth, 'DD.MM.YYYY').format('YYYY-MM-DD'),
          contractNumber: this.regData.contractNumber
        };
        var successMsg = this.$t('message.dashboardContentContactPerson.addRolePolicyHolder'); // Don't know why, but putting this.$t into message body will throw an exception, so this is a workaround
        var errorMsg = this.$t('error.dashboardContentContactPerson.addRolePolicyHolder');
        this.$store.dispatch('addRolePolicyHolder', payload).then(function () {
          _this.showSuccessMsg({ message: successMsg });
        }).catch(function () {
          _this.showErrorMsg({ message: errorMsg });
        });
      }
    }
  },
  notifications: {
    showErrorMsg: {
      type: 'error'
    },
    showSuccessMsg: {
      type: 'success'
    }
  },
  validations: {
    regData: {
      dateOfBirth: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        isValidDate: __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].validators.isValidDate
      },
      contractNumber: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        isValidContractNumber: function isValidContractNumber(value) {
          return __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].validators.isValidContractNumber(value, this);
        }
      }
    }
  }
});

/***/ }),

/***/ "XJ56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("L/hj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.fromPath = from.path;
      if (to.query.email) {
        vm.confirmData.email = to.query.email;
      } else {
        next('/');
      }
    });
  },
  data: function data() {
    return {
      confirmData: {
        email: null,
        password: null,
        passwordConfirm: null,
        verificationCode: null
      },
      error: {
        isVisible: false
      },
      fromPath: '/'
    };
  },

  methods: {
    back: function back() {
      this.$router.replace(this.fromPath);
    },
    submit: function submit() {
      var _this = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('confirmResetPassword', this.confirmData).then(function () {
          return _this.$router.push('/signin');
        }).catch(function () {
          _this.error.isVisible = true;
        });
      }
    }
  },
  validations: {
    confirmData: {
      password: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        isValidPassword: __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].validators.isValidPassword
      },
      passwordConfirm: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["sameAs"])('password')
      },
      verificationCode: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),

/***/ "XNDa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    invalidEmail: function invalidEmail() {
      return this.$t('error.resetPassword.email');
    }
  },
  data: function data() {
    return {
      email: null,
      error: {
        isVisible: false
      }
    };
  },

  methods: {
    back: function back() {
      this.$router.back();
    },
    submit: function submit() {
      var _this = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('resetPassword', this.email).then(function () {
          return _this.$router.push({ path: '/resetPassword/confirm', query: { email: _this.email } });
        }).catch(function () {
          _this.error.message = _this.$t('error.resetPassword.submit', { email: _this.email });
          _this.error.isVisible = true;
        });
      }
    }
  },
  validations: {
    email: {
      email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"],
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),

/***/ "XoGe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractSummary__ = __webpack_require__("URMB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Infobox__ = __webpack_require__("AHrk");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContractAddressDetails',
  components: {
    ContractSummary: __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractSummary__["a" /* default */],
    Infobox: __WEBPACK_IMPORTED_MODULE_2__components_common_Infobox__["a" /* default */]
  },
  computed: {
    addressText: function addressText() {
      if (this.addresses.length === 0) {
        return false;
      }
      return true;
    },
    addresses: function addresses() {
      return this.$store.getters.addresses;
    },
    contractCategories: function contractCategories() {
      var _this = this;

      return this.$store.getters.contractCategories.map(function (category) {
        return {
          value: category,
          text: _this.$t('enums.contractCategories.' + category)
        };
      });
    },
    contract: function contract() {
      return this.$store.getters.currentContract;
    }
  },
  methods: {
    getTitle: function getTitle(address) {
      return address.street + ' ' + address.streetNumber;
    },
    getAddressBoxClass: function getAddressBoxClass(address) {
      if (this.contract.address && this.contract.address.id === address.id) {
        return 'address-box__selected';
      }
      return 'address-box_un_selected';
    },
    onSelectAddressbox: function onSelectAddressbox(address) {
      this.contract.address = address;
      this.$store.commit('setCurrentContract', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.contract));
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dashboard_Dashboard__ = __webpack_require__("UE3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contactPerson_ContactPersonList__ = __webpack_require__("+gC3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_contactPerson_ContactPersonDetails__ = __webpack_require__("1UH2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_contracts_ContractList__ = __webpack_require__("DrUZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_account_AccountDetails__ = __webpack_require__("PY2h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_address_AddressList__ = __webpack_require__("vzLz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_address_AddressSearchForm__ = __webpack_require__("rwcI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_address_AddressConfirmForm__ = __webpack_require__("9aVW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_address_AddressDetails__ = __webpack_require__("A9Ar");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_AdminContractPartnerDetails__ = __webpack_require__("nswO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_admin_AdminContractPartnerList__ = __webpack_require__("2AZw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_admin_AdminContractPartnerTemplateDetails__ = __webpack_require__("+kr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_admin_AdminUserDetail__ = __webpack_require__("yWLd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_AdminUserList__ = __webpack_require__("dVos");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_policyholder_PolicyHolderContracts__ = __webpack_require__("HKXj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_policyholder_PolicyHolderDetails__ = __webpack_require__("DGwN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_auth_SignIn__ = __webpack_require__("nxid");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_auth_SignUp__ = __webpack_require__("Yy6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_auth_SignUpConfirm__ = __webpack_require__("JCnD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_auth_SignUpContactPerson__ = __webpack_require__("K0aD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_auth_SignUpContactPersonRejected__ = __webpack_require__("iuRu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_auth_ResetPassword__ = __webpack_require__("/Toh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_auth_ResetPasswordConfirm__ = __webpack_require__("NhAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_info_Imprint__ = __webpack_require__("IeG7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_info_Terms__ = __webpack_require__("dcqW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_info_Policies__ = __webpack_require__("zT+r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_info_Faq__ = __webpack_require__("A4RO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_info_InfoText__ = __webpack_require__("a0lb");

































__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var routes = [{
  path: '/signin',
  component: __WEBPACK_IMPORTED_MODULE_20__components_auth_SignIn__["a" /* default */]
}, {
  path: '/signup',
  component: __WEBPACK_IMPORTED_MODULE_21__components_auth_SignUp__["a" /* default */]
}, {
  path: '/signup/confirm',
  component: __WEBPACK_IMPORTED_MODULE_22__components_auth_SignUpConfirm__["a" /* default */]
}, {
  path: '/signupcontactperson',
  component: __WEBPACK_IMPORTED_MODULE_23__components_auth_SignUpContactPerson__["a" /* default */]
}, {
  path: '/signupcontactpersonrejected',
  component: __WEBPACK_IMPORTED_MODULE_24__components_auth_SignUpContactPersonRejected__["a" /* default */]
}, {
  path: '/resetpassword',
  component: __WEBPACK_IMPORTED_MODULE_25__components_auth_ResetPassword__["a" /* default */]
}, {
  path: '/resetpassword/confirm',
  component: __WEBPACK_IMPORTED_MODULE_26__components_auth_ResetPasswordConfirm__["a" /* default */]
}, {
  path: '/',
  redirect: '/dashboard'
}, {
  path: '/dashboard',
  name: 'Dashboard',
  component: __WEBPACK_IMPORTED_MODULE_4__components_dashboard_Dashboard__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/contactpersons',
  name: 'ContactPersonList',
  component: __WEBPACK_IMPORTED_MODULE_5__components_contactPerson_ContactPersonList__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/contactpersons/:id',
  name: 'ContactPersonDetails',
  component: __WEBPACK_IMPORTED_MODULE_6__components_contactPerson_ContactPersonDetails__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/contracts/:id',
  name: 'EditContract',
  component: __WEBPACK_IMPORTED_MODULE_7__components_contracts_ContractList__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/contracts',
  name: 'ContractList',
  component: __WEBPACK_IMPORTED_MODULE_7__components_contracts_ContractList__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/addresses',
  component: __WEBPACK_IMPORTED_MODULE_9__components_address_AddressList__["a" /* default */],
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_10__components_address_AddressSearchForm__["a" /* default */]
  }, {
    path: 'confirm',
    component: __WEBPACK_IMPORTED_MODULE_11__components_address_AddressConfirmForm__["a" /* default */]
  }]
}, {
  path: '/addresses/:id',
  name: 'AddressDetails',
  component: __WEBPACK_IMPORTED_MODULE_12__components_address_AddressDetails__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/account',
  name: 'Account',
  component: __WEBPACK_IMPORTED_MODULE_8__components_account_AccountDetails__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/policyHolders/:id',
  name: 'PolicyHolderDetails',
  component: __WEBPACK_IMPORTED_MODULE_19__components_policyholder_PolicyHolderDetails__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/policyHolders/:id/:contractId',
  name: 'ViewPolicyHolderContracts',
  component: __WEBPACK_IMPORTED_MODULE_18__components_policyholder_PolicyHolderContracts__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/faq',
  name: 'Faq',
  component: __WEBPACK_IMPORTED_MODULE_30__components_info_Faq__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/imprint',
  name: 'Imprint',
  component: __WEBPACK_IMPORTED_MODULE_27__components_info_Imprint__["a" /* default */]
}, {
  path: '/info',
  name: 'Info',
  component: __WEBPACK_IMPORTED_MODULE_31__components_info_InfoText__["a" /* default */]
}, {
  path: '/terms',
  name: 'Terms',
  component: __WEBPACK_IMPORTED_MODULE_28__components_info_Terms__["a" /* default */]
}, {
  path: '/policies',
  name: 'Policies',
  component: __WEBPACK_IMPORTED_MODULE_29__components_info_Policies__["a" /* default */]
}, {
  path: '/admin/users',
  name: 'AdminUserList',
  component: __WEBPACK_IMPORTED_MODULE_17__components_admin_AdminUserList__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/users/:id',
  name: 'AdminUserDetail',
  component: __WEBPACK_IMPORTED_MODULE_16__components_admin_AdminUserDetail__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/contractpartners',
  name: 'AdminContractPartnerList',
  component: __WEBPACK_IMPORTED_MODULE_14__components_admin_AdminContractPartnerList__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/contractpartners/:id',
  name: 'AdminContractPartnerDetails',
  component: __WEBPACK_IMPORTED_MODULE_13__components_admin_AdminContractPartnerDetails__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/contractpartners/template/:id',
  name: 'AdminContractPartnerTemplateDetails',
  component: __WEBPACK_IMPORTED_MODULE_15__components_admin_AdminContractPartnerTemplateDetails__["a" /* default */],
  meta: {
    requiresAuth: true
  }
}];

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({ routes: routes });
router.beforeEach(function (to, from, next) {
  var currentUser = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.currentUser;
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });

  if (requiresAuth) {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length === 0) {
      next({
        path: '/signIn',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yy6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__("oyeM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a88b9f52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__("75gL");
function injectStyle (ssrContext) {
  __webpack_require__("eHWv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a88b9f52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a88b9f52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zemm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContractOverview',
  props: {
    contract: {
      type: Object,
      required: true
    },
    contractCategories: {
      type: Array,
      required: true
    },
    policyHolder: {
      type: Object,
      required: true
    }
  },
  computed: {
    contractAddress: function contractAddress() {
      return this.contract.address;
    },
    contractPartner: function contractPartner() {
      return this.contract.contractPartner;
    },
    contractCategoryText: function contractCategoryText() {
      var _this = this;

      if (this.contract.contractCategory) {
        var filteredCategories = this.contractCategories.filter(function (contractCategory) {
          return contractCategory.value === _this.contract.contractCategory;
        });
        if (filteredCategories.length > 0) {
          return filteredCategories[0].text;
        }
      }
      return '';
    },
    contractNumberText: function contractNumberText() {
      return this.contract.contractCategory === 'INSURANCE' ? this.$t('message.contractInformationForm.label.insuranceNumber') : this.$t('message.contractInformationForm.label.contractNumber');
    }
  }
});

/***/ }),

/***/ "ZiaC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a0lb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoText_vue__ = __webpack_require__("Mhcg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70f1f56d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoText_vue__ = __webpack_require__("jmcO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70f1f56d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoText_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a2Ma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('Autocomplete',{attrs:{"items":_vm.filteredContractPartners,"component-item":_vm.contractPartnerTemplate,"get-label":_vm.getContractPartnerLabel,"min-len":0,"auto-select-one-item":false,"placeholder":_vm.$t('message.contractPartnerDetails.placeholder.contractPartner')},on:{"update-items":_vm.updateContractPartners,"item-selected":_vm.updateContractPartner},model:{value:(_vm.contractPartner),callback:function ($$v) {_vm.contractPartner=$$v},expression:"contractPartner"}})],1)],1),_vm._v(" "),(_vm.showForm)?_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"md":"12","lg":"12","xl":"10"}},[_c('b-form',[_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v("\n              "+_vm._s(_vm.$t('message.contractPartnerDetails.label.contractPartnerName'))+"\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.formData.contractPartnerName.$error ? false : null,"invalid-feedback":_vm.$t('error.contractPartnerDetails.contractPartner.contractPartnerName')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"company","state":_vm.$v.formData.contractPartnerName.$error ? false : null},on:{"change":function($event){_vm.$v.formData.contractPartnerName.$touch()}},model:{value:(_vm.formData.contractPartnerName),callback:function ($$v) {_vm.$set(_vm.formData, "contractPartnerName", $$v)},expression:"formData.contractPartnerName"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.contractPartnerDetails.label.domain')))])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.formData.domain.$error ? false : null,"invalid-feedback":_vm.$t('error.contractPartnerDetails.contractPartner.domain')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"url","state":_vm.$v.formData.domain.$error ? false : null},on:{"change":function($event){_vm.$v.formData.domain.$touch()}},model:{value:(_vm.formData.domain),callback:function ($$v) {_vm.$set(_vm.formData, "domain", $$v)},expression:"formData.domain"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v("\n              "+_vm._s(_vm.$t('message.contractPartnerDetails.label.email'))+"\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.formData.email.$error ? false : null,"invalid-feedback":_vm.$t('error.contractPartnerDetails.contractPartner.email')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"url","state":_vm.$v.formData.email.$error ? false : null},on:{"change":function($event){_vm.$v.formData.email.$touch()}},model:{value:(_vm.formData.email),callback:function ($$v) {_vm.$set(_vm.formData, "email", $$v)},expression:"formData.email"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.contractPartnerDetails.label.street')))])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.formData.street.$error ? false : null,"invalid-feedback":_vm.$t('error.contractPartnerDetails.contractPartner.street')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"street","state":_vm.$v.formData.street.$error ? false : null,"@change":_vm.$v.formData.street.$touch()},model:{value:(_vm.formData.street),callback:function ($$v) {_vm.$set(_vm.formData, "street", $$v)},expression:"formData.street"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.contractPartnerDetails.label.streetNumber')))])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.formData.streetNumber.$error ? false : null,"invalid-feedback":_vm.$t('error.contractPartnerDetails.contractPartner.streetNumber')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"street","state":_vm.$v.formData.streetNumber.$error ? false : null,"@change":_vm.$v.formData.streetNumber.$touch()},model:{value:(_vm.formData.streetNumber),callback:function ($$v) {_vm.$set(_vm.formData, "streetNumber", $$v)},expression:"formData.streetNumber"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v("\n              "+_vm._s(_vm.$t('message.contractPartnerDetails.label.postalCode'))+"\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.formData.postalCode.$error ? false : null,"invalid-feedback":_vm.$t('error.contractPartnerDetails.contractPartner.postalCode')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"postalCode","state":_vm.$v.formData.postalCode.$error ? false : null},on:{"change":function($event){_vm.$v.formData.postalCode.$touch()}},model:{value:(_vm.formData.postalCode),callback:function ($$v) {_vm.$set(_vm.formData, "postalCode", $$v)},expression:"formData.postalCode"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v("\n              "+_vm._s(_vm.$t('message.contractPartnerDetails.label.city'))+"\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.formData.city.$error ? false : null,"invalid-feedback":_vm.$t('error.contractPartnerDetails.contractPartner.city')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"city","state":_vm.$v.formData.city.$error ? false : null},on:{"change":function($event){_vm.$v.formData.city.$touch()}},model:{value:(_vm.formData.city),callback:function ($$v) {_vm.$set(_vm.formData, "city", $$v)},expression:"formData.city"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v("\n              "+_vm._s(_vm.$t('message.contractPartnerDetails.label.postOfficeBox'))+"\n            ")])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.formData.postOfficeBox.$error ? false : null,"invalid-feedback":_vm.$t('error.contractPartnerDetails.contractPartner.postOfficeBox')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"postalCode","state":_vm.$v.formData.postOfficeBox.$error ? false : null},on:{"change":function($event){_vm.$v.formData.postOfficeBox.$touch()}},model:{value:(_vm.formData.postOfficeBox),callback:function ($$v) {_vm.$set(_vm.formData, "postOfficeBox", $$v)},expression:"formData.postOfficeBox"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3",attrs:{"cols":"3"}},[_c('label',{staticClass:"w-100 text-right"},[_vm._v(_vm._s(_vm.$t('message.contractPartnerDetails.label.country')))])]),_vm._v(" "),_c('b-col',{staticClass:"px-3",attrs:{"cols":"9"}},[_c('b-form-group',{attrs:{"state":_vm.$v.formData.country.$error ? false : null,"invalid-feedback":_vm.$t('error.contractPartnerDetails.contractPartner.country')}},[_c('b-input',{staticClass:"rounded-0",attrs:{"id":"country","state":_vm.$v.formData.country.$error ? false : null},on:{"change":function($event){_vm.$v.formData.country.$touch()}},model:{value:(_vm.formData.country),callback:function ($$v) {_vm.$set(_vm.formData, "country", $$v)},expression:"formData.country"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"col-form-label px-3 ",attrs:{"offset":"3"}},[_c('div',{staticClass:"requieredFields text-right"},[_c('span',{domProps:{"innerHTML":_vm._s( _vm.$t('message.contractPartnerDetails.label.requiredFields'))}})])])],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"px-3",attrs:{"offset":"3"}},[_c('b-form-group',{attrs:{"state":_vm.$v.formData.confirmed.$error ? false : null,"invalid-feedback":_vm.$t('error.contractPartnerDetails.contractPartner.confirmed')}},[_c('b-form-checkbox',{attrs:{"id":"confirm","state":_vm.$v.formData.confirmed.$error ? false : null},on:{"change":function($event){_vm.$v.formData.confirmed.$touch()}},model:{value:(_vm.formData.confirmed),callback:function ($$v) {_vm.$set(_vm.formData, "confirmed", $$v)},expression:"formData.confirmed"}},[_vm._v("\n                "+_vm._s(_vm.$t('message.contractPartnerDetails.label.confirmed'))+"\n              ")])],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"px-3",attrs:{"offset":"3"}},[_c('b-form-text',[_vm._v("\n              "+_vm._s(_vm.$t('message.contractPartnerDetails.infoText'))+"\n            ")])],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a6Wh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractWizard_vue__ = __webpack_require__("fka7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0554234c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractWizard_vue__ = __webpack_require__("SgFV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractWizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0554234c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractWizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aFTp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminUserInvitation',
  created: function created() {
    var _this = this;

    if (!this.invitations.length) {
      var id = parseInt(this.$route.params.id);
      this.$store.dispatch('fetchAdminUserInvitationList', id).then(function () {
        _this.invitations = _this.$store.getters.adminUserInvitationList;
      }).catch(function () {});
    }
  },
  data: function data() {
    return {
      fields: [{
        key: 'contactPersonFirstname',
        label: this.$t('message.adminUserInvitation.table.contactPersonFirstname')
      }, {
        key: 'contactPersonLastname',
        label: this.$t('message.adminUserInvitation.table.contactPersonLastname')
      }, {
        key: 'contactPersonEmail',
        label: this.$t('message.adminUserInvitation.table.contactPersonEmail')
      }, {
        key: 'createdAt',
        label: this.$t('message.adminUserInvitation.table.createdAt')
      }, {
        key: 'status',
        label: this.$t('message.adminUserInvitation.table.status')
      }],
      invitations: []
    };
  }
});

/***/ }),

/***/ "aMpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isPolicyHolder)?_c('div',[_c('b-row',[_c('b-col',[_c('h2',[_c('span',{staticClass:"ti-home"}),_vm._v(" "),_c('span',{staticClass:"mx-2"},[_vm._v(_vm._s(_vm.$t('message.addressList.title')))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('message.addressList.subtitle')))])])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0"},[_vm._v("\n          "+_vm._s(_vm.addressInfo)+"\n        ")])],1)],1),_vm._v(" "),_vm._l((Math.ceil(_vm.addresses.length / 3)),function(i){return _c('b-row',{key:i,staticClass:"mt-3"},_vm._l((_vm.addresses.slice((i - 1) * 3, i * 3)),function(address){return _c('b-col',{key:address.id,staticClass:"mt-md-4 mt-lg-0"},[_c('b-link',{staticClass:"address-link",attrs:{"to":'/addresses/' + address.id}},[_c('Infobox',{attrs:{"title":_vm.getTitle(address),"subtitle":_vm.getSubtitle(address),"message":_vm.getMessage(address)}},[_c('span',{staticClass:"infobox-icon ti-home"})])],1)],1)}))}),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('router-view')],1)],1)],2):_vm._e(),_vm._v(" "),(!_vm.isPolicyHolder)?_c('div',[(!_vm.isEditable)?_c('div',[_c('b-row',[_c('b-col',[_c('h2',[_c('span',{staticClass:"ti-home"}),_vm._v(" "),_c('span',{staticClass:"mx-2"},[_vm._v(_vm._s(_vm.$t('message.addressList.title')))]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('message.addressList.subtitleNonPolicyHolder')))])])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0"},[_vm._v("\n          "+_vm._s(_vm.addressInfo)+"\n        ")])],1)],1),_vm._v(" "),_vm._l((Math.ceil(_vm.addresses.length / 3)),function(i){return _c('b-row',{key:i,staticClass:"mt-3"},_vm._l((_vm.addresses.slice((i - 1) * 3, i * 3)),function(address){return _c('b-col',{key:address.id,staticClass:"mt-md-4 mt-lg-0"},[_c('div',[_c('infobox',{attrs:{"message":_vm.getMessage(address),"title":_vm.getTitle(address),"subtitle":_vm.getSubtitle(address),"variant":"noHover"}},[_c('span',{staticClass:"infobox-icon ti-home"})]),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.editAddress(address)}}},[_vm._v(_vm._s(_vm.$t('message.addressDetails.btn.edit')))]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.delete-address-model",modifiers:{"delete-address-model":true}}],attrs:{"variant":"danger"},on:{"click":function($event){_vm.setCurrentAddress(address)}}},[_vm._v(_vm._s(_vm.$t('message.addressDetails.btn.delete')))])],1)],1)],1)])}))}),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('router-view')],1)],1)],2):_c('div',[_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"cols":"10"}},[_c('address-form',{ref:"addressForm",attrs:{"address":_vm.getCurrentAddress(),"onSubmitFn":_vm.saveAddress}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right px-4",attrs:{"cols":"10"}},[_c('b-btn',{attrs:{"variant":"link"},on:{"click":_vm.cancel}},[_vm._v("\n          "+_vm._s(_vm.$t('message.addressDetails.btn.cancel'))+"\n        ")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.saveAddress}},[_vm._v("\n          "+_vm._s(_vm.$t('message.addressDetails.btn.save'))+"\n        ")])],1)],1)],1)]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"id":"delete-address-model","cancel-variant":"primary","ok-variant":"danger","title":_vm.$t('message.addressDetails.modal.title'),"ok-title":_vm.$t('message.addressDetails.modal.btn.ok'),"cancel-title":_vm.$t('message.addressDetails.modal.btn.cancel')},on:{"ok":_vm.deleteAddress}},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.addressDetails.modal.question')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aQ/i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b/pP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('b-card',{staticClass:"rounded-0",attrs:{"title":_vm.$t('message.addressSearchForm.title')}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-form-group',{staticClass:"mt-4",attrs:{"state":this.isInvalidPlace ? false : null,"invalid-feedback":_vm.$t('error.addressSearchForm.autocomplete')}},[_c('vue-google-autocomplete',{class:_vm.isInvalidPlace ? 'form-control rounded-0 is-invalid' : 'form-control rounded-0',attrs:{"id":'autocomplete_address',"placeholder":_vm.$t('message.addressSearchForm.input.placeholder.autocomplete')},on:{"placeChanged":_vm.onPlaceChanged,"noPlaceFound":_vm.onNoPlaceFound}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-button',{staticClass:"ml-auto rounded-0",attrs:{"type":"submit","variant":"primary","disabled":!_vm.isValidForm}},[_vm._v("\n        "+_vm._s(_vm.$t('message.addressSearchForm.btn.submit'))+"\n      ")])],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cJ7x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[(_vm.icon)?_c('span',{staticClass:"mr-2",class:_vm.icon}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cRrj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContractPartnerForm_vue__ = __webpack_require__("F3JS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cd8d0dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContractPartnerForm_vue__ = __webpack_require__("CxbK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContractPartnerForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cd8d0dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContractPartnerForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cbW9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "couq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v(_vm._s(_vm.title)+"\n    "),_c('b-badge',{staticClass:"ml-2 px-3",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.items.length))]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('b-button',{staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"collapseId","aria-expanded":_vm.showCollapse ? 'true' : 'false'},on:{"click":function($event){_vm.showCollapse = !_vm.showCollapse}}},[(!_vm.showCollapse)?_c('span',{staticClass:"ti-angle-up"}):_c('span',{staticClass:"ti-angle-down"})])],1)],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":_vm.collapseId},model:{value:(_vm.showCollapse),callback:function ($$v) {_vm.showCollapse=$$v},expression:"showCollapse"}},[_c('b-table',{attrs:{"striped":"","responsive":"","fields":_vm.fields,"items":_vm.items,"tbody-class":"text-muted"},scopedSlots:_vm._u([{key:"actions",fn:function(row){return [_c('div',{staticClass:"text-right"},[_c('b-button',{staticClass:"btn-link",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){_vm.showDetails(row)}}},[_c('span',{staticClass:"ti-search"})])],1)]}}])}),_vm._v(" "),(!_vm.items || _vm.items.length === 0)?_c('div',{staticClass:"text-center"},[_vm._v("\n      "+_vm._s(_vm.$t('message.adminContractsCard.noItems'))+"\n    ")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dOuy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_b64_to_blob__ = __webpack_require__("ibJL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_b64_to_blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_b64_to_blob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("L/hj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminUserDocuments',
  created: function created() {
    this.$store.commit('setAdminCertificateOfInheritance', null);
    this.$store.dispatch('fetchAdminPowerOfAttorney', this.userId);
    this.$store.dispatch('fetchAdminCertificateOfDeath', this.userId);
  },

  computed: {
    certificateOfDeath: function certificateOfDeath() {
      return this.$store.getters.adminCertificateOfDeath;
    },
    certificateOfInheritance: function certificateOfInheritance() {
      return this.$store.getters.adminCertificateOfInheritance;
    },
    options: function options() {
      var contactPersons = this.$store.getters.adminContactPersons;
      if (!contactPersons) return [{ value: null, text: this.$t('message.adminUserDocuments.noPH') }];
      var options = contactPersons.map(function (cp) {
        var option = {};
        option['value'] = cp.id;
        option['text'] = cp.firstName + ' ' + cp.lastName;
        return option;
      });
      options.unshift({ value: null, text: this.$t('message.adminUserDocuments.selectCP') });
      return options;
    },
    powerOfAttorney: function powerOfAttorney() {
      return this.$store.getters.adminPowerOfAttorney;
    },
    userId: function userId() {
      return parseInt(this.$route.params.id);
    }
  },
  data: function data() {
    return {
      selected: null
    };
  },

  methods: {
    deleteCertificateOfDeath: function deleteCertificateOfDeath() {
      this.$store.dispatch('deleteAdminCertificateOfDeath', this.userId);
    },
    deleteCertificateOfInheritance: function deleteCertificateOfInheritance() {
      this.$store.dispatch('deleteAdminCertificateOfInheritance', {
        policyHolderId: this.userId,
        cpId: this.selected
      });
    },
    deletePowerOfAttorney: function deletePowerOfAttorney() {
      this.$store.dispatch('deleteAdminPowerOfAttorney', this.userId);
    },
    downloadCertificateOfDeath: function downloadCertificateOfDeath() {
      __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].download(this.certificateOfDeath);
    },
    downloadCertificateOfInheritance: function downloadCertificateOfInheritance() {
      var certificateOfInheritance = this.certificateOfInheritance;
      if (certificateOfInheritance) {
        var contentType = 'application/pdf';
        var blob = __WEBPACK_IMPORTED_MODULE_0_b64_to_blob___default()(certificateOfInheritance.file, contentType);
        __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].downloadBlob(blob, this.$t('message.policyHolderDetails.certificateOfInheritance'));
      }
    },
    downloadPowerOfAttorney: function downloadPowerOfAttorney() {
      __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].download(this.powerOfAttorney);
    },
    uploadCertificateOfDeath: function uploadCertificateOfDeath(event) {
      var _this = this;

      var file = event.target.files[0];
      if (file) {
        this.$store.dispatch('uploadAdminCertificateOfDeath', {
          policyHolderId: this.userId,
          certificateOfDeath: file
        }).then(function () {
          _this.showSuccessMsg({
            message: _this.$t('message.policyHolderDetails.uploadCertificateOfDeath')
          });
        }).catch(function () {
          _this.showErrorMsg({
            message: _this.$t('error.policyHolderDetails.uploadCertificateOfDeath')
          });
        });
      }
    },
    uploadCertificateOfInheritance: function uploadCertificateOfInheritance(event) {
      var _this2 = this;

      var file = event.target.files[0];
      if (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          var base64Value = reader.result.split(',')[1];
          _this2.$store.dispatch('uploadAdminCertificateOfInheritance', {
            policyHolderId: _this2.userId,
            cpId: _this2.selected,
            file: file,
            documents: {
              certificateOfInheritance: base64Value
            }
          }).then(function () {
            _this2.showSuccessMsg({
              message: _this2.$t('message.policyHolderDetails.uploadCertificateOfInheritance')
            });
          }).catch(function () {
            _this2.showErrorMsg({
              message: _this2.$t('error.policyHolderDetails.uploadCertificateOfInheritance')
            });
          });
        };
        reader.onerror = function () {
          _this2.showErrorMsg({
            message: _this2.$t('error.policyHolderDetails.fileReaderError')
          });
        };
      }
    },
    uploadPoa: function uploadPoa(event) {
      var _this3 = this;

      var file = event.target.files[0];
      if (file) {
        this.loading = true;
        this.$store.dispatch('uploadAdminPowerOfAttorney', {
          policyHolderId: this.userId,
          powerOfAttorney: file
        }).then(function () {
          _this3.showSuccessMsg({
            message: _this3.$t('message.accountPowerOfAttorneyForm.uploadSuccess')
          });
        }).catch(function () {
          _this3.showErrorMsg({
            message: _this3.$t('error.accountPowerOfAttorneyForm.uploadFailure')
          });
        }).finally(function () {
          _this3.loading = false;
        });
      }
    },
    selectCp: function selectCp(event) {
      this.$store.dispatch('fetchAdminCertificateOfInheritance', {
        policyHolderId: this.userId,
        cpId: event
      });
    }
  },
  notifications: {
    showSuccessMsg: {
      type: 'success'
    },
    showErrorMsg: {
      type: 'error'
    }
  }
});

/***/ }),

/***/ "dSu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__ = __webpack_require__("AE0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractsCard__ = __webpack_require__("hZwL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contracts_ContractOverview__ = __webpack_require__("MZE8");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PolicyHolderContracts',
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__["a" /* default */],
    ContractsCard: __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractsCard__["a" /* default */],
    ContractOverview: __WEBPACK_IMPORTED_MODULE_2__components_contracts_ContractOverview__["a" /* default */]
  },
  computed: {
    contract: function contract() {
      var contractId = parseInt(this.$route.params.contractId);
      return this.$route.params.contractId ? this.$store.getters.policyHolderContracts.filter(function (contract) {
        return contract.id === contractId;
      })[0] : null;
    },
    contractCategories: function contractCategories() {
      var _this = this;

      return this.$store.getters.contractCategories.map(function (category) {
        return {
          value: category,
          text: _this.$t('enums.contractCategories.' + category)
        };
      });
    },
    policyHolder: function policyHolder() {
      return this.$store.getters.policyHolder;
    },
    policyHolderName: function policyHolderName() {
      return this.policyHolder.firstName + ' ' + this.policyHolder.lastName;
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.contract) {
      var id = parseInt(this.$route.params.id);
      if (id) {
        this.$store.dispatch('fetchPolicyHolderById', id).then(function () {
          _this2.$store.dispatch('fetchContractsByPolicyHolderId', id);
        }).catch(function () {
          _this2.$router.replace('/policyHolders');
        });
      } else {
        this.router.replace('/policyHolders');
      }
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    getContractsByCategory: function getContractsByCategory(category) {
      return this.$store.getters.policyHolderContracts.filter(function (contract) {
        return contract.contractCategory === category;
      });
    },
    onShowDetails: function onShowDetails(item) {
      this.$router.push({
        name: 'ViewPolicyHolderContracts',
        params: { id: parseInt(this.$route.params.id), contractId: item.id }
      });
    }
  }
});

/***/ }),

/***/ "dVos":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserList_vue__ = __webpack_require__("+V29");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ebf2130_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserList_vue__ = __webpack_require__("Nllq");
function injectStyle (ssrContext) {
  __webpack_require__("hgCQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ebf2130"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ebf2130_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "dcqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__("AxMl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a3785e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__("0pqe");
function injectStyle (ssrContext) {
  __webpack_require__("ESy8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50a3785e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a3785e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eFgi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eHWv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eV1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.title,"icon":"ti-agenda"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-alert',{staticClass:"rounded-0",attrs:{"variant":"warning","show":true}},[_vm._v("\n        "+_vm._s(_vm.$t('message.adminContractPartnerDetails.warning'))+"\n      ")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0"},[_c('admin-contract-partner-form',{on:{"onCancel":_vm.cancel,"onSave":_vm.saveContractPartner}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eVfV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_VueGoogleAutocomplete__ = __webpack_require__("Bzl3");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_1__components_common_VueGoogleAutocomplete__["a" /* default */]
  },
  computed: {
    addresses: function addresses() {
      return this.$store.getters.addresses;
    },
    isContactPerson: function isContactPerson() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesContactPerson = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'CONTACT_PERSON';
        });
        if (rolesContactPerson.length > 0) {
          return true;
        }
      }
      return false;
    },
    isPolicyHolder: function isPolicyHolder() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesPolicyHolder = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'POLICY_HOLDER';
        });
        if (rolesPolicyHolder.length > 0) {
          return true;
        }
      }
      return false;
    },
    isVisible: function isVisible() {
      if (this.isPolicyHolder) {
        return true;
      } else if (this.isContactPerson && this.addresses.length === 0) {
        return true;
      }
    }
  },
  data: function data() {
    return {
      address: null,
      isInvalidPlace: false,
      isValidForm: false
    };
  },

  methods: {
    onNoPlaceFound: function onNoPlaceFound() {
      this.isInvalidPlace = true;
      this.isValidForm = false;
    },
    onPlaceChanged: function onPlaceChanged(place) {
      this.address = {
        street: place.route,
        streetNumber: place.street_number,
        postalCode: place.postal_code,
        city: place.locality,
        country: place.country
      };
      this.isInvalidPlace = false;
      this.isValidForm = true;
    },
    onSubmit: function onSubmit() {
      if (this.address) {
        this.$store.commit('setCurrentAddress', this.address);
        this.$router.push({ path: 'addresses/confirm' });
      }
    }
  }
});

/***/ }),

/***/ "f5rW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fC2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AccountChangeEmailForm',
  data: function data() {
    return {
      email: null,
      emailConfirm: null
    };
  },

  methods: {
    submit: function submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('submit', this.email);
      }
    },
    reset: function reset() {
      this.email = null;
      this.emailConfirm = null;
      this.$v.$reset();
    }
  },
  computed: {
    currentEmail: function currentEmail() {
      return this.$store.getters.currentUser.email;
    }
  },
  validations: {
    email: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
    },
    emailConfirm: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      sameAsEmail: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["sameAs"])('email')
    }
  }
});

/***/ }),

/***/ "fka7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_contracts_ContractAddressDetails__ = __webpack_require__("8Ukx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contracts_ContractEstateDetails__ = __webpack_require__("sDju");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contracts_ContractInformationDetails__ = __webpack_require__("ykpL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_contracts_ContractPartnerDetails__ = __webpack_require__("pswo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_form_wizard_dist_vue_form_wizard_min_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContractWizard',
  components: {
    ContractAddressDetails: __WEBPACK_IMPORTED_MODULE_3__components_contracts_ContractAddressDetails__["a" /* default */],
    ContractEstateDetails: __WEBPACK_IMPORTED_MODULE_4__components_contracts_ContractEstateDetails__["a" /* default */],
    ContractInformationDetails: __WEBPACK_IMPORTED_MODULE_5__components_contracts_ContractInformationDetails__["a" /* default */],
    ContractPartnerDetails: __WEBPACK_IMPORTED_MODULE_6__components_contracts_ContractPartnerDetails__["a" /* default */],
    FormWizard: __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__["TabContent"]
  },
  computed: {
    currentContract: function currentContract() {
      return this.$store.getters.currentContract;
    },
    showBtnContractPartnerCancel: function showBtnContractPartnerCancel() {
      if (this.currentContract.contractPartner && this.currentContract.contractPartner.id && (this.prevWizardTabIndex === -1 || this.nextWizardTabIndex === 0)) {
        return true;
      }
      return false;
    }
  },
  data: function data() {
    return {
      prevWizardTabIndex: -1,
      nextWizardTabIndex: 0
    };
  },

  methods: {
    onCancelWizard: function onCancelWizard() {
      this.$store.commit('setCurrentContract', {});
      this.$router.push('/contracts');
    },
    onCompleteContractWizard: function onCompleteContractWizard() {
      var _this = this;

      var handleSuccess = function handleSuccess(isComplete) {
        if (!isComplete) {
          _this.$refs.contractWizardModal.show();
        }
        var contractInfoDetails = _this.$refs.contractInformationDetails;
        var contractInfoFrom = contractInfoDetails.$refs.contractInformationForm;
        _this.$refs.contractWizard.reset();
        _this.$refs.contractPartnerDetails.resetContractPartner();
        _this.showSuccessMsg({
          message: _this.$t('message.contractList.createContract')
        });
        _this.$store.commit('setCurrentContract', {
          contractCategory: null
        });
        _this.$router.push('/contracts');
        setTimeout(function () {
          contractInfoFrom.resetValidation();
        }, 500);
      };
      if (this.currentContract.id && this.currentContract.id !== -1) {
        var contractPartner = this.$refs.contractPartnerDetails.getContractPartner();
        this.$store.dispatch('updateContractPartner', contractPartner).then(function () {
          return _this.$store.dispatch('updateContract', _this.currentContract);
        }).then(function (isComplete) {
          return handleSuccess(isComplete);
        }).catch(function () {
          _this.showErrorMsg({
            message: _this.$t('error.contractWizard.storeContract')
          });
        });
      } else {
        var _contractPartner = this.$refs.contractPartnerDetails.getContractPartner();
        this.$store.dispatch('storeContractPartner', _contractPartner).then(function (response) {
          _this.$store.commit('updateContractPartner', response);
          return _this.$store.dispatch('storeContract', _this.currentContract);
        }).then(function (isComplete) {
          handleSuccess(isComplete);
        }).catch(function () {
          _this.showErrorMsg({
            message: _this.$t('error.contractWizard.storeContract')
          });
        });
      }
    },
    onDeleteContract: function onDeleteContract() {
      var _this2 = this;

      this.$store.dispatch('deleteContract', this.currentContract.id).then(function () {
        _this2.showSuccessMsg({
          message: _this2.$t('message.contractWizard.deleteContract')
        });
        _this2.$store.commit('setCurrentContract', {});
        _this2.$router.push('/contracts');
      }).catch(function () {
        _this2.showErrorMsg({
          message: _this2.$t('error.contractWizard.deleteContract')
        });
      });
    },
    onWizardTabChange: function onWizardTabChange(prevIndex, nextIndex) {
      this.$emit('wizardChange', nextIndex);
      this.prevWizardTabIndex = prevIndex;
      this.nextWizardTabIndex = nextIndex;
    },
    onWizardPrevClicked: function onWizardPrevClicked() {
      var wizard = this.$refs.contractWizard;
      if (this.currentContract.contractCategory === 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT' && wizard.isLastStep) {
        wizard.prevTab();
      }
    },
    validateContractAddress: function validateContractAddress() {
      var vm = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        vm.$store.commit('setCurrentContract', vm.currentContract);
        resolve(true);
      });
    },
    validateContractEstate: function validateContractEstate() {
      var vm = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        vm.$store.commit('setCurrentContract', vm.currentContract);
        resolve(true);
      });
    },
    validateContractInformation: function validateContractInformation() {
      var _this3 = this;

      var vm = this;
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var contractInfoDetails = vm.$refs.contractInformationDetails;
        var contractInfoForm = contractInfoDetails.$refs.contractInformationForm;
        contractInfoForm.$v.$touch();
        if (contractInfoForm.$v.$invalid) {
          reject(_this3.showErrorMsg({
            message: _this3.$t('error.contractList.check')
          }));
        }
        vm.$store.commit('setCurrentContract', vm.currentContract);
        resolve(true);
      });
    },
    validateContractPartner: function validateContractPartner() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var contractPartnerDetails = _this4.$refs.contractPartnerDetails;
        contractPartnerDetails.stashContractPartner();
        if (!_this4.currentContract.contractPartner && !contractPartnerDetails.getContractPartner().searchValue) {
          _this4.showErrorMsg({
            message: _this4.$t('error.contractList.missing')
          });
          reject(false);
        } else if (!_this4.currentContract.contractPartner && contractPartnerDetails.getContractPartner().searchValue) {
          _this4.showErrorMsg({
            message: _this4.$t('error.contractList.noContractPartnerFounded')
          });
          contractPartnerDetails.createEmptyContractPartner();
          reject(false);
        } else if (_this4.currentContract.contractPartner) {
          contractPartnerDetails.$v.$touch();
          if (!contractPartnerDetails.$v.$invalid) {
            // const contractPartner = contractPartnerDetails.getContractPartner()
            // this.$store.dispatch('storeContractPartner', contractPartner)
            //   .then((contractPartner) => {
            //     this.$store.commit('updateContractPartner', contractPartner)
            resolve(true);
            //   })
            //   .catch(() => {
            //     this.showErrorMsg({
            //       message: this.$t('error.contractList.create')
            //     })
            //     reject(false)
            //   })
          } else {
            _this4.showErrorMsg({
              message: _this4.$t('error.contractList.invalid')
            });
            reject(false);
          }
        } else {
          resolve(true);
        }
      });
    },
    verifyContractInformation: function verifyContractInformation() {
      if (this.currentContract.contractCategory === 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT') {
        this.currentContract.address = undefined;
        this.currentContract = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.currentContract);
        this.$store.commit('setCurrentContract', this.currentContract);

        var wizard = this.$refs.contractWizard;
        var activeTabIndex = wizard.activeTabIndex;
        if (this.prevWizardTabIndex > activeTabIndex) {
          wizard.prevTab();
        }

        if (this.prevWizardTabIndex < activeTabIndex) {
          this.$refs.contractWizard.nextTab();
        }
      }
    }
  },
  notifications: {
    showErrorMsg: {
      type: 'error'
    },
    showSuccessMsg: {
      type: 'success'
    }
  }
});

/***/ }),

/***/ "fpRT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gJbj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.$t('message.contractList.title'),"icon":"ti-receipt"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0",attrs:{"title":_vm.contractWizardTitle}},[_c('contract-wizard',{on:{"wizardChange":_vm.wizardChange}})],1)],1)],1),_vm._v(" "),(!_vm.$route.params.id)?_c('div',_vm._l((_vm.contractCategories),function(category){return (_vm.getContractsByCategory(category.value).length > 0)?_c('b-row',{key:category.value,staticClass:"mt-4"},[_c('b-col',[_c('ContractsCard',{attrs:{"collapseId":category.value + 'Id',"title":category.text,"items":_vm.getContractsByCategory(category.value),"phView":true},on:{"showDetails":_vm.onShowDetails}})],1)],1):_vm._e()})):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gh8r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContractsCard_vue__ = __webpack_require__("PZiL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adf998f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContractsCard_vue__ = __webpack_require__("couq");
function injectStyle (ssrContext) {
  __webpack_require__("GDfv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7adf998f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContractsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adf998f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContractsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gmY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios_auth__ = __webpack_require__("NwdG");





var state = {
  contracts: [],
  contractsByAddress: [],
  contractsByContactPerson: [],
  contractCategories: ['INSURANCE', 'FINANCE', 'HABITATION_HOUSEHOLD_AND_COMMUNICATION', 'LEISURE_AND_CLUB', 'SUBSCRIPTION', 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT', 'OTHER'],
  currentContract: {},
  estateAdministrationTypes: ['TERMINATE_CONTRACT', 'TRANSFER_TO_PERSON_OF_TRUST']
};

var getters = {
  currentContract: function currentContract(state) {
    return state.currentContract;
  },
  contracts: function contracts(state) {
    return state.contracts;
  },
  contractsByAddress: function contractsByAddress(state) {
    return state.contractsByAddress;
  },
  contractsByContactPerson: function contractsByContactPerson(state) {
    return state.contractsByContactPerson;
  },
  contractCategories: function contractCategories(state) {
    return state.contractCategories;
  },
  estateAdministrationTypes: function estateAdministrationTypes(state) {
    return state.estateAdministrationTypes;
  }
};

var actions = {
  deleteContract: function deleteContract(_ref, id) {
    var getters = _ref.getters,
        dispatch = _ref.dispatch,
        commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].delete('/contracts/' + id, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        commit('deleteContract', id);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchContractById: function fetchContractById(_ref2, payload) {
    var getters = _ref2.getters,
        state = _ref2.state,
        dispatch = _ref2.dispatch,
        commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var contract = state.contracts.find(function (contract) {
        return contract.id === payload.id;
      });
      if (contract && !payload.forceFetch) {
        commit('setCurrentContract', contract);
        resolve();
      } else {
        var currentUser = getters.currentUser;
        var idToken = currentUser.idToken;
        var authValue = 'Bearer '.concat(idToken);
        __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].get('/contracts/' + payload.id, {
          headers: {
            Authorization: authValue
          }
        }).then(function (response) {
          dispatch('setLogoutTimer');
          commit('setCurrentContract', response.data);
          resolve();
        }).catch(function (err) {
          reject(err);
        });
      }
    });
  },
  fetchContracts: function fetchContracts(_ref3) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        getters = _ref3.getters;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].get('/contracts', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setContracts', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  fetchContractsByAddress: function fetchContractsByAddress(_ref4, addressId) {
    var getters = _ref4.getters,
        dispatch = _ref4.dispatch,
        state = _ref4.state,
        commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].get('/contracts', {
        headers: {
          Authorization: authValue
        },
        params: {
          addressId: addressId
        }
      }).then(function (response) {
        commit('setContractsByAddress', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  fetchContractsByContactPerson: function fetchContractsByContactPerson(_ref5, contactPersonId) {
    var getters = _ref5.getters,
        dispatch = _ref5.dispatch,
        commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].get('/contracts', {
        headers: {
          Authorization: authValue
        },
        params: {
          contactPersonId: contactPersonId
        }
      }).then(function (response) {
        commit('setContractsByContactPerson', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  storeContract: function storeContract(_ref6, contract) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch,
        getters = _ref6.getters;

    // Clone contactPerson to prevent serialization error
    var clone = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, contract);
    delete clone.contactPerson;
    if (contract.contactPerson && contract.contactPerson.id) {
      clone.contactPerson = {
        id: contract.contactPerson.id
      };
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].post('/contracts', clone, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('addContract', response.data);
        dispatch('setLogoutTimer');
        resolve(response.data.isComplete);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  updateContract: function updateContract(_ref7, contract) {
    var getters = _ref7.getters,
        commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    var clone = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, contract);
    delete clone.contactPerson;
    if (contract.contactPerson && contract.contactPerson.id) {
      clone.contactPerson = {
        id: contract.contactPerson.id
      };
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].put('/contracts/' + contract.id, clone, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('updateContract', response.data);
        commit('setCurrentContract', {});
        dispatch('setLogoutTimer');
        resolve(response.data.isComplete);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  updateContractsWithAddress: function updateContractsWithAddress(_ref8, data) {
    var getters = _ref8.getters,
        commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      var dto = {
        currentAddressId: data.currentAddressId,
        newAddressId: data.newAddressId
      };
      __WEBPACK_IMPORTED_MODULE_3__axios_auth__["a" /* default */].put('/contracts/changeAddress/', dto, {
        headers: {
          Authorization: authValue
        },
        params: {
          oldAddressId: data.oldAddressId,
          newAddressId: data.newAddressId
        }
      }).then(function () {
        commit('setContractsByAddress', []);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};

var mutations = {
  addContract: function addContract(state, contract) {
    state.contracts.push(contract);
  },
  deleteAccountLink: function deleteAccountLink(state) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.currentContract, 'accountLink');
  },
  deleteAccountNumber: function deleteAccountNumber(state) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.currentContract, 'accountNumber');
  },
  deleteAccountUsername: function deleteAccountUsername(state) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.currentContract, 'accountUsername');
  },
  deleteCancellationPeriod: function deleteCancellationPeriod(state) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.currentContract, 'cancellationPeriod');
  },
  deleteContract: function deleteContract(state, id) {
    var contractIndex = state.contracts.findIndex(function (contract) {
      return contract.id === id;
    });
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.contracts, contractIndex);
  },
  deleteConclusionDate: function deleteConclusionDate(state) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.currentContract, 'conclusionDate');
  },
  deleteContractDuration: function deleteContractDuration(state) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.currentContract, 'contractDuration');
  },
  deleteContractNumber: function deleteContractNumber(state) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.currentContract, 'contractNumber');
  },
  deleteInsuredPersonNumber: function deleteInsuredPersonNumber(state) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].delete(state.currentContract, 'insuredPersonNumber');
  },
  setCurrentContract: function setCurrentContract(state, contract) {
    state.currentContract = contract;
  },
  setContracts: function setContracts(state, contracts) {
    state.contracts = contracts;
  },
  setContractsByAddress: function setContractsByAddress(state, contracts) {
    state.contractsByAddress = contracts;
  },
  setContractsByContactPerson: function setContractsByContactPerson(state, contracts) {
    state.contractsByContactPerson = contracts;
  },
  updateConclusionDate: function updateConclusionDate(state, date) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.currentContract, 'conclusionDate', date);
  },
  updateContract: function updateContract(state, contract) {
    var contractToUpdateIndex = state.contracts.findIndex(function (contractToUpdate) {
      return contractToUpdate.id === contract.id;
    });
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.contracts, contractToUpdateIndex, contract);
  },
  updateContractCategory: function updateContractCategory(state, category) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.currentContract, 'contractCategory', category);
  },
  updateContactPerson: function updateContactPerson(state, contactPerson) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.currentContract, 'contactPerson', contactPerson);
  },
  updateContractPartner: function updateContractPartner(state, contractPartner) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.currentContract, 'contractPartner', contractPartner);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "hZwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractsCard_vue__ = __webpack_require__("QgH0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d844e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractsCard_vue__ = __webpack_require__("l6SN");
function injectStyle (ssrContext) {
  __webpack_require__("jVhU")
  __webpack_require__("7d9F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60d844e9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d844e9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hgCQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "igVF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__ = __webpack_require__("AE0Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Imprint',
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__["a" /* default */]
  }
});

/***/ }),

/***/ "igZc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('ContractSummary',{staticClass:"mt-2",attrs:{"contract":_vm.contract,"contractCategories":_vm.contractCategories}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('p',{staticClass:"text-muted mt-2"},[_vm._v("\n      "+_vm._s(_vm.infoText)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap cursorBcard"},_vm._l((_vm.contactPersons),function(contactPerson){return _c('div',{key:contactPerson.id,staticClass:"p-0 my-2 mr-3 rounded-0 btn-estate-administration",attrs:{"variant":"transparent"},on:{"click":function($event){_vm.onSelectContactPerson(contactPerson)}}},[_c('BusinessCard',{staticClass:"rounded-0",class:_vm.getPotClass(contactPerson),attrs:{"size":"sm","name":contactPerson.firstName + ' ' + contactPerson.lastName,"relation":contactPerson.relation,"imageSrc":contactPerson.avatarUuid}})],1)}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iuRu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpContactPersonRejected_vue__ = __webpack_require__("LsK4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27c97117_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpContactPersonRejected_vue__ = __webpack_require__("sHHI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpContactPersonRejected_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27c97117_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpContactPersonRejected_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jJRv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TermsFooter'
});

/***/ }),

/***/ "jVhU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jW+E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractPartnerTemplate_vue__ = __webpack_require__("C8AS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a8a81c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractPartnerTemplate_vue__ = __webpack_require__("2tAM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractPartnerTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a8a81c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractPartnerTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jmcO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{staticClass:"text-uppercase",attrs:{"title":_vm.$t('message.info.title')}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('p',[_c('a',{attrs:{"target":"_blank","href":"https://meine-vertraege.net"}},[_vm._v("Meine-vertraege.net")]),_vm._v(" ist ein digitaler Vertragsmanager der es Benutzern erlaubt,\n       seine kompletten Vertragsverhältnisse zu erfassen und aufzulisten. Des Weiteren kann der Kontoinhaber Kontaktpersonen bestimmen, welche nach seinem Ableben Einsicht in die ihnen zugeordneten Verträge gewährt bekommen."),_c('br'),_vm._v("\n       Der digitale Vertragsmanager wird als Assistancedienstleistung der Bestattungsvorsorgeversicherung von der \n       "),_c('a',{attrs:{"target":"_blank","href":"https://www.nuernberger.de/"}},[_vm._v("NÜRNBERGER VERSICHERUNG")]),_vm._v(" in Kooperation mit dem \n       "),_c('a',{attrs:{"target":"_blank","href":"https://www.bestatter.de/"}},[_vm._v("Kuratorium Deutsche Bestattungskultur")]),_vm._v(" angeboten.\n\n     ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',[_c('a',{attrs:{"target":"_blank","href":"https://www.nuernberger.de"}},[_c('img',{staticClass:"n-logo",attrs:{"src":__webpack_require__("S7IL")}})]),_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.bestatter.de/"}},[_c('img',{staticClass:"b-logo mt-5",attrs:{"src":__webpack_require__("qpYN")}})])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kADP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__ = __webpack_require__("DHB8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b895ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__ = __webpack_require__("I75R");
function injectStyle (ssrContext) {
  __webpack_require__("R9PX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19b895ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b895ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kD7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.user.firstName + ' ' + _vm.user.lastName,"icon":'ti-user'}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('business-card',{staticClass:"rounded-0 h-100",attrs:{"name":_vm.name,"contractNumber":_vm.user.contractNumber,"email":_vm.user.email,"roles":_vm.roles,"userTitle":_vm.user.title,"createdAt":_vm.user.createdAt,"dateOfBirth":_vm.user.dateOfBirth,"dateOfDeath":_vm.user.dateOfDeath,"showIcon":!!_vm.user.dateOfDeath,"imageSrc":_vm.user.avatarUuid}})],1),_vm._v(" "),_c('b-col',[_c('admin-user-status')],1)],1),_vm._v(" "),_vm._l((_vm.contractCategories),function(category){return (_vm.getContractsByCategory(category.value).length > 0)?_c('b-row',{key:category.value,staticClass:"mt-2"},[_c('b-col',[_c('AdminContractsCard',{attrs:{"collapseId":category.value + 'Id',"title":category.text,"items":_vm.getContractsByCategory(category.value),"phView":false}})],1)],1):_vm._e()}),_vm._v(" "),_c('admin-user-address'),_vm._v(" "),_c('admin-user-contact-person'),_vm._v(" "),_c('admin-user-invitation'),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('admin-user-documents')],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l+Xk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminContractPartnerForm__ = __webpack_require__("cRrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_HeaderView__ = __webpack_require__("AE0Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminContractPartnerTemplateDetails',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (to.params && to.params.id) {
        vm.$store.dispatch('fetchAdminContractPartnerTemplateById', parseInt(to.params.id)).catch(function () {
          vm.showErrorMsg({
            message: vm.$t('error.adminContractPartnerTemplateDetails.fetchContractPartnerTemplateById')
          });
          vm.$router.replace('/admin/contractpartners');
        });
      } else {
        vm.$router.replace('/admin/contractpartners');
      }
    });
  },

  components: {
    AdminContractPartnerForm: __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminContractPartnerForm__["a" /* default */],
    HeaderView: __WEBPACK_IMPORTED_MODULE_1__components_common_HeaderView__["a" /* default */]
  },
  computed: {
    contractPartner: function contractPartner() {
      return this.$store.getters.adminContractPartner;
    }
  },
  methods: {
    cancel: function cancel() {
      this.$router.push('/admin/contractpartners');
    },
    deleteContractPartnerTemplate: function deleteContractPartnerTemplate() {
      var _this = this;

      this.$store.dispatch('deleteAdminContractPartnerTemplate', this.contractPartner).then(function () {
        _this.showSuccessMsg({
          message: _this.$t('message.adminContractPartnerTemplateDetails.deleteContractPartnerTemplate')
        });
        _this.$router.push('/admin/contractpartners');
      }).catch(function () {
        return _this.showErrorMsg({
          message: _this.$t('error.adminContractPartnerTemplateDetails.deleteContractPartnerTemplate')
        });
      });
    },
    saveContractPartnerTemplate: function saveContractPartnerTemplate() {
      var _this2 = this;

      this.$store.dispatch('storeAdminContractPartnerTemplate', this.contractPartner).then(function () {
        _this2.showSuccessMsg({
          message: _this2.$t('message.adminContractPartnerTemplateDetails.saveContractPartnerTemplate')
        });
        _this2.$router.push('/admin/contractpartners');
      }).catch(function () {
        return _this2.showErrorMsg({
          message: _this2.$t('message.adminContractPartnerTemplateDetails.saveContractPartnerTemplate')
        });
      });
    }
  },
  notifications: {
    showErrorMsg: {
      type: 'error'
    },
    showSuccessMsg: {
      type: 'success'
    }
  }
});

/***/ }),

/***/ "l6SN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v(_vm._s(_vm.title)+"\n    "),_c('b-badge',{staticClass:"ml-2 px-3",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.items.length))]),_vm._v(" "),_c('span',{staticClass:"float-right"},[_c('b-button',{staticClass:"btn-link",attrs:{"size":"md","variant":"link","aria-controls":"collapseId","aria-expanded":_vm.showCollapse ? 'true' : 'false'},on:{"click":function($event){_vm.showCollapse = !_vm.showCollapse}}},[(!_vm.showCollapse)?_c('span',{staticClass:"ti-angle-up"}):_c('span',{staticClass:"ti-angle-down"})])],1)],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":_vm.collapseId},model:{value:(_vm.showCollapse),callback:function ($$v) {_vm.showCollapse=$$v},expression:"showCollapse"}},[_c('b-table',{attrs:{"striped":"","hover":"","responsive":"","fields":_vm.fields,"items":_vm.items,"tbody-tr-class":"show-cursor","tbody-class":"text-muted"},scopedSlots:_vm._u([{key:"contractPartner.contractPartnerName",fn:function(row){return [_c('div',{class:{'text-danger' : !row.item.isComplete},on:{"click":function($event){_vm.showDetails(row)}}},[_vm._v(_vm._s(row.item.contractPartner ? row.item.contractPartner.contractPartnerName : ''))])]}},{key:"contractType",fn:function(row){return [_c('div',{class:{'text-danger' : !row.item.isComplete},on:{"click":function($event){_vm.showDetails(row)}}},[_vm._v(_vm._s(row.item.contractType))])]}},{key:"cancellationPeriod",fn:function(row){return [_c('div',{class:{'text-danger' : !row.item.isComplete},on:{"click":function($event){_vm.showDetails(row)}}},[_vm._v("\n          "+_vm._s(_vm.getCancellationPeriodText(row.item.cancellationPeriod))+"\n        ")])]}}])}),_vm._v(" "),(!_vm.items || _vm.items.length === 0)?_c('div',{staticClass:"text-center"},[_vm._v("\n      "+_vm._s(_vm.$t('message.contractsCard.noItems'))+"\n    ")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lFWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('router-link',{staticClass:"infobox-link",attrs:{"to":"/contracts"}},[_c('Infobox',{attrs:{"title":_vm.contracts.length,"message":_vm.contractMessage,"subtitle":_vm.$t('message.dashboard.infobox.contracts.subtitle'),"variant":"dark"}},[_c('span',{staticClass:"infobox-icon ti-receipt"})])],1)],1),_vm._v(" "),_c('b-col',[_c('router-link',{staticClass:"infobox-link",attrs:{"to":"/contactpersons"}},[_c('Infobox',{attrs:{"title":_vm.contactPersons.length,"message":_vm.contactPersonsMessage,"subtitle":_vm.$t('message.dashboard.infobox.contactPersons.subtitle'),"variant":"dark"}},[_c('span',{staticClass:"infobox-icon ti-user"})])],1)],1),_vm._v(" "),_c('b-col',[_c('router-link',{staticClass:"infobox-link",attrs:{"to":"/addresses"}},[_c('Infobox',{attrs:{"title":_vm.addresses.length,"subtitle":_vm.$t('message.dashboard.infobox.addresses.subtitle'),"variant":"dark"}},[_c('span',{staticClass:"infobox-icon ti-home"})])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_Infobox__ = __webpack_require__("AHrk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardContent',
  components: {
    Infobox: __WEBPACK_IMPORTED_MODULE_0__components_common_Infobox__["a" /* default */]
  },
  computed: {
    addresses: function addresses() {
      return this.$store.getters.addresses;
    },
    contactPersons: function contactPersons() {
      return this.$store.getters.contactPersons;
    },
    contactPersonsMessage: function contactPersonsMessage() {
      var invitations = this.$store.getters.invitations;
      if (invitations.length !== 0) {
        return this.$t('message.dashboard.infobox.contactPersons.invitations', { amount: invitations.length });
      }
      return '';
    },
    contractMessage: function contractMessage() {
      var incompleteContracts = this.contracts.filter(function (contract) {
        return !contract.isComplete;
      });
      if (incompleteContracts.length > 0) {
        return this.$t('message.dashboard.infobox.contracts.completed', { amount: incompleteContracts.length });
      }
      return '';
    },
    contracts: function contracts() {
      return this.$store.getters.contracts;
    }
  },
  created: function created() {
    this.$store.dispatch('fetchAddresses');
    this.$store.dispatch('fetchContactPersons');
    this.$store.dispatch('fetchContracts');
    this.$store.dispatch('fetchInvitations');
  }
});

/***/ }),

/***/ "mEBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contracts_ContractInformationForm__ = __webpack_require__("X/yy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractSummary__ = __webpack_require__("URMB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContractInformationDetails',
  components: {
    ContractInformationForm: __WEBPACK_IMPORTED_MODULE_0__components_contracts_ContractInformationForm__["a" /* default */],
    ContractSummary: __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractSummary__["a" /* default */]
  },
  computed: {
    contract: function contract() {
      return this.$store.getters.currentContract;
    },
    contractCategories: function contractCategories() {
      var _this = this;

      return this.$store.getters.contractCategories.map(function (category) {
        return {
          value: category,
          text: _this.$t('enums.contractCategories.' + category)
        };
      });
    }
  }
});

/***/ }),

/***/ "mWE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('ContractSummary',{staticClass:"mt-2",attrs:{"contract":_vm.contract,"contractCategories":_vm.contractCategories}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('contract-information-form',{ref:"contractInformationForm",attrs:{"contractCategories":_vm.contractCategories}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mXTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"contactPersonModal",attrs:{"id":"contactPersonModal","ok-variant":"primary","cancel-variant":"link","ok-title":_vm.$t('message.contactPersonDialog.btn.submit'),"cancel-title":_vm.$t('message.contactPersonDialog.btn.cancel')},on:{"ok":_vm.onSubmit}},[_c('div',{attrs:{"slot":"modal-title"},slot:"modal-title"},[_c('span',{staticClass:"ti-user"}),_vm._v("\n      "+_vm._s(_vm.$t('message.contactPersonDialog.title'))+"\n    ")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-group',{attrs:{"id":"contactPersonSalutation","label-for":"contactPersonSalutation"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n          "+_vm._s(_vm.$t('message.contactPersonDialog.label.salutation'))+"\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-radio-group',{attrs:{"options":_vm.salutations,"state":_vm.$v.contactPerson.salutation.$error ? false : null},on:{"change":function($event){_vm.$v.contactPerson.salutation.$touch()}},model:{value:(_vm.contactPerson.salutation),callback:function ($$v) {_vm.$set(_vm.contactPerson, "salutation", $$v)},expression:"contactPerson.salutation"}})],1),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"contactPersonFirstName","label-for":"contactPersonFirstName"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n              "+_vm._s(_vm.$t('message.contactPersonDialog.label.firstName'))+"\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.contactPerson.firstName.$error ? false : null},on:{"change":function($event){_vm.$v.contactPerson.firstName.$touch()}},model:{value:(_vm.contactPerson.firstName),callback:function ($$v) {_vm.$set(_vm.contactPerson, "firstName", $$v)},expression:"contactPerson.firstName"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"contactPersonLastName","label-for":"contactPersonLastName"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n              "+_vm._s(_vm.$t('message.contactPersonDialog.label.lastName'))+"\n              "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.contactPerson.lastName.$error ? false : null},on:{"change":function($event){_vm.$v.contactPerson.lastName.$touch()}},model:{value:(_vm.contactPerson.lastName),callback:function ($$v) {_vm.$set(_vm.contactPerson, "lastName", $$v)},expression:"contactPerson.lastName"}})],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"contactPersonEmail","label-for":"contactPersonEmail"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n          "+_vm._s(_vm.$t('message.contactPersonDialog.label.email'))+"\n          "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.contactPerson.email.$error ? false : null},on:{"change":function($event){_vm.$v.contactPerson.email.$touch()}},model:{value:(_vm.contactPerson.email),callback:function ($$v) {_vm.$set(_vm.contactPerson, "email", $$v)},expression:"contactPerson.email"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mcd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"rounded-0 h-100"},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":this.$t('message.adminUserDetail.legitimation')}},[_c('b-form-radio-group',{attrs:{"disabled":!_vm.userIsPolicyHolder,"buttons":"","button-variant":"outline-primary","options":_vm.legiOptions},model:{value:(_vm.legiSelected),callback:function ($$v) {_vm.legiSelected=$$v},expression:"legiSelected"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"w-75"},[_c('b-col',[_c('b-form-group',{attrs:{"label":this.$t('message.adminUserDetail.status'),"state":_vm.$v.newDateOfDeath.$error ? false : null,"invalid-feedback":_vm.$t('error.personalInformationForm.dateOfBirth')}},[_c('b-input-group',[_c('b-form-radio-group',{staticClass:"input-group-btn",attrs:{"buttons":"","button-variant":"outline-primary","options":_vm.doaOptions},model:{value:(_vm.aliveSelected),callback:function ($$v) {_vm.aliveSelected=$$v},expression:"aliveSelected"}}),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0 text-right",attrs:{"disabled":_vm.aliveSelected2 || !!_vm.user.dateOfDeath,"id":"dateOfBirth","placeholder":"TT.MM.JJJJ","state":_vm.$v.newDateOfDeath.$error ? false : null},on:{"change":function($event){_vm.$v.newDateOfDeath.$touch()}},model:{value:(_vm.dateOfDeathField),callback:function ($$v) {_vm.dateOfDeathField=$$v},expression:"dateOfDeathField"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.submitStatus}},[_c('span',{staticClass:"ti-save mr-2"}),_vm._v("\n          "+_vm._s(_vm.$t('message.adminUserDetail.save'))+"\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mqSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('b-jumbotron',{staticClass:"p-4 rounded-0",attrs:{"header-level":"6","bg-variant":"white"}},[_c('template',{slot:"header"},[_vm._v("\n          "+_vm._s(_vm.$t('message.dashboard.title', { userName: _vm.userName }))+"\n        ")])],2)],1)],1),_vm._v(" "),(_vm.isContactPerson && !_vm.isPolicyHolder)?_c('dashboard-content-contact-person',{staticClass:"mt-4"}):_vm._e(),_vm._v(" "),(_vm.isPolicyHolder)?_c('dashboard-content',{staticClass:"mt-4"}):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('router-link',{staticClass:"infobox-link-faq",attrs:{"to":"/faq"}},[_c('b-card',{staticClass:"infoboxFaq rounded-0 h-100",attrs:{"title":_vm.$t('message.dashboard.faq.title')}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('message.dashboard.faq.text'))}})])],1)],1),_vm._v(" "),_c('b-col',[_c('b-card',{staticClass:"rounded-0 h-100",attrs:{"title":_vm.$t('message.dashboard.info.title')}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('message.dashboard.info.text'))}})])],1)],1),_vm._v(" "),(_vm.isPolicyHolder)?_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0 h-100",attrs:{"title":_vm.$t('message.dashboard.powerOfAttorney.title')}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('message.dashboard.powerOfAttorney.explanation'))}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('ul',{staticClass:"list-unstyled"},[_c('li',[_c('span',{staticClass:"ti-printer mr-2"}),_vm._v(_vm._s(_vm.$t('message.dashboard.powerOfAttorney.step1')))]),_vm._v(" "),_c('li',[_c('span',{staticClass:"ti-marker-alt mr-2"}),_vm._v(_vm._s(_vm.$t('message.dashboard.powerOfAttorney.step2')))]),_vm._v(" "),_c('li',[_c('span',{staticClass:"ti-email mr-2"}),_vm._v(_vm._s(_vm.$t('message.dashboard.powerOfAttorney.step3')))]),_vm._v(" "),_c('li',{staticClass:"offset-2"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('message.dashboard.powerOfAttorney.address'))}})])])]),_vm._v(" "),_c('b-col',{staticClass:"text-right mt-auto"},[_c('b-btn',{attrs:{"href":"/static/documents/Vollmacht_meine-vertraege.pdf","target":"_blank"}},[_c('span',{staticClass:"ti-download mr-2"}),_vm._v(_vm._s(_vm.$t('message.dashboard.powerOfAttorney.download'))+"\n            ")])],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nkW5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nswO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContractPartnerDetails_vue__ = __webpack_require__("oAWV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a81950_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContractPartnerDetails_vue__ = __webpack_require__("eV1W");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminContractPartnerDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a81950_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminContractPartnerDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nxid":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__ = __webpack_require__("1b5d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49ae43e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__ = __webpack_require__("O6na");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49ae43e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o7xE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminSidebar',
  computed: {
    userName: function userName() {
      var currentUser = this.$store.getters.currentUser;
      return currentUser.firstName + ' ' + currentUser.lastName;
    }
  }
});

/***/ }),

/***/ "oAWV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminContractPartnerForm__ = __webpack_require__("cRrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_HeaderView__ = __webpack_require__("AE0Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminContactPartnerDetails',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (to.params && to.params.id) {
        vm.$store.dispatch('fetchAdminContractPartnerById', parseInt(to.params.id)).catch(function () {
          vm.showErrorMsg({
            message: vm.$t('error.adminContractPartnerDetails.fetchAdminContractPartnerById')
          });
          vm.$router.replace('/admin/contractpartners');
        });
      } else {
        vm.$router.replace('/admin/contractpartners');
      }
    });
  },

  components: {
    AdminContractPartnerForm: __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminContractPartnerForm__["a" /* default */],
    HeaderView: __WEBPACK_IMPORTED_MODULE_1__components_common_HeaderView__["a" /* default */]
  },
  computed: {
    contractPartner: function contractPartner() {
      return this.$store.getters.adminContractPartner;
    },
    title: function title() {
      return this.$t('message.adminContractPartnerDetails.title');
    }
  },
  methods: {
    cancel: function cancel() {
      this.$router.push('/admin/contractpartners');
    },
    saveContractPartner: function saveContractPartner() {
      var _this = this;

      this.$store.dispatch('storeAdminContractPartnerTemplate', this.contractPartner).then(function () {
        _this.showSuccessMsg({
          message: _this.$t('message.adminContractPartnerDetails.saveContractPartner')
        });
        _this.$router.push('/admin/contractpartners');
      }).catch(function () {
        return _this.showErrorMsg({
          message: _this.$t('error.adminContractPartnerDetails.saveContractPartner')
        });
      });
    }
  },
  notifications: {
    showErrorMsg: {
      type: 'error'
    },
    showSuccessMsg: {
      type: 'success'
    }
  }
});

/***/ }),

/***/ "oIsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.addresses.length !== 0)?_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v("\n        "+_vm._s(_vm.$t('message.adminUserAddress.title'))+"\n      ")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","responsive":"","fields":_vm.fields,"items":_vm.addresses,"tbody-class":"text-muted"}})],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oPHQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_address_AddressForm__ = __webpack_require__("Sm2i");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddressConfirmForm',
  components: {
    AddressForm: __WEBPACK_IMPORTED_MODULE_1__components_address_AddressForm__["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var currentAddress = vm.$store.getters.currentAddress;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentAddress).length === 0) {
        next('/addresses');
      }
    });
  },
  destroyed: function destroyed() {
    this.$store.commit('setCurrentAddress', {});
  },

  computed: {
    currentAddress: function currentAddress() {
      return this.$store.getters.currentAddress;
    }
  },
  methods: {
    back: function back() {
      this.$router.push('/addresses');
    },
    submit: function submit() {
      var _this = this;

      var addressForm = this.$refs.addressForm;
      addressForm.$v.$touch();
      if (!addressForm.$v.$invalid) {
        this.$store.dispatch('storeAddress', this.currentAddress).then(function () {
          _this.showSuccessMsg({
            message: _this.$t('message.addressConfirmForm.storeAddress')
          });
          _this.$router.push('/addresses');
        }).catch(function () {
          _this.showErrorMsg({
            message: _this.$t('error.addressConfirmForm.storeAddress')
          });
        });
      }
    }
  },
  notifications: {
    showSuccessMsg: {
      type: 'success'
    },
    showErrorMsg: {
      type: 'error'
    }
  }
});

/***/ }),

/***/ "obC3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdGVkIGJ5IEljb01vb24uaW8gLS0+DQo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4NCjxnPg0KPC9nPg0KCTxwYXRoIGQ9Ik0xNyAxNi40ODhjLTAuMDYzLTIuNjg3LTIuNzc4LTQuOTk5LTYuNTIxLTUuNjA5di0xLjM3NGMwLjQ5Mi0wLjQ3MyAwLjg0Mi0xLjIwNyAxLjA3MS0xLjgzMyAwLjMzMi0wLjE2NiAwLjYyNC0wLjUzNiAwLjc5NC0xLjAzMyAwLjIzOC0wLjY4OCAwLjE0Ni0xLjMyMy0wLjIwNi0xLjYyOSAwLjAyOC0wLjIzOCAwLjA0Ni0wLjQ4MSAwLjAxNS0wLjcyMy0wLjA3OS0wLjY2MyAwLjA2NS0xLjAzOCAwLjE5NC0xLjM2OCAwLjEwNi0wLjI3NyAwLjIyOS0wLjU5MSAwLjEwNi0wLjk0NS0wLjQ0Mi0xLjI3My0xLjcyNy0xLjk3NC0zLjYxOC0xLjk3NGwtMC4yNjQgMC4wMDVjLTEuMzEzIDAuMDQ3LTEuNzA3IDAuNi0xLjk3MSAxLjExNS0wLjAzMyAwLjA2Mi0wLjA3NyAwLjE0Ni0wLjA3NyAwLjE1MS0xLjcxMiAwLjE1My0xLjY5NyAxLjU2OS0xLjY4NCAyLjcwN2wwLjAwMyAwLjM2OWMwIDAuMjA1IDAuMDA5IDAuNDE5IDAuMDI2IDAuNjM5LTAuNDI1IDAuMy0wLjUwNCAxLjAwNS0wLjE3OSAxLjczNyAwLjE4NSAwLjQxNSAwLjQ1MiAwLjcyOSAwLjc0OSAwLjg5MiAwLjI0MyAwLjY3NCAwLjYyNSAxLjQ3IDEuMTc5IDEuOTY1djEuMjgzYy0zLjc5OCAwLjU4OS02LjU1NCAyLjkwNy02LjYxNyA1LjYyNWwtMC4wMTIgMC41MTJoMTcuMDIzbC0wLjAxMS0wLjUxMnpNMS4wNTQgMTZjMC4zOTItMi4wOTQgMi44NTktMy44MjEgNi4xMjItNC4yMDRsMC40NDEtMC4wNTJ2LTIuNjY2bC0wLjIxNi0wLjE1Yy0wLjM5My0wLjI3Mi0wLjc5MS0wLjk0Ny0xLjA5MC0xLjg1MWwtMC4wODMtMC4yODEtMC4yOTQtMC4wNTFjLTAuMDUzLTAuMDE5LTAuMjA4LTAuMTUzLTAuMzMtMC40MjgtMC4wNzUtMC4xNjgtMC4xMDQtMC4zMTItMC4xMTItMC40MTVsMC41MSAwLjE0My0wLjA5Ni0wLjc0OWMtMC4wNDItMC4zMy0wLjA2NC0wLjY1MS0wLjA2NC0wLjk1bC0wLjAwMy0wLjM4Yy0wLjAxNS0xLjM0MSAwLjA1MS0xLjYzNCAwLjc3My0xLjY5OSAwLjU0NS0wLjA0OCAwLjc1Mi0wLjQ0OSAwLjg3Ni0wLjY4OSAwLjE1LTAuMjkyIDAuMjgtMC41NDMgMS4xMi0wLjU3NGwwLjIyNy0wLjAwNGMwLjgyOSAwIDIuMjc5IDAuMTY5IDIuNjY5IDEuMjgyIDAgMC4wNDMtMC4wNTIgMC4xNzctMC4wOTAgMC4yNzUtMC4xNDUgMC4zNzQtMC4zNjQgMC45MzktMC4yNTQgMS44NTMgMC4wMjQgMC4xODgtMC4wMDcgMC40MjQtMC4wNDAgMC42NzVsLTAuMDg5IDAuODA1IDAuNDQxLTAuMDQ4YzAuMDA4IDAuMTA0LTAuMDA0IDAuMjY5LTAuMDc1IDAuNDcyLTAuMDk3IDAuMjg5LTAuMjQyIDAuNDM4LTAuMjM3IDAuNDU0aC0wLjM2bC0wLjExNCAwLjM0MmMtMC4yODMgMC44NTMtMC42NSAxLjQ5Ny0xLjAwOSAxLjc2OGwtMC4xOTggMC4xNXYyLjcyNmwwLjQzOCAwLjA1NWMzLjIxMSAwLjQwMSA1LjY0MSAyLjEyMyA2LjAzMCA0LjE5MmgtMTQuODkzeiIgZmlsbD0iIzAwMDAwMCIgLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "olgt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i18n',{staticClass:"mt-4",attrs:{"path":"message.accountDeactivationForm.deactivate","tag":"p"}},[_c('b-link',{directives:[{name:"b-modal",rawName:"v-b-modal.modal1",modifiers:{"modal1":true}}],attrs:{"variant":"link","place":"deactivateLink"}},[_vm._v("\n      "+_vm._s(_vm.$t('message.accountDeactivationForm.deactivateLink'))+"\n    ")])],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal1","cancel-variant":"primary","ok-variant":"danger","title":_vm.$t('message.accountDeactivationForm.title'),"ok-title":_vm.$t('message.accountDeactivationForm.btn.ok'),"cancel-title":_vm.$t('message.accountDeactivationForm.btn.cancel')},on:{"ok":_vm.deactivate}},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.accountDeactivationForm.question')))]),_vm._v(" "),_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.accountDeactivationForm.message')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oyeM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("L/hj");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.regData.roles = [{
      roleOfUser: 'POLICY_HOLDER'
    }];
    var invitation = this.$store.getters.invitation;
    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(invitation).length !== 0) {
      this.regData.salutation = invitation.contactPersonSalutation;
      this.regData.firstName = invitation.contactPersonFirstname;
      this.regData.lastName = invitation.contactPersonLastname;
      this.regData.email = invitation.contactPersonEmail;
      this.regData.invitationUuid = invitation.uuid;
      this.regData.invitationEmail = invitation.contactPersonEmail;
      this.regData.invitationInviterId = invitation.policyHolderId;
      this.regData.relation = this.$store.getters.relationTypes[0];
      this.regData.roles = [{
        roleOfUser: 'CONTACT_PERSON'
      }];
    }
  },

  computed: {
    invitation: function invitation() {
      var invitation = this.$store.getters.invitation;
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(invitation).length === 0) {
        return undefined;
      }
      return invitation;
    },
    relationText: function relationText() {
      return this.$t('message.signUp.label.relation', {
        firstName: this.invitation.policyHolderFirstName,
        lastName: this.invitation.policyHolderLastName,
        salutation: this.invitation.policyHolderSalutation ? this.$t('enums.salutations.' + this.invitation.policyHolderSalutation) : undefined
      });
    },
    relationTypes: function relationTypes() {
      var _this = this;

      return this.$store.getters.relationTypes.map(function (relationType) {
        return {
          value: relationType,
          text: _this.$t('enums.relationTypes.' + relationType)
        };
      });
    }
  },
  data: function data() {
    return {
      notification: {
        isVisible: false,
        variant: 'danger'
      },
      regData: {},
      salutations: [{ text: this.$t('message.signUp.radio.mister'), value: 'MR' }, { text: this.$t('message.signUp.radio.miss'), value: 'MRS' }]
    };
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      this.$v.$touch();
      if (!this.$v.$invalid) {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.regData);
        if (this.regData.dateOfBirth) {
          data.dateOfBirth = this.$moment(this.regData.dateOfBirth, 'DD.MM.YYYY').format('YYYY-MM-DD');
        }
        this.$store.dispatch('signUp', data).then(function () {
          _this2.$router.push({ path: '/signup/confirm', query: { email: _this2.regData.email } });
        }).catch(function () {
          _this2.notification.isVisible = true;
        });
      }
    }
  },
  validations: {
    regData: {
      acceptTerms: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      dateOfBirth: {
        required: function required() {
          if (this.invitation) {
            return true;
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"];
          }
        },

        isValidDate: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].validators.isValidDate
      },
      email: {
        email: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["email"],
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      firstName: {
        isCharactersOnly: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].validators.isCharactersOnly,
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      contractNumber: {
        required: function required() {
          if (this.invitation) {
            return true;
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"];
          }
        },
        isValidContractNumber: function isValidContractNumber(value) {
          if (this.invitation) {
            return true;
          } else {
            return __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].validators.isValidContractNumber(value, this);
          }
        },
        isNumeric: function isNumeric(value) {
          if (this.invitation) {
            return true;
          } else {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["numeric"])(value);
          }
        }
      },
      lastName: {
        isCharactersOnly: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].validators.isCharactersOnly,
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      password: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        isValidPassword: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].validators.isValidPassword
      },
      relation: {
        required: function required() {
          if (this.invitation) {
            return __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"];
          } else {
            return true;
          }
        }
      },
      salutation: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
      },
      passwordConfirm: {
        required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"],
        sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["sameAs"])('password')
      }
    }
  }
});

/***/ }),

/***/ "p7WO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardContent_vue__ = __webpack_require__("lqHy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf4cdd4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardContent_vue__ = __webpack_require__("lFWN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf4cdd4e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pswo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractPartnerDetails_vue__ = __webpack_require__("vObA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3941c858_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractPartnerDetails_vue__ = __webpack_require__("a2Ma");
function injectStyle (ssrContext) {
  __webpack_require__("GyvN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3941c858"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractPartnerDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3941c858_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractPartnerDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q2t0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvatarForm_vue__ = __webpack_require__("AeLq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08b2f658_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvatarForm_vue__ = __webpack_require__("qVAI");
function injectStyle (ssrContext) {
  __webpack_require__("0GBZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08b2f658"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvatarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08b2f658_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvatarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qVAI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{staticClass:"px-0",attrs:{"cols":"6"}},[_c('label',{style:(_vm.isReadonly ? '' : _vm.selectorStyles)},[_c('div',{staticClass:"circle rounded-circle"},[(!_vm.avatar)?_c('img',{staticClass:"default-avatar",attrs:{"height":_vm.avatarHeight,"width":_vm.avatarWidth,"alt":_vm.$t('message.avatar.default'),"src":__webpack_require__("obC3")}}):_vm._e(),_vm._v(" "),(_vm.avatar)?_c('img',{staticClass:"rounded-circle",attrs:{"height":_vm.avatarHeight,"width":_vm.avatarWidth,"alt":_vm.$t('message.avatar.default'),"src":_vm.avatarSrc}}):_vm._e()]),_vm._v(" "),_c('input',{attrs:{"type":"file","hidden":"","accept":"image/*","disabled":_vm.isReadonly},on:{"change":_vm.onFileChanged}})]),_vm._v(" "),(!_vm.isReadonly)?_c('label',{staticClass:"text-center mt-3",style:(_vm.isReadonly ? '' : _vm.selectorStyles)},[_vm._v("\n        "+_vm._s(_vm.$t('message.avatar.maxFileDimensions'))+"\n        "),_c('br'),_vm._v("\n        "+_vm._s(_vm.$t('message.avatar.maxFileDimensionsValue' , {
        height: _vm.maxHeight,
        width: _vm.maxWidth
        }))+"\n        "),_c('input',{attrs:{"type":"file","hidden":"","accept":"image/*","disabled":_vm.isReadonly},on:{"change":_vm.onFileChanged}})]):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qpYN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Bestatter-logo.fc7ecbf.png";

/***/ }),

/***/ "rP78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autocompleteValue),expression:"autocompleteValue"}],ref:"autocomplete",class:_vm.className,attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder},domProps:{"value":(_vm.autocompleteValue)},on:{"blur":function($event){_vm.onBlur()},"change":_vm.onChange,"focus":function($event){_vm.onFocus()},"keypress":_vm.onKeyPress,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.autocompleteValue=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rWj5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountDeactivationForm_vue__ = __webpack_require__("wnan");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e900992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountDeactivationForm_vue__ = __webpack_require__("olgt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountDeactivationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e900992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountDeactivationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "roUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',[_c('b-nav',{attrs:{"vertical":""}},[_c('b-nav-text',{staticClass:"text-uppercase text-muted"},[_vm._v("\n      "+_vm._s(_vm.userName)+"\n    ")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/dashboard"}},[_c('i',{staticClass:"ti-dashboard mx-2"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.adminSidebar.navItem.dashboard')))])]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/admin/users"}},[_c('i',{staticClass:"ti-user mx-2"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.adminSidebar.navItem.users')))])]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/admin/contractpartners"}},[_c('i',{staticClass:"ti-agenda mx-2"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.adminSidebar.navItem.contractPartners')))])]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/account"}},[_c('i',{staticClass:"ti-settings mx-2"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.adminSidebar.navItem.account')))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rwcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressSearchForm_vue__ = __webpack_require__("eVfV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aeec38f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressSearchForm_vue__ = __webpack_require__("b/pP");
function injectStyle (ssrContext) {
  __webpack_require__("PZAq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressSearchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aeec38f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressSearchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sDRF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sDju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractEstateDetails_vue__ = __webpack_require__("tV2I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7612f6cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractEstateDetails_vue__ = __webpack_require__("igZc");
function injectStyle (ssrContext) {
  __webpack_require__("/f27")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7612f6cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractEstateDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7612f6cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractEstateDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sHHI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v(_vm._s(_vm.$t('message.signUpContactPersonRejected.title')))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sWcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{staticClass:"text-uppercase",attrs:{"title":_vm.$t('message.imprint.title'),"icon":''}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('address',[_vm._v("CodeCamp:N GmbH")]),_vm._v(" "),_c('address',[_vm._v("Solgerstr. 18")]),_vm._v(" "),_c('address',[_vm._v("90429 Nürnberg")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("info [at] codecamp-n.com")]),_vm._v(" "),_c('p',[_vm._v("Tel.: +49 (0)911 / 27 44 85 23")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Geschäftsführer:")]),_vm._v(" "),_c('p',[_vm._v("Florian Zenk")]),_vm._v(" "),_c('p',[_vm._v("Bernhard Preuschoff")]),_vm._v(" "),_c('p',[_vm._v("Gerlinde Wanke")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Registernummer: HRB 34360")]),_vm._v(" "),_c('p',[_vm._v("Registergericht: Amtsgericht Nürnberg")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Umsatzsteuer-ID: DE133500778")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('h4',{staticClass:"text-uppercase"},[_vm._v("RECHTLICHE HINWEISE")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("\n        Die Inhalte auf dieser Internetseite, der Hauptseite sowie allen\n        Unterseiten werden sorgfältig erarbeitet und laufend gepflegt. Die\n        CodeCamp:N GmbH ist dabei bemüht gemäß § 7 Abs. 1 Telemediengesetz\n        (TMG) diese Inhalte vollständig und aktuell zu halten.\n        Nichtsdestotrotz können fehlerhafte Inhalte enthalten sein, weshalb\n        die CodeCamp:N GmbH keine Gewähr nach §§ 8 bis 10 TMG für\n        Vollständigkeit, Aktualität und Richtigkeit der Inhalte übernimmt. Die\n        Inhalte sollen nur der allgemeinen Information dienen und sind\n        deswegen bewusst allgemein formuliert und stellen keine Beratung des\n        Nutzers für den Einzelfall dar und können keine Einzelfallberatung\n        ersetzen. Die CodeCamp:N GmbH haftet nicht für Schäden, die daraus\n        resultieren, dass auf die Vollständigkeit, Aktualität und Richtigkeit\n        der Inhalte dieser Internetseite vertraut wurde. Es sei denn der\n        Schaden resultiert aus vorsätzlicher oder grob fahrlässiger\n        Falschinformation. Diesbezüglich ist eine Haftung jedoch erst ab dem\n        Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei\n        Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese\n        Inhalte umgehend entfernen. Die CodeCamp:N GmbH behält sich das Recht\n        vor, jederzeit Änderungen, Ergänzungen oder Löschungen der Inhalte\n        dieser Internetseite vorzunehmen.\n      ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('h4',{staticClass:"text-uppercase"},[_vm._v("URHEBERRECHTE / MARKEN UND LOGOS")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("\n        Die Inhalte und Werke auf dieser Internetseite, der Hauptseite sowie\n        allen Unterseiten sind nach deutschem Urheberrecht geschützt. Ohne\n        vorherige schriftliche Zustimmung der CodeCamp:N GmbH dürfen Inhalte,\n        insbesondere Texte, Bilder, Grafiken etc., nicht genutzt oder\n        verwendet werden. Dies gilt für jegliche Nutzungen, also ganz oder\n        teilweise, privat oder kommerziell. Die Marken und Logos auf der\n        Internetseite der CodeCamp:N GmbH sind urheberrechtlich geschützt.\n        Ohne vorherige schriftliche Zustimmung der CodeCamp:N GmbH dürfen\n        Marken oder Logos nicht genutzt werden. Dies gilt für jegliche\n        Nutzungen, also ganz oder teilweise, privat oder kommerziell.\n      ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('h4',{staticClass:"text-uppercase"},[_vm._v("\n        HYPERLINKS UND VERWEISE AUF INTERNETSEITEN DRITTER\n      ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("\n        Wenn Sie Internetseiten Dritter aufrufen, verlassen Sie insoweit die\n        Internetseite der CodeCamp:N GmbH. Die CodeCamp:N GmbH ist für den\n        Inhalt von Internetseiten Dritter nicht verantwortlich. Die CodeCamp:N\n        GmbH haftet nicht für den Inhalt von Internetseiten Dritter. Die\n        CodeCamp:N GmbH übernimmt keine weitere Haftung für die\n        Vollständigkeit, Aktualität oder Richtigkeit von Internetseiten\n        Dritter, soweit hierauf mit einem Hyperlink oder sonstigem Verweis\n        referenziert wird. Die CodeCamp:N GmbH macht sich die Inhalte der\n        Internetseite Dritter nicht zu Eigen.\n      ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("\n        Bei der erstmaligen Verknüpfung haben wir den fremden Inhalt\n        genauestens überprüft. Jedoch trifft uns keine Verpflichtung zur\n        laufenden Überprüfung auf Veränderung der Inhalte, auf die wir\n        verweisen. Stellen wir jedoch fest, dass ein Inhalt einer fremden\n        Seite, die wir verknüpft haben, eine zivil- oder strafrechtliche\n        Verantwortlichkeit auslöst, werden wir den Link auf diese Seite\n        aufheben, soweit uns dies möglich und zumutbar ist.\n      ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("\n        Gerne nehmen wir Hinweise an, dass ein solcher Fall vorliegen könnte.\n      ")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',[_vm._v("Ihre CodeCamp:N GmbH")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sk3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactPersonDialog',
  data: function data() {
    return {
      contactPerson: {},
      salutations: [{ value: 'MR', text: this.$t('enums.salutations.MR') }, { value: 'MRS', text: this.$t('enums.salutations.MRS') }]
    };
  },

  methods: {
    onSubmit: function onSubmit(bvEvt) {
      bvEvt.preventDefault();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$refs.contactPersonModal.hide();
        this.$emit('submit', this.contactPerson);
      }
    },
    show: function show() {
      this.$v.$reset();
      this.contactPerson = {};
      this.$refs.contactPersonModal.show();
    }
  },
  validations: {
    contactPerson: {
      email: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
      },
      firstName: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      lastName: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      salutation: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),

/***/ "t3gJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tV2I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_BusinessCard__ = __webpack_require__("ReR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractSummary__ = __webpack_require__("URMB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContractEstateDetails',
  components: {
    BusinessCard: __WEBPACK_IMPORTED_MODULE_0__components_common_BusinessCard__["a" /* default */],
    ContractSummary: __WEBPACK_IMPORTED_MODULE_1__components_contracts_ContractSummary__["a" /* default */]
  },
  computed: {
    contract: function contract() {
      return this.$store.getters.currentContract;
    },
    contractCategories: function contractCategories() {
      var _this = this;

      return this.$store.getters.contractCategories.map(function (category) {
        return {
          value: category,
          text: _this.$t('enums.contractCategories.' + category)
        };
      });
    },
    contactPersons: function contactPersons() {
      return this.$store.getters.contactPersons;
    },
    infoText: function infoText() {
      if (this.contactPersons.length > 0) {
        return this.$t('message.contractEstateDetails.infoTextWithContactPersons');
      } else {
        return this.$t('message.contractEstateDetails.infoTextWithoutContactPersons');
      }
    }
  },
  methods: {
    getPotClass: function getPotClass(pot) {
      if (this.contract.contactPerson && this.contract.contactPerson.id === pot.id) {
        return 'person-of-trust__selected';
      }
      return '';
    },
    onSelectContactPerson: function onSelectContactPerson(contactPerson) {
      this.$store.commit('updateContactPerson', contactPerson);
    }
  }
});

/***/ }),

/***/ "tbQo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-group',{staticClass:"mt-4"},[_c('label',[_vm._v(_vm._s(_vm.$t('message.accountChangeEmailForm.label.currentEmail')))]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0 text-muted",attrs:{"value":_vm.currentEmail,"disabled":""}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mt-4"},[_c('label',[_vm._v("\n      "+_vm._s(_vm.$t('message.accountChangeEmailForm.label.email'))+"\n      "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.email.$error ? false : null},on:{"changed":function($event){_vm.$v.email.$touch()}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mt-4",attrs:{"state":_vm.$v.emailConfirm.$error ? false : null}},[_c('label',[_vm._v("\n      "+_vm._s(_vm.$t('message.accountChangeEmailForm.label.emailConfirm'))+"\n      "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-input',{staticClass:"rounded-0",attrs:{"state":_vm.$v.emailConfirm.$error ? false : null},on:{"changed":function($event){_vm.$v.emailConfirm.$touch()}},model:{value:(_vm.emailConfirm),callback:function ($$v) {_vm.emailConfirm=$$v},expression:"emailConfirm"}})],1),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary","type":"submit"}},[_c('span',{staticClass:"ti-save mr-2"}),_vm._v("\n        "+_vm._s(_vm.$t('message.accountChangeEmailForm.btn.save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tgqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.$t('message.adminContractPartnerTemplateDetails.title'),"icon":"ti-agenda"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0"},[_c('admin-contract-partner-form',{on:{"onCancel":_vm.cancel,"onDelete":_vm.deleteContractPartnerTemplate,"onSave":_vm.saveContractPartnerTemplate}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tvvB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u9Pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountChangeEmailForm_vue__ = __webpack_require__("fC2L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0836e90d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountChangeEmailForm_vue__ = __webpack_require__("tbQo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountChangeEmailForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0836e90d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountChangeEmailForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ud5a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookiePopup_vue__ = __webpack_require__("Hldr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1eac71_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookiePopup_vue__ = __webpack_require__("ArdV");
function injectStyle (ssrContext) {
  __webpack_require__("76mk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookiePopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1eac71_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookiePopup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uhAE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("L/hj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    submit: function submit() {
      var vm = this;
      vm.$v.$touch();
      if (!vm.$v.$invalid) {
        vm.onSubmit(vm.passwordData).then(function () {
          return vm.$v.$reset();
        });
      }
    }
  },
  props: {
    onSubmit: {
      type: Function,
      required: true
    },
    passwordData: {
      type: Object,
      required: true
    }
  },
  validations: {
    passwordData: {
      oldPassword: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      newPassword: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        isValidPassword: __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].validators.isValidPassword
      },
      newPasswordConfirm: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        sameAsNewPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["sameAs"])('newPassword')
      }
    }
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vObA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_autocomplete__ = __webpack_require__("HpzI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_v_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_v_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contracts_ContractPartnerTemplate__ = __webpack_require__("jW+E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("L/hj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_1_v_autocomplete___default.a,
    ContractPartnerTemplate: __WEBPACK_IMPORTED_MODULE_2__components_contracts_ContractPartnerTemplate__["a" /* default */]
  },
  computed: {
    contractPartners: function contractPartners() {
      var contractPartners = this.$store.getters.contractPartners;
      var additionalContractPartnerIndex = contractPartners.findIndex(function (contractPartner) {
        return contractPartner.id === -1;
      });
      if (additionalContractPartnerIndex !== -1) {
        contractPartners.splice(additionalContractPartnerIndex, 1);
      }
      contractPartners.push({
        id: -1,
        contractPartnerName: this.$t('message.contractList.infoCard.step1.contractPartnerName')
      });
      return contractPartners;
    },

    contractPartner: {
      get: function get() {
        return this.$store.getters.currentContract.contractPartner;
      },
      set: function set(contractPartner) {
        this.selectedContractPartner = contractPartner;
      }
    },
    showForm: function showForm() {
      this.isFormVisible = false;
      if (this.contractPartner && this.contractPartner.id === -1) {
        var searchValue = this.formData.searchValue ? this.formData.searchValue : this.formData.contractPartnerName;
        this.$v.$reset();
        this.formData.templateId = null;
        this.formData.contractPartnerName = searchValue;
        this.isFormVisible = true;
      } else if (this.contractPartner) {
        this.formData = this.contractPartner;
        this.formData.templateId = this.contractPartner.templateId ? this.contractPartner.templateId : null;
        this.isFormVisible = true;
      }
      return this.isFormVisible;
    }
  },
  data: function data() {
    return {
      formData: {},
      isFormVisible: false,
      selectedContractPartner: this.contractPartner,
      contractPartnerTemplate: __WEBPACK_IMPORTED_MODULE_2__components_contracts_ContractPartnerTemplate__["a" /* default */],
      filteredContractPartners: this.contractPartners
    };
  },

  methods: {
    getContractPartner: function getContractPartner() {
      return this.formData;
    },
    getContractPartnerLabel: function getContractPartnerLabel(contractPartner) {
      return contractPartner ? contractPartner.contractPartnerName : '';
    },
    setFormVisible: function setFormVisible(isVisible) {
      this.isFormVisible = isVisible;
    },
    stashContractPartner: function stashContractPartner() {
      var currentContractPartner = this.getContractPartner();
      this.$store.commit('updateContractPartner', currentContractPartner);
    },
    resetContractPartner: function resetContractPartner() {
      this.$v.$reset();
      this.$store.commit('updateContractPartner', {});
      this.formData = {};
    },
    createEmptyContractPartner: function createEmptyContractPartner() {
      this.$v.$reset();
      this.$store.commit('updateContractPartner', this.contractPartners[this.contractPartners.length - 1]);
    },
    updateContractPartner: function updateContractPartner(contractPartner) {
      this.$v.$reset();
      if (this.contractPartner && this.contractPartner.id) {
        // this results in the "create new CP" being assigned a wrong id, leading to the crutch in ContractPartnerTemplate
        contractPartner.id = this.contractPartner.id;
      }
      if (contractPartner && contractPartner.hasOwnProperty('isTemplate') && contractPartner.isTemplate === true) {
        // if (contractPartner && contractPartner.hasOwnProperty('isDeletable') && contractPartner.isDeletable === true) {
        if (contractPartner.templateId === null) {
          contractPartner.templateId = contractPartner.id;
        }
      }
      this.$store.commit('updateContractPartner', contractPartner);
    },
    updateContractPartners: function updateContractPartners(text) {
      this.formData.searchValue = text;
      // this.formData.contractPartnerName = text
      this.filteredContractPartners = this.contractPartners.filter(function (contractPartner) {
        return contractPartner.contractPartnerName.toLowerCase().includes(text.toLowerCase()) || contractPartner.id === -1;
      });
    }
  },
  validations: {
    formData: {
      contractPartnerName: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      domain: {
        isValidDomain: __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].validators.isValidDomain
      },
      email: {
        email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"],
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      street: {},
      streetNumber: {},
      postOfficeBox: {},
      postalCode: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      city: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      country: {},
      confirmed: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      }
    }
  }
});

/***/ }),

/***/ "vfBd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"rounded-0"},[_c('h4',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('b-form',{staticClass:"mt-4",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('b-form-group',{attrs:{"id":"acceptRequest","label-for":"acceptRequest"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n        "+_vm._s(_vm.$t('message.signUpContactPerson.label.acceptRequest'))+"\n        "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-radio-group',{attrs:{"options":_vm.requestOptions,"state":_vm.$v.contactPersonRequest.isAccepted.$error ? false : null},on:{"change":function($event){_vm.$v.contactPersonRequest.isAccepted.$touch()}},model:{value:(_vm.contactPersonRequest.isAccepted),callback:function ($$v) {_vm.$set(_vm.contactPersonRequest, "isAccepted", $$v)},expression:"contactPersonRequest.isAccepted"}})],1),_vm._v(" "),(_vm.contactPersonRequest.isAccepted === 'true')?_c('b-form-group',{attrs:{"id":"hasAccount","label-for":"hasAccount"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n        "+_vm._s(_vm.$t('message.signUpContactPerson.label.hasAccount'))+"\n        "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-radio-group',{attrs:{"options":_vm.accountOptions,"state":_vm.$v.contactPersonRequest.hasAccount.$error ? false : null},on:{"change":function($event){_vm.$v.contactPersonRequest.hasAccount.$touch()}},model:{value:(_vm.contactPersonRequest.hasAccount),callback:function ($$v) {_vm.$set(_vm.contactPersonRequest, "hasAccount", $$v)},expression:"contactPersonRequest.hasAccount"}})],1):_vm._e(),_vm._v(" "),(_vm.contactPersonRequest.hasAccount === 'true')?_c('b-form-group',{attrs:{"id":"relation","label-for":"relation"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n        "+_vm._s(_vm.relationText)+"\n        "),_c('span',{staticClass:"text-danger"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-select',{staticClass:"rounded-0",attrs:{"options":_vm.relationTypes},model:{value:(_vm.relation),callback:function ($$v) {_vm.relation=$$v},expression:"relation"}})],1):_vm._e(),_vm._v(" "),_c('b-form-row',{staticClass:"mt-4"},[_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary","type":"submit"}},[_vm._v("\n          "+_vm._s(_vm.$t('message.signUpContactPerson.btn.submit'))+"\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vhM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserContactPerson_vue__ = __webpack_require__("GeN8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40423be0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserContactPerson_vue__ = __webpack_require__("E8ON");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserContactPerson_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40423be0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserContactPerson_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vzLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressList_vue__ = __webpack_require__("3L2t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ac18f0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressList_vue__ = __webpack_require__("aMpA");
function injectStyle (ssrContext) {
  __webpack_require__("tvvB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ac18f0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ac18f0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wBvz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('h2',[_vm._v(_vm._s(_vm.$t('message.addressDetails.title')))])])],1),_vm._v(" "),(!_vm.isEditable)?_c('div',[_c('b-row',{staticClass:"mt-4"},[_c('b-col',[(_vm.currentAddress)?_c('Infobox',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"variant":"noHover"}},[_c('span',{staticClass:"infobox-icon ti-home"})]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-btn',{attrs:{"variant":"link"},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('message.addressDetails.btn.back')))])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.editAddress}},[_vm._v(_vm._s(_vm.$t('message.addressDetails.btn.edit')))]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.delete-address-model",modifiers:{"delete-address-model":true}}],attrs:{"variant":"danger"}},[_vm._v(_vm._s(_vm.$t('message.addressDetails.btn.delete')))])],1)],1),_vm._v(" "),(_vm.isPolicyHolder)?_c('div',{staticClass:"mt-5"},[_c('b-row',[_c('b-col',[_c('contracts-card',{attrs:{"collapseId":"addressContracts","title":_vm.$t('message.addressDetails.contractsCard.title'),"items":_vm.contractsByAddress},on:{"showDetails":_vm.onShowDetails}})],1)],1),_vm._v(" "),(_vm.contractsByAddress.length !== 0)?_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"rounded-0 mt-4",attrs:{"title":_vm.$t('message.addressDetails.moveTitle')}},[_c('b-row',[(_vm.isSingleAddress)?_c('b-col',[_vm._v("\n                "+_vm._s(_vm.$t('message.addressDetails.moveMessageSingleAddr'))+"\n              ")]):_vm._e(),_vm._v(" "),(!_vm.isSingleAddress)?_c('b-col',[_vm._v("\n                "+_vm._s(_vm.$t('message.addressDetails.moveMessage'))+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',_vm._l((Math.ceil(_vm.filteredAddresses.length / 3)),function(i){return _c('b-row',{key:i,staticClass:"mt-3"},_vm._l((_vm.filteredAddresses.slice((i - 1) * 3, i * 3)),function(address){return _c('b-col',{key:address.id},[_c('b-btn',{staticClass:"p-0 my-2 mr-4 rounded-0 btn-address w-100",attrs:{"variant":"transparent"},on:{"click":function($event){_vm.onSelectAddressbox(address)}}},[_c('Infobox',{class:_vm.getAddressBoxClass(address),attrs:{"title":_vm.getTitle(address),"subtitle":address.postalCode + ' ' + address.city}},[_c('span',{staticClass:"infobox-icon ti-home"})])],1)],1)}))}))],1),_vm._v(" "),(!_vm.isSingleAddress)?_c('b-row',[_c('b-col',{staticClass:"text-right"},[_c('b-btn',{attrs:{"variant":"primary","disabled":_vm.contractsByAddress.length === 0 || !_vm.newAddress},on:{"click":_vm.updateContractsWithAddress}},[_vm._v("\n                  "+_vm._s(_vm.$t('message.addressDetails.moveBtn'))+"\n                ")])],1)],1):_vm._e()],1)],1)],1):_vm._e()],1):_vm._e()],1):_c('div',[_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"cols":"10"}},[_c('address-form',{ref:"addressForm",attrs:{"address":_vm.currentAddress,"onSubmitFn":_vm.saveAddress}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right px-4",attrs:{"cols":"10"}},[_c('b-btn',{attrs:{"variant":"link"},on:{"click":_vm.cancel}},[_vm._v("\n          "+_vm._s(_vm.$t('message.addressDetails.btn.cancel'))+"\n        ")]),_vm._v(" "),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.saveAddress}},[_vm._v("\n          "+_vm._s(_vm.$t('message.addressDetails.btn.save'))+"\n        ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"delete-address-model","cancel-variant":"primary","ok-variant":"danger","title":_vm.$t('message.addressDetails.modal.title'),"ok-title":_vm.$t('message.addressDetails.modal.btn.ok'),"cancel-title":_vm.$t('message.addressDetails.modal.btn.cancel')},on:{"ok":_vm.deleteAddress}},[_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.addressDetails.modal.question')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wDzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__ = __webpack_require__("AE0Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Policies',
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_0__components_common_HeaderView__["a" /* default */]
  }
});

/***/ }),

/***/ "wiRz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_vm._v(" "),(_vm.isSignedIn)?_c('div',{staticClass:"d-flex flex-row mt-5"},[(_vm.isAdmin)?_c('admin-sidebar',{staticClass:"px-2 pt-4"}):_c('app-sidebar',{staticClass:"px-2 pt-4"}),_vm._v(" "),_c('main',[_c('b-container',{staticClass:"bg-light",attrs:{"fluid":""}},[_c('b-row',{staticClass:"content"},[_c('b-col',{staticClass:"px-4 py-5"},[_c('router-view')],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-0"},[_c('terms-footer')],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.isSignedIn)?_c('b-container',{staticClass:"mt-5",attrs:{"fluid":""}},[_c('b-row',{staticClass:"content"},[_c('b-col',{staticClass:"py-5 mx-auto",attrs:{"md":"6","lg":"5"}},[_c('router-view')],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-0"},[_c('terms-footer')],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wnan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    deactivate: function deactivate() {
      this.onDeactivateFn();
    }
  },
  props: {
    onDeactivateFn: {
      type: Function,
      required: true
    }
  }
});

/***/ }),

/***/ "xF8D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('b-row',[_c('b-col',[_c('router-link',{staticClass:"p-2",attrs:{"to":"/imprint","place":"terms"}},[_vm._v(_vm._s(_vm.$t('message.footer.imprint')))]),_vm._v(" "),_c('router-link',{staticClass:"p-2",attrs:{"to":"/terms","place":"terms"}},[_vm._v(_vm._s(_vm.$t('message.footer.terms')))]),_vm._v(" "),_c('router-link',{staticClass:"p-2",attrs:{"to":"/policies","place":"privacyPolicies"}},[_vm._v(_vm._s(_vm.$t('message.footer.privacyPolicies')))]),_vm._v(" "),_c('router-link',{staticClass:"p-2",attrs:{"to":"/info","place":"terms"}},[_vm._v(_vm._s(_vm.$t('message.footer.info')))])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right"},[_c('span',{staticClass:"p-2"},[_vm._v(_vm._s(_vm.$t('message.footer.copyright')))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_AdminSidebar__ = __webpack_require__("JkXQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_AppHeader__ = __webpack_require__("VOCW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_AppSidebar__ = __webpack_require__("kADP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_CookiePopup__ = __webpack_require__("ud5a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_TermsFooter__ = __webpack_require__("FeJt");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CookiePopup: __WEBPACK_IMPORTED_MODULE_4__components_common_CookiePopup__["a" /* default */],
    AdminSidebar: __WEBPACK_IMPORTED_MODULE_1__components_admin_AdminSidebar__["a" /* default */],
    AppHeader: __WEBPACK_IMPORTED_MODULE_2__components_common_AppHeader__["a" /* default */],
    AppSidebar: __WEBPACK_IMPORTED_MODULE_3__components_common_AppSidebar__["a" /* default */],
    TermsFooter: __WEBPACK_IMPORTED_MODULE_5__components_common_TermsFooter__["a" /* default */]
  },
  computed: {
    currentUser: function currentUser() {
      return this.$store.getters.currentUser;
    },
    userName: function userName() {
      return this.currentUser.firstName + ' ' + this.currentUser.lastName;
    },
    isSignedIn: function isSignedIn() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.currentUser).length > 0) {
        return true;
      }
      return false;
    },
    isAdmin: function isAdmin() {
      var currentUser = this.$store.getters.currentUser;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(currentUser).length > 0) {
        var rolesAdmin = currentUser.roles.filter(function (role) {
          return role.roleOfUser === 'ADMIN';
        });
        if (rolesAdmin.length > 0) {
          return true;
        }
      }
      return false;
    }
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('tryAutoLogin').then(function () {
      _this.$router.replace(_this.$route.query.redirect);
    }).catch(function () {}); // Do nothing because we already handle this
  }
});

/***/ }),

/***/ "xSZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios_auth__ = __webpack_require__("NwdG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__("L/hj");





var state = {
  currentUser: {},
  powerOfAttorney: null
};

var getters = {
  currentUser: function currentUser(state) {
    return state.currentUser;
  },
  powerOfAttorney: function powerOfAttorney(state) {
    return state.powerOfAttorney;
  }
};

var actions = {
  addRolePolicyHolder: function addRolePolicyHolder(_ref, payload) {
    var getters = _ref.getters,
        dispatch = _ref.dispatch,
        commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = state.currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].post('/users/' + currentUser.id + '/addRolePolicyHolder', payload, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        var user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, currentUser, {
          roles: response.data.roles
        });
        commit('setCurrentUser', user);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  changeEmail: function changeEmail(_ref2, email) {
    var dispatch = _ref2.dispatch,
        state = _ref2.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var attributes = [];
      var emailAttr = {
        Name: 'email',
        Value: email
      };
      attributes.push(emailAttr);
      dispatch('updateAttributes', attributes).then(function () {
        return dispatch('setCurrentUser', {
          cognitoId: state.currentUser.cognitoId,
          idToken: state.currentUser.idToken,
          accessToken: state.currentUser.accessToken,
          refreshToken: state.currentUser.refreshToken
        });
      }).then(function () {
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  changedPassword: function changedPassword(_ref3) {
    var state = _ref3.state,
        dispatch = _ref3.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var idToken = state.currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/users/' + state.currentUser.id + '/changedPassword', {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function () {
        return reject();
      });
    });
  },
  deleteCurrentUser: function deleteCurrentUser(_ref4) {
    var state = _ref4.state;

    var idToken = state.currentUser.idToken;
    var authValue = 'Bearer '.concat(idToken);
    return __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].delete('/users/' + state.currentUser.id, {
      headers: {
        Authorization: authValue
      }
    });
  },
  deletePowerOfAttorney: function deletePowerOfAttorney(_ref5) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        state = _ref5.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var idToken = state.currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].delete('/users/' + state.currentUser.id + '/powerOfAttorny', {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        commit('setPowerOfAttorney', null);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getPowerOfAttorney: function getPowerOfAttorney(_ref6) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch,
        state = _ref6.state;

    var idToken = state.currentUser.idToken;
    var authValue = 'Bearer '.concat(idToken);
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/users/' + state.currentUser.id + '/powerOfAttorny', {
        responseType: 'arraybuffer',
        headers: {
          Authorization: authValue,
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var poaMeta = __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* default */].contentDispositionToMeta(response);
        poaMeta.file = response.data;
        commit('setPowerOfAttorney', poaMeta);
        dispatch('setLogoutTimer');
        resolve(poaMeta);
      }).catch(function (err) {
        switch (err.response.status) {
          case 404:
            {
              // no poa uploaded yet
              dispatch('setLogoutTimer');
              resolve();
              break;
            }
          default:
            {
              reject(err);
            }
        }
      });
    });
  },
  uploadPowerOfAttorney: function uploadPowerOfAttorney(_ref7, file) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch,
        state = _ref7.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var idToken = state.currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      var formData = new FormData();
      formData.append('file', file);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].post('/users/' + state.currentUser.id + '/powerOfAttorny', formData, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        var powerOfAttorneyMeta = {};
        powerOfAttorneyMeta.filename = file.name;
        powerOfAttorneyMeta.mimeType = file.type;
        powerOfAttorneyMeta.file = file;
        commit('setPowerOfAttorney', powerOfAttorneyMeta);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  setCurrentUser: function setCurrentUser(_ref8, cognitoUserData) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var idToken = cognitoUserData.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].get('/users/current', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        var data = response.data;
        var user = {
          id: data.id,
          avatar: data.avatar,
          cognitoId: cognitoUserData.cognitoId,
          idToken: cognitoUserData.idToken,
          accessToken: cognitoUserData.accessToken,
          refreshToken: cognitoUserData.refreshToken,
          expirationDate: cognitoUserData.expirationDate,
          contractNumber: data.contractNumber,
          email: data.email,
          dateOfBirth: data.dateOfBirth,
          dateOfDeath: data.dateOfDeath,
          firstName: data.firstName,
          lastName: data.lastName,
          roles: data.roles,
          salutation: data.salutation,
          title: data.title
        };
        commit('setCurrentUser', user);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  updateUser: function updateUser(_ref9, user) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch,
        state = _ref9.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var idToken = state.currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].put('/users/' + user.id, user, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function () {
        return reject();
      });
    });
  },
  deleteAvatar: function deleteAvatar(_ref10) {
    var state = _ref10.state,
        dispatch = _ref10.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var idToken = state.currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].delete('/avatars/' + state.currentUser.avatar.uuid, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        state.currentUser.avatar = null;
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function () {
        return reject();
      });
    });
  },
  uploadAvatar: function uploadAvatar(_ref11, avatar) {
    var commit = _ref11.commit,
        state = _ref11.state,
        dispatch = _ref11.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var idToken = state.currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      var formData = new FormData();
      formData.append('file', avatar);
      if (!state.currentUser.avatar) {
        __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].post('/avatars/', formData, {
          headers: {
            Authorization: authValue
          }
        }).then(function (response) {
          var location = response.headers.location;
          var uuid = location.substr(location.lastIndexOf('/') + 1, location.length);
          state.currentUser.avatar = { uuid: uuid };
          dispatch('setLogoutTimer');
          resolve();
        }).catch(function () {
          return reject();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].put('/avatars/' + state.currentUser.avatar.uuid, formData, {
          headers: {
            Authorization: authValue
          }
        }).then(function (response) {
          dispatch('setLogoutTimer');
          resolve();
        }).catch(function () {
          return reject();
        });
      }
    });
  },
  validateContractNumber: function validateContractNumber(_ref12, data) {
    var commit = _ref12.commit;

    return __WEBPACK_IMPORTED_MODULE_2__axios_auth__["a" /* default */].post('/users/validateContractNumber', data);
  }
};

var mutations = {
  setCurrentUser: function setCurrentUser(state, user) {
    state.currentUser = user;
  },
  setPowerOfAttorney: function setPowerOfAttorney(state, powerOfAttorney) {
    state.powerOfAttorney = powerOfAttorney;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "xYEv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios_auth__ = __webpack_require__("NwdG");



var state = {
  contractPartners: [],
  contractPartner: {}
};

var getters = {
  contractPartners: function contractPartners(state) {
    return state.contractPartners;
  },
  contractPartner: function contractPartner(state) {
    return state.contractPartner;
  }
};

var actions = {
  fetchContractPartners: function fetchContractPartners(_ref) {
    var getters = _ref.getters,
        commit = _ref.commit,
        dispatch = _ref.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].get('/contractPartnerTemplates', {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('setContractPartners', response.data);
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  storeContractPartner: function storeContractPartner(_ref2, contractPartner) {
    var getters = _ref2.getters,
        commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].post('/contractPartners', contractPartner, {
        headers: {
          Authorization: authValue
        }
      }).then(function (response) {
        commit('addContractPartner', response.data);
        dispatch('setLogoutTimer');
        resolve(response.data);
      }).catch(function (err) {
        return reject(err);
      });
    });
  },
  updateContractPartner: function updateContractPartner(_ref3, contractPartner) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch,
        getters = _ref3.getters;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var currentUser = getters.currentUser;
      var idToken = currentUser.idToken;
      var authValue = 'Bearer '.concat(idToken);
      __WEBPACK_IMPORTED_MODULE_1__axios_auth__["a" /* default */].put('/contractPartners/' + contractPartner.id, contractPartner, {
        headers: {
          Authorization: authValue
        }
      }).then(function () {
        dispatch('setLogoutTimer');
        resolve();
      }).catch(function (err) {
        return reject(err);
      });
    });
  }
};

var mutations = {
  addContractPartner: function addContractPartner(state, contractPartner) {
    state.contractPartners.push(contractPartner);
  },
  setContractPartners: function setContractPartners(state, contractPartners) {
    state.contractPartners = contractPartners;
  },
  setContractPartner: function setContractPartner(state, contractPartner) {
    state.contractPartner = contractPartner;
  },
  updateContractPartnerName: function updateContractPartnerName(state, contractPartnerName) {
    state.contractPartner.contractPartnerName = contractPartnerName;
  },
  updateDomain: function updateDomain(state, domain) {
    state.contractPartner.domain = domain;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "xmeH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yTxD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yWLd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserDetail_vue__ = __webpack_require__("2AxU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7da257ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserDetail_vue__ = __webpack_require__("kD7q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminUserDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7da257ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminUserDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yc7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminUserAddress',
  created: function created() {
    var _this = this;

    if (!this.addresses.length) {
      var id = parseInt(this.$route.params.id);
      this.$store.dispatch('fetchAdminAddresses', id).then(function () {
        _this.addresses = _this.$store.getters.adminAddresses;
      });
    }
  },
  data: function data() {
    return {
      fields: [{
        key: 'city',
        label: this.$t('message.adminUserAddress.table.city')
      }, {
        key: 'street',
        label: this.$t('message.adminUserAddress.table.street')
      }, {
        key: 'streetNumber',
        label: this.$t('message.adminUserAddress.table.streetNumber')
      }, {
        key: 'postalCode',
        label: this.$t('message.adminUserAddress.table.postalCode')
      }],
      addresses: []
    };
  }
});

/***/ }),

/***/ "yhgE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("L/hj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContractInformationForm',
  props: {
    contractCategories: {
      type: Array,
      required: true
    }
  },
  computed: {
    contract: function contract() {
      return this.$store.getters.currentContract;
    },
    contractNumberText: function contractNumberText() {
      return this.contract.contractCategory === 'INSURANCE' ? this.$t('message.contractInformationForm.label.insuranceNumber') : this.$t('message.contractInformationForm.label.contractNumber');
    },

    conclusionDate: {
      get: function get() {
        var isYearValid = this.$moment(this.contract.conclusionDate, 'YYYY-MM-DD', true).isValid();

        if (this.contract.conclusionDate && isYearValid) {
          return this.$moment(this.contract.conclusionDate, 'YYYY-MM-DD').format('DD.MM.YYYY');
        }
        return this.contract.conclusionDate;
      },
      set: function set(value) {
        var isYearValid = this.$moment(value, 'DD.MM.YYYY', true).isValid();

        if (value && isYearValid) {
          var formattedDate = this.$moment(value, 'DD.MM.YYYY').format('YYYY-MM-DD');
          this.$store.commit('updateConclusionDate', formattedDate);
        } else {
          this.$store.commit('updateConclusionDate', value);
        }
      }
    }
  },
  data: function data() {
    return {
      selectedContractCategory: null
    };
  },

  methods: {
    getPlaceholderLabel: function getPlaceholderLabel(contractType) {
      switch (contractType) {
        case 'INSURANCE':
          return this.$t('message.contractInformationForm.contractPlaceholder.unique.insurance');
        case 'FINANCE':
          return this.$t('message.contractInformationForm.contractPlaceholder.unique.finance');
        case 'HABITATION_HOUSEHOLD_AND_COMMUNICATION':
          return this.$t('message.contractInformationForm.contractPlaceholder.unique.habitationHouseholdAndCommunication');
        case 'LEISURE_AND_CLUB':
          return this.$t('message.contractInformationForm.contractPlaceholder.unique.leisureAndClub');
        case 'SUBSCRIPTION':
          return this.$t('message.contractInformationForm.contractPlaceholder.unique.subscription');
        case 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT':
          return this.$t('message.contractInformationForm.contractPlaceholder.unique.onlineSubscriptionAndSocialMediaAccount');
        case 'OTHER':
          return this.$t('message.contractInformationForm.contractPlaceholder.unique.other');
      }
    },
    contractCategoryChanged: function contractCategoryChanged(category) {
      this.selectedContractCategory = category;
      if (this.contract.contractCategory) {
        this.$refs.contractCategoryModal.show();
      } else {
        this.$store.commit('updateContractCategory', this.selectedContractCategory);
        this.$v.$reset();
      }
    },
    revertContractCategory: function revertContractCategory() {
      if (this.contract.contractCategory) {
        this.$refs.contractCategory.localValue = this.contract.contractCategory;
      } else {
        this.$refs.contractCategory.localValue = null;
      }
    },
    setContractCategory: function setContractCategory() {
      this.$store.commit('updateContractCategory', this.selectedContractCategory);
      switch (this.contract.contractCategory) {
        case 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT':
          this.$store.commit('deleteContractNumber');
          this.$store.commit('deleteConclusionDate');
          this.$store.commit('deleteContractDuration');
          this.$store.commit('deleteCancellationPeriod');
          break;
        default:
          this.$store.commit('deleteAccountNumber');
          this.$store.commit('deleteInsuredPersonNumber');
          this.$store.commit('deleteAccountUsername');
          this.$store.commit('deleteAccountLink');
          break;
      }
      this.$v.$reset();
    },
    resetValidation: function resetValidation() {
      this.$v.$reset();
    }
  },
  validations: {
    conclusionDate: {
      isValidDate: __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].validators.isValidDate
    },
    contract: {
      accountNumber: {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function (model) {
          if (model.contractCategory === 'FINANCE') {
            return true;
          }
          return false;
        }),
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(100)
      },
      cancellationPeriod: {
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"],
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(2)
      },
      comment: {
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(325)
      },
      contractCategory: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
      },
      contractDuration: {
        numeric: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["numeric"],
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(3)
      },
      contractNumber: {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function (model) {
          if (model.contractCategory !== 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT') {
            return true;
          }
          return false;
        }),
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(100)
      },
      contractType: {
        required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(100)
      },
      accountLink: {
        isValidDomain: __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* default */].validators.isValidDomain
      },
      insuredPersonNumber: {
        maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(100)
      },
      accountUsername: {
        required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function (model) {
          if (model.contractCategory === 'ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT') {
            return true;
          }
          return false;
        })
      }
    }
  }
});

/***/ }),

/***/ "ykpL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractInformationDetails_vue__ = __webpack_require__("mEBB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a92959_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractInformationDetails_vue__ = __webpack_require__("mWE+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContractInformationDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41a92959_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContractInformationDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z2pm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"mt-2"},[_c('b-col',[(_vm.contractPartner)?_c('b-card',{staticClass:"rounded-0 h-100",attrs:{"title":_vm.$t('message.contractOverview.label.partner')}},[_c('div',[_vm._v(_vm._s(_vm.contractPartner.contractPartnerName))]),_vm._v(" "),_c('div',[_vm._v("\n          "+_vm._s(_vm.contractPartner.street)+" "+_vm._s(_vm.contractPartner.streetNumber)),_c('br'),_vm._v("\n          "+_vm._s(_vm.contractPartner.postalCode + ' ' + _vm.contractPartner.city)),_c('br'),_vm._v("\n          "+_vm._s(_vm.contractPartner.postOfficeBox)+"\n        ")])]):_vm._e()],1),_vm._v(" "),_c('b-col',[(_vm.contractAddress)?_c('b-card',{staticClass:"rounded-0 h-100",attrs:{"title":_vm.$t('message.contractOverview.label.address')}},[_vm._v("\n        "+_vm._s(_vm.policyHolder.firstName + ' ' + _vm.policyHolder.lastName)+"\n        "),(_vm.contractAddress.street)?_c('div',[_vm._v(_vm._s(_vm.contractAddress.street + ' ' + _vm.contractAddress.streetNumber))]):_vm._e(),_vm._v(" "),(_vm.contractAddress.postalCode)?_c('div',[_vm._v(_vm._s(_vm.contractAddress.postalCode)+" "),(_vm.contractAddress.city)?_c('span',[_vm._v(_vm._s(_vm.contractAddress.city))]):_vm._e()]):_vm._e()]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0",attrs:{"title":_vm.$t('message.contractOverview.label.info')}},[_c('div',{staticClass:"mb-3"},[_c('b',[_vm._v(_vm._s(_vm.contractCategoryText))])]),_vm._v(" "),(_vm.contract.contractType)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.contractType'))+":\n          "+_vm._s(_vm.contract.contractType)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contract.contractNumber)?_c('div',[_vm._v(_vm._s(_vm.contractNumberText)+":\n          "+_vm._s(_vm.contract.contractNumber)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contract.accountNumber)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.accountNumber'))+":\n          "+_vm._s(_vm.contract.accountNumber)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contract.insuredPersonNumber)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.insuredPersonNumber'))+":\n          "+_vm._s(_vm.contract.insuredPersonNumber)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contract.conclusionDate)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.conclusionDate'))+":\n          "+_vm._s(_vm._f("moment")(_vm.contract.conclusionDate,'DD.MM.YYYY'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contract.contractDuration)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.contractDuration'))+":\n          "+_vm._s(_vm.contract.contractDuration)+" "+_vm._s(_vm.$t('message.contractInformationForm.label.months'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contract.cancellationPeriod)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.cancellationPeriod'))+":\n          "+_vm._s(_vm.contract.cancellationPeriod)+"\n          "+_vm._s(_vm.$t('message.contractInformationForm.label.months'))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contract.accountUsername)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.username'))+":\n          "+_vm._s(_vm.contract.accountUsername)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contract.accountLink)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.link'))+":\n          "+_vm._s(_vm.contract.accountLink)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contract.link)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.link'))+": "+_vm._s(_vm.contract.link))]):_vm._e(),_vm._v(" "),(_vm.contract.comment)?_c('div',[_vm._v(_vm._s(_vm.$t('message.contractInformationForm.label.comment'))+": "+_vm._s(_vm.contract.comment)+"\n        ")]):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zC/Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    message: {
      type: String
    },
    variant: {
      type: String,
      default: function _default() {
        return 'light';
      }
    }
  },
  computed: {
    getStyle: function getStyle() {
      if (this.variant === 'dark') {
        return {
          bgColor: 'bg-dark',
          title: 'title-dark',
          subtitle: 'subtitle-light',
          message: 'text-danger'
        };
      } else if (this.variant === 'noHover') {
        return {
          bgColor: 'noHover',
          title: 'title-light',
          subtitle: 'subtitle-light'
        };
      } else {
        return {
          bgColor: 'white',
          title: 'title-light',
          subtitle: 'subtitle-light'
        };
      }
    }
  }
});

/***/ }),

/***/ "zT+r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Policies_vue__ = __webpack_require__("wDzV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525e0589_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Policies_vue__ = __webpack_require__("0kM9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Policies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525e0589_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Policies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zgIE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('header-view',{attrs:{"title":_vm.$t('message.contactPersonList.title'),"icon":'ti-user'}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('b-card',{staticClass:"rounded-0"},[_c('b-row',[_c('b-col',[_c('p',[_vm._v(_vm._s(_vm.$t('message.contactPersonList.introductoryPhrase')))])])],1),_vm._v(" "),_vm._l((Math.ceil(_vm.contactPersons.length / 2)),function(i){return _c('b-row',{key:i,staticClass:"mb-lg-4"},[_vm._l((_vm.contactPersons.slice((i - 1) * 2, i * 2)),function(contactPerson){return _c('b-col',{key:contactPerson.id + contactPerson.name,staticClass:"mt-md-4 mt-lg-0",attrs:{"cols":"12","xl":"6"}},[_c('div',{staticClass:"p-0 m-0 w-100 cursor-pointer",class:{'not-allowed' : contactPerson.status !== _vm.$t('enums.invitationStatus.REGISTERED')},attrs:{"variant":"transparent","router-tag":"div"},on:{"click":function($event){_vm.showContactPerson(contactPerson)}}},[_c('business-card',{staticClass:"rounded-0 h-100",attrs:{"name":contactPerson.name,"relation":contactPerson.relationshipType? _vm.$t('enums.relationTypes.' + contactPerson.relationshipType) : null,"email":contactPerson.email,"status":contactPerson.status,"imageSrc":contactPerson.avatarUuid}})],1)])}),_vm._v(" "),(i == Math.ceil(_vm.contactPersons.length / 2))?_c('b-col',{class:{'mt-4' : _vm.contactPersons.length % 2 === 0},attrs:{"cols":"12","xl":"6"}},[_c('b-btn',{staticClass:"w-100 h-100 pt-4 pb-2 rounded-0",on:{"click":_vm.showContactPersonDialog}},[_c('span',{staticClass:"ti-plus font-weight-bold pt-1",style:('font-size: 4rem; border: 1px solid #fff; border-radius: 3rem; padding: 5px;')}),_vm._v(" "),_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.contactPersonList.btn.createContactPerson')))])])],1):_vm._e()],2)}),_vm._v(" "),(_vm.contactPersons.length === 0)?_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"w-100 h-100 pt-4 pb-2 rounded-0",on:{"click":_vm.showContactPersonDialog}},[_c('span',{staticClass:"ti-plus font-weight-bold pt-1",style:('font-size: 4rem; border: 1px solid #fff; border-radius: 3rem; padding: 5px;')}),_vm._v(" "),_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('message.contactPersonList.btn.createContactPerson')))])])],1)],1):_vm._e()],2)],1)],1),_vm._v(" "),_c('contact-person-dialog',{ref:"contactPersonDialog",on:{"submit":_vm.submitContactPersonDialog}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.26e277caf2f2c151c290.js